import _get from "/Users/tongjie/Desktop/QNRTC-Web/Demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _slicedToArray from "/Users/tongjie/Desktop/QNRTC-Web/Demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/Users/tongjie/Desktop/QNRTC-Web/Demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/Users/tongjie/Desktop/QNRTC-Web/Demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _assertThisInitialized from "/Users/tongjie/Desktop/QNRTC-Web/Demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/Users/tongjie/Desktop/QNRTC-Web/Demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _classCallCheck from "/Users/tongjie/Desktop/QNRTC-Web/Demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/tongjie/Desktop/QNRTC-Web/Demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/tongjie/Desktop/QNRTC-Web/Demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/tongjie/Desktop/QNRTC-Web/Demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/tongjie/Desktop/QNRTC-Web/Demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e85) { throw _e85; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e86) { didErr = true; err = _e86; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import e from "webrtc-adapter";
import t from "eventemitter3";
import i from "lodash.remove";
import s from "fingerprintjs2";
import r from "localforage";
import o from "pako";
import n from "blueimp-md5";
import a from "lodash.groupby";
import { detect as c } from "detect-browser";
import * as A from "semver";
import d from "mobile-detect";
import u from "lodash.uniqby";
import h from "sdp-transform";
function l() {
  var e = new Date();
  function t(e) {
    var t = e.toString();
    return t.length < 2 ? "0" + t : t;
  }
  var i = t(e.getHours()),
    s = t(e.getMinutes()),
    r = t(e.getSeconds()),
    o = e.getMilliseconds();
  return "[".concat(i, ":").concat(s, ":").concat(r, ".").concat(o, "]");
}
var m = new ( /*#__PURE__*/function (_t2) {
  _inherits(_class, _t2);
  function _class(e) {
    var _this;
    _classCallCheck(this, _class);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this)), _this.level = e;
    return _this;
  }
  _createClass(_class, [{
    key: "setLevel",
    value: function setLevel(e) {
      this.level = e;
    }
  }, {
    key: "log",
    value: function log() {
      var _console;
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
      if ("log" === this.savedLevel && this.emit("log", "log", t), "log" !== this.level) return;
      var s = "".concat(l(), " %cLOG-QNRTC");
      (_console = console).info.apply(_console, [s, "color: #66ccff; font-weight: bold;"].concat(t));
    }
  }, {
    key: "debug",
    value: function debug() {
      var _console2;
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
      if ("log" !== this.savedLevel && "debug" !== this.savedLevel || this.emit("log", "debug", t), "log" !== this.level && "debug" !== this.level) return;
      var s = "".concat(l(), " %cDEBUG-QNRTC");
      (_console2 = console).info.apply(_console2, [s, "color: #A28148; font-weight: bold;"].concat(t));
    }
  }, {
    key: "warning",
    value: function warning() {
      var _console3;
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
      if (this.savedLevel && "disable" !== this.savedLevel && this.emit("log", "warn", t), "disable" === this.level) return;
      var s = "".concat(l(), " %cWARNING-QNRTC");
      (_console3 = console).warn.apply(_console3, [s, "color: #E44F44; font-weight: bold;"].concat(t));
    }
  }, {
    key: "error",
    value: function error() {
      var _console4;
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
      if (this.savedLevel && "disable" !== this.savedLevel && this.emit("log", "error", t), "disable" === this.level) return;
      var s = "".concat(l(), " %cERROR-QNRTC");
      (_console4 = console).error.apply(_console4, [s, "color: #E44F44; font-weight: bold;"].concat(t));
    }
  }, {
    key: "setSavedLevel",
    value: function setSavedLevel(e) {
      this.savedLevel = e;
    }
  }]);
  return _class;
}(t))("log");
function p(e, t) {
  var i = {};
  for (var s in e) Object.prototype.hasOwnProperty.call(e, s) && t.indexOf(s) < 0 && (i[s] = e[s]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;
    for (s = Object.getOwnPropertySymbols(e); r < s.length; r++) t.indexOf(s[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, s[r]) && (i[s[r]] = e[s[r]]);
  }
  return i;
}
function g(e, t, i, s) {
  return new (i || (i = Promise))(function (r, o) {
    function n(e) {
      try {
        c(s.next(e));
      } catch (e) {
        o(e);
      }
    }
    function a(e) {
      try {
        c(s.throw(e));
      } catch (e) {
        o(e);
      }
    }
    function c(e) {
      var t;
      e.done ? r(e.value) : (t = e.value, t instanceof i ? t : new i(function (e) {
        e(t);
      })).then(n, a);
    }
    c((s = s.apply(e, t || [])).next());
  });
}
"function" == typeof SuppressedError && SuppressedError;
var f = function f(e) {
    return !!e && !!e.audio && e.audio.enabled;
  },
  k = function k(e) {
    return !!e && !!e.video && e.video.enabled;
  },
  v = function v(e) {
    return !!e && !!e.screen && e.screen.enabled;
  };
var b, T, y, E, S;
function I(e) {
  return void 0 !== e;
}
!function (e) {
  e[e.camera = 0] = "camera", e[e.microphone = 1] = "microphone";
}(b || (b = {})), function (e) {
  e[e.prompt = 1] = "prompt", e[e.denied = 2] = "denied", e[e.granted = 3] = "granted";
}(T || (T = {})), function (e) {
  e[e.INVALID = -1] = "INVALID", e[e.EXCELLENT = 1] = "EXCELLENT", e[e.GOOD = 2] = "GOOD", e[e.FAIR = 3] = "FAIR", e[e.POOR = 4] = "POOR";
}(y || (y = {})), function (e) {
  e[e.Idle = 0] = "Idle", e[e.Connecting = 1] = "Connecting", e[e.Connect = 2] = "Connect";
}(E || (E = {})), function (e) {
  e[e.NORMAL = 0] = "NORMAL", e[e.EXTERNAL = 1] = "EXTERNAL", e[e.MIXING = 2] = "MIXING";
}(S || (S = {}));
var _ = {
  publishUrl: "",
  height: 720,
  width: 1080,
  fps: 25,
  kbps: 1e3,
  audioOnly: !1,
  stretchMode: "aspectFill"
};
var w;
!function (e) {
  e.IDLE = "idle", e.LOADING = "loading", e.PLAY = "play", e.PAUSE = "pause", e.STOP = "stop", e.END = "end";
}(w || (w = {}));
var R = {
  Init: 1,
  UnInit: 2,
  JoinRoom: 3,
  MCSAuth: 4,
  SignalAuth: 5,
  LeaveRoom: 6,
  PublisherPC: 7,
  PublishTracks: 8,
  UnPublishTracks: 9,
  SubscriberPC: 10,
  SubscribeTracks: 11,
  UnSubscribeTracks: 13,
  MuteTracks: 14,
  ICEConnectionState: 15,
  CallbackStatistics: 16,
  KickoutUser: 17,
  RoomStateChanged: 18,
  AudioDeviceInOut: 19,
  VideoDeviceInOut: 20,
  SDKError: 21,
  ApplicationState: 22,
  CreateMergeJob: 24,
  UpdateMergeTracks: 25,
  StopMerge: 26,
  AuthorizationStatus: 27,
  DeviceChanged: 28,
  DefaultSetting: 29,
  MediaStatistics: 30,
  AbnormalDisconnect: 31,
  CreateForwardJob: 36,
  StopForwardJob: 37,
  WebsocketConnect: 40,
  NetworkChange: 46,
  SystemRequirementsTest: 47,
  AutoplayFail: 49,
  TrackEnded: 50,
  WebSDKException: 51,
  VideoPlayQuality: 53,
  AudioPlayQuality: 54,
  JoinRoomResult: 55,
  SetClientRole: 56,
  StartMediaRelay: 57,
  UpdateMediaRelay: 58,
  StopMediaRelay: 59,
  MCURelayAuth: 60,
  SignalFired: 66
};
var D = "4.3.2";
var C = navigator.userAgent.toLowerCase().indexOf("firefox") > -1,
  M = !!window.chrome,
  O = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i),
  P = function () {
    var e = c();
    if (!navigator || !navigator.appVersion || !e) return e;
    var t = /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/.exec(window.navigator.appVersion);
    return t && t[1] ? Object.assign(Object.assign({}, e), {
      chromeVersion: t[1]
    }) : e;
  }() || {},
  q = !!new d(navigator.userAgent).mobile(),
  L = navigator.userAgent.toLowerCase().indexOf("electron") > -1;
function x() {
  try {
    return !!window && "RTCPeerConnection" in window && "WebSocket" in window && !!navigator && !!navigator.mediaDevices && !!navigator.mediaDevices.getUserMedia;
  } catch (e) {
    return !1;
  }
}
function N() {
  var e = navigator && navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia,
    t = navigator && navigator.mediaDevices && navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().displaySurface;
  return C ? !!e && !!t : !!e;
}
function j() {
  return "createMediaStreamDestination" in (window.AudioContext || window.webkitAudioContext || window.Object).prototype;
}
var F = function () {
  if (!P) return {
    support: x(),
    supportRestartICE: !0,
    getDisplayMedia: N(),
    disconnectAudioNode: !0
  };
  switch (P.name) {
    case "chrome":
      return {
        support: x(),
        mediaStreamDest: A.gte(P.version, "55.0.0"),
        replaceTrack: A.gte(P.version, "65.0.0"),
        screenSharing: A.gte(P.version, "55.0.0"),
        connectionState: A.gte(P.version, "72.0.0"),
        stats: A.gte(P.version, "67.0.0"),
        ondevicechange: A.gte(P.version, "57.0.0"),
        minMaxWithIdeal: A.gte(P.version, "56.0.0"),
        supportTransceivers: A.gte(P.version, "69.0.0"),
        unifiedPlan: A.gte(P.version, "72.0.0"),
        supportRestartICE: !0,
        getReceivers: A.gte(P.version, "59.0.0"),
        needH264FmtpLine: A.lte(P.version, "51.0.0"),
        audioContextOptions: !0,
        getDisplayMedia: N(),
        disconnectAudioNode: !0,
        setPlaybackDevice: !0
      };
    case "ios":
    case "safari":
      return {
        support: x(),
        replaceTrack: A.gte(P.version, "11.0.0"),
        stats: A.gte(P.version, "11.0.0"),
        ondevicechange: !1,
        connectionState: !0,
        mediaStreamDest: A.gte(P.version, "12.0.0"),
        screenSharing: A.gte(P.version, "13.0.0"),
        unifiedPlan: A.gte(P.version, "12.1.0"),
        supportTransceivers: !0,
        minMaxWithIdeal: !1,
        supportRestartICE: !0,
        getReceivers: !0,
        audioContextOptions: !0,
        getDisplayMedia: N(),
        disconnectAudioNode: !1
      };
    case "firefox":
      return {
        support: x(),
        replaceTrack: !0,
        stats: A.gte(P.version, "66.0.0"),
        ondevicechange: A.gte(P.version, "52.0.0"),
        connectionState: !0,
        mediaStreamDest: !0,
        screenSharing: !0,
        minMaxWithIdeal: !0,
        unifiedPlan: !0,
        supportTransceivers: A.gte(P.version, "59.0.0"),
        supportRestartICE: !1,
        getReceivers: !0,
        audioContextOptions: A.gte(P.version, "55.0.0"),
        getDisplayMedia: N(),
        disconnectAudioNode: !0
      };
    case "crios":
    case "ios-webview":
      return {
        support: x(),
        getDisplayMedia: N(),
        mediaStreamDest: j(),
        unifiedPlan: !0,
        supportTransceivers: !0,
        supportRestartICE: !0,
        disconnectAudioNode: !0
      };
    default:
      return {
        support: x(),
        mediaStreamDest: j(),
        supportRestartICE: !0,
        getDisplayMedia: N(),
        disconnectAudioNode: !0
      };
  }
}();
var U = /*#__PURE__*/function (_t3) {
  _inherits(U, _t3);
  function U(e) {
    var _this2;
    _classCallCheck(this, U);
    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(U).call(this)), _this2._closed = !1, _this2._busy = !1, _this2._queue = [], _this2.name = e || "TaskQueue", _this2.isDebug = t;
    return _this2;
  }
  _createClass(U, [{
    key: "close",
    value: function close() {
      this._closed = !0;
    }
  }, {
    key: "push",
    value: function push(e, t) {
      var _this3 = this;
      return this.isDebug && m.debug("".concat(this.name, " push()"), e, t), new Promise(function (i, s) {
        _this3._queue.push({
          method: e,
          data: t,
          resolve: i,
          reject: s
        }), _this3._handlePendingCommands();
      });
    }
  }, {
    key: "_handlePendingCommands",
    value: function _handlePendingCommands() {
      var _this4 = this;
      if (this._busy) return;
      var e = this._queue,
        t = e[0];
      t && (this._busy = !0, this._handleCommand(t).then(function () {
        _this4._busy = !1, e.shift(), _this4._handlePendingCommands();
      }));
    }
  }, {
    key: "_handleCommand",
    value: function _handleCommand(e) {
      var _this5 = this;
      if (this.isDebug && m.debug("".concat(this.name, " _handleCommand() "), e.method, e.data), this._closed) return e.reject(new Ze("closed")), Promise.resolve();
      var t = {
        promise: null
      };
      return this.emit("exec", e, t), Promise.resolve().then(function () {
        return t.promise;
      }).then(function (t) {
        _this5.isDebug && m.debug("".concat(_this5.name, " _handleCommand() | command succeeded"), e.method), _this5._closed ? e.reject(new Ze("closed")) : e.resolve(t);
      }).catch(function (t) {
        _this5.isDebug && m.warning("".concat(_this5.name, " _handleCommand() | command failed [method:%s]: %o"), e.method, t), e.reject(t);
      });
    }
  }]);
  return U;
}(t);
var V, B;
!function (e) {
  e.DISCONNECTED = "DISCONNECTED", e.CONNECTING = "CONNECTING", e.CONNECTED = "CONNECTED", e.RECONNECTING = "RECONNECTING", e.RECONNECTED = "RECONNECTED";
}(V || (V = {})), function (e) {
  e.ACTIVE = "ACTIVE", e.INACTIVE = "INACTIVE";
}(B || (B = {}));
var H = {
    "360p": {
      width: 640,
      height: 360,
      frameRate: 15,
      bitrate: 400
    },
    "640x360_15": {
      width: 640,
      height: 360,
      frameRate: 15,
      bitrate: 400
    },
    "640x360_30": {
      width: 640,
      height: 360,
      frameRate: 30,
      bitrate: 600
    },
    "480p": {
      width: 640,
      height: 480,
      frameRate: 15,
      bitrate: 500
    },
    "640x480_15": {
      width: 640,
      height: 480,
      frameRate: 15,
      bitrate: 500
    },
    "640x480_30": {
      width: 640,
      height: 480,
      frameRate: 30,
      bitrate: 1e3
    },
    "720p": {
      width: 1280,
      height: 720,
      frameRate: 15,
      bitrate: 1130
    },
    "1280x720_15": {
      width: 1280,
      height: 720,
      frameRate: 15,
      bitrate: 1130
    },
    "1280x720_30": {
      width: 1280,
      height: 720,
      frameRate: 30,
      bitrate: 2e3
    },
    "1080p": {
      width: 1920,
      height: 1080,
      frameRate: 15,
      bitrate: 2080
    },
    "1920x1080_15": {
      width: 1920,
      height: 1080,
      frameRate: 15,
      bitrate: 2080
    },
    "1920x1080_30": {
      width: 1920,
      height: 1080,
      frameRate: 30,
      bitrate: 4e3
    },
    "1440p": {
      width: 2560,
      height: 1440,
      frameRate: 30,
      bitrate: 4850
    },
    "2560x1440_30": {
      width: 2560,
      height: 1440,
      frameRate: 30,
      bitrate: 4850
    },
    "4k": {
      width: 3840,
      height: 2160,
      frameRate: 30,
      bitrate: 8910
    },
    "3840x2160_30": {
      width: 3840,
      height: 2160,
      frameRate: 30,
      bitrate: 8910
    }
  },
  Q = H["480p"],
  G = {
    LOW: {
      sampleRate: 16e3,
      stereo: !1,
      bitrate: 24,
      sampleSize: 16
    },
    STANDARD: {
      sampleRate: 48e3,
      stereo: !1,
      bitrate: 64,
      sampleSize: 16
    },
    STANDARD_STEREO: {
      sampleRate: 48e3,
      stereo: !0,
      bitrate: 80,
      sampleSize: 16
    },
    HIGH: {
      sampleRate: 48e3,
      stereo: !1,
      bitrate: 96,
      sampleSize: 16
    },
    HIGH_STEREO: {
      sampleRate: 48e3,
      stereo: !0,
      bitrate: 128,
      sampleSize: 16
    }
  },
  J = G.STANDARD,
  W = {
    "480p": {
      width: 640,
      height: 480,
      frameRate: 15,
      bitrate: 500
    },
    "640x480_5": {
      width: 640,
      height: 480,
      frameRate: 5,
      bitrate: 200
    },
    "640x480_15": {
      width: 640,
      height: 480,
      frameRate: 15,
      bitrate: 500
    },
    "640x480_30": {
      width: 640,
      height: 480,
      frameRate: 30,
      bitrate: 1e3
    },
    "720p": {
      width: 1280,
      height: 720,
      frameRate: 15,
      bitrate: 1130
    },
    "1280x720_5": {
      width: 1280,
      height: 720,
      frameRate: 5,
      bitrate: 400
    },
    "1280x720_15": {
      width: 1280,
      height: 720,
      frameRate: 15,
      bitrate: 1130
    },
    "1280x720_30": {
      width: 1280,
      height: 720,
      frameRate: 30,
      bitrate: 2e3
    },
    "1080p": {
      width: 1920,
      height: 1080,
      frameRate: 15,
      bitrate: 2080
    },
    "1920x1080_5": {
      width: 1920,
      height: 1080,
      frameRate: 5,
      bitrate: 700
    },
    "1920x1080_15": {
      width: 1920,
      height: 1080,
      frameRate: 15,
      bitrate: 2080
    },
    "1920x1080_30": {
      width: 1920,
      height: 1080,
      frameRate: 30,
      bitrate: 4e3
    }
  },
  K = W["720p"];
var z, Y, Z, X, $, ee, te, ie, se, re, oe, ne, ae, ce, Ae, de;
!function (e) {
  e.WINDOW = "window", e.SCREEN = "screen", e.ALL = "all";
}(z || (z = {})), function (e) {
  e.IDLE = "IDLE", e.PlAYING = "PlAYING", e.MIXING = "MIXING", e.PAUSED = "PAUSED", e.STOPPED = "STOPPED", e.COMPLETED = "COMPLETED";
}(Y || (Y = {})), function (e) {
  e.FILL = "scaleToFit", e.ASPECT_FILL = "aspectFill", e.ASPECT_FIT = "aspectFit";
}(Z || (Z = {})), function (e) {
  e.STARTED = "STARTED", e.STOPPED = "STOPPED";
}(X || (X = {})), function (e) {
  e.UNKNOWN = "UNKNOWN", e.EXCELLENT = "EXCELLENT", e.GOOD = "GOOD", e.FAIR = "FAIR", e.POOR = "POOR";
}($ || ($ = {})), function (e) {
  e.LOW = "LOW", e.MEDIUM = "MEDIUM", e.HIGH = "HIGH";
}(ee || (ee = {})), function (e) {
  e.LEAVE = "LEAVE", e.KICKED_OUT = "KICKED_OUT", e.ERROR = "ERROR";
}(te || (te = {})), function (e) {
  e.VERBOSE = "VERBOSE", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.NONE = "NONE";
}(ie || (ie = {})), function (e) {
  e.FORCE_UDP = "FORCE_UDP", e.FORCE_TCP = "FORCE_TCP", e.PREFER_UDP = "PREFER_UDP";
}(se || (se = {})), function (e) {
  e.MOTION = "motion", e.DETAIL = "detail", e.DEFAULT = "";
}(re || (re = {})), function (e) {
  e.SCREEN = "screen", e.WINDOW = "window", e.ALL = "all";
}(oe || (oe = {})), function (e) {
  e.RTC = "RTC", e.LIVE = "LIVE";
}(ne || (ne = {})), function (e) {
  e.BROADCASTER = "BROADCASTER", e.AUDIENCE = "AUDIENCE";
}(ae || (ae = {})), function (e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.STOPPED = 1] = "STOPPED", e[e.INVALID_TOKEN = 2] = "INVALID_TOKEN", e[e.NO_ROOM = 3] = "NO_ROOM", e[e.ROOM_CLOSED = 4] = "ROOM_CLOSED", e[e.PLAYER_EXISTED = 5] = "PLAYER_EXISTED";
}(ce || (ce = {})), function (e) {
  e.NORMAL = "NORMAL", e.GENERAL = "GENERAL", e.SERVERE = "SERVERE";
}(Ae || (Ae = {})), function (e) {
  e.CORE = "Core", e.API = "API", e.AUDIO = "Audio", e.VIDEO = "Video", e.SIGNAL = "Signal";
}(de || (de = {}));
var ue = "qnrtcqosevents";
function he() {
  return new Promise(function (e, t) {
    window.requestIdleCallback ? window.requestIdleCallback(function () {
      s.get(function (t) {
        var i = n(JSON.stringify(t));
        e(i);
      });
    }) : setTimeout(function () {
      s.get(function (t) {
        var i = n(JSON.stringify(t));
        e(i);
      });
    }, 500);
  });
}
function le(e) {
  var t = [];
  for (var _i2 = 0; _i2 < e.length; _i2++) {
    var _s2 = e.charCodeAt(_i2);
    _s2 < 128 ? t.push(_s2) : _s2 < 2048 ? t.push(192 | _s2 >> 6, 128 | 63 & _s2) : _s2 < 55296 || _s2 >= 57344 ? t.push(224 | _s2 >> 12, 128 | _s2 >> 6 & 63, 128 | 63 & _s2) : (_i2++, _s2 = 65536 + ((1023 & _s2) << 10 | 1023 & e.charCodeAt(_i2)), t.push(240 | _s2 >> 18, 128 | _s2 >> 12 & 63, 128 | _s2 >> 6 & 63, 128 | 63 & _s2));
  }
  return new Uint8Array(t);
}
var me = new ( /*#__PURE__*/function () {
  function _class2() {
    var _this6 = this;
    _classCallCheck(this, _class2);
    this.events = [], this.lastSubmitTime = Date.now(), this.submitQueue = new U("qossubmit", !1), he().then(function (e) {
      _this6.deviceId = e, _this6.base.device_id = _this6.deviceId;
    }).catch(function () {
      _this6.deviceId = "unknow", _this6.base.device_id = _this6.deviceId;
    }), this.base = {
      qos_version: "2.0",
      device_id: "",
      bundle_id: "",
      url: window.location.href,
      app_version: "",
      sdk_version: D,
      device_model: "".concat(P.name).concat(P.version),
      os_platform: "Web",
      os_version: "",
      host_environment: P.os
    }, this.initSubmitQueue(), this.submitQueue.push("resume").catch(it);
  }
  _createClass(_class2, [{
    key: "setSessionId",
    value: function setSessionId(e) {
      for (var _t4 = this.events.length - 1; _t4 >= 0; _t4 -= 1) {
        var _i3 = this.events[_t4];
        if (_i3.session_id) break;
        _i3.session_id = e;
      }
      this.sessionId = e;
    }
  }, {
    key: "setUserBase",
    value: function setUserBase(e, t, i) {
      this.userBase = {
        user_id: e,
        room_name: t,
        app_id: i
      };
      for (var _e2 = this.events.length - 1; _e2 >= 0; _e2 -= 1) {
        var _t5 = this.events[_e2];
        if (_t5.user_base) break;
        _t5.user_base = this.userBase;
      }
    }
  }, {
    key: "addEvent",
    value: function addEvent(e, t, i) {
      var s = Object.assign({
        timestamp: Date.now(),
        event_id: R[e],
        event_name: e
      }, t);
      this.submitQueue.push("add", s).catch(it), this.submit(i);
    }
  }, {
    key: "submit",
    value: function submit() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      this.submitQueue.push("submit", e).catch(it);
    }
  }, {
    key: "initSubmitQueue",
    value: function initSubmitQueue() {
      var _this7 = this;
      this.submitQueue.on("exec", function (e, t) {
        switch (e.method) {
          case "submit":
            return void (t.promise = _this7._submit(e.data));
          case "add":
            return void (t.promise = _this7._addEvent(e.data));
          case "resume":
            return void (t.promise = _this7._recoverStoredEvents());
        }
      });
    }
  }, {
    key: "_recoverStoredEvents",
    value: function _recoverStoredEvents() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var e;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return r.getItem(ue);
            case 2:
              e = _context.sent;
              _context.next = 5;
              return r.removeItem(ue);
            case 5:
              e && (this.events = JSON.parse(window.atob(decodeURIComponent(e))), this.events = this.events.filter(function (e) {
                return !!e.session_id && !!e.user_base;
              }).sort(function (e, t) {
                return e.event.timestamp - t.event.timestamp;
              }));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "_addEvent",
    value: function _addEvent(e) {
      return this.events.push({
        user_base: this.userBase,
        event: e,
        session_id: this.sessionId
      }), this.submit(), Promise.resolve();
    }
  }, {
    key: "saveEvents",
    value: function saveEvents() {
      var e = encodeURIComponent(window.btoa(JSON.stringify(this.events)));
      r.setItem(ue, e).catch(it);
    }
  }, {
    key: "submitCheck",
    value: function submitCheck() {
      return !!(this.sessionId && this.deviceId && this.userBase) && (Date.now() - this.lastSubmitTime > 3e5 || this.events.length >= 30);
    }
  }, {
    key: "_submit",
    value: function _submit() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _e3, _iterator, _step, _t6;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!!e || this.submitCheck())) {
                _context2.next = 33;
                break;
              }
              _context2.prev = 1;
              _e3 = this.encodeQosSubmitData();
              _iterator = _createForOfIteratorHelper(_e3);
              _context2.prev = 4;
              _iterator.s();
            case 6:
              if ((_step = _iterator.n()).done) {
                _context2.next = 14;
                break;
              }
              _t6 = _step.value;
              _context2.next = 10;
              return fetch("https://pili-rtc-qos.qiniuapi.com/v1/rtcevent", {
                method: "POST",
                headers: {
                  "Content-Type": "application/x-gzip"
                },
                body: _t6.buffer
              });
            case 10:
              if (_context2.sent.ok) {
                _context2.next = 12;
                break;
              }
              throw ke("rtcevent error");
            case 12:
              _context2.next = 6;
              break;
            case 14:
              _context2.next = 19;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](4);
              _iterator.e(_context2.t0);
            case 19:
              _context2.prev = 19;
              _iterator.f();
              return _context2.finish(19);
            case 22:
              this.lastSubmitTime = Date.now();
              this.events = [];
              _context2.next = 26;
              return r.removeItem(ue);
            case 26:
              _context2.next = 31;
              break;
            case 28:
              _context2.prev = 28;
              _context2.t1 = _context2["catch"](1);
              m.log(_context2.t1);
            case 31:
              _context2.next = 34;
              break;
            case 33:
              this.saveEvents();
            case 34:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 28], [4, 16, 19, 22]]);
      }));
    }
  }, {
    key: "encodeQosSubmitData",
    value: function encodeQosSubmitData() {
      var e = a(this.events, function (e) {
          return e.session_id || "" + JSON.stringify(e.user_base);
        }),
        t = [];
      for (var _i4 in e) {
        var _s3 = e[_i4];
        if (0 === _s3.length) continue;
        var _r = {
          session_id: _s3[0].session_id,
          user_base: _s3[0].user_base,
          base: this.base,
          items: _s3.map(function (e) {
            return e.event;
          })
        };
        m.log("encode", _r);
        var _n = new Uint8Array(o.gzip(le(JSON.stringify(_r))));
        t.push(_n);
      }
      return t;
    }
  }]);
  return _class2;
}())();
{
  var Ns = function Ns(e, t) {
    var i;
    switch (e) {
      case "prompt":
        i = T.prompt;
        break;
      case "granted":
        i = T.granted;
        break;
      case "denied":
        i = T.denied;
        break;
      default:
        return;
    }
    var s = Ae.NORMAL;
    (i === T.prompt || T.denied) && (s = Ae.SERVERE), me.addEvent("AuthorizationStatus", {
      type: t,
      status: i,
      event_grade: s,
      event_category: de.CORE
    });
  };
  var js = function js(e) {
    xs && xs.permissions && xs.permissions.query({
      name: e
    }).then(function (t) {
      Ns(t.state, b[e]), t.onchange = function () {
        Ns(t.state, b[e]);
      };
    }).catch(function (e) {
      m.debug("error when queryPermission", e);
    });
  };
  var xs = navigator;
  js("camera"), js("microphone");
}
document.visibilityState && document.addEventListener("visibilitychange", function () {
  me.addEvent("ApplicationState", {
    state: "visible" === document.visibilityState ? 0 : 2,
    event_grade: Ae.GENERAL,
    event_category: de.CORE
  });
});
var pe = function () {
  var e = y.INVALID,
    t = "unknow";
  var i = function i(e) {
      var t;
      switch (e) {
        case "cellular":
          t = 0;
          break;
        case "wifi":
          t = 1;
          break;
        case "ethernet":
          t = 2;
          break;
        default:
          t = -1;
      }
      return t;
    },
    s = function s() {
      me.addEvent("NetworkChange", {
        network_type: i(t),
        network_name: t,
        network_grade: e,
        event_grade: Ae.GENERAL,
        event_category: de.CORE
      });
    },
    r = navigator,
    o = r.connection || r.mozConnection || r.webkitConnection;
  return o && o.type && (t = o.type, o.onchange = function () {
    t !== o.type && (t = o.type, s());
  }), s(), function (t) {
    t !== e && (e = t, s());
  };
}();
var ge = /*#__PURE__*/function (_Error) {
  _inherits(ge, _Error);
  function ge(e, t) {
    var _this8;
    _classCallCheck(this, ge);
    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(ge).call(this, t)), _this8.code = e, _this8.error = t, me.addEvent("SDKError", {
      error_code: e,
      error_msg: t
    });
    return _this8;
  }
  return ge;
}(_wrapNativeSuper(Error));
var fe = function fe(e) {
    return new ge(10053, "invalid parameters: ".concat(e));
  },
  ke = function ke(e) {
    return new ge(21005, "piliRTC: unexpected error ".concat(e));
  },
  ve = function ve(e) {
    return new ge(21001, "enterRoom error, can not get accessToken. Error: ".concat(e, "\n please check enterRoom arguments"));
  },
  be = function be(e) {
    return new ge(21006, "not support! ".concat(e));
  },
  Te = function Te(e) {
    return new ge(21007, "track play is not allowed: ".concat(e));
  },
  ye = function ye(e) {
    return new ge(23003, "plugin not avaliable! ".concat(e));
  },
  Ee = function Ee(e) {
    return new ge(23004, "NotAllowedError: no permission to access media device. ".concat(e));
  },
  Se = function Se(e) {
    return new ge(22011, "can not decode audio data, ".concat(e.toString()));
  },
  Ie = function Ie() {
    return new ge(23005, "no audio track when createScreenVideoTrack withAudio enable");
  },
  _e = function _e(e) {
    return new ge(23008, "require('electron') error, please checkout if electron environment is ok: ".concat(e));
  },
  we = function we(e) {
    return new ge(24e3, "relay error, can not get relayToken. Error: ".concat(e));
  },
  Re = function Re(e) {
    return new ge(24001, "invalid client mode, ".concat(e));
  },
  De = function De(e) {
    return new ge(24002, "invalid client role, ".concat(e));
  },
  Ce = function Ce() {
    return ke("websocket abort");
  },
  Me = function Me(e) {
    return fe("can not set merge layout stream, no merge job id ".concat(e));
  },
  Oe = function Oe() {
    return Ee("can not sharing screen/window on chrome");
  },
  Pe = function Pe() {
    return ke("subscribe/publish operation is aborted");
  },
  qe = function qe() {
    return fe("cannot found preset");
  },
  Le = function Le() {
    return new ge(22003, "mix source error");
  },
  xe = function xe() {
    return new ge(22002, "mixed source does not find a valid track");
  },
  Ne = function Ne() {
    return new ge(22001, "effectID already exists, cannot create QNAudioEffect");
  },
  je = function je() {
    return new ge(22004, "effectID is not exists, pleast createAudioEffect first");
  },
  Fe = function Fe() {
    return new ge(22005, "failed to write recording file");
  },
  Ue = function Ue() {
    return new ge(22006, "audio and video resources do not exist");
  },
  Ve = function Ve() {
    return new ge(22007, "recording time exceeded limit");
  },
  Be = function Be() {
    return new ge(22009, "the operation is not supported in the current state");
  },
  He = function He(e, t) {
    return new ge(e, "publish error, signaling code: ".concat(e, ", msg: ").concat(t));
  },
  Qe = function Qe(e, t) {
    return new ge(e, "create merge job error, signaling code: ".concat(e, ", msg: ").concat(t));
  },
  Ge = function Ge(e, t) {
    return new ge(e, "create forward job error, signaling code: ".concat(e, ", msg: ").concat(t));
  },
  Je = function Je(e, t) {
    return new ge(e, "media format not support, ".concat(t));
  },
  We = function We(e, t) {
    return new ge(e, "subscribe error, signaling code: ".concat(e, ", msg: ").concat(t));
  },
  Ke = function Ke(e, t) {
    return new ge(e, "send control error, code: ".concat(e, ", msg: ").concat(t));
  },
  ze = function ze(e, t) {
    return new ge(e, t);
  },
  Ye = function Ye() {
    return new ge(10052, "server unavailable");
  };
var Ze = /*#__PURE__*/function (_Error2) {
  _inherits(Ze, _Error2);
  function Ze(e) {
    var _this9;
    _classCallCheck(this, Ze);
    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(Ze).call(this, e)), _this9.name = "InvalidStateError", Error.hasOwnProperty("captureStackTrace") ? Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this9)), Ze) : _this9.stack = new Error(e).stack;
    return _this9;
  }
  return Ze;
}(_wrapNativeSuper(Error));
var Xe = Object.freeze({
  __proto__: null,
  CONTROL_ERROR: Ke,
  CREATE_FORWARD_JOB_ERROR: Ge,
  CREATE_MERGE_JOB_ERROR: Qe,
  CREATE_SCREEN_AUDIO_ERROR: Ie,
  ERROR_AUDIO_DECODE_ERROR: Se,
  ERROR_AUDIO_MIXING_AUDIO_NOT_FOUND: xe,
  ERROR_AUDIO_MIXING_IO_EXCEPTION: Le,
  ERROR_AUTH_FAILED: ve,
  ERROR_DEVICE_NOT_ALLOWED: Ee,
  ERROR_EFFECT_ID_IS_EXIST: Ne,
  ERROR_EFFECT_ID_IS_NOT_EXIST: je,
  ERROR_ELECTRON_REQUIRE_ERROR: _e,
  ERROR_FATAL: ke,
  ERROR_INVALID_CLIENT_MODE: Re,
  ERROR_INVALID_CLIENT_ROLE: De,
  ERROR_INVALID_PARAMETER: fe,
  ERROR_NOT_SUPPORT: be,
  ERROR_PLAY_NOT_ALLOWED: Te,
  ERROR_PLUGIN_NOT_AVAILABLE: ye,
  ERROR_RECONNECT_FAILED: function ERROR_RECONNECT_FAILED(e) {
    return new ge(21003, "reconnect failed！".concat(e));
  },
  ERROR_RECORDER_EXCEEDING_TIME: Ve,
  ERROR_RECORDER_PARAMS_EXCEPTION: function ERROR_RECORDER_PARAMS_EXCEPTION() {
    return new ge(22008, "");
  },
  ERROR_RECORDER_SOURCE_EXCEPTION: Ue,
  ERROR_RECORDER_STATE_EXCEPTION: Be,
  ERROR_RECORDER_WRITE: Fe,
  ERROR_RELAY_TOKEN: we,
  InvalidStateError: Ze,
  JOIN_ROOM_ERROR: function JOIN_ROOM_ERROR(e, t) {
    return new ge(e, "joinRoom error, code: ".concat(e, ", ").concat(t));
  },
  NO_MERGE_JOB: Me,
  PRESET_NOT_FOUND: qe,
  PUBLISH_ERROR: He,
  QNRTCError: ge,
  SCREEN_PERMISSION_DENIED: Oe,
  SERVER_ERROR: ze,
  SERVER_UNAVAILABLE: Ye,
  SUB_ERROR: We,
  SUB_PUB_ABORT: Pe,
  UNPUBLISH_ERROR: function UNPUBLISH_ERROR(e, t) {
    return new ge(e, "unpublish error, code: ${code}, msg: ${msg}");
  },
  UNSUB_ERROR: function UNSUB_ERROR(e, t) {
    return new ge(e, "unsubscribe error, code: ${code}, msg: ${msg}");
  },
  UNSUPPORT_FMT: Je,
  WS_ABORT: Ce
});
function $e(e) {
  var t = e.split(".")[1];
  if (!t) throw new Error("parse jwt error, can not find payload string.");
  var i = atob(t);
  return JSON.parse(i);
}
function et(e) {
  try {
    var _t7 = e.split(":")[2],
      _i5 = atob(_t7);
    return JSON.parse(_i5);
  } catch (e) {
    throw ke("can not parse roomToken, ".concat(e));
  }
}
function tt(e, t, i) {
  if (!i) return null;
  for (var _s4 = 0; _s4 < e.length; _s4 += 1) {
    var _r2 = e[_s4];
    if (_r2[t] === i) return _r2;
  }
  return null;
}
function it() {}
function st(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
  if (t >= 4) return e;
  for (var _i6 in e) void 0 === e[_i6] && delete e[_i6], e[_i6] instanceof File || e[_i6] instanceof ArrayBuffer || "object" == typeof e[_i6] && (e[_i6] = st(e[_i6], t + 1));
  return e;
}
function rt(e) {
  Promise.resolve().then(e);
}
function ot(e) {
  return ("0" + e.toString(16)).substr(-2);
}
function nt() {
  var e = new Uint8Array(((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 5) || 40) / 2);
  return window.crypto.getRandomValues(e), Array.from(e, ot).join("");
}
function at(e) {
  return new Promise(function (t) {
    setTimeout(function () {
      t();
    }, e);
  });
}
var ct = {};
function At(e, t) {
  if (!ct[t]) return ct[t] = !0, e();
}
function dt(e) {
  m.warning("play failed!", e), m.warning("play failed due to browser security policy, see: http://s.qnsdk.com/s/Txsdz");
}
var ut = [];
var ht;
function lt(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5e3;
  return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _iterator2, _step2, _e5, _t8, i;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          i = function _i8(i) {
            return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
              var s, _e4, _i7, _r3, _o, _n2;
              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    s = "".concat(i).concat(e);
                    m.debug("requesting on", s);
                    _context3.prev = 2;
                    _e4 = new AbortController();
                    _context3.next = 6;
                    return Promise.race([new Promise(function (s, r) {
                      _i7 = window.setTimeout(function () {
                        _e4.abort("Time limit exceeded"), r({
                          networkCode: -1,
                          message: "请求超时"
                        });
                      }, t);
                    }), fetch(s, {
                      signal: _e4.signal
                    })]);
                  case 6:
                    _r3 = _context3.sent;
                    clearTimeout(_i7);
                    _o = _r3.status, _n2 = _r3.statusText;
                    if (!(_o >= 500)) {
                      _context3.next = 11;
                      break;
                    }
                    return _context3.abrupt("return");
                  case 11:
                    if (!(_o >= 400)) {
                      _context3.next = 13;
                      break;
                    }
                    throw {
                      retry: !1,
                      message: "".concat(_o, " ").concat(_n2)
                    };
                  case 13:
                    return _context3.abrupt("return", _r3.json());
                  case 16:
                    _context3.prev = 16;
                    _context3.t0 = _context3["catch"](2);
                    return _context3.abrupt("return", _context3.t0 instanceof TypeError ? void m.error("bad request with host:", i, _context3.t0.message) : (console.error(i, _context3.t0), _context3.t0));
                  case 19:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3, null, [[2, 16]]);
            }));
          };
          if (!ht) {
            _context5.next = 3;
            break;
          }
          return _context5.abrupt("return", i(ht));
        case 3:
          _iterator2 = _createForOfIteratorHelper( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
            return _regeneratorRuntime().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.t0 = ut.length;
                  if (!_context4.t0) {
                    _context4.next = 4;
                    break;
                  }
                  m.debug("using custom mcu server hosts:", ut);
                  return _context4.delegateYield(ut, "t1", 4);
                case 4:
                  _context4.next = 6;
                  return "https://rtc.qiniuapi.com";
                case 6:
                  _context4.next = 8;
                  return "https://rtc.qiniu.com";
                case 8:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          })());
          _context5.prev = 4;
          _iterator2.s();
        case 6:
          if ((_step2 = _iterator2.n()).done) {
            _context5.next = 15;
            break;
          }
          _e5 = _step2.value;
          _context5.next = 10;
          return i(_e5);
        case 10:
          _t8 = _context5.sent;
          if (!_t8) {
            _context5.next = 13;
            break;
          }
          return _context5.abrupt("return", (ht = _e5, _t8));
        case 13:
          _context5.next = 6;
          break;
        case 15:
          _context5.next = 20;
          break;
        case 17:
          _context5.prev = 17;
          _context5.t0 = _context5["catch"](4);
          _iterator2.e(_context5.t0);
        case 20:
          _context5.prev = 20;
          _iterator2.f();
          return _context5.finish(20);
        case 23:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[4, 17, 20, 23]]);
  }));
}
function mt(e) {
  return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var t, _t9;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          t = e.match(/(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/);
          if (!(e.match(/^([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])$/) || t)) {
            _context6.next = 3;
            break;
          }
          return _context6.abrupt("return", e);
        case 3:
          _context6.prev = 3;
          _context6.next = 6;
          return fetch("https://".concat(e, "/ip"));
        case 6:
          _t9 = _context6.sent;
          _context6.next = 9;
          return _t9.json();
        case 9:
          return _context6.abrupt("return", _context6.sent.ip);
        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6["catch"](3);
          m.warning("resolve ice failed, retry", _context6.t0);
          _context6.next = 17;
          return at(1e3);
        case 17:
          _context6.next = 19;
          return mt(e);
        case 19:
          return _context6.abrupt("return", _context6.sent);
        case 20:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[3, 12]]);
  }));
}
var pt;
!function (e) {
  e[e.AudioLevelUnusual = 0] = "AudioLevelUnusual";
}(pt || (pt = {}));
var gt = /*#__PURE__*/function () {
  _createClass(gt, null, [{
    key: "create",
    value: function create(e) {
      this.instance || (this.instance = new gt());
      var t = this.instance.getValidStandard(e.code);
      return this.instance.qosAddEvent(Object.assign(Object.assign({
        valid_standard: t
      }, e), {
        event_grade: Ae.SERVERE
      })), this.instance;
    }
  }]);
  function gt() {
    _classCallCheck(this, gt);
  }
  _createClass(gt, [{
    key: "qosAddEvent",
    value: function qosAddEvent(e) {
      me.addEvent("WebSDKException", e);
    }
  }, {
    key: "getValidStandard",
    value: function getValidStandard(e) {
      if (e === pt.AudioLevelUnusual) return "0-1";
    }
  }]);
  return gt;
}();
var ft = /*#__PURE__*/function () {
  function ft(e) {
    _classCallCheck(this, ft);
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ft.AlphaForPacketLossFractionSmoother;
    this.mLastFilteredTimestamp = Date.now(), this.mMax = ft.kValueUndefined, this.smooth_interval = "audio" === e ? ft.SMOOTH_AUDIO_INTERVAL : ft.SMOOTH_VIDEO_INTERVAL, this.Reset(t);
  }
  _createClass(ft, [{
    key: "Reset",
    value: function Reset(e) {
      this.mAlpha = e, this.mFiltered = ft.kValueUndefined;
    }
  }, {
    key: "Apply",
    value: function Apply(e) {
      var t = Date.now() - this.mLastFilteredTimestamp;
      if (t < this.smooth_interval && 0 === e) return void (this.applied = !1);
      var i;
      if (this.mFiltered === ft.kValueUndefined) i = e;else if (1 === t) i = this.mAlpha * this.mFiltered + (1 - this.mAlpha) * e;else {
        var _s5 = Math.pow(this.mAlpha, t);
        i = _s5 * this.mFiltered + (1 - _s5) * e;
      }
      isNaN(i) || (this.mFiltered = i), this.mMax !== ft.kValueUndefined && this.mFiltered > this.mMax && (this.mFiltered = this.mMax), this.mLastFilteredTimestamp = Date.now(), this.applied = !0;
    }
  }, {
    key: "Filtered",
    value: function Filtered() {
      return this.mFiltered;
    }
  }, {
    key: "LastFilteredTime",
    value: function LastFilteredTime() {
      return this.mLastFilteredTimestamp;
    }
  }, {
    key: "UpdateBase",
    value: function UpdateBase(e) {
      this.mAlpha = e;
    }
  }]);
  return ft;
}();
function kt() {
  var e = {};
  return function (t, i) {
    return t in e || (e[t] = new ft(i)), e[t];
  };
}
ft.kValueUndefined = -1, ft.AlphaForPacketLossFractionSmoother = .9999, ft.SMOOTH_VIDEO_INTERVAL = 1e3, ft.SMOOTH_AUDIO_INTERVAL = 5e3;
var vt = kt(),
  bt = kt(),
  Tt = function Tt() {
    return {
      id: "",
      kind: "audio",
      packetLossRate: 0,
      bitrate: 0,
      bytes: 0,
      packets: 0,
      packetLoss: 0,
      frameRate: 0,
      rtt: 0,
      timestamp: Date.now(),
      networkGrade: y.INVALID
    };
  };
function yt(e, t) {
  var i;
  i = e > 15 || t > 400 ? y.POOR : e > 8 || t > 200 ? y.FAIR : e > 1 || t > 100 ? y.GOOD : y.EXCELLENT;
  var s = navigator;
  return s.connection && s.connection.effectiveType && ["slow-2g", "2g", "3g"].includes(s.connection.effectiveType) && (i = y.POOR), i;
}
var Et = {
    track_audio_volume: 0,
    jitter_buffer_delay: 0,
    bytes_sent: 0,
    bytes_received: 0
  },
  St = {
    nack_count: 0,
    fir_count: 0,
    pli_count: 0,
    width: 0,
    height: 0,
    jitter_buffer_delay: 0,
    bytes_sent: 0,
    frame_encoded: 0,
    bytes_received: 0,
    frame_decoded: 0
  },
  It = {
    frames_received: 0,
    frames_sent: 0,
    packets_lost: 0,
    packets_received: 0,
    packets_sent: 0,
    timestamp: 0,
    bytes_sent: 0,
    bytes_received: 0
  };
var _t, wt, Rt;
function Dt(e, t) {
  return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var i, s, r;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return e.getStats();
        case 3:
          i = _context7.sent;
          _context7.next = 9;
          break;
        case 6:
          _context7.prev = 6;
          _context7.t0 = _context7["catch"](0);
          return _context7.abrupt("return", (m.debug("get media statistic stats error, fallback to default", _context7.t0), []));
        case 9:
          if (i) {
            _context7.next = 11;
            break;
          }
          return _context7.abrupt("return", (m.debug("get null media statistic stats, fallback to default"), []));
        case 11:
          s = _toConsumableArray(i.values()), r = s.filter(function (e) {
            return (e.type === wt.InBoundRtp || e.type === wt.OutBoundRtp) && (s.find(function (t) {
              return t.id === e.trackId && "track" === t.type;
            }) || s.find(function (t) {
              return t.id === e.mediaSourceId && "media-source" === t.type;
            }));
          }).map(function (e) {
            return function (e, t, i) {
              var s = _defineProperty(_defineProperty(_defineProperty({}, wt.MediaSource, t.filter(function (e) {
                return e.type === wt.MediaSource;
              }).find(function (t) {
                return t.id === e.mediaSourceId;
              })), wt.Track, t.filter(function (e) {
                return e.type === wt.Track;
              }).find(function (t) {
                return t.id === e.trackId;
              })), wt.RemoteInBound, t.filter(function (e) {
                return e.type === wt.RemoteInBound;
              }).find(function (t) {
                return t.id === e.remoteId;
              }));
              var r = function (e, t, i) {
                var s = {
                  id: e,
                  track_id: t,
                  kind: "audio",
                  kbps: 0,
                  framerate: 0,
                  packet_lost_rate: 0,
                  rtt: 0,
                  extra_stats: null,
                  calculation_stats: Object.assign({}, It)
                };
                return i === _t.Audio ? s.extra_stats = Object.assign({}, Et) : s.extra_stats = Object.assign({}, St), s;
              }(e.id, e.trackID, e.mediaType);
              r.rtt = Mt(s[wt.RemoteInBound]) || Mt(e) || 0, r.calculation_stats.packets_lost = Ot(e, s[wt.RemoteInBound]) || 0, e.mediaType === _t.Video ? (r = function (e, t) {
                return t.kind = e.kind, t.extra_stats.nack_count = e.nackCount, t.extra_stats.fir_count = e.firCount, t.extra_stats.pli_count = e.pliCount, t.extra_stats.bytes_sent = e.bytesSent || 0, t.extra_stats.frame_encoded = e.framesEncoded || 0, t.extra_stats.bytes_received = e.bytesReceived || 0, t.extra_stats.frame_decoded = e.framesDecoded || 0, t.calculation_stats.bytes_received = e.bytesReceived || 0, t.calculation_stats.bytes_sent = e.bytesSent || 0, t.calculation_stats.packets_received = e.packetsReceived || 0, t.calculation_stats.packets_sent = e.packetsSent || 0, t.calculation_stats.timestamp = e.timestamp || 0, t;
              }(e, r), s[wt.MediaSource] && (r = function (e, t) {
                return t.framerate = e.framesPerSecond, t;
              }(s[wt.MediaSource], r)), s[wt.Track] && (r = function (e, t, i) {
                var s = [].concat(_toConsumableArray(i.publishedTracks), _toConsumableArray(i.subscribedTracks)),
                  r = s.find(function (t) {
                    return t.mediaTrack.id === e.trackIdentifier;
                  });
                return t.track_id = r && r.info && r.info.trackID || "", t.extra_stats.width = e.frameWidth, t.extra_stats.height = e.frameHeight, t.extra_stats.jitter_buffer_delay = e.jitterBufferDelay || 0, t.calculation_stats.frames_sent = e.framesSent || 0, t.calculation_stats.frames_received = e.framesReceived || 0, t;
              }(s[wt.Track], r, i))) : (r = function (e, t) {
                return t.kind = e.kind, t.extra_stats.bytes_sent = e.bytesSent || 0, t.extra_stats.bytes_received = e.bytesReceived || 0, t.extra_stats.track_audio_volume = Ct(e.audioLevel, e.type), t.calculation_stats.bytes_received = e.bytesReceived || 0, t.calculation_stats.bytes_sent = e.bytesSent || 0, t.calculation_stats.packets_received = e.packetsReceived || 0, t.calculation_stats.packets_sent = e.packetsSent || 0, t.calculation_stats.timestamp = e.timestamp || 0, t;
              }(e, r), s[wt.MediaSource] && (r = function (e, t) {
                return t.extra_stats.track_audio_volume = Ct(e.audioLevel, e.type), t;
              }(s[wt.MediaSource], r)), s[wt.Track] && (r = function (e, t, i) {
                var s = [].concat(_toConsumableArray(i.publishedTracks), _toConsumableArray(i.subscribedTracks)),
                  r = s.find(function (t) {
                    return t.mediaTrack.id === e.trackIdentifier;
                  });
                return t.track_id = r && r.info && r.info.trackID || "", t.extra_stats.jitter_buffer_delay = e.jitterBufferDelay || 0, t.calculation_stats.frames_sent = e.framesSent || 0, t.calculation_stats.frames_received = e.framesReceived || 0, t;
              }(s[wt.Track], r, i)));
              return r;
            }(e, s, t);
          });
          return _context7.abrupt("return", r);
        case 13:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 6]]);
  }));
}
function Ct(e, t) {
  var i = e || 0;
  var s = {
    chrome: ["86.0.4240", "87.0.4280"]
  };
  return s[P.name] && s[P.name].includes(P.version) && t === wt.InBoundRtp ? (i = Math.min(e / 32767, 1), gt.create({
    code: pt.AudioLevelUnusual,
    actual_value: e,
    extra_info: {
      stats_report_type: t
    }
  })) : (i > 1 || i < 0) && gt.create({
    code: pt.AudioLevelUnusual,
    actual_value: e,
    extra_info: {
      stats_report_type: t
    }
  }), i;
}
function Mt(e) {
  if (e) return e.roundTripTime ? 1e3 * e.roundTripTime : e.googRtt ? e.googRtt : e.mozRtt ? e.mozRtt : void 0;
}
function Ot(e, t) {
  return "inbound-rtp" === e.type ? e.packetsLost : "outbound-rtp" === e.type && t ? t.packetsLost : void 0;
}
function Pt(e, t, i, s) {
  var r = t - e,
    o = s - i;
  if (r <= 0 || o <= 0) return 0;
  var n = r / o;
  return n > 1 ? 1 : n;
}
function qt() {
  var e = {
    bundlePolicy: "max-bundle",
    rtcpMuxPolicy: "require",
    iceServers: []
  };
  F.unifiedPlan ? e.sdpSemantics = "unified-plan" : e.sdpSemantics = "plan-b";
  var t = new RTCPeerConnection(e);
  return F.unifiedPlan && F.supportTransceivers && (t.addTransceiver("audio", {
    direction: "inactive"
  }), t.addTransceiver("video", {
    direction: "inactive"
  })), t;
}
function Lt(e, t, i) {
  var s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 600,
    r = arguments.length > 4 ? arguments[4] : void 0;
  return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var _o2;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          if (!i) {
            _context8.next = 5;
            break;
          }
          _o2 = [{
            rid: "hi",
            active: !0,
            maxBitrate: 1e3 * s
          }, {
            rid: "lo",
            active: !0,
            maxBitrate: 1e3 * i.bitrate,
            scaleResolutionDownBy: i.scaleResolutionDownBy
          }];
          _context8.next = 4;
          return t.addTransceiver(e, {
            direction: "sendonly",
            sendEncodings: _o2,
            streams: [r]
          });
        case 4:
          return _context8.abrupt("return", _context8.sent);
        case 5:
          _context8.next = 7;
          return t.addTransceiver(e, {
            direction: "sendonly",
            streams: [r]
          });
        case 7:
          return _context8.abrupt("return", _context8.sent);
        case 8:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
}
function xt(e, t, i, s) {
  return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var _r4;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          if (!F.stats) {
            _context10.next = 5;
            break;
          }
          _context10.next = 3;
          return function (e, t, i) {
            return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
              var s, r, _iterator3, _step3, _e6, _t10, _o3;
              return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                while (1) switch (_context9.prev = _context9.next) {
                  case 0:
                    _context9.prev = 0;
                    _context9.next = 3;
                    return e.getStats(t);
                  case 3:
                    s = _context9.sent;
                    _context9.next = 9;
                    break;
                  case 6:
                    _context9.prev = 6;
                    _context9.t0 = _context9["catch"](0);
                    return _context9.abrupt("return", (m.debug("get stats error, fallback to default", _context9.t0), []));
                  case 9:
                    if (s) {
                      _context9.next = 11;
                      break;
                    }
                    return _context9.abrupt("return", (m.debug("get null stats, fallback to default"), []));
                  case 11:
                    r = [];
                    _iterator3 = _createForOfIteratorHelper(s.values());
                    try {
                      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                        _e6 = _step3.value;
                        if ("send" === i && "outbound-rtp" === _e6.type && !_e6.isRemote || "recv" === i && "inbound-rtp" === _e6.type && !_e6.isRemote) {
                          _t10 = Tt(), _o3 = s.get(_e6.remoteId);
                          _t10.packetLoss = Ot(_e6, _o3) || 0, _t10.bytes = "send" === i ? _e6.bytesSent : _e6.bytesReceived, _t10.packets = "send" === i ? _e6.packetsSent : _e6.packetsReceived, _t10.rtt = Mt(_e6) || Mt(_o3) || 0, _t10.id = _e6.id, _t10.kind = _e6.kind, _e6.frameWidth && (_t10.width = _e6.frameWidth), _e6.frameHeight && (_t10.height = _e6.frameHeight), _e6.framesPerSecond && (_t10.frameRate = _e6.framesPerSecond), _e6.framerateMean && (_t10.frameRate = Math.ceil(_e6.framerateMean)), r.push(_t10);
                        }
                      }
                    } catch (err) {
                      _iterator3.e(err);
                    } finally {
                      _iterator3.f();
                    }
                    return _context9.abrupt("return", r);
                  case 15:
                  case "end":
                    return _context9.stop();
                }
              }, _callee9, null, [[0, 6]]);
            }));
          }(e, t, i);
        case 3:
          _r4 = _context10.sent;
          return _context10.abrupt("return", function (e, t) {
            if (!t || 0 === t.length) return e;
            if (t.length !== e.length) return e;
            var i = Object.values(a([].concat(_toConsumableArray(e), _toConsumableArray(t)), "id"));
            if (!i.every(function (e) {
              return 2 === e.length;
            })) return e;
            return i.map(function (e) {
              var _e7 = _slicedToArray(e, 2),
                t = _e7[0],
                i = _e7[1];
              var s = (t.timestamp - i.timestamp) / 1e3;
              if (s <= 0) return t;
              var r = Object.assign({}, t),
                o = Pt(i.packetLoss, t.packetLoss, i.packets, t.packets);
              r.networkGrade = yt(o, r.rtt);
              var n = vt(t.id, t.kind);
              return n.Apply(o), r.packetLossRate = n.Filtered() < 0 ? 0 : n.Filtered(), r.bitrate = 8 * (t.bytes - i.bytes) / s, r.bitrate < 0 ? i : r;
            });
          }(_r4, s));
        case 5:
          return _context10.abrupt("return", (At(function () {
            m.warning("your browser does not support getStats");
          }, "not-support-stats-warning"), []));
        case 6:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
}
!function (e) {
  e.Video = "video", e.Audio = "audio";
}(_t || (_t = {})), function (e) {
  e.MediaSource = "media-source", e.Track = "track", e.OutBoundRtp = "outbound-rtp", e.InBoundRtp = "inbound-rtp", e.RemoteInBound = "remote-inbound-rtp";
}(wt || (wt = {})), function (e) {
  e.In = "in", e.Out = "out";
}(Rt || (Rt = {})), window.addEventListener("message", function (e) {
  e.origin === window.location.origin && function (e) {
    if ("PermissionDeniedError" === e) {
      if (Ft = "PermissionDeniedError", jt) return jt("PermissionDeniedError");
      throw Oe();
    }
    "qnrtc:rtcmulticonnection-extension-loaded" === e && (Ft = "desktop");
    "rtcmulticonnection-extension-loaded" === e && (m.warning("your chrome screen sharing plugin is not the latest version, or you have other screen sharing plugins."), Ut = !1);
    e.sourceId && jt && jt(Nt = e.sourceId, !0 === e.canRequestAudioTrack);
  }(e.data);
});
var Nt,
  jt,
  Ft = "screen",
  Ut = !0;
function Vt() {
  return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return new Promise(function (e, t) {
            "desktop" !== Ft ? (window.postMessage("qnrtc:are-you-there", "*"), setTimeout(function () {
              e("screen" !== Ft);
            }, 2e3)) : e(!0);
          });
        case 2:
          return _context11.abrupt("return", _context11.sent);
        case 3:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
}
function Bt(e, t) {
  return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    var i;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          i = t.source;
          _context12.next = 3;
          return new Promise(function (s, r) {
            var o = {
              mozMediaSource: i || "window",
              mediaSource: i || "window",
              height: t.height,
              width: t.width
            };
            if (C) return void s(o);
            var n = {
              mandatory: {
                chromeMediaSource: Ft,
                maxWidth: ii(t.width),
                maxHeight: ii(t.height)
              },
              optional: []
            };
            "desktop" !== Ft ? s(n) : e ? function (e) {
              if (Nt) return e(Nt);
              jt = e, window.postMessage("qnrtc:audio-plus-tab", "*");
            }(function (e, t) {
              n.mandatory.chromeMediaSourceId = e, t && (n.canRequestAudioTrack = !0), "PermissionDeniedError" !== e ? s(n) : r(Oe());
            }) : function (e) {
              var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
              jt = e, arguments.length > 1 && void 0 !== arguments[1] && arguments[1] ? window.postMessage("qnrtc:get-sourceId-screen", "*") : t ? window.postMessage("qnrtc:get-sourceId-window", "*") : window.postMessage("qnrtc:get-sourceId", "*");
            }(function (e) {
              n.mandatory.chromeMediaSourceId = e, "PermissionDeniedError" !== e ? s(n) : r(Oe());
            }, "screen" === i, "window" === i);
          });
        case 3:
          return _context12.abrupt("return", _context12.sent);
        case 4:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
}
var Ht = /*#__PURE__*/function () {
  function Ht(e, t) {
    _classCallCheck(this, Ht);
    this.tracks = [], this.publishedTrackInfo = [], this.userID = e, this.userData = t;
  }
  _createClass(Ht, [{
    key: "addTracks",
    value: function addTracks(e) {
      var _this10 = this;
      this.tracks = this.tracks.concat(e), this.tracks = u(this.tracks, "mediaTrack");
      var _iterator4 = _createForOfIteratorHelper(this.tracks),
        _step4;
      try {
        var _loop = function _loop() {
          var e = _step4.value;
          e.once("release", function () {
            i(_this10.tracks, function (t) {
              return t === e;
            });
          });
        };
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "removeTracksByTrackId",
    value: function removeTracksByTrackId(e) {
      i(this.tracks, function (t) {
        return !!t.info.trackID && -1 !== e.indexOf(t.info.trackID);
      });
    }
  }, {
    key: "addPublishedTrackInfo",
    value: function addPublishedTrackInfo(e) {
      this.publishedTrackInfo = this.publishedTrackInfo.concat(e), this.publishedTrackInfo = u(this.publishedTrackInfo, "trackID");
    }
  }, {
    key: "removePublishedTrackInfo",
    value: function removePublishedTrackInfo(e) {
      i(this.publishedTrackInfo, function (t) {
        return -1 !== e.indexOf(t.trackID);
      });
    }
  }, {
    key: "published",
    get: function get() {
      return this.publishedTrackInfo.length > 0;
    }
  }]);
  return Ht;
}();
function Qt(e) {
  var t = document.createElement("audio"),
    i = new MediaStream([e]);
  return t.style.visibility = "hidden", t.className = "qnrtc-audio-player qnrtc-stream-player", t.dataset.localid = e.id, t.srcObject = i, t.autoplay = !0, {
    element: t,
    stream: i
  };
}
function Gt(e) {
  var t = document.createElement("video"),
    i = new MediaStream([e]);
  return t.style.width = "100%", t.style.height = "100%", t.style.objectFit = "contain", t.muted = !0, t.className = "qnrtc-video-player qnrtc-stream-player", t.dataset.localid = e.id, t.setAttribute("playsinline", !0), t.autoplay = !0, t.srcObject = i, O && (t.setAttribute("controls", !0), rt(function () {
    t && t.srcObject && t.removeAttribute("controls");
  })), {
    element: t,
    stream: i
  };
}
var Jt = /*#__PURE__*/function (_t11) {
  _inherits(Jt, _t11);
  function Jt() {
    _classCallCheck(this, Jt);
    return _possibleConstructorReturn(this, _getPrototypeOf(Jt).apply(this, arguments));
  }
  _createClass(Jt, [{
    key: "safeEmit",
    value: function safeEmit(e) {
      try {
        for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) i[s - 1] = arguments[s];
        this.emit.apply(this, [e].concat(i));
      } catch (t) {
        m.warning("safeEmit() | event listener threw an error [event:%s]:%o", e, t);
      }
    }
  }, {
    key: "safeEmitAsPromise",
    value: function safeEmitAsPromise(e) {
      var _this11 = this;
      for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) i[s - 1] = arguments[s];
      return new Promise(function (t, s) {
        var r = t;
        _this11.safeEmit.apply(_this11, [e].concat(i, [r, function (t) {
          m.warning("safeEmitAsPromise() | errback called [event:%s]:%o", e, t), s(t);
        }]));
      });
    }
  }]);
  return Jt;
}(t);
var Wt = /*#__PURE__*/function (_Jt) {
  _inherits(Wt, _Jt);
  _createClass(Wt, [{
    key: "setPlaybackDevice",
    value: function setPlaybackDevice(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!(F.setPlaybackDevice || be("setPlaybackDevice api not support"), this.playbackDevice = e, this.mediaElement)) {
                _context13.next = 2;
                break;
              }
              return _context13.abrupt("return", this.mediaElement.setSinkId(e));
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
    }
  }]);
  function Wt(e, t, i, s) {
    var _this12;
    _classCallCheck(this, Wt);
    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(Wt).call(this)), _this12.master = !1, _this12.stats = [], _this12.isReplacedByImageTrack = !1, _this12.direction = "local", _this12.sourceType = S.NORMAL, _this12.onended = function (e) {
      return g(_assertThisInitialized(_assertThisInitialized(_this12)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (!("local" === this.direction)) {
                _context14.next = 11;
                break;
              }
              m.warning("track ended", this.mediaTrack, this.info.trackID);
              _context14.t0 = this.info.trackID && this._selfEndedCallback;
              if (!_context14.t0) {
                _context14.next = 6;
                break;
              }
              _context14.next = 6;
              return this._selfEndedCallback([this.info.trackID]);
            case 6:
              this.emit("ended", e);
              me.addEvent("TrackEnded", {
                track_id: this.info.trackID,
                kind: this.info.kind,
                label: this.mediaTrack.label,
                event_grade: Ae.SERVERE
              });
              this.release();
              _context14.next = 12;
              break;
            case 11:
              this.emit("@ended", e);
            case 12:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
    }, _this12.mediaTrack = e, _this12.mediaTrack.addEventListener("ended", _this12.onended), _this12.userID = t, i && (_this12.direction = i), _this12.info = {
      kind: e.kind,
      muted: !e.enabled,
      userID: _this12.userID,
      versionid: 0,
      profiles: s || []
    }, _this12.handleMediaPause = _this12.handleMediaPause.bind(_assertThisInitialized(_assertThisInitialized(_this12)));
    return _this12;
  }
  _createClass(Wt, [{
    key: "play",
    value: function play(e, t) {
      var _this13 = this;
      var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
        mirror: !1
      };
      return new Promise(function (s, r) {
        _this13.removeMediaElement();
        var o = "video" === _this13.info.kind ? Gt : Qt,
          _o4 = o(_this13.mediaTrack),
          n = _o4.element,
          a = _o4.stream;
        _this13.mediaElement = n, "audio" === _this13.info.kind && void 0 !== t && (_this13.mediaElement.muted = t), i.mirror ? _this13.mediaElement.style.transform = "rotateY(180deg)" : _this13.mediaElement.style.transform = "", _this13.mediaElement.setAttribute("controls", !0), e.appendChild(_this13.mediaElement), _this13.mediaElement.onplaying = function () {
          _this13.mediaElement && (_this13.mediaElement.onplaying = null), s();
        }, Promise.resolve().then(function () {
          if (_this13.mediaElement.removeAttribute("controls"), _this13.playbackDevice) return _this13.setPlaybackDevice(_this13.playbackDevice);
        }).then(function () {
          (function (e) {
            var _this14 = this;
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 3e3;
            var i = function i() {
              return g(_this14, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
                return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                  while (1) switch (_context15.prev = _context15.next) {
                    case 0:
                      if (!(qs.deviceManager && qs.deviceManager.currentPlaybackDeviceID && e.setSinkId && e.setSinkId(qs.deviceManager.currentPlaybackDeviceID), e.paused)) {
                        _context15.next = 2;
                        break;
                      }
                      return _context15.abrupt("return", e.play());
                    case 2:
                    case "end":
                      return _context15.stop();
                  }
                }, _callee15);
              }));
            };
            return new Promise(function (s, r) {
              var o = setTimeout(function () {
                i().then(s).catch(r);
              }, t);
              e.onloadedmetadata = function () {
                clearTimeout(o), i().then(s).catch(r);
              }, "WeixinJSBridge" in window ? window.WeixinJSBridge.invoke("getNetworkType", {}, function () {
                i().then(s).catch(it);
              }, !1) : document.addEventListener("WeixinJSBridgeReady", function () {
                i().then(s).catch(it);
              }, !1);
            });
          })(_this13.mediaElement).then(s).catch(function (e) {
            var t = e instanceof Error ? e.name + ", " + e.message : "play failed" + String(e);
            "NotAllowedError" === e.name ? (r(Te(t)), me.addEvent("AutoplayFail", {
              track_id: _this13.info.trackID,
              local_id: _this13.mediaTrack.id,
              label: _this13.mediaTrack.label,
              kind: _this13.info.kind,
              reason: t,
              event_grade: Ae.SERVERE
            })) : r(ke(t));
          });
        });
      });
    }
  }, {
    key: "handleMediaPause",
    value: function handleMediaPause() {
      var _this15 = this;
      setTimeout(function () {
        return _this15.mediaElement.play().catch(dt);
      }, 900);
    }
  }, {
    key: "switchPlayingTrack",
    value: function switchPlayingTrack() {
      if (this.mediaElement) {
        if (this.isReplacedByImageTrack && this.imageStreamTrack) this.mediaElement.srcObject = new MediaStream([this.imageStreamTrack.mediaTrack]);else {
          if (this.isReplacedByImageTrack || !this.mediaTrack) return;
          this.mediaElement.srcObject = new MediaStream([this.mediaTrack]);
        }
        this.mediaElement.paused || this.mediaElement.play().catch(dt);
      }
    }
  }, {
    key: "resume",
    value: function resume(e) {
      if (this.mediaTrack.removeEventListener("ended", this.onended), this.mediaTrack.stop(), this.mediaTrack = e, this.mediaTrack.addEventListener("ended", this.onended), this.mediaElement) {
        var _t12 = new MediaStream([e]);
        this.mediaElement.dataset.localid = e.id, this.mediaElement.srcObject = _t12;
      }
      this.removeAllListeners("@get-stats"), this.resetStats();
    }
  }, {
    key: "getStats",
    value: function getStats() {
      return this.statsInterval || this.startGetStatsInterval(), this.stats;
    }
  }, {
    key: "getCurrentFrameDataURL",
    value: function getCurrentFrameDataURL() {
      return this.mediaElement && this.mediaElement instanceof HTMLVideoElement ? function (e) {
        var t = document.createElement("canvas");
        t.width = e.videoWidth, t.height = e.videoHeight;
        var i = t.getContext("2d");
        return i ? (i.drawImage(e, 0, 0, e.videoWidth, e.videoHeight), t.toDataURL()) : "data:,";
      }(this.mediaElement) : "data:,";
    }
  }, {
    key: "setMaster",
    value: function setMaster(e) {
      this.master = e;
    }
  }, {
    key: "setMute",
    value: function setMute(e) {
      this.info.muted = e, this.mediaTrack.enabled = !e, this.emit("mute", e);
    }
  }, {
    key: "setKbps",
    value: function setKbps(e) {
      this.info.kbps = e;
    }
  }, {
    key: "setInfo",
    value: function setInfo(e) {
      this.info = Object.assign(Object.assign({}, this.info), e);
    }
  }, {
    key: "removeMediaElement",
    value: function removeMediaElement() {
      this.mediaElement && (this.mediaElement.removeEventListener("pause", this.handleMediaPause), this.mediaElement.remove(), this.mediaElement = void 0);
    }
  }, {
    key: "release",
    value: function release() {
      this.emit("release"), this.removeAllListeners(), this.statsInterval && window.clearInterval(this.statsInterval), "local" !== this.direction && F.unifiedPlan || this.mediaTrack.stop(), this.removeMediaElement(), this.imageStreamTrack && (this.imageStreamTrack.release(), this.imageStreamTrack = void 0), this.remoteAudioHelper && (this.remoteAudioHelper.release(), this.remoteAudioHelper = void 0);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.info.trackID = void 0, this.info.userID = void 0, this.info.versionid = 0, this.userID = void 0, this.resetStats();
    }
  }, {
    key: "resetStats",
    value: function resetStats() {
      this.stats = [], this.lastStats = [];
    }
  }, {
    key: "startGetStatsInterval",
    value: function startGetStatsInterval() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _this16 = this;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              this.statsInterval = window.setInterval(function () {
                return g(_this16, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
                  var e;
                  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                    while (1) switch (_context16.prev = _context16.next) {
                      case 0:
                        e = this.listeners("@get-stats");
                        if (!(!e || 0 === e.length)) {
                          _context16.next = 3;
                          break;
                        }
                        return _context16.abrupt("return", []);
                      case 3:
                        _context16.next = 5;
                        return this.safeEmitAsPromise("@get-stats", this.lastStats);
                      case 5:
                        this.stats = _context16.sent;
                        this.lastStats = _toConsumableArray(this.stats);
                      case 7:
                      case "end":
                        return _context16.stop();
                    }
                  }, _callee16, this);
                }));
              }, 1e3);
            case 1:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "setVolume",
    value: function setVolume(e) {
      m.warning("not implement");
    }
  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      return m.warning("not implement"), new Uint8Array();
    }
  }, {
    key: "getCurrentFrequencyData",
    value: function getCurrentFrequencyData() {
      return m.warning("not implement"), new Uint8Array();
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return m.warning("not implement"), 0;
    }
  }, {
    key: "getCurrentVolumeLevel",
    value: function getCurrentVolumeLevel() {
      return m.warning("not implement"), 0;
    }
  }, {
    key: "setLoop",
    value: function setLoop(e) {
      m.warning("not implement");
    }
  }, {
    key: "startAudioSource",
    value: function startAudioSource() {
      m.warning("not implement");
    }
  }, {
    key: "pauseAudioSource",
    value: function pauseAudioSource() {
      m.warning("not implement");
    }
  }, {
    key: "resumeAudioSource",
    value: function resumeAudioSource() {
      m.warning("not implement");
    }
  }, {
    key: "stopAudioSource",
    value: function stopAudioSource() {
      m.warning("not implement");
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return m.warning("not implement"), 0;
    }
  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(e) {
      m.warning("not implement");
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return m.warning("not implement"), 0;
    }
  }, {
    key: "selfEndedCallback",
    set: function set(e) {
      this._selfEndedCallback = e;
    }
  }]);
  return Wt;
}(Jt);
function Kt(e) {
  return {
    timestamp: e.msgts,
    data: e.text,
    userID: e.playerid,
    type: e.type,
    msgid: e.msgid
  };
}
function zt(e) {
  return {
    trackID: e.trackid,
    tag: e.tag,
    mid: e.mid || void 0,
    kind: e.kind,
    userID: e.playerid,
    muted: e.muted,
    versionid: e.versionid,
    profiles: e.profiles || []
  };
}
function Yt(e, t) {
  return {
    trackid: e.trackID,
    mid: e.mid || void 0,
    kind: e.kind,
    master: t,
    muted: !!e.muted,
    playerid: e.userID,
    tag: e.tag || "",
    versionid: e.versionid
  };
}
function Zt(e) {
  if (!e.info.mid && F.unifiedPlan) throw ke("can not find track mid!");
  return {
    localid: e.mediaTrack.id,
    localmid: e.info.mid || void 0,
    master: e.master,
    kind: e.info.kind,
    kbps: e.info.kbps,
    tag: e.info.tag
  };
}
function Xt(e) {
  return new Ht(e.playerid, e.playerdata);
}
function $t(e, t, i) {
  var s;
  return "audio" === e.kind ? (s = new Ri(e), s.initAudioManager(!0)) : s = new Wt(e), i && s.setKbps(i), s.setInfo({
    tag: t
  }), s;
}
function ei(e) {
  switch (e) {
    case "window":
      return "application";
    case "screen":
      return ["window", "monitor"];
    default:
      return;
  }
}
var ti = function ti(e) {
  return function (e) {
    0 === Object.keys(e.audio).length && "boolean" != typeof e.audio && (e.audio = !0);
    0 === Object.keys(e.video).length && "boolean" != typeof e.video && (e.video = !0);
    return e;
  }(function (e) {
    if (F.minMaxWithIdeal) return e;
    return ["video", "screen"].forEach(function (t) {
      "object" == typeof e[t] && "object" == typeof e[t].width && e[t].width.ideal && delete e[t].width.ideal, "object" == typeof e[t] && "object" == typeof e[t].height && e[t].height.ideal && delete e[t].height.ideal;
    }), e;
  }(st(e)));
};
function ii(e) {
  if (e) return "number" == typeof e ? e : e.exact ? e.exact : e.max ? e.max : e.ideal ? e.ideal : e.min ? e.min : void 0;
}
var si = "qiniu-rtc-client";
function ri(e) {
  return e.map(function (e) {
    var t = {
      component: 1,
      foundation: e.foundation,
      ip: e.ip,
      port: e.port,
      priority: e.priority,
      transport: e.protocol,
      type: e.type
    };
    return e.tcpType && (t.tcptype = e.tcpType), t;
  });
}
var oi = /*#__PURE__*/function () {
  _createClass(oi, [{
    key: "transportRemoteParameters",
    get: function get() {
      return this._transportRemoteParameters;
    }
  }]);
  function oi(e, t) {
    _classCallCheck(this, oi);
    this.lastSubMids = [], this.sessionVersion = 0, this.direction = e, this.extendedRtpCapabilities = t;
  }
  _createClass(oi, [{
    key: "setTransportRemoteParameters",
    value: function setTransportRemoteParameters(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _iterator5, _step5, _t13;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _iterator5 = _createForOfIteratorHelper(e.iceCandidates);
              _context18.prev = 1;
              _iterator5.s();
            case 3:
              if ((_step5 = _iterator5.n()).done) {
                _context18.next = 10;
                break;
              }
              _t13 = _step5.value;
              _context18.next = 7;
              return mt(_t13.ip);
            case 7:
              _t13.ip = _context18.sent;
            case 8:
              _context18.next = 3;
              break;
            case 10:
              _context18.next = 15;
              break;
            case 12:
              _context18.prev = 12;
              _context18.t0 = _context18["catch"](1);
              _iterator5.e(_context18.t0);
            case 15:
              _context18.prev = 15;
              _iterator5.f();
              return _context18.finish(15);
            case 18:
              this._transportRemoteParameters = e;
            case 19:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this, [[1, 12, 15, 18]]);
      }));
    }
  }, {
    key: "createRemoteAnswer",
    value: function createRemoteAnswer(e, t, i) {
      if (m.log("create remote answer", t, i), !this.transportRemoteParameters) throw ke("no transportRemoteParameters!");
      return F.unifiedPlan ? function (e, t, i, s, r) {
        var o = h.parse(i),
          n = {
            version: 0
          };
        n.origin = {
          address: "0.0.0.0",
          ipVer: 4,
          netType: "IN",
          sessionId: "5975129998295344376",
          sessionVersion: 2,
          username: si
        }, n.name = "-", n.timing = {
          start: 0,
          stop: 0
        }, n.icelite = t.iceParameters.iceLite ? "ice-lite" : void 0, n.msidSemantic = {
          semantic: "WMS",
          token: "*"
        }, n.media = [], n.fingerprint = {
          type: t.dtlsParameters.fingerprints[0].algorithm,
          hash: t.dtlsParameters.fingerprints[0].value
        };
        var _iterator6 = _createForOfIteratorHelper(o.media),
          _step6;
        try {
          var _loop2 = function _loop2() {
            var i = _step6.value;
            var o = "inactive" === i.direction,
              a = i.type,
              c = "audio" === a ? e.codecs[0] : e.codecs[1],
              A = e.headerExtensions.filter(function (e) {
                return e.kind === a;
              });
            Os && A.push({
              uri: "urn:3gpp:video-orientation",
              sendId: 13
            });
            var d = {
              type: i.type,
              port: r && r.has(String(i.mid)) ? 0 : 7,
              protocol: "RTP/SAVPF",
              connection: {
                ip: "127.0.0.1",
                version: 4
              },
              mid: i.mid,
              iceUfrag: t.iceParameters.usernameFragment,
              icePwd: t.iceParameters.password,
              candidates: ri(t.iceCandidates),
              endOfCandidates: "end-of-candidates",
              iceOptions: "renomination",
              setup: "server" === t.dtlsParameters.role ? "actpass" : "active",
              direction: "sendonly" === i.direction || "sendrecv" === i.direction ? "recvonly" : "inactive",
              rtp: [{
                payload: c.sendPayloadType,
                codec: c.name,
                rate: c.clockRate,
                encoding: c.channels > 1 ? c.channels : void 0
              }],
              rtcpFb: [],
              fmtp: [{
                payload: c.sendPayloadType,
                config: Object.keys(c.parameters).map(function (e) {
                  return "".concat(e, "=").concat(c.parameters[e], ";");
                }).join("")
              }],
              payloads: c.sendPayloadType,
              rtcpMux: "rtcp-mux",
              rtcpRsize: "rtcp-rsize",
              ext: A.map(function (e) {
                return {
                  uri: e.uri,
                  value: e.sendId
                };
              })
            };
            c.rtcpFeedback && c.rtcpFeedback.length > 0 && c.rtcpFeedback.forEach(function (e) {
              d.rtcpFb.push({
                payload: c.sendPayloadType,
                type: e.type,
                subtype: e.parameter
              });
            }), c.sendRtxPayloadType && (d.rtp.push({
              payload: c.sendRtxPayloadType,
              codec: "rtx",
              rate: c.clockRate,
              encoding: c.channels > 1 ? c.channels : void 0
            }), d.fmtp.push({
              payload: c.sendRtxPayloadType,
              config: "apt=".concat(c.sendPayloadType, ";")
            }), d.payloads = "".concat(c.sendPayloadType, " ").concat(c.sendRtxPayloadType)), ai(a, d, e, c);
            var u = s[d.mid];
            "video" === d.type && u && !o && (d.rids = [{
              id: "hi",
              direction: "recv"
            }, {
              id: "lo",
              direction: "recv"
            }], d.simulcast = {
              dir1: "recv",
              list1: "hi;lo"
            }), n.media.push(d);
          };
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        var a = (o.media || []).filter(function (e) {
          return e.hasOwnProperty("mid") && 0 !== e.port;
        }).map(function (e) {
          return String(e.mid);
        });
        a.length > 0 && (n.groups = [{
          type: "BUNDLE",
          mids: a.join(" ")
        }]);
        return h.write(n);
      }(this.extendedRtpCapabilities, this.transportRemoteParameters, e, t, i) : function (e, t, i) {
        var s = h.parse(i);
        s.version = 0, s.origin = {
          address: "0.0.0.0",
          ipVer: 4,
          netType: "IN",
          sessionId: "5975129998295344376",
          sessionVersion: 2,
          username: si
        }, s.name = "-", s.timing = {
          start: 0,
          stop: 0
        }, s.icelite = t.iceParameters.iceLite ? "ice-lite" : void 0, s.msidSemantic = {
          semantic: "WMS",
          token: "*"
        }, s.fingerprint = {
          type: t.dtlsParameters.fingerprints[0].algorithm,
          hash: t.dtlsParameters.fingerprints[0].value
        };
        var r = [];
        var _iterator7 = _createForOfIteratorHelper(s.media),
          _step7;
        try {
          var _loop3 = function _loop3() {
            var i = _step7.value;
            var s = i.type,
              o = e.codecs.find(function (e) {
                return e.kind === s;
              }),
              n = (e.headerExtensions || []).filter(function (e) {
                return e.kind === s;
              });
            if (!o) throw ke("can not find codec" + s);
            var a = {
              type: s,
              mid: s,
              port: 7,
              protocol: "RTP/SAVPF",
              connection: {
                ip: "127.0.0.1",
                version: 4
              },
              iceUfrag: t.iceParameters.usernameFragment,
              icePwd: t.iceParameters.password,
              candidates: ri(t.iceCandidates),
              endOfCandidates: "end-of-candidates",
              iceOptions: "renomination",
              setup: "server" === t.dtlsParameters.role ? "actpass" : "active",
              direction: "recvonly",
              rtp: [{
                payload: o.sendPayloadType,
                codec: o.name,
                rate: o.clockRate,
                encoding: o.channels > 1 ? o.channels : void 0
              }],
              rtcpFb: [],
              fmtp: [{
                payload: o.sendPayloadType,
                config: Object.keys(o.parameters).map(function (e) {
                  return "".concat(e, "=").concat(o.parameters[e], ";");
                }).join("")
              }],
              payloads: o.sendPayloadType,
              rtcpMux: "rtcp-mux",
              rtcpRsize: "rtcp-rsize",
              ext: n.map(function (e) {
                return {
                  uri: e.uri,
                  value: e.sendId
                };
              })
            };
            o.rtcpFeedback && o.rtcpFeedback.length > 0 && o.rtcpFeedback.forEach(function (e) {
              a.rtcpFb.push({
                payload: o.sendPayloadType,
                type: e.type,
                subtype: e.parameter
              });
            }), o.sendRtxPayloadType && (a.rtp.push({
              payload: o.sendRtxPayloadType,
              codec: "rtx",
              rate: o.clockRate,
              encoding: o.channels > 1 ? o.channels : void 0
            }), a.fmtp.push({
              payload: o.sendRtxPayloadType,
              config: "apt=".concat(o.sendPayloadType, ";")
            }), a.payloads = "".concat(o.sendPayloadType, " ").concat(o.sendRtxPayloadType)), r.push(a);
          };
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            _loop3();
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
        return s.media = r, h.write(s);
      }(this.extendedRtpCapabilities, this.transportRemoteParameters, e);
    }
  }, {
    key: "createRemoteOffer",
    value: function createRemoteOffer(e) {
      if (!this.transportRemoteParameters) throw ke("no transportRemoteParameters!");
      if (F.unifiedPlan) {
        var _t14 = function (e, t) {
          var s = [];
          var _iterator8 = _createForOfIteratorHelper(t),
            _step8;
          try {
            var _loop4 = function _loop4() {
              var r = _step8.value;
              var t = i(e, function (e) {
                return e.mid === r;
              })[0];
              t && s.push(t);
            };
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              _loop4();
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
          return s = s.concat(e), t = s.map(function (e) {
            return e.mid;
          }), s;
        }(e, this.lastSubMids);
        return this.lastSubMids = _t14.map(function (e) {
          return e.mid;
        }), this.sessionVersion += 1, function (e, t, i, s) {
          m.debug("createUnifiedPlanOfferSdp: consumerInfos", e);
          var r = {},
            o = e.map(function (e) {
              return e.mid;
            });
          r.version = 0, r.origin = {
            address: "0.0.0.0",
            ipVer: 4,
            netType: "IN",
            sessionId: "5975129998295344377",
            sessionVersion: s,
            username: si
          }, r.name = "-", r.timing = {
            start: 0,
            stop: 0
          }, r.icelite = i.iceParameters.iceLite ? "ice-lite" : void 0, r.msidSemantic = {
            semantic: "WMS",
            token: "*"
          }, o.length > 0 && (r.groups = [{
            type: "BUNDLE",
            mids: o.join(" ")
          }]);
          r.media = [], r.fingerprint = {
            type: i.dtlsParameters.fingerprints[0].algorithm,
            hash: i.dtlsParameters.fingerprints[0].value
          };
          var _iterator9 = _createForOfIteratorHelper(e),
            _step9;
          try {
            var _loop5 = function _loop5() {
              var s = _step9.value;
              var e = "audio" === s.kind ? t.codecs[0] : t.codecs[1],
                o = t.headerExtensions.filter(function (e) {
                  return e.kind === s.kind;
                }),
                n = {
                  type: s.kind,
                  port: 7,
                  protocol: "RTP/SAVPF",
                  connection: {
                    ip: "127.0.0.1",
                    version: 4
                  },
                  mid: s.mid,
                  msid: "".concat(s.streamId, " ").concat(s.trackID),
                  iceUfrag: i.iceParameters.usernameFragment,
                  icePwd: i.iceParameters.password,
                  candidates: ri(i.iceCandidates),
                  endOfCandidates: "end-of-candidates",
                  iceOptions: "renomination",
                  setup: "server" === i.dtlsParameters.role ? "actpass" : "active",
                  direction: s.closed ? "inactive" : "sendonly",
                  rtp: [{
                    payload: e.recvPayloadType,
                    codec: e.name,
                    rate: e.clockRate,
                    encoding: e.channels > 1 ? e.channels : void 0
                  }],
                  rtcpFb: [],
                  fmtp: [{
                    payload: e.recvPayloadType,
                    config: Object.keys(e.parameters).map(function (t) {
                      return "".concat(t, "=").concat(e.parameters[t], ";");
                    }).join("")
                  }],
                  payloads: e.recvPayloadType,
                  rtcpMux: "rtcp-mux",
                  rtcpRsize: "rtcp-rsize",
                  ext: s.closed ? [] : o.map(function (e) {
                    return {
                      uri: e.uri,
                      value: e.recvId
                    };
                  }),
                  ssrcs: !s.closed && s.ssrc ? [{
                    id: s.ssrc,
                    attribute: "cname",
                    value: s.cname
                  }] : [],
                  ssrcGroups: []
                };
              e.rtcpFeedback && e.rtcpFeedback.length > 0 && e.rtcpFeedback.forEach(function (t) {
                n.rtcpFb.push({
                  payload: e.recvPayloadType,
                  type: t.type,
                  subtype: t.parameter
                });
              }), e.recvRtxPayloadType && (n.rtp.push({
                payload: e.recvRtxPayloadType,
                codec: "rtx",
                rate: e.clockRate,
                encoding: e.channels > 1 ? e.channels : void 0
              }), n.fmtp.push({
                payload: e.recvRtxPayloadType,
                config: "apt=".concat(e.recvPayloadType, ";")
              }), n.payloads = "".concat(e.recvPayloadType, " ").concat(e.recvRtxPayloadType)), ai(s.kind, n, t, e, !0), s.rtxSsrc && !s.closed && (n.ssrcs = n.ssrcs.concat([{
                id: s.rtxSsrc,
                attribute: "cname",
                value: s.cname
              }]), n.ssrcGroups.push({
                semantics: "FID",
                ssrcs: "".concat(s.ssrc, " ").concat(s.rtxSsrc)
              })), r.media.push(n);
            };
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              _loop5();
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
          return h.write(r);
        }(_t14, this.extendedRtpCapabilities, this.transportRemoteParameters, this.sessionVersion);
      }
      {
        var _t15 = new Set();
        return e.forEach(function (e) {
          return _t15.add(e.kind);
        }), 0 === e.length && (_t15.add("audio"), _t15.add("video")), function (e, t, i, s) {
          m.debug("createPlanBOfferSdp: consumerInfos", t, "kinds", e), e = ["audio", "video"];
          var r = {
            version: 0
          };
          r.origin = {
            address: "0.0.0.0",
            ipVer: 4,
            netType: "IN",
            sessionId: "5975129998295344377",
            sessionVersion: 2,
            username: si
          }, r.name = "-", r.timing = {
            start: 0,
            stop: 0
          }, r.icelite = s.iceParameters.iceLite ? "ice-lite" : void 0, r.msidSemantic = {
            semantic: "WMS",
            token: "*"
          }, r.groups = [{
            type: "BUNDLE",
            mids: e.join(" ")
          }], r.media = [], r.fingerprint = {
            type: s.dtlsParameters.fingerprints[0].algorithm,
            hash: s.dtlsParameters.fingerprints[0].value
          };
          var _iterator10 = _createForOfIteratorHelper(e),
            _step10;
          try {
            var _loop6 = function _loop6() {
              var o = _step10.value;
              var e = t.filter(function (e) {
                  return e.kind === o;
                }),
                n = i.codecs.find(function (e) {
                  return e.kind === o;
                }),
                a = (i.headerExtensions || []).filter(function (e) {
                  return e.kind === o;
                });
              if (!n) throw ke("no codec" + o);
              var c = {
                type: o,
                port: 7,
                protocol: "RTP/SAVPF",
                connection: {
                  ip: "127.0.0.1",
                  version: 4
                },
                mid: o,
                iceUfrag: s.iceParameters.usernameFragment,
                icePwd: s.iceParameters.password,
                candidates: ri(s.iceCandidates),
                endOfCandidates: "end-of-candidates",
                iceOptions: "renomination",
                setup: "server" === s.dtlsParameters.role ? "actpass" : "active",
                direction: "sendonly",
                rtp: [{
                  payload: n.recvPayloadType,
                  codec: n.name,
                  rate: n.clockRate,
                  encoding: n.channels > 1 ? n.channels : void 0
                }],
                rtcpFb: [],
                fmtp: [{
                  payload: n.recvPayloadType,
                  config: Object.keys(n.parameters).map(function (e) {
                    return "".concat(e, "=").concat(n.parameters[e], ";");
                  }).join("")
                }],
                payloads: n.recvPayloadType,
                rtcpMux: "rtcp-mux",
                rtcpRsize: "rtcp-rsize",
                ssrcs: [],
                ssrcGroups: [],
                ext: a.map(function (e) {
                  return {
                    uri: e.uri,
                    value: e.recvId
                  };
                })
              };
              n.rtcpFeedback && n.rtcpFeedback.length > 0 && n.rtcpFeedback.forEach(function (e) {
                c.rtcpFb.push({
                  payload: n.recvPayloadType,
                  type: e.type,
                  subtype: e.parameter
                });
              }), n.recvRtxPayloadType && (c.rtp.push({
                payload: n.recvRtxPayloadType,
                codec: "rtx",
                rate: n.clockRate,
                encoding: n.channels > 1 ? n.channels : void 0
              }), c.fmtp.push({
                payload: n.recvRtxPayloadType,
                config: "apt=".concat(n.recvPayloadType, ";")
              }), c.payloads = "".concat(n.recvPayloadType, " ").concat(n.recvRtxPayloadType));
              var _iterator11 = _createForOfIteratorHelper(e),
                _step11;
              try {
                for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                  var _t16 = _step11.value;
                  c.ssrcs.push({
                    id: _t16.ssrc,
                    attribute: "msid",
                    value: "".concat(_t16.streamId, " ").concat(_t16.trackID)
                  }), c.ssrcs.push({
                    id: _t16.ssrc,
                    attribute: "mslabel",
                    value: "".concat(_t16.streamId)
                  }), c.ssrcs.push({
                    id: _t16.ssrc,
                    attribute: "label",
                    value: "".concat(_t16.trackID)
                  }), c.ssrcs.push({
                    id: _t16.ssrc,
                    attribute: "cname",
                    value: "".concat(_t16.cname)
                  }), _t16.rtxSsrc && (c.ssrcGroups.push({
                    semantics: "FID",
                    ssrcs: "".concat(_t16.ssrc, " ").concat(_t16.rtxSsrc)
                  }), c.ssrcs.push({
                    id: _t16.rtxSsrc,
                    attribute: "msid",
                    value: "".concat(_t16.streamId, " ").concat(_t16.trackID)
                  }), c.ssrcs.push({
                    id: _t16.rtxSsrc,
                    attribute: "mslabel",
                    value: "".concat(_t16.streamId)
                  }), c.ssrcs.push({
                    id: _t16.rtxSsrc,
                    attribute: "label",
                    value: "".concat(_t16.trackID)
                  }), c.ssrcs.push({
                    id: _t16.rtxSsrc,
                    attribute: "cname",
                    value: "".concat(_t16.cname)
                  }));
                }
              } catch (err) {
                _iterator11.e(err);
              } finally {
                _iterator11.f();
              }
              r.media.push(c);
            };
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              _loop6();
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
          return h.write(r);
        }(Array.from(_t15), e, this.extendedRtpCapabilities, this.transportRemoteParameters);
      }
    }
  }, {
    key: "updateICEData",
    value: function updateICEData(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var _iterator12, _step12, _e8;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (!this.transportRemoteParameters) {
                _context19.next = 20;
                break;
              }
              _iterator12 = _createForOfIteratorHelper(t);
              _context19.prev = 2;
              _iterator12.s();
            case 4:
              if ((_step12 = _iterator12.n()).done) {
                _context19.next = 11;
                break;
              }
              _e8 = _step12.value;
              _context19.next = 8;
              return mt(_e8.ip);
            case 8:
              _e8.ip = _context19.sent;
            case 9:
              _context19.next = 4;
              break;
            case 11:
              _context19.next = 16;
              break;
            case 13:
              _context19.prev = 13;
              _context19.t0 = _context19["catch"](2);
              _iterator12.e(_context19.t0);
            case 16:
              _context19.prev = 16;
              _iterator12.f();
              return _context19.finish(16);
            case 19:
              this.transportRemoteParameters.iceCandidates = t, this.transportRemoteParameters.iceParameters = e;
            case 20:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this, [[2, 13, 16, 19]]);
      }));
    }
  }]);
  return oi;
}();
function ni(e) {
  return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
    var t;
    return _regeneratorRuntime().wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return e.createOffer({
            offerToReceiveAudio: !0,
            offerToReceiveVideo: !0
          });
        case 2:
          t = _context20.sent;
          return _context20.abrupt("return", t.sdp ? {
            isH264: -1 !== t.sdp.toLowerCase().indexOf("h264"),
            sdp: t.sdp
          } : {
            isH264: !1,
            sdp: ""
          });
        case 4:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
}
function ai(e, t, i, s) {
  var r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
  var o = i.codecs.filter(function (t) {
    return t.kind === e && t.name !== s.name;
  });
  if (o.length > 0) {
    var _e9 = r ? s.recvPayloadType : s.sendPayloadType;
    var _i9 = [];
    o.forEach(function (s) {
      var o = r ? s.recvPayloadType : s.sendPayloadType;
      _i9.push(o), t.rtp.push({
        payload: o,
        codec: s.name,
        rate: s.clockRate,
        encoding: s.channels > 1 ? s.channels : void 0
      }), t.fmtp.push({
        payload: o,
        config: "".concat(_e9, "/").concat(_e9)
      });
    }), t.payloads = "".concat(t.payloads, " ").concat(_i9.join(" "));
  }
}
function ci(e) {
  var t = h.parse(e);
  if (!("media" in t)) return h.write(t);
  if (!Array.isArray(t.media)) return h.write(t);
  var _iterator13 = _createForOfIteratorHelper(t.media),
    _step13;
  try {
    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
      var _e10 = _step13.value;
      "ext" in _e10 && Array.isArray(_e10.ext) && "video" === _e10.type && (_e10.ext = _e10.ext.filter(function (e) {
        return "urn:3gpp:video-orientation" !== e.uri;
      }));
    }
  } catch (err) {
    _iterator13.e(err);
  } finally {
    _iterator13.f();
  }
  return h.write(t);
}
function Ai(e, t, i) {
  return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
    var s, r, o, n, a, c, _e11, _t17, _i10;
    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          s = 0, r = !1;
          o = e.appId, n = e.roomName, a = e.userId, c = "/v3/apps/".concat(o, "/rooms/").concat(n, "/auth?user=").concat(a, "&token=").concat(t);
        case 2:
          _e11 = {
            auth_start_time: Date.now(),
            auth_dns_time: 0,
            auth_server_ip: "",
            room_token: t,
            auth_url: c
          };
          _context21.prev = 3;
          _context21.next = 6;
          return lt(c, i);
        case 6:
          _t17 = _context21.sent;
          return _context21.abrupt("return", (s++, me.addEvent("MCSAuth", Object.assign(Object.assign({}, _e11), {
            auth_take_time: Date.now() - _e11.auth_start_time,
            auth_error_code: 0,
            auth_error_message: "",
            access_token: _t17.accessToken,
            event_grade: Ae.NORMAL,
            event_category: de.CORE,
            auth_network_code: 0,
            fire_times: s,
            auth_reason: r ? "reconnect" : "connect"
          })), _t17));
        case 10:
          _context21.prev = 10;
          _context21.t0 = _context21["catch"](3);
          _i10 = _context21.t0;
          if (!(r = !0, s++, me.addEvent("MCSAuth", Object.assign(Object.assign({}, _e11), {
            auth_take_time: Date.now() - _e11.auth_start_time,
            auth_error_code: void 0 === _i10.retry ? -1 : Number(_i10.message),
            auth_error_message: void 0 === _i10.retry ? _i10.toString() : _i10.message,
            access_token: "",
            event_grade: Ae.SERVERE,
            event_category: de.CORE,
            auth_network_code: void 0 === _i10.retry ? _i10.networkCode || -2 : 0,
            fire_times: s,
            auth_reason: r ? "reconnect" : "connect"
          })), !1 === _i10.retry)) {
            _context21.next = 15;
            break;
          }
          throw ve(_i10.message);
        case 15:
          _context21.next = 17;
          return at(1e3);
        case 17:
          m.warning("can not get accessToken, retry.", ve(_i10));
        case 18:
          _context21.next = 2;
          break;
        case 20:
        case "end":
          return _context21.stop();
      }
    }, _callee21, null, [[3, 10]]);
  }));
}
function di(e, t, i) {
  return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
    var s, r, o, n, _e12, _t18, _i11;
    return _regeneratorRuntime().wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          s = e.appId, r = e.roomName, o = e.userId, n = "/v3/apps/".concat(s, "/rooms/").concat(r, "/relay/token?user=").concat(o, "&token=").concat(t);
        case 1:
          _e12 = {
            auth_start_time: Date.now(),
            auth_dns_time: 0,
            auth_server_ip: "",
            room_token: t
          };
          _context22.prev = 2;
          _context22.next = 5;
          return lt(n, i);
        case 5:
          _t18 = _context22.sent;
          if (!(void 0 === _t18)) {
            _context22.next = 8;
            break;
          }
          throw Ye();
        case 8:
          return _context22.abrupt("return", (me.addEvent("MCURelayAuth", Object.assign(Object.assign({}, _e12), {
            auth_take_time: Date.now() - _e12.auth_start_time,
            auth_error_code: 0,
            auth_error_message: "",
            access_token: _t18.relayToken || "no relay token",
            auth_network_code: 0
          })), _t18));
        case 11:
          _context22.prev = 11;
          _context22.t0 = _context22["catch"](2);
          _i11 = _context22.t0;
          if (!(me.addEvent("MCURelayAuth", Object.assign(Object.assign({}, _e12), {
            auth_take_time: Date.now() - _e12.auth_start_time,
            auth_error_code: void 0 === _i11.retry ? -1 : Number(_i11.message),
            auth_error_message: void 0 === _i11.retry ? _i11.toString() : _i11.message,
            access_token: "",
            auth_network_code: _i11.networkCode || 0
          })), !_i11.retry)) {
            _context22.next = 16;
            break;
          }
          throw we(_i11.message);
        case 16:
          _context22.next = 18;
          return at(1e3);
        case 18:
          m.warning("can not get relayToken, retry.", we(_i11));
        case 19:
          _context22.next = 1;
          break;
        case 21:
        case "end":
          return _context22.stop();
      }
    }, _callee22, null, [[2, 11]]);
  }));
}
var ui;
!function (e) {
  e[e.CONNECTING = 0] = "CONNECTING", e[e.OPEN = 1] = "OPEN", e[e.CLOSING = 2] = "CLOSING", e[e.CLOSED = 3] = "CLOSED";
}(ui || (ui = {}));
var hi = Xe.JOIN_ROOM_ERROR,
  li = Xe.ERROR_RECONNECT_FAILED;
var mi = /*#__PURE__*/function (_Jt2) {
  _inherits(mi, _Jt2);
  _createClass(mi, [{
    key: "setUrl",
    value: function setUrl(e) {
      this.url = e + "?rpcid=".concat(this.rpcid);
    }
  }, {
    key: "_state",
    set: function set(e) {
      this.emit("@ws-state-change", this.__state, e), this.__state = e;
    }
  }, {
    key: "state",
    get: function get() {
      return this.__state;
    }
  }, {
    key: "reconnectTimes",
    set: function set(e) {
      this._reconnectTimes = e, this.currentLeftReconnectTimes = e;
    },
    get: function get() {
      return this._reconnectTimes;
    }
  }, {
    key: "requestTimeout",
    set: function set(e) {
      this.wsConnectTimeout = e;
    }
  }]);
  function mi(e, t, i, s, r) {
    var _this17;
    _classCallCheck(this, mi);
    var o;
    var n = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : ["subscribe", "publish"];
    _this17 = _possibleConstructorReturn(this, _getPrototypeOf(mi).call(this)), o = _assertThisInitialized(_assertThisInitialized(_this17)), _this17.privileges = [], _this17.rpcid = nt(16), _this17.startInitTime = -1, _this17.startAuthTime = 0, _this17.initWs = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
        t = arguments.length > 1 ? arguments[1] : void 0,
        i = arguments.length > 2 ? arguments[2] : void 0;
      return new Promise(function (s, r) {
        if (o.ws && o.ws.readyState === WebSocket.OPEN && (o.ws.close(), o.ws.onclose = null), e) o.ws = t, o.setUrl(i);else {
          o.startInitTime = Date.now();
          try {
            o.wsConnectTimeoutID = setTimeout(function () {
              o.ws && (o.ws.onopen = null, o.ws.onclose = null, o.ws.onerror = null, o.ws.close());
              var t = o.wsConnectTimeout / 1e3 + "s timeout";
              me.addEvent("WebsocketConnect", {
                happy_dns_resolve_time: 0,
                happy_dns_take_effect: !1,
                socket_node_info: o.url,
                socket_connect_time: Date.now() - o.startInitTime,
                socket_connect_success: !1,
                socket_connect_error_message: t,
                event_grade: Ae.SERVERE,
                event_category: de.CORE,
                dns_resolve_time: 0,
                dns_take_effect: !1,
                dns_resolved_ip: "",
                socket_connect_reason: e ? "connect" : "reconnect"
              }), o.startInitTime = -1, o.reconnect(o.wsConnectTimeout).catch(function (e) {
                m.warning("signaling: reconnect timeout error", e);
              });
            }, o.wsConnectTimeout), o.ws = new WebSocket(o.url), o._state = ui.CONNECTING;
          } catch (e) {
            throw ke("init signaling websocket faild!\nError: ".concat(e));
          }
        }
        o.ws.onerror = o.onWsError, o.ws.onclose = o.onWsClose.bind(o, s, r);
        var n = function n() {
          o.wsConnectTimeoutID && clearTimeout(o.wsConnectTimeoutID), o.emit("ws:onopen"), m.log("signaling: websocket open", o.url), e || (me.addEvent("WebsocketConnect", {
            happy_dns_resolve_time: 0,
            happy_dns_take_effect: !1,
            socket_node_info: o.url,
            socket_connect_time: Date.now() - o.startInitTime,
            socket_connect_success: !0,
            event_grade: Ae.NORMAL,
            event_category: de.CORE,
            dns_resolve_time: 0,
            dns_take_effect: !1,
            dns_resolved_ip: "",
            socket_connect_reason: e ? "connect" : "reconnect"
          }), o.startInitTime = -1), o.ws.onmessage = o.onWsMsg;
          var t = {
            token: o.accessToken,
            reconntoken: o.reconnectToken,
            agent: "".concat(P.name).concat(P.version),
            sdkversion: D,
            capsdp: o.capsdp,
            msgsn: o.customMsgNumber,
            supportdomain: !0,
            privileges: o.privileges
          };
          o.playerdata && (t.playerdata = o.playerdata), o.startAuthTime = Date.now(), o.request("auth", t).then(function (t) {
            switch (0 !== t.code && (me.addEvent("SignalAuth", {
              auth_start_time: o.startAuthTime,
              auth_dns_time: 0,
              auth_server_ip: o.url,
              auth_error_code: t.code,
              auth_error_message: t.error,
              auth_take_time: Date.now() - o.startAuthTime,
              access_token: o.accessToken,
              event_grade: Ae.SERVERE,
              event_category: de.CORE,
              auth_server_info: i,
              auth_reason: e ? "connect" : "reconnect"
            }), o.startAuthTime = 0), t.code) {
              case 0:
                o.ws.onclose = o.onWsClose.bind(o, null, null), o.reconnectToken = t.reconntoken, m.log("signaling: websocket authed"), o._state = ui.OPEN, me.addEvent("SignalAuth", {
                  auth_start_time: o.startAuthTime,
                  auth_dns_time: 0,
                  auth_server_ip: o.url,
                  auth_error_code: 0,
                  auth_error_message: "",
                  auth_take_time: Date.now() - o.startAuthTime,
                  access_token: o.accessToken,
                  event_grade: Ae.NORMAL,
                  event_category: de.CORE,
                  auth_server_info: i,
                  auth_reason: e ? "connect" : "reconnect"
                }), o.emit("@signalingauth", t), o.startAuthTime = 0, s(t);
                break;
              case 10001:
              case 10002:
              case 10011:
              case 10022:
              case 10012:
              case 10004:
                o.emit("@error", t), r(li(t.error));
                break;
              case 10005:
                o.emit("@error", t), r(li(t.error));
              case 10052:
                if (m.debug("10052 auth, retry", e), o.reconnectToken = void 0, e) {
                  r(hi(t.code, t.error));
                  break;
                }
                return void o.emit("@error", t);
              case 10054:
                r(Je(10054, t.error));
                break;
              default:
                r(ke(t.error));
            }
            0 !== t.code && (o.reconnectToken = void 0, o._state = ui.CLOSED, o.release());
          });
        };
        o.ws.onopen = function () {
          n();
        }, e && n();
      });
    }, _this17.onWsMsg = function (e) {
      var t = e.data;
      _this17.emit("ws:onmessage", t);
      var i = t.indexOf("=");
      if (!(i > 0)) throw ke("signaling model can not parse message: ".concat(t));
      {
        var _e13 = t.substring(0, i),
          _s7 = JSON.parse(t.substring(i + 1)),
          _r5 = _s7.rpcid,
          _o5 = _s7.pcid,
          _n3 = _s7.code,
          _a = _s7.error,
          _c = p(_s7, ["rpcid", "pcid", "code", "error"]),
          _A = {
            cmd_type: _e13,
            rpcid: _r5,
            pcid: _o5,
            code: _n3,
            error: _a,
            raw: JSON.stringify(_c)
          };
        "ping" !== _e13 && "send-message-res" !== _e13 && "send-qos-message-res" !== _e13 && (/res$/.test(_e13) ? me.addEvent("SignalFired", Object.assign({
          kind: "receive"
        }, _A)) : me.addEvent("SignalFired", Object.assign({
          kind: "notify"
        }, _A))), _this17.receiveWsMsg(_e13, _s7);
      }
    }, _this17.onWsError = function (e) {
      _this17.wsConnectTimeoutID && clearTimeout(_this17.wsConnectTimeoutID), m.warning("signaling: websocket error", e), _this17.emit("@ws:error", e), -1 !== _this17.startInitTime && (me.addEvent("WebsocketConnect", {
        happy_dns_resolve_time: 0,
        happy_dns_take_effect: !1,
        socket_node_info: _this17.url,
        socket_connect_time: Date.now() - _this17.startInitTime,
        socket_connect_success: !1,
        event_grade: Ae.SERVERE,
        event_category: de.CORE,
        dns_resolve_time: 0,
        dns_take_effect: !1,
        dns_resolved_ip: "",
        socket_connect_reason: ""
      }), _this17.startInitTime = -1);
    }, _this17.sendWsMsg = function (e, t) {
      var i = t.rpcid,
        s = p(t, ["rpcid"]);
      if ("pong" !== e && "send-qos-message" !== e && "send-message" !== e && me.addEvent("SignalFired", {
        kind: "send",
        cmd_type: e,
        rpcid: i,
        raw: JSON.stringify(s)
      }), _this17.ws.readyState !== WebSocket.OPEN) throw Ce();
      var r = JSON.stringify(t);
      try {
        _this17.ws.send("".concat(e, "=").concat(r)), _this17.emit("send", e, t);
      } catch (e) {
        throw m.warning("signaling: websocket send error", e), _this17.reconnect().catch(function (e) {
          m.warning("signaling: reconnect error", e);
        }), Ce();
      }
    }, _this17.handlePing = function () {
      _this17.sendWsMsg("pong", {}), _this17.reconnectTimeoutID && clearTimeout(_this17.reconnectTimeoutID), _this17.reconnectTimeoutID = setTimeout(function () {
        m.debug("signaling: websocket heartbeat timeout"), _this17.reconnect().catch(function (e) {
          m.warning("signaling: reconnect error", e);
        });
      }, 9e3);
    }, _this17.receiveWsMsg = function (e, t) {
      switch (_this17.emit("receive", e, t), e) {
        case "ping":
          _this17.handlePing();
          break;
        case "auth-res":
          _this17.emit("@auth-res", t);
        case "pubpc-res":
        case "subpc-res":
        case "pub-tracks":
        case "webrtc-candidate":
        case "on-player-in":
        case "on-player-out":
        case "disconnect":
        case "mute-tracks":
        case "on-add-tracks":
        case "on-remove-tracks":
        case "on-player-reconnect":
        case "on-player-reconnect-in":
        case "on-command":
          _this17.emit(e, t);
          break;
        case "sub-res":
        case "unsub-res":
          _this17.emit(e, t), _this17.emit("".concat(e, "-").concat(t.streamid), t);
          break;
        case "control-res":
          _this17.emit(e, t), _this17.emit("".concat(e, "-").concat(t.command, "-").concat(t.playerid), t);
          break;
        case "on-pubpc-connected":
        case "on-pubpc-disconnected":
          _this17.emit("on-pubpc-state", {
            pcid: t.pcid,
            connected: "on-pubpc-connected" === e
          }), _this17.emit("".concat(e, "-").concat(t.pcid), t);
          break;
        case "on-subpc-disconnected":
        case "on-subpc-connected":
          _this17.emit("on-subpc-state", {
            pcid: t.pcid,
            connected: "on-subpc-connected" === e
          }), _this17.emit(e, t);
          break;
        case "pub-tracks-res":
          _this17.emit(e, t);
          break;
        case "on-messages":
        case "on-qos-messages":
          t.messages = t.messages.sort(function (e, t) {
            return e.msgsn - t.msgsn;
          }), _this17.customMsgNumber = t.messages[t.messages.length - 1].msgsn, _this17.emit(e, t);
          break;
        case "unpub-tracks-res":
        case "sub-tracks-res":
        case "unsub-tracks-res":
        case "on-pubpc-restart-notify":
        case "on-subpc-restart-notify":
        case "set-sub-profile-res":
        case "on-sub-profile-changed":
        case "pubpc-restart-res":
        case "subpc-restart-res":
        case "create-merge-job-res":
        case "create-forward-job-res":
        case "stop-forward-res":
        case "on-job-connected":
        case "on-job-disconnected":
        case "on-merge-job-connected":
        case "on-merge-job-disconnected":
        case "update-merge-tracks-res":
        case "set-privileges-res":
        case "start-media-relay-res":
        case "update-media-relay-res":
        case "stop-media-relay-res":
        case "on-media-relay-state":
          _this17.emit(e, t);
      }
    }, _this17.accessToken = e, _this17.capsdp = t, _this17.reconnectTimes = i, _this17.wsConnectTimeout = s, _this17.playerdata = r, _this17.privileges = n, _this17._state = ui.CONNECTING;
    return _this17;
  }
  _createClass(mi, [{
    key: "onWsClose",
    value: function onWsClose(e, t, i) {
      this.wsConnectTimeoutID && clearTimeout(this.wsConnectTimeoutID), this._state = ui.CLOSED, m.warning("signaling: websocket onclose", i), this.startAuthTime && me.addEvent("SignalAuth", {
        auth_start_time: this.startAuthTime,
        auth_dns_time: 0,
        auth_server_ip: this.url,
        auth_error_code: i.code,
        auth_error_message: i.toString(),
        auth_take_time: Date.now() - this.startAuthTime,
        access_token: this.accessToken,
        event_grade: Ae.NORMAL,
        event_category: de.CORE,
        auth_server_info: this.url,
        auth_reason: "connect"
      });
      var s = this.reconnectPromise;
      switch (i.code) {
        case 1e3:
          this.emit("@closed");
          break;
        case 1001:
        case 1005:
        case 1011:
        case 1013:
          s = this.reconnect();
          break;
        case 1006:
          s = this.reconnect(this.wsConnectTimeout);
          break;
        case 1007:
        case 1008:
        case 1009:
        case 1010:
          break;
        case 1012:
        case 1014:
          s = this.reconnect(5e3);
      }
      e && t && (s ? s.then(e).catch(function (e) {
        m.warning("signaling: reconnect error", e);
      }) : t(i));
    }
  }, {
    key: "sendDisconnect",
    value: function sendDisconnect() {
      if (this.state === ui.OPEN) try {
        this.sendWsMsg("disconnect", {});
      } catch (e) {}
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      var _this18 = this;
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1e3;
      return this.reconnectTimeoutID && clearTimeout(this.reconnectTimeoutID), this.wsConnectTimeoutID && clearTimeout(this.wsConnectTimeoutID), this.reconnectPromise && this._state === ui.CONNECTING ? this.reconnectPromise : this.currentLeftReconnectTimes <= 0 ? (this.emit("@error", {
        code: 10007
      }), Promise.reject("websocket reconnectTimes run out, reconnect stops.")) : (this.currentLeftReconnectTimes -= 1, this._state = ui.CONNECTING, m.debug("signaling: websocket reconnecting, currentLeftReconnectTimes remaining: ", this.currentLeftReconnectTimes), this.reconnectPromise = at(e).then(function () {
        return _this18.initWs();
      }).then(function (e) {
        return _this18.reconnectPromise = void 0, _this18.currentLeftReconnectTimes = _this18.reconnectTimes, e;
      }).catch(function (e) {
        return _this18._state = ui.CLOSED, _this18.emit("error", e), Promise.reject(e);
      }), this.reconnectPromise);
    }
  }, {
    key: "request",
    value: function request(e, t) {
      var _this19 = this;
      var i = nt(8);
      return t.rpcid = i, m.log("ws request", i, e, t), this.sendWsMsg(e, t), new Promise(function (t) {
        var s = function s(r) {
          r.rpcid === i && (m.log("ws response", i, e, r), _this19.off("".concat(e, "-res"), s), t(r));
        };
        _this19.on("".concat(e, "-res"), s);
      });
    }
  }, {
    key: "release",
    value: function release() {
      this.reconnectTimeoutID && clearTimeout(this.reconnectTimeoutID), this.wsConnectTimeoutID && clearTimeout(this.wsConnectTimeoutID), this.removeAllListeners(), this.ws && (this.ws.onopen = null, this.ws.onclose = null, this.ws.onerror = null, this.ws.close());
    }
  }]);
  return mi;
}(Jt);
var pi = function pi() {
  _classCallCheck(this, pi);
};
var gi = /*#__PURE__*/function () {
  function gi(e, t, i, s) {
    var _this20 = this;
    _classCallCheck(this, gi);
    this.videoTrackInfo = [], this.audioTrackInfo = [], this.layoutLevel = 0, this.width = e, this.height = t, this.jobID = s, this.controller = i, this.controller.getCurrentTracks().forEach(function (e) {
      "audio" === e.kind ? _this20.audioTrackInfo.push(e) : _this20.videoTrackInfo.push(e);
    }), this.controller.addMergeTrack(this.audioTrackInfo.map(function (e) {
      return {
        trackID: e.trackID
      };
    }), this.jobID), this.initLayout(), this.controller.onAddTracks = function (e) {
      var t = e.filter(function (e) {
          return "audio" === e.kind;
        }),
        i = e.filter(function (e) {
          return "video" === e.kind;
        });
      _this20.controller.addMergeTrack(t.map(function (e) {
        return {
          trackID: e.trackID
        };
      }), _this20.jobID), i.forEach(_this20.handleAddVideoTrack.bind(_this20));
    }, this.controller.onRemoveTracks = function (e) {
      e.filter(function (e) {
        return "video" === e.kind;
      }).forEach(_this20.handleRemoveVideoTrack.bind(_this20));
    }, m.log("init default merger, init layout: ", this.layout);
  }
  _createClass(gi, [{
    key: "initLayout",
    value: function initLayout() {
      var e = this.videoTrackInfo.length;
      this.layoutLevel = 0, this.layout = {
        "level-0": {
          items: {
            "item-0": {
              x: 0,
              y: 0,
              isExpand: !1,
              isExpanded: !1,
              index: 0
            }
          },
          itemWidth: this.width,
          itemHeight: this.height,
          maxItems: 1,
          currentItems: 0,
          splitWidthFlag: this.width < this.height
        }
      };
      var t = this.width >= this.height;
      if (0 !== e) {
        for (; Math.pow(2, this.layoutLevel) < e;) this.updateLayoutLevel(t), t = !t;
        this.setLevelLayoutStream();
      }
    }
  }, {
    key: "updateLayoutLevel",
    value: function updateLayoutLevel(e) {
      var _this21 = this;
      var t = this.layout["level-".concat(this.layoutLevel)],
        i = t.itemWidth,
        s = t.itemHeight;
      this.layoutLevel += 1;
      var r = Math.pow(2, this.layoutLevel),
        o = e ? i / 2 : i,
        n = e ? s : s / 2;
      if (1 === this.layoutLevel) this.layout["level-".concat(this.layoutLevel)] = {
        items: {
          "item-0": {
            x: 0,
            y: 0,
            isExpand: !1,
            isExpanded: !1,
            index: 0
          },
          "item-1": {
            x: this.width >= this.height ? o : 0,
            y: this.width < this.height ? n : 0,
            isExpand: !1,
            isExpanded: !1,
            index: 1
          }
        },
        maxItems: r,
        currentItems: 0,
        itemWidth: o,
        itemHeight: n,
        splitWidthFlag: e
      };else {
        this.layout["level-".concat(this.layoutLevel)] = {
          items: {},
          maxItems: r,
          currentItems: 0,
          itemWidth: o,
          itemHeight: n,
          splitWidthFlag: e
        };
        var _t19 = this.layout["level-".concat(this.layoutLevel)].items;
        Object.keys(this.layout["level-".concat(this.layoutLevel - 1)].items).forEach(function (i) {
          var s = _this21.layout["level-".concat(_this21.layoutLevel - 1)].items[i],
            r = 2 * s.index;
          _t19["item-".concat(r)] = {
            x: s.x,
            y: s.y,
            isExpand: !1,
            isExpanded: !1,
            index: r
          }, _t19["item-".concat(r + 1)] = e ? {
            x: s.x + o,
            y: s.y,
            isExpand: !1,
            isExpanded: !1,
            index: r + 1
          } : {
            x: s.x,
            y: s.y + n,
            isExpand: !1,
            isExpanded: !1,
            index: r + 1
          };
        });
      }
      m.log("merger: increase layout level, current level: ".concat(this.layoutLevel), this.layout);
    }
  }, {
    key: "setLevelLayoutStream",
    value: function setLevelLayoutStream() {
      var e = this.videoTrackInfo.length,
        t = this.layout["level-".concat(this.layoutLevel)];
      var i = t.maxItems - e,
        s = 0;
      for (var _e14 = 0; _e14 < t.maxItems; _e14 += 1) i > 0 ? _e14 % 2 == 0 ? (t.items["item-".concat(_e14)].isExpand = !0, t.items["item-".concat(_e14)].trackID = this.videoTrackInfo[s].trackID, this.sendMergeOpt(this.layoutLevel, _e14), s += 1) : (t.items["item-".concat(_e14)].isExpanded = !0, i -= 1) : (t.items["item-".concat(_e14)].trackID = this.videoTrackInfo[s].trackID, this.sendMergeOpt(this.layoutLevel, _e14), s += 1);
      t.currentItems = e;
    }
  }, {
    key: "sendMergeOpt",
    value: function sendMergeOpt(e, t) {
      var i = this.layout["level-".concat(e)],
        s = i.items["item-".concat(t)];
      if (!s.trackID || s.isExpanded) return;
      var r = i.itemWidth,
        o = i.itemHeight;
      s.isExpand && (i.splitWidthFlag ? r *= 2 : o *= 2);
      var n = {
        x: s.x,
        y: s.y,
        w: r,
        h: o,
        z: 0,
        trackID: s.trackID
      };
      this.controller.addMergeTrack([n], this.jobID);
    }
  }, {
    key: "handleRemoveVideoTrack",
    value: function handleRemoveVideoTrack(e) {
      i(this.videoTrackInfo, function (t) {
        return t.trackID === e.trackID;
      });
      var t = this.layout["level-".concat(this.layoutLevel)];
      if (this.layoutLevel > 0 && this.videoTrackInfo.length <= this.layout["level-".concat(this.layoutLevel - 1)].maxItems) this.layoutLevel -= 1, m.log("merger: reduce layout level, current level: ".concat(this.layoutLevel), this.layout), this.setLevelLayoutStream();else for (var _i12 in t.items) {
        var _s8 = t.items[_i12];
        if (_s8.trackID === e.trackID) {
          _s8.index % 2 == 0 ? (t.items["item-".concat(_s8.index + 1)] ? (_s8.isExpand = !0, _s8.trackID = t.items["item-".concat(_s8.index + 1)].trackID, t.items["item-".concat(_s8.index + 1)].isExpanded = !0, t.items["item-".concat(_s8.index + 1)].trackID = void 0) : _s8.trackID = void 0, this.sendMergeOpt(this.layoutLevel, _s8.index)) : (_s8.isExpanded = !0, _s8.trackID = void 0, t.items["item-".concat(_s8.index - 1)].isExpand = !0, this.sendMergeOpt(this.layoutLevel, _s8.index - 1));
          break;
        }
      }
    }
  }, {
    key: "handleAddVideoTrack",
    value: function handleAddVideoTrack(e) {
      var t = this.videoTrackInfo.length;
      if (this.videoTrackInfo.push(e), this.videoTrackInfo = u(this.videoTrackInfo, "trackID"), this.videoTrackInfo.length === t) return void m.log("handle add video track ignore", e);
      var i = this.layout["level-".concat(this.layoutLevel)];
      if (this.videoTrackInfo.length <= i.maxItems) {
        for (var _t20 in i.items) {
          var _s9 = i.items[_t20];
          if (!_s9.trackID) {
            _s9.trackID = e.trackID, _s9.isExpanded && (_s9.isExpanded = !1, i.items["item-".concat(_s9.index - 1)].isExpand = !1, this.sendMergeOpt(this.layoutLevel, _s9.index - 1)), this.sendMergeOpt(this.layoutLevel, _s9.index);
            break;
          }
        }
        i.currentItems = this.videoTrackInfo.length;
      } else this.updateLayoutLevel(!i.splitWidthFlag), this.setLevelLayoutStream();
    }
  }, {
    key: "release",
    value: function release() {
      this.controller.release();
    }
  }]);
  return gi;
}();
var fi = /*#__PURE__*/function () {
  function fi() {
    _classCallCheck(this, fi);
  }
  _createClass(fi, null, [{
    key: "loadImage",
    value: function loadImage(e) {
      if (e instanceof File) return fi.loadImageFromFile(e);
      if (e instanceof ArrayBuffer) return fi.loadImageFromArrayBuffer(e);
      if ("string" == typeof e) return fi.loadImageFromUrl(e);
      throw be("unsupported image source");
    }
  }, {
    key: "loadImageFromUrl",
    value: function loadImageFromUrl(e) {
      return new Promise(function (t, i) {
        var s = new Image();
        s.crossOrigin = "Anonymous", s.src = e, s.onload = function () {
          t(s);
        }, s.onerror = function (e) {
          i(e);
        };
      });
    }
  }, {
    key: "loadImageFromFile",
    value: function loadImageFromFile(e) {
      return new Promise(function (t, i) {
        var s = new FileReader();
        s.onload = function (e) {
          s.result && t(fi.loadImageFromUrl(s.result));
        }, s.onerror = function (e) {
          i(e);
        }, s.readAsDataURL(e);
      });
    }
  }, {
    key: "loadImageFromArrayBuffer",
    value: function loadImageFromArrayBuffer(e) {
      return new Promise(function (t, i) {
        var s = new Blob([e]),
          r = URL.createObjectURL(s);
        t(fi.loadImageFromUrl(r));
      });
    }
  }]);
  return fi;
}();
var ki = /*#__PURE__*/function () {
  function ki() {
    _classCallCheck(this, ki);
    this.canvas = document.createElement("canvas"), this.ctx = this.canvas.getContext("2d");
  }
  _createClass(ki, [{
    key: "setSource",
    value: function setSource(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.t0 = e !== this.source;
              if (!_context23.t0) {
                _context23.next = 5;
                break;
              }
              this.source = e;
              _context23.next = 5;
              return this.createImageStreamTrack(e);
            case 5:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
    }
  }, {
    key: "createImageStreamTrack",
    value: function createImageStreamTrack(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var _this22 = this;
        var t, i;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              if (!(e instanceof File)) {
                _context24.next = 6;
                break;
              }
              _context24.next = 3;
              return fi.loadImageFromFile(e);
            case 3:
              _context24.t0 = _context24.sent;
              _context24.next = 16;
              break;
            case 6:
              if (!(e instanceof ArrayBuffer)) {
                _context24.next = 12;
                break;
              }
              _context24.next = 9;
              return fi.loadImageFromArrayBuffer(e);
            case 9:
              _context24.t1 = _context24.sent;
              _context24.next = 15;
              break;
            case 12:
              _context24.next = 14;
              return fi.loadImageFromUrl(e);
            case 14:
              _context24.t1 = _context24.sent;
            case 15:
              _context24.t0 = _context24.t1;
            case 16:
              t = _context24.t0;
              this.canvas.width = t.width;
              this.canvas.height = t.height;
              this.drawIntervalId && clearInterval(this.drawIntervalId);
              this.drawIntervalId = setInterval(function () {
                _this22.ctx.drawImage(t, 0, 0);
              }, 900);
              i = this.canvas.captureStream(1);
              this.mediaTrack = i.getTracks()[0];
            case 23:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
    }
  }, {
    key: "release",
    value: function release() {
      this.drawIntervalId && clearInterval(this.drawIntervalId);
    }
  }, {
    key: "id",
    get: function get() {
      if (this.mediaTrack) return this.mediaTrack.id;
    }
  }]);
  return ki;
}();
var vi = function vi(e, t, i, s) {
  _classCallCheck(this, vi);
  this.id = e, this.mid = t, this.kind = i, this.rtpParameters = s, this.track = null;
};
var bi = /*#__PURE__*/function () {
  function bi(e, t, i, s, r) {
    _classCallCheck(this, bi);
    this._connectStatus = E.Idle, this.track = i, this.trackID = s, this.mid = r, this.transport = e, this.direction = t;
  }
  _createClass(bi, [{
    key: "startConnect",
    value: function startConnect() {
      var _this23 = this;
      return this.connectStatus = E.Connecting, new Promise(function (e, t) {
        _this23.onConnectStatusChange = function (i, s) {
          s === E.Connect && e(), s === E.Idle && t();
        };
      });
    }
  }, {
    key: "appendConsumner",
    value: function appendConsumner(e, t) {
      this.consumer = new vi(this.trackID, this.mid, t, e), this.transport.appendConsumer(this.consumer);
    }
  }, {
    key: "setMute",
    value: function setMute(e) {
      this.track && this.track.setMute(e);
    }
  }, {
    key: "addTrackId",
    value: function addTrackId(e) {
      this.track && (this.trackID = e, this.track.setInfo({
        trackID: e
      }));
    }
  }, {
    key: "release",
    value: function release() {
      this.consumer && this.transport ? (this.transport.recvHandler.isPcReady && this.transport.removeConsumers([this.consumer]), this.track && this.track.release()) : this.track && this.track.reset();
    }
  }, {
    key: "connectStatus",
    get: function get() {
      return this._connectStatus;
    },
    set: function set(e) {
      var _this24 = this;
      if (e !== this._connectStatus) {
        var t = this._connectStatus;
        this._connectStatus = e, rt(function () {
          _this24.onConnectStatusChange && _this24.onConnectStatusChange(t, _this24._connectStatus);
        });
      }
    }
  }]);
  return bi;
}();
var Ti = "data:text/javascript;base64," + btoa("\nclass AudioBufferProcessor extends AudioWorkletProcessor {\n  constructor(...args) {\n    super(...args);\n    this.signal = true;\n    this.port.onmessage = (e) => {\n      this.signal = false;\n    };\n  }\n  process (inputs, outputs, parameters) {\n    inputs.length && inputs[0].length && this.port.postMessage(inputs[0][0]);\n    return this.signal;\n  }\n}\nregisterProcessor('audio-buffer-processor', AudioBufferProcessor);\n"),
  yi = window.AudioContext || window.webkitAudioContext || window.Object,
  Ei = F.audioContextOptions ? new yi({
    latencyHint: "interactive"
  }) : new yi();
if (window.audioContext = Ei, window.Promise) {
  var Fs = function Fs() {
    var e;
    (e = Ei, new Promise(function (t, i) {
      if ("suspended" === e.state) {
        m.log("audio context state is suspended");
        var _s10 = function _s10() {
          e.resume().then(function () {
            document.body.removeEventListener("touchstart", _s10), document.body.removeEventListener("touchend", _s10), document.body.removeEventListener("mousedown", _s10), document.body.removeEventListener("mouseup", _s10), t(!0);
          }).catch(i);
        };
        document.body.addEventListener("touchstart", _s10, !0), document.body.addEventListener("touchend", _s10, !0), document.body.addEventListener("mousedown", _s10, !0), document.body.addEventListener("mouseup", _s10, !0), _s10();
      } else t(!1);
    })).then(function (e) {
      m.debug("web audio context unlocked", e);
    }).catch(function (e) {
      m.warning("can not unlock web audio context", e);
    }), window.removeEventListener("load", Fs);
  };
  document.body ? Fs() : window.addEventListener("load", Fs), Ei.onstatechange = function () {
    Fs();
  };
}
var Si = 4096,
  Ii = Ei.sampleRate,
  _i = ["play", "playing", "pause", "ended", "waiting", "seeking"];
var wi = /*#__PURE__*/function (_Jt3) {
  _inherits(wi, _Jt3);
  _createClass(wi, [{
    key: "audioSourceState",
    get: function get() {
      return this._audioSourceState;
    },
    set: function set(e) {
      e !== this._audioSourceState && (this.emit("@audio-source-state-change", e, this._audioSourceState), this._audioSourceState = e);
    }
  }]);
  function wi() {
    var _this25;
    _classCallCheck(this, wi);
    _this25 = _possibleConstructorReturn(this, _getPrototypeOf(wi).call(this)), _this25.audioSource = null, _this25.sampleList = new Float32Array(), _this25.isScriptNodeAvailable = "createScriptProcessor" in Ei, _this25._audioSourceState = w.IDLE, _this25.bufferSourceDuration = {
      startTime: 0,
      pauseTime: 0,
      lastPauseTime: 0,
      offsetTime: 0,
      stopTime: 0
    }, _this25.handleMediaElementEvents = function (e) {
      switch (e.type) {
        case "playing":
        case "play":
          _this25.audioSourceState = w.PLAY;
          break;
        case "waiting":
        case "seeking":
          _this25.audioSourceState = w.LOADING;
          break;
        case "ended":
          _this25.audioSourceElement && (_this25.audioSourceElement.currentTime = 0), _this25.audioSourceState = w.END;
      }
    };
    return _this25;
  }
  _createClass(wi, [{
    key: "initAudioContext",
    value: function initAudioContext() {
      m.log("init audio context", Ei.state), "suspended" === Ei.state && (m.log("audio context suspended"), Ei.resume().catch(function (e) {
        m.warning("resume audiocontext failed! see: http://s.qnsdk.com/s/Txsdz", e);
      })), m.log("init audio finish", Ei.state), this.analyserNode = Ei.createAnalyser(), this.analyserNode.fftSize = 2048, this.gainNode = Ei.createGain(), function (e) {
        if (F.disconnectAudioNode) return;
        var t = e.connect,
          s = e.disconnect;
        e.connect = function (i, s, r) {
          return e._inputNodes || (e._inputNodes = []), i instanceof AudioNode ? (e._inputNodes.push(i), e._inputNodes = u(e._inputNodes, function (e) {
            return e;
          }), t.call(e, i, s, r)) : t.call(e, i, s), e;
        }, e.disconnect = function (t, r, o) {
          if (!t) return s.call(e), void (e._inputNodes = []);
          s.call(e, t, r, o), i(e._inputNodes, function (e) {
            return e === t;
          });
          var _iterator14 = _createForOfIteratorHelper(e._inputNodes),
            _step14;
          try {
            for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
              var _t21 = _step14.value;
              e.connect(_t21);
            }
          } catch (err) {
            _iterator14.e(err);
          } finally {
            _iterator14.f();
          }
        };
      }(this.gainNode), F.mediaStreamDest && (this.audioStream = Ei.createMediaStreamDestination());
    }
  }, {
    key: "setMediaStreamSource",
    value: function setMediaStreamSource(e) {
      this.audioSource = Ei.createMediaStreamSource(e), this.connect();
    }
  }, {
    key: "setAudioBufferSource",
    value: function setAudioBufferSource() {
      var _this26 = this;
      this.audioSource = Ei.createBufferSource(), this.audioSource.onended = function () {
        _this26.audioSource.onended = null, _this26.audioSource.stop(), _this26.audioSource.disconnect(), _this26.audioSource = null, _this26.bufferSourceDuration.stopTime = Ei.currentTime, _this26.audioSourceState = w.END;
      }, this.connect();
    }
  }, {
    key: "setMediaElementSource",
    value: function setMediaElementSource(e) {
      this.audioSource = Ei.createMediaElementSource(e), this.audioSourceElement = e;
      for (var _i14 = 0, _i13 = _i; _i14 < _i13.length; _i14++) {
        var _e15 = _i13[_i14];
        this.audioSourceElement.addEventListener(_e15, this.handleMediaElementEvents);
      }
      this.connect();
    }
  }, {
    key: "setAudioSourceLoop",
    value: function setAudioSourceLoop(e) {
      this.audioSourceLoop = e, this.isAudioSource() ? this.audioSource.loop = !!e : this.audioSourceElement && (this.audioSourceElement.loop = !!e);
    }
  }, {
    key: "setAudioBuffer",
    value: function setAudioBuffer(e) {
      this.isAudioSource() && (this.audioSource.buffer = e, this.audioSourceBuffer = e);
    }
  }, {
    key: "playAudioSource",
    value: function playAudioSource() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      if (this.isAudioSource()) {
        this.resetBufferSourceDuration();
        try {
          this.audioSource.start(0, e), this.bufferSourceDuration.startTime = Ei.currentTime, this.bufferSourceDuration.offsetTime = e, this.audioSourceState = w.PLAY;
        } catch (t) {
          this.stopAudioSource(), this.playAudioSource(e);
        }
      } else this.audioSourceElement ? (this.audioSourceElement.currentTime = 0, this.audioSourceElement.play().catch(dt)) : null === this.audioSource && this.audioSourceBuffer && (this.resetBufferSourceDuration(), this.setAudioBufferSource(), this.setAudioBuffer(this.audioSourceBuffer), this.setAudioSourceLoop(!!this.audioSourceLoop), this.audioSource.start(0, e), this.bufferSourceDuration.startTime = Ei.currentTime, this.bufferSourceDuration.offsetTime = e, this.audioSourceState = w.PLAY);
    }
  }, {
    key: "resumeAudioSource",
    value: function resumeAudioSource() {
      if (this.isAudioSource()) {
        if (this.audioSourceState !== w.PAUSE) return;
        this.audioSource.playbackRate.value = 1, this.bufferSourceDuration.pauseTime += Ei.currentTime - this.bufferSourceDuration.lastPauseTime, this.bufferSourceDuration.lastPauseTime = 0, this.audioSourceState = w.PLAY;
      } else this.audioSourceElement && this.audioSourceElement.play().catch(dt);
    }
  }, {
    key: "pauseAudioSource",
    value: function pauseAudioSource() {
      this.isAudioSource() ? (this.audioSource.playbackRate.value = C ? 1e-7 : Number.MIN_VALUE, this.bufferSourceDuration.lastPauseTime || (this.bufferSourceDuration.lastPauseTime = Ei.currentTime), this.audioSourceState = w.PAUSE) : this.audioSourceElement && (this.audioSourceElement.pause(), this.audioSourceState !== w.END && (this.audioSourceState = w.PAUSE));
    }
  }, {
    key: "stopAudioSource",
    value: function stopAudioSource() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
        t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      this.isAudioSource() ? (this.audioSource.onended = null, this.audioSource.stop(), this.audioSource.disconnect(), this.audioSource = null, this.bufferSourceDuration.stopTime = Ei.currentTime, e || !1 !== t || (this.audioSourceState = w.STOP)) : this.audioSourceElement && (!1 === t && (this.audioSourceState = w.STOP), this.audioSourceElement.pause(), this.audioSourceElement.currentTime = 0);
    }
  }, {
    key: "getAudioSourceCurrentTime",
    value: function getAudioSourceCurrentTime() {
      if (this.audioSourceElement) return this.audioSourceElement.currentTime;
      if (this.isAudioSource()) {
        var _e16 = Ei.currentTime;
        var t = this.getAudioSourceDuration();
        this.bufferSourceDuration.lastPauseTime && (_e16 = this.bufferSourceDuration.lastPauseTime), this.bufferSourceDuration.stopTime && (_e16 = this.bufferSourceDuration.stopTime);
        var _i15 = this.bufferSourceDuration.offsetTime + _e16 - this.bufferSourceDuration.startTime - this.bufferSourceDuration.pauseTime;
        return Math.max(0, _i15 % t);
      }
      return 0;
    }
  }, {
    key: "setAudioSourceCurrentTime",
    value: function setAudioSourceCurrentTime(e) {
      this.audioSourceElement ? this.audioSourceElement.currentTime = e : this.isAudioSource() && (this.stopAudioSource(!0), this.playAudioSource(e));
    }
  }, {
    key: "getAudioSourceDuration",
    value: function getAudioSourceDuration() {
      return this.audioSourceElement ? this.audioSourceElement.duration : this.audioSourceBuffer ? this.audioSourceBuffer.duration : 0;
    }
  }, {
    key: "release",
    value: function release(e) {
      if (e && this.audioSource instanceof MediaStreamAudioSourceNode && this.audioSource.mediaStream && this.audioSource.mediaStream.getTracks().map(function (e) {
        return e.stop();
      }), this.audioSource && this.audioSource.disconnect(), this.gainNode.disconnect(), this.audioSourceElement) {
        for (var _i17 = 0, _i16 = _i; _i17 < _i16.length; _i17++) {
          var _e17 = _i16[_i17];
          this.audioSourceElement.removeEventListener(_e17, this.handleMediaElementEvents);
        }
        this.audioSourceElement.src = "", this.audioSourceElement.load(), this.audioSourceElement.remove(), this.audioSourceElement = void 0;
      }
      this.scriptNode && this.scriptNode.disconnect(), this.audioWorkletNode && (this.sampleList = new Float32Array(), this.audioWorkletNode.port.postMessage("close"), this.audioWorkletNode.disconnect());
    }
  }, {
    key: "connect",
    value: function connect() {
      this.audioSource ? (this.audioSource.connect(this.analyserNode), this.audioSource.connect(this.gainNode), this.audioStream && (this.gainNode.connect(this.audioStream), this.onAudioBuffer())) : m.warning("no audio source, can not connect");
    }
  }, {
    key: "handleAudioBuffer",
    value: function handleAudioBuffer(e) {
      var t = e.inputBuffer;
      this.emit("audioBuffer", t), this.audioBufferCallback && this.audioBufferCallback(t);
    }
  }, {
    key: "handleAudioProcressBuffer",
    value: function handleAudioProcressBuffer(e) {
      var t = new Float32Array(e.data.length);
      for (var _i18 = 0; _i18 < e.data.length; _i18++) t[_i18] = e.data[_i18];
      var i = this.sampleList;
      if (this.sampleList = new Float32Array(i.length + t.length), this.sampleList.set(i), this.sampleList.set(t, i.length), this.sampleList.length === Si) {
        var _e18 = Ei.createBuffer(2, Si, Ii);
        for (var _t22 = 0; _t22 < 2; _t22++) {
          var _i19 = _e18.getChannelData(_t22);
          for (var _e19 = 0; _e19 < _i19.length; _e19++) _i19[_e19] = this.sampleList[_e19];
        }
        this.emit("audioBuffer", _e18), this.audioBufferCallback && this.audioBufferCallback(_e18), this.sampleList = new Float32Array();
      }
    }
  }, {
    key: "onAudioBuffer",
    value: function onAudioBuffer(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Si;
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              this.audioBufferCallback = e;
              this.audioBufferSize = t;
              _context25.t0 = this.audioStream && this.audioSource;
              if (!_context25.t0) {
                _context25.next = 16;
                break;
              }
              if (!this.isScriptNodeAvailable) {
                _context25.next = 8;
                break;
              }
              this.scriptNode || (this.scriptNode = Ei.createScriptProcessor(t), this.audioSource.connect(this.scriptNode), this.scriptNode.connect(this.audioStream), this.scriptNode.onaudioprocess = this.handleAudioBuffer.bind(this));
              _context25.next = 16;
              break;
            case 8:
              _context25.t1 = this.audioWorkletNode;
              if (_context25.t1) {
                _context25.next = 16;
                break;
              }
              _context25.next = 12;
              return Ei.audioWorklet.addModule(Ti);
            case 12:
              this.audioWorkletNode = new AudioWorkletNode(Ei, "audio-buffer-processor");
              this.audioSource.connect(this.audioWorkletNode);
              this.audioWorkletNode.connect(this.audioStream);
              this.audioWorkletNode.port.onmessage = this.handleAudioProcressBuffer.bind(this);
            case 16:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
    }
  }, {
    key: "resetBufferSourceDuration",
    value: function resetBufferSourceDuration() {
      this.bufferSourceDuration = {
        offsetTime: 0,
        startTime: 0,
        lastPauseTime: 0,
        pauseTime: 0,
        stopTime: 0
      };
    }
  }, {
    key: "isAudioSource",
    value: function isAudioSource() {
      var e = this.audioSource;
      return e instanceof AudioBufferSourceNode || e instanceof AudioScheduledSourceNode;
    }
  }]);
  return wi;
}(Jt);
var Ri = /*#__PURE__*/function (_Wt) {
  _inherits(Ri, _Wt);
  function Ri(e, t, i) {
    var _this27;
    _classCallCheck(this, Ri);
    if ("audio" !== e.kind) throw new Error("audio track only!");
    _this27 = _possibleConstructorReturn(this, _getPrototypeOf(Ri).call(this, e, t, i)), _this27.mediaStream = new MediaStream(), _this27.mediaStream.addTrack(e);
    return _this27;
  }
  _createClass(Ri, [{
    key: "resume",
    value: function resume(e) {
      this.mediaTrack = e, this.removeAllListeners("@get-stats"), this.resetStats();
      var t = new MediaStream([e]);
      this.mediaStream = t, this.mediaElement && (this.mediaElement.dataset.localid = e.id, this.mediaElement.srcObject = t), this.audioManager && (this.audioManager.release("local" === this.direction), this.initAudioManager());
    }
  }, {
    key: "initAudioManager",
    value: function initAudioManager(e) {
      var _this28 = this;
      this.audioManager = new wi(), this.audioManager.initAudioContext(), this.audioManager.setMediaStreamSource(this.mediaStream), this.audioManager.on("audioBuffer", function (e) {
        _this28.emit("audioBuffer", e);
      }), e && F.mediaStreamDest && (this.mediaStream = this.audioManager.audioStream.stream, this.mediaTrack = this.mediaStream.getTracks()[0]);
    }
  }, {
    key: "setVolume",
    value: function setVolume(e) {
      e < 0 || e > 100 ? m.warning("available volume value is between 0 to 100 , current ".concat(e, " is unavailable")) : "local" != this.direction ? this.mediaElement && (this.mediaElement.volume = e) : this.audioManager.gainNode.gain.setValueAtTime(e, Ei.currentTime);
    }
  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      var e = new Uint8Array(2048);
      return this.audioManager.analyserNode.getByteTimeDomainData(e), e;
    }
  }, {
    key: "getCurrentFrequencyData",
    value: function getCurrentFrequencyData() {
      var e = new Uint8Array(this.audioManager.analyserNode.frequencyBinCount);
      return this.audioManager.analyserNode.getByteFrequencyData(e), e;
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.audioManager.gainNode.gain.value;
    }
  }, {
    key: "getCurrentVolumeLevel",
    value: function getCurrentVolumeLevel() {
      var e = this.getCurrentFrequencyData();
      var t = 0,
        i = e.length;
      return e.forEach(function (s, r) {
        var o = r * (Ei.sampleRate || 44100) / e.length;
        if (o > 22050) return void (i -= 1);
        var n = function (e) {
          var t = e * e;
          return 187374169.94399998 * t * t / ((t + 424.36) * Math.sqrt((t + 11599.29) * (t + 544496.41)) * (t + 14884e4));
        }(o) * s / 255;
        n <= 0 ? i -= 1 : t += n * n;
      }), 0 === i ? 0 : Math.sqrt(t / i);
    }
  }, {
    key: "release",
    value: function release() {
      this.emit("release"), this.removeAllListeners(), this.statsInterval && window.clearInterval(this.statsInterval), this.audioManager && this.audioManager.release("local" === this.direction), this.removeMediaElement();
    }
  }]);
  return Ri;
}(Wt);
var Di = /*#__PURE__*/function (_Jt4) {
  _inherits(Di, _Jt4);
  function Di(e, t, i) {
    var _this29;
    _classCallCheck(this, Di);
    _this29 = _possibleConstructorReturn(this, _getPrototypeOf(Di).call(this)), _this29._isRestartingICE = !1, _this29.isPcReady = !1, _this29.midRidEncoding = {}, _this29.removeMids = new Set(), _this29.lastMediaStatistics = [], _this29.intervalId = -1, _this29.playQualityIntervalId = -1, _this29.qualityStats = new Map(), _this29._direction = e, _this29._pc = qt(), _this29._extendedRtpCapabilities = t, _this29._remoteSdp = new oi(e, t), _this29._simulcast = !!i && i.simulcast, _this29.coreInstance = i && i.core, _this29._pc.addEventListener("iceconnectionstatechange", function () {
      return g(_assertThisInitialized(_assertThisInitialized(_this29)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        var e, t;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              e = "";
              _context26.t0 = _toConsumableArray;
              _context26.next = 4;
              return this._pc.getStats();
            case 4:
              _context26.t1 = _context26.sent.values();
              t = (0, _context26.t0)(_context26.t1).find(function (e) {
                return "remote-candidate" === e.type;
              });
              _context26.t2 = (void 0 !== t && (e = t.protocol), this._pc.iceConnectionState);
              _context26.next = _context26.t2 === "checking" ? 9 : _context26.t2 === "connected" ? 11 : _context26.t2 === "completed" ? 11 : _context26.t2 === "failed" ? 13 : _context26.t2 === "disconnected" ? 15 : _context26.t2 === "closed" ? 17 : 18;
              break;
            case 9:
              this.emit("@connectionstatechange", "connecting", e);
              return _context26.abrupt("break", 18);
            case 11:
              this.emit("@connectionstatechange", "connected", e), this.registerMediaStatisticStatsReport(), this.registerPlayQualityReport();
              return _context26.abrupt("break", 18);
            case 13:
              this.emit("@connectionstatechange", "failed", e), this.unregisterMediaStatisticStatsReport(), this.unregisterPlayQualityReport();
              return _context26.abrupt("break", 18);
            case 15:
              this.emit("@connectionstatechange", "disconnected", e), this.unregisterMediaStatisticStatsReport(), this.unregisterPlayQualityReport();
              return _context26.abrupt("break", 18);
            case 17:
              this.emit("@connectionstatechange", "closed", e), this.unregisterMediaStatisticStatsReport(), this.unregisterPlayQualityReport();
            case 18:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
    });
    return _this29;
  }
  _createClass(Di, [{
    key: "getStats",
    value: function getStats(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return xt(this._pc, e, this._direction, t);
            case 2:
              return _context27.abrupt("return", _context27.sent);
            case 3:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
    }
  }, {
    key: "registerPlayQualityReport",
    value: function registerPlayQualityReport() {
      var _this30 = this;
      "send" !== this._direction && (this.unregisterPlayQualityReport(), this.playQualityIntervalId = window.setInterval(function () {
        return g(_this30, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
          var e, _iterator15, _step15, t, _e20;
          return _regeneratorRuntime().wrap(function _callee29$(_context29) {
            while (1) switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return function (e, t) {
                  return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
                    var i, s;
                    return _regeneratorRuntime().wrap(function _callee28$(_context28) {
                      while (1) switch (_context28.prev = _context28.next) {
                        case 0:
                          _context28.prev = 0;
                          _context28.next = 3;
                          return e.getStats();
                        case 3:
                          i = _context28.sent;
                          _context28.next = 9;
                          break;
                        case 6:
                          _context28.prev = 6;
                          _context28.t0 = _context28["catch"](0);
                          return _context28.abrupt("return", (At(function () {
                            m.debug("get media statistic stats error, fallback to default", _context28.t0);
                          }, "getStats error"), []));
                        case 9:
                          if (i) {
                            _context28.next = 11;
                            break;
                          }
                          return _context28.abrupt("return", (At(function () {
                            m.debug("get null media statistic stats, fallback to default");
                          }, "getStats error"), []));
                        case 11:
                          s = _toConsumableArray(i.values());
                          return _context28.abrupt("return", t.subscribedTracks.map(function (e) {
                            var t = e.mediaTrack,
                              i = s.find(function (e) {
                                return e.type === wt.Track && e.trackIdentifier === t.id;
                              });
                            if (!i) return;
                            var r = s.find(function (e) {
                              return e.type === wt.InBoundRtp && e.trackId === i.id;
                            });
                            return r ? {
                              time: Date.now(),
                              trackID: e.info.trackID,
                              kind: "video" === r.kind ? "video" : "audio",
                              framesDecoded: r.framesDecoded || -1,
                              totalSamplesReceived: r.totalSamplesReceived || -1
                            } : void 0;
                          }).filter(I));
                        case 13:
                        case "end":
                          return _context28.stop();
                      }
                    }, _callee28, null, [[0, 6]]);
                  }));
                }(this._pc, this.coreInstance);
              case 2:
                e = _context29.sent;
                _iterator15 = _createForOfIteratorHelper(e);
                try {
                  for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                    t = _step15.value;
                    _e20 = this.qualityStats.get(t.trackID);
                    _e20 ? _e20.push(t) : this.qualityStats.set(t.trackID, [t]);
                  }
                } catch (err) {
                  _iterator15.e(err);
                } finally {
                  _iterator15.f();
                }
                this.addQualityStats();
              case 6:
              case "end":
                return _context29.stop();
            }
          }, _callee29, this);
        }));
      }, 2e3));
    }
  }, {
    key: "unregisterPlayQualityReport",
    value: function unregisterPlayQualityReport() {
      "send" !== this._direction && -1 !== this.playQualityIntervalId && (window.clearInterval(this.playQualityIntervalId), this.addQualityStats(!0), this.playQualityIntervalId = -1);
    }
  }, {
    key: "addQualityStats",
    value: function addQualityStats() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      var t = _toConsumableArray(this.qualityStats.values());
      if (t.some(function (e) {
        return e.length >= 30;
      }) || e) {
        m.log("quality stats", this.qualityStats);
        var _iterator16 = _createForOfIteratorHelper(t),
          _step16;
        try {
          var _loop7 = function _loop7() {
            var e = _step16.value;
            if (0 === e.length) return 1; // continue
            var t = e[0].trackID,
              i = 2 * e.length * 1e3;
            if ("video" === e[0].kind) {
              var _s11 = 1e3 * e.reduce(function (t, i, s) {
                return s >= 1 && e[s].framesDecoded === e[s - 1].framesDecoded ? t + 2 : t;
              }, 0);
              me.addEvent("VideoPlayQuality", {
                track_id: t,
                freeze_duration: _s11,
                total_duration: i
              });
            } else {
              var _s12 = 1e3 * e.reduce(function (t, i, s) {
                return s >= 1 && e[s].totalSamplesReceived === e[s - 1].totalSamplesReceived ? t + 2 : t;
              }, 0);
              me.addEvent("AudioPlayQuality", {
                track_id: t,
                freeze_duration: _s12,
                total_duration: i
              });
            }
          };
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            if (_loop7()) continue;
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
        this.qualityStats = new Map();
      }
    }
  }, {
    key: "registerMediaStatisticStatsReport",
    value: function registerMediaStatisticStatsReport() {
      var _this31 = this;
      this.unregisterMediaStatisticStatsReport(), this.intervalId = window.setInterval(function () {
        return g(_this31, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
          var e;
          return _regeneratorRuntime().wrap(function _callee30$(_context30) {
            while (1) switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return Dt(this._pc, this.coreInstance);
              case 2:
                e = _context30.sent;
                e && e.length > 0 && (this.addMediaStatistics(e, this.lastMediaStatistics), this.lastMediaStatistics = e);
              case 4:
              case "end":
                return _context30.stop();
            }
          }, _callee30, this);
        }));
      }, 3e3);
    }
  }, {
    key: "unregisterMediaStatisticStatsReport",
    value: function unregisterMediaStatisticStatsReport() {
      -1 !== this.intervalId && (window.clearInterval(this.intervalId), this.lastMediaStatistics = [], this.intervalId = -1);
    }
  }, {
    key: "addMediaStatistics",
    value: function addMediaStatistics(e, t) {
      var i = e.map(function (e) {
        var i = bt(e.id, e.kind),
          s = t.find(function (t) {
            return t.id === e.id;
          });
        if (!s) return e;
        var r = s.calculation_stats,
          o = e.calculation_stats,
          n = p(e, ["calculation_stats"]);
        return Object.assign(Object.assign({}, n), function (e, t, i) {
          if (!e || !t) return {
            framerate: 0,
            kbps: 0,
            packet_lost_rate: 0
          };
          var s = (e.timestamp - t.timestamp) / 1e3,
            r = 0 === s ? 0 : (e.frames_sent - t.frames_sent + (e.frames_received - t.frames_received)) / s,
            o = 0 === s ? 0 : (e.bytes_sent - t.bytes_sent + (e.bytes_received - t.bytes_received)) / (1024 * s / 8),
            n = Pt(t.packets_lost, e.packets_lost, t.packets_received + t.packets_sent, e.packets_received + e.packets_sent);
          i.Apply(n);
          var a = i.Filtered() < 0 ? 0 : 100 * i.Filtered();
          return {
            framerate: Math.ceil(r),
            kbps: Math.ceil(o),
            packet_lost_rate: Math.ceil(a)
          };
        }(o, r, i));
      });
      m.log("media statistics", i), me.addEvent("MediaStatistics", {
        cpu_loading: 0,
        track_stats: i
      });
      var s = yt(i.sort(function (e, t) {
        return t.packet_lost_rate - e.packet_lost_rate;
      })[0].packet_lost_rate, i.sort(function (e, t) {
        return t.rtt - e.rtt;
      })[0].rtt);
      pe(s);
      var r = i.map(function (e) {
        return {
          kind: e.kind,
          lostRate: e.packet_lost_rate,
          rtt: e.rtt,
          track: e.track_id
        };
      });
      this.emit("@send-qos-message", {
        qos: JSON.stringify({
          networkGrade: s,
          tracks_qos: r
        })
      });
    }
  }, {
    key: "getCurrentIceConnectionState",
    value: function getCurrentIceConnectionState() {
      return this._pc.iceConnectionState;
    }
  }, {
    key: "close",
    value: function close() {
      m.log("handle", this._direction, "close"), this.removeAllListeners(), this.unregisterMediaStatisticStatsReport(), this.unregisterPlayQualityReport(), this._pc.close(), this.isPcReady = !1;
    }
  }]);
  return Di;
}(Jt);
var Ci = /*#__PURE__*/function (_Di) {
  _inherits(Ci, _Di);
  function Ci(e, t, i) {
    var _this32;
    _classCallCheck(this, Ci);
    _this32 = _possibleConstructorReturn(this, _getPrototypeOf(Ci).call(this, "send", e, i)), m.log("init send handler"), _this32._transportReady = !1, _this32._stream = new MediaStream(), _this32._signaling = t, t.on("on-pubpc-state", function (e) {
      _this32._remoteSdp.transportRemoteParameters && e.pcid === _this32._remoteSdp.transportRemoteParameters.pcid && (e.connected || _this32.emit("@connectionstatechange", "remote-disconnected"));
    });
    return _this32;
  }
  _createClass(Ci, [{
    key: "getReady",
    value: function getReady(e) {
      var _this33 = this;
      return new Promise(function (t, i) {
        var s = function s(i) {
          if (i.pcid === e.pcid) {
            if (_this33._signaling.off("on-pubpc-state", s), !i.connected) return;
            _this33.isPcReady = !0, t();
          }
        };
        _this33._signaling.on("on-pubpc-state", s);
      });
    }
  }, {
    key: "addProducerTracks",
    value: function addProducerTracks(e) {
      var _this34 = this;
      m.debug("add producer", e);
      var t = e.filter(function (e) {
        return !_this34._stream.getTrackById(e.mediaTrack.id);
      });
      if (0 === t.length) return Promise.reject(new Error("track already added"));
      var i;
      var s = [];
      var r,
        o = !0;
      return Promise.resolve().then(function () {
        return g(_this34, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
          var _this35 = this;
          var _iterator17, _step17, _e22, _iterator18, _step18, _e21, _t23;
          return _regeneratorRuntime().wrap(function _callee31$(_context31) {
            while (1) switch (_context31.prev = _context31.next) {
              case 0:
                _iterator17 = _createForOfIteratorHelper(t);
                try {
                  for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                    _e22 = _step17.value;
                    this._stream.addTrack(_e22.mediaTrack);
                  }
                } catch (err) {
                  _iterator17.e(err);
                } finally {
                  _iterator17.f();
                }
                if (!(F.unifiedPlan && F.supportTransceivers)) {
                  _context31.next = 24;
                  break;
                }
                _iterator18 = _createForOfIteratorHelper(t);
                _context31.prev = 4;
                _iterator18.s();
              case 6:
                if ((_step18 = _iterator18.n()).done) {
                  _context31.next = 14;
                  break;
                }
                _e21 = _step18.value;
                _context31.next = 10;
                return Lt(_e21.mediaTrack, this._pc, _e21.lowStreamConfig, _e21.info.kbps, this._stream);
              case 10:
                _t23 = _context31.sent;
                m.debug("add transceiver", _t23, _t23.mid), s.push(_t23);
              case 12:
                _context31.next = 6;
                break;
              case 14:
                _context31.next = 19;
                break;
              case 16:
                _context31.prev = 16;
                _context31.t0 = _context31["catch"](4);
                _iterator18.e(_context31.t0);
              case 19:
                _context31.prev = 19;
                _iterator18.f();
                return _context31.finish(19);
              case 22:
                _context31.next = 25;
                break;
              case 24:
                m.debug("add tracks", t), i = t.map(function (e) {
                  return _this35._pc.addTrack(e.mediaTrack, _this35._stream);
                });
              case 25:
                return _context31.abrupt("return", Oi(this._pc, this._simulcast));
              case 26:
              case "end":
                return _context31.stop();
            }
          }, _callee31, this, [[4, 16, 19, 22]]);
        }));
      }).then(function (e) {
        var t;
        return F.needH264FmtpLine && (e.sdp += "a=fmtp:107 level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=42e01f".concat("\n")), t = {
          type: "offer",
          sdp: e.sdp
        }, r = t.sdp, m.log("publish: set local offer", t), _this34._pc.setLocalDescription(t);
      }).then(function () {
        var _loop8 = function _loop8() {
          var t = _s13[_i20];
          if (!t.sender.track) return 1; // continue
          var i = e.find(function (e) {
            return e.mediaTrack === t.sender.track;
          });
          if (!i || !t.mid) throw ke("can not get transceiver mid!");
          i.setInfo({
            mid: t.mid
          }), _this34.midRidEncoding[t.mid] = i.lowStreamConfig;
        };
        for (var _i20 = 0, _s13 = s; _i20 < _s13.length; _i20++) {
          if (_loop8()) continue;
        }
        if (!_this34._transportReady) return o = !1, _this34._setupTransport(e);
      }).then(function () {
        return _this34._remoteSdp.createRemoteAnswer(r, _this34.midRidEncoding, _this34.removeMids);
      }).then(function (e) {
        var t = {
          type: "answer",
          sdp: e
        };
        return m.debug("addProducer answer", t), _this34._pc.setRemoteDescription(t);
      }).then(function () {
        return _this34._pcReady;
      }).then(function () {
        return o ? _this34.safeEmitAsPromise("@needpubtracks", e, r) : Promise.resolve(_this34._remoteSdp.transportRemoteParameters);
      }).catch(function (e) {
        m.log("add producer error", e);
        try {
          var _iterator19 = _createForOfIteratorHelper(i),
            _step19;
          try {
            for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
              var _e24 = _step19.value;
              _this34._pc.removeTrack(_e24);
            }
          } catch (err) {
            _iterator19.e(err);
          } finally {
            _iterator19.f();
          }
          for (var _i21 = 0, _s14 = s; _i21 < _s14.length; _i21++) {
            var _e23 = _s14[_i21];
            _e23.direction = "inactive";
          }
        } catch (e) {}
        var _iterator20 = _createForOfIteratorHelper(t),
          _step20;
        try {
          for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
            var _e25 = _step20.value;
            _this34._stream.removeTrack(_e25.mediaTrack);
          }
        } catch (err) {
          _iterator20.e(err);
        } finally {
          _iterator20.f();
        }
        throw e instanceof ge ? e : ke(e);
      });
    }
  }, {
    key: "removeProducerTracks",
    value: function removeProducerTracks(e) {
      var _this36 = this;
      m.debug("removeProducerTracks", e);
      var t = e.filter(function (e) {
        return void 0 !== e.track && !!_this36._stream.getTrackById(e.track.mediaTrack.id);
      }).map(function (e) {
        return e.track.isReplacedByImageTrack ? e.track.imageStreamTrack.mediaTrack : e.track.mediaTrack;
      });
      var i;
      return Promise.resolve().then(function () {
        F.unifiedPlan && F.supportTransceivers && _this36._pc.getTransceivers().forEach(function (e) {
          e.sender.track && e.mid && t.includes(e.sender.track) && _this36.removeMids.add(e.mid);
        });
        var e = _this36._pc.getSenders().filter(function (e) {
          return e.track && t.includes(e.track);
        });
        if (0 === e.length) return m.warning("removeProducerTracks [nothing to remove]"), Promise.reject("removeProducerTracks: nothing to remote");
        var _iterator21 = _createForOfIteratorHelper(e),
          _step21;
        try {
          for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
            var _t24 = _step21.value;
            _this36._pc.removeTrack(_t24);
          }
        } catch (err) {
          _iterator21.e(err);
        } finally {
          _iterator21.f();
        }
        var _iterator22 = _createForOfIteratorHelper(t),
          _step22;
        try {
          for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
            var _e26 = _step22.value;
            _this36._stream.removeTrack(_e26);
          }
        } catch (err) {
          _iterator22.e(err);
        } finally {
          _iterator22.f();
        }
        return Oi(_this36._pc, _this36._simulcast);
      }).then(function (e) {
        var t = new RTCSessionDescription(e);
        return i = t.sdp, m.log("unpublish: set local offer", t), _this36._pc.setLocalDescription(t);
      }).then(function () {
        var e = {
          type: "answer",
          sdp: _this36._remoteSdp.createRemoteAnswer(i, _this36.midRidEncoding, _this36.removeMids)
        };
        return m.log("unpublish: set remote answer", e), _this36._pc.setRemoteDescription(e);
      }).catch(function (e) {
        if (0 !== _this36._stream.getTracks().length) throw e instanceof ge ? e : ke(e);
        m.debug("removeProducer() | ignoring expected error due no sending tracks: %s", e.toString());
      }).then(function () {
        _this36.safeEmitAsPromise("@needunpubtracks", e);
      });
    }
  }, {
    key: "replaceTrack",
    value: function replaceTrack(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var i, s;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              if (this._pc.getSenders) {
                _context32.next = 2;
                break;
              }
              throw ke("getSenders is not supported.");
            case 2:
              i = this._pc.getSenders().find(function (t) {
                if (!t.track) return !1;
                if (!e.track) return !1;
                var i = t.track.id;
                return !(!e.track.mediaTrack || i !== e.track.mediaTrack.id) || !(!e.track.imageStreamTrack || i !== e.track.imageStreamTrack.id);
              });
              if (i) {
                _context32.next = 5;
                break;
              }
              throw ke("sender not found when replaceTrack: ".concat(e.trackID));
            case 5:
              if (i.replaceTrack) {
                _context32.next = 7;
                break;
              }
              throw ke("replaceTrack is not supported.");
            case 7:
              e.track && (e.track.mediaTrack = t, e.track.removeMediaElement());
              s = i.track;
              _context32.next = 11;
              return i.replaceTrack(t);
            case 11:
              this._stream.removeTrack(s);
              this._stream.addTrack(t);
            case 13:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
    }
  }, {
    key: "replaceProducerTrack",
    value: function replaceProducerTrack(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var i;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              if (this._pc.getSenders) {
                _context33.next = 2;
                break;
              }
              throw ke("getSenders is not supported.");
            case 2:
              i = this._pc.getSenders().find(function (t) {
                if (!t.track) return !1;
                if (!e.track) return !1;
                var i = t.track.id;
                return !(!e.track.mediaTrack || i !== e.track.mediaTrack.id) || !(!e.track.imageStreamTrack || i !== e.track.imageStreamTrack.id);
              });
              if (i) {
                _context33.next = 5;
                break;
              }
              throw ke("sender not found when replaceProducerTrack: ".concat(e.trackID));
            case 5:
              if (i.replaceTrack) {
                _context33.next = 7;
                break;
              }
              throw ke("replaceTrack is not supported.");
            case 7:
              if (!("image" === t)) {
                _context33.next = 13;
                break;
              }
              m.debug("replaceTrack", e.track.imageStreamTrack.mediaTrack);
              _context33.next = 11;
              return i.replaceTrack(e.track.imageStreamTrack.mediaTrack);
            case 11:
              _context33.next = 18;
              break;
            case 13:
              _context33.t0 = "video" === t;
              if (!_context33.t0) {
                _context33.next = 18;
                break;
              }
              m.debug("replaceTrack", e.track.mediaTrack);
              _context33.next = 18;
              return i.replaceTrack(e.track.mediaTrack);
            case 18:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
    }
  }, {
    key: "restartICE",
    value: function restartICE(e, t) {
      var _this37 = this;
      return m.log("restart send ice"), this._isRestartingICE = !0, Promise.resolve().then(function () {
        return _this37._remoteSdp.updateICEData(e, t);
      }).then(function () {
        return Oi(_this37._pc, _this37._simulcast, {
          iceRestart: !0
        });
      }).then(function (e) {
        return _this37._pc.setLocalDescription(e);
      }).then(function () {
        var e = {
          type: "answer",
          sdp: _this37._remoteSdp.createRemoteAnswer(_this37._pc.localDescription.sdp, _this37.midRidEncoding, _this37.removeMids)
        };
        return _this37._pc.setRemoteDescription(e);
      });
    }
  }, {
    key: "_setupTransport",
    value: function _setupTransport(e) {
      var _this38 = this;
      var t = Date.now();
      return Promise.resolve().then(function () {
        return _this38._pc.localDescription ? _this38._pc.localDescription : Oi(_this38._pc, _this38._simulcast);
      }).then(function (t) {
        return _this38.safeEmitAsPromise("@needpubpc", t.sdp, e);
      }).then(function (i) {
        return me.addEvent("PublisherPC", {
          signal_take_time: Date.now() - t,
          result_code: i.code,
          up_stream_ip: (i.iceCandidates || []).map(function (e) {
            var t = e.ip;
            return t;
          }).join(","),
          tracks: i.tracks.map(function (t) {
            var i = e.find(function (e) {
              return e.mediaTrack.id === t.localid;
            });
            if (i) return {
              local_id: t.localid,
              track_id: t.trackid,
              source_type: i.sourceType,
              kind: i.info.kind,
              tag: i.info.tag || "",
              muted: !!i.info.muted,
              master: !!i.master,
              kbps: i.info.kbps || -1,
              encode_video_width: 0,
              encode_video_height: 0
            };
          }).filter(function (e) {
            return void 0 !== e;
          })
        }), _this38.pcid = i.pcid, _this38._transportReady = !0, _this38._pcReady = _this38.getReady(i), _this38._remoteSdp.setTransportRemoteParameters(i);
      });
    }
  }]);
  return Ci;
}(Di);
var Mi = /*#__PURE__*/function (_Di2) {
  _inherits(Mi, _Di2);
  function Mi(e, t, i) {
    var _this39;
    _classCallCheck(this, Mi);
    _this39 = _possibleConstructorReturn(this, _getPrototypeOf(Mi).call(this, "recv", e, i)), _this39._transportCreated = !1, _this39._consumerInfos = new Map(), _this39._signaling = t, t.on("on-subpc-state", function (e) {
      _this39._remoteSdp.transportRemoteParameters && e.pcid === _this39._remoteSdp.transportRemoteParameters.pcid && (e.connected || _this39.emit("@connectionstatechange", "remote-disconnected"));
    }), m.log("init recvhandler", _assertThisInitialized(_assertThisInitialized(_this39)));
    return _this39;
  }
  _createClass(Mi, [{
    key: "getReady",
    value: function getReady(e) {
      var _this40 = this;
      return new Promise(function (t, i) {
        var s = function s(i) {
          if (i.pcid === e.pcid) {
            if (_this40._signaling.off("on-subpc-state", s), !i.connected) return;
            _this40.isPcReady = !0, t();
          }
        };
        _this40._signaling.on("on-subpc-state", s);
      });
    }
  }, {
    key: "addConsumerTracks",
    value: function addConsumerTracks(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var _this41 = this;
        var _t25, _iterator23, _step23, _i22, _e27, t, i, _iterator24, _step24, _loop10;
        return _regeneratorRuntime().wrap(function _callee34$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              if (!(F.unifiedPlan && C)) {
                _context35.next = 22;
                break;
              }
              _t25 = [];
              _iterator23 = _createForOfIteratorHelper(e);
              _context35.prev = 3;
              _iterator23.s();
            case 5:
              if ((_step23 = _iterator23.n()).done) {
                _context35.next = 13;
                break;
              }
              _i22 = _step23.value;
              _context35.next = 9;
              return this.addConsumerTrack(_i22);
            case 9:
              _e27 = _context35.sent;
              _t25.push(_e27);
            case 11:
              _context35.next = 5;
              break;
            case 13:
              _context35.next = 18;
              break;
            case 15:
              _context35.prev = 15;
              _context35.t0 = _context35["catch"](3);
              _iterator23.e(_context35.t0);
            case 18:
              _context35.prev = 18;
              _iterator23.f();
              return _context35.finish(18);
            case 21:
              return _context35.abrupt("return", _t25);
            case 22:
              m.log("add consumers", e);
              t = [], i = Array.from(this._consumerInfos.values());
              _iterator24 = _createForOfIteratorHelper(e);
              _context35.prev = 25;
              _loop10 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop10() {
                var s, e, _e31, _t26;
                return _regeneratorRuntime().wrap(function _loop10$(_context34) {
                  while (1) switch (_context34.prev = _context34.next) {
                    case 0:
                      s = _step24.value;
                      e = i.find(function (e) {
                        return e.consumerId === s.id;
                      });
                      if (e && !e.closed) t.push(e);else {
                        _e31 = _this41.genNewConsumerInfo(s);
                        if (F.unifiedPlan) {
                          _t26 = s.mid;
                          _e31.mid = _t26, _this41._consumerInfos.set(_t26, _e31);
                        } else _this41._consumerInfos.set(s.id, _e31);
                        t.push(_e31);
                      }
                    case 3:
                    case "end":
                      return _context34.stop();
                  }
                }, _loop10);
              });
              _iterator24.s();
            case 28:
              if ((_step24 = _iterator24.n()).done) {
                _context35.next = 32;
                break;
              }
              return _context35.delegateYield(_loop10(), "t1", 30);
            case 30:
              _context35.next = 28;
              break;
            case 32:
              _context35.next = 37;
              break;
            case 34:
              _context35.prev = 34;
              _context35.t2 = _context35["catch"](25);
              _iterator24.e(_context35.t2);
            case 37:
              _context35.prev = 37;
              _iterator24.f();
              return _context35.finish(37);
            case 40:
              return _context35.abrupt("return", Promise.resolve().then(function () {
                var e = {
                  type: "offer",
                  sdp: _this41._remoteSdp.createRemoteOffer(Array.from(_this41._consumerInfos.values()))
                };
                return m.debug("subscribe: set remote offer", e), _this41._pc.setRemoteDescription(e);
              }).then(function () {
                return F.unifiedPlan, _this41._pc.createAnswer();
              }).then(function (e) {
                return m.debug("subscribe, set local answer", e), _this41._pc.setLocalDescription(e);
              }).then(function () {
                return _this41._pcReady;
              }).then(function () {
                var _loop9 = function _loop9() {
                  var s = t[_i23],
                    r = e[_i23];
                  if (!r.track) {
                    if (F.unifiedPlan) {
                      var _e28 = _this41._pc.getTransceivers().find(function (e) {
                        return !!e.receiver.track && (e.receiver.track.id === s.trackID || e.mid === s.mid);
                      });
                      _e28 && (r.track = _e28.receiver.track);
                    } else if (F.getReceivers) {
                      var _e29 = _this41._pc.getReceivers().find(function (e) {
                        var t = e.track;
                        return !!t && s.trackID === t.id;
                      });
                      _e29 && (r.track = _e29.track);
                    } else {
                      var _e30 = _this41._pc.getRemoteStreams().find(function (e) {
                        return e.id === s.streamId;
                      });
                      _e30 && (r.track = _e30.getTrackById(s.trackID));
                    }
                    if (!r.track) throw ke("remote track not found");
                    m.log("subscribe: get new track", r.track);
                  }
                };
                for (var _i23 = 0; _i23 < t.length; _i23 += 1) {
                  _loop9();
                }
                return e.map(function (e) {
                  return e.track;
                });
              }));
            case 41:
            case "end":
              return _context35.stop();
          }
        }, _callee34, this, [[3, 15, 18, 21], [25, 34, 37, 40]]);
      }));
    }
  }, {
    key: "genNewConsumerInfo",
    value: function genNewConsumerInfo(e) {
      var t = e.rtpParameters.encodings[0],
        i = e.rtpParameters.rtcp.cname,
        s = e.mid;
      return {
        kind: e.kind,
        streamId: F.unifiedPlan ? e.rtpParameters.msid : "recv-stream-".concat(t.ssrc),
        trackID: F.unifiedPlan ? "consumer-".concat(e.kind, "-").concat(s) : "consumer-".concat(e.kind, "-").concat(t.ssrc),
        ssrc: t.ssrc,
        rtxSsrc: t.rtx ? t.rtx.ssrc : void 0,
        cname: i,
        consumerId: e.id,
        closed: !1
      };
    }
  }, {
    key: "addConsumerTrack",
    value: function addConsumerTrack(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var _this42 = this;
        var t, i, _i24, _t27;
        return _regeneratorRuntime().wrap(function _callee35$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              m.log("add consumer", e);
              t = null;
              i = Array.from(this._consumerInfos.values()).find(function (t) {
                return t.consumerId === e.id;
              });
              if (i && !i.closed) t = i;else {
                _i24 = this.genNewConsumerInfo(e);
                if (F.unifiedPlan) {
                  _t27 = e.mid;
                  _i24.mid = _t27, this._consumerInfos.set(_t27, _i24);
                } else this._consumerInfos.set(e.id, _i24);
                t = _i24;
              }
              return _context36.abrupt("return", Promise.resolve().then(function () {
                var e = {
                  type: "offer",
                  sdp: _this42._remoteSdp.createRemoteOffer(Array.from(_this42._consumerInfos.values()))
                };
                return m.log("set ontrack"), _this42._pc.ontrack = function (e) {
                  m.log("ontrack", e.receiver.track);
                }, m.debug("subscribe: set remote offer", e), _this42._pc.setRemoteDescription(e);
              }).then(function () {
                return _this42._pc.createAnswer();
              }).then(function (e) {
                return m.debug("subscribe, set local answer", e), _this42._pc.setLocalDescription(e);
              }).then(function () {
                return _this42._pcReady;
              }).then(function () {
                var i = null;
                if (F.unifiedPlan && F.supportTransceivers && e && t) {
                  var _s15 = _this42._pc.getTransceivers().find(function (i) {
                    return !!i.receiver.track && (i.receiver.track.id === t.trackID || i.mid === t.mid) && (e.track = i.receiver.track, !0);
                  });
                  _s15 && (i = _s15.receiver.track);
                } else if (e && t) {
                  var _s16 = _this42._pc.getReceivers().find(function (i) {
                    var s = i.track;
                    return !!s && t.trackID === s.id && (e.track = s, !0);
                  });
                  _s16 && (i = _s16.track);
                }
                if (!i && e) throw ke("remote track not found");
                return m.log("subscribe: get new track", i, i.readyState), i;
              }));
            case 5:
            case "end":
              return _context36.stop();
          }
        }, _callee35, this);
      }));
    }
  }, {
    key: "removeConsumerTracks",
    value: function removeConsumerTracks(e) {
      var _this43 = this;
      m.log("remove consumer", e);
      var t = !1;
      var _iterator25 = _createForOfIteratorHelper(e),
        _step25;
      try {
        var _loop11 = function _loop11() {
          var i = _step25.value;
          var e = Array.from(_this43._consumerInfos.values()).find(function (e) {
            return e.consumerId === i.id && !e.closed;
          });
          e ? (t = !0, F.unifiedPlan ? (i.track = null, e.closed = !0) : _this43._consumerInfos.delete(i.id)) : m.log("can not find unpublish track target, ignore");
        };
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          _loop11();
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
      return t ? Promise.resolve().then(function () {
        var e = {
          type: "offer",
          sdp: _this43._remoteSdp.createRemoteOffer(Array.from(_this43._consumerInfos.values()))
        };
        return m.log("unsubscribe set remote offer", e), _this43._pc.setRemoteDescription(e);
      }).then(function () {
        return _this43._pc.createAnswer();
      }).then(function (e) {
        return m.log("unsubscribe set local answer", e), _this43._pc.setLocalDescription(e);
      }) : Promise.resolve();
    }
  }, {
    key: "restartICE",
    value: function restartICE(e, t) {
      var _this44 = this;
      return m.log("recv restart ice"), this._isRestartingICE = !0, Promise.resolve().then(function () {
        return _this44._remoteSdp.updateICEData(e, t);
      }).then(function () {
        var e = {
          type: "offer",
          sdp: _this44._remoteSdp.createRemoteOffer(Array.from(_this44._consumerInfos.values()))
        };
        return _this44._pc.setRemoteDescription(e);
      }).then(function () {
        return _this44._pc.createAnswer();
      }).then(function (e) {
        _this44._pc.setLocalDescription(e);
      });
    }
  }, {
    key: "setupTransport",
    value: function setupTransport(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        var t, i;
        return _regeneratorRuntime().wrap(function _callee36$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              if (!this._transportCreated) {
                _context37.next = 4;
                break;
              }
              _context37.next = 3;
              return this._pcReady;
            case 3:
              return _context37.abrupt("return", _context37.sent);
            case 4:
              t = Date.now();
              _context37.next = 7;
              return this.safeEmitAsPromise("@needsubpc", e);
            case 7:
              i = _context37.sent;
              me.addEvent("SubscriberPC", {
                signal_take_time: Date.now() - t,
                result_code: i.code,
                down_stream_ip: (i.iceCandidates || []).map(function (e) {
                  var t = e.ip;
                  return t;
                }).join(","),
                tracks: i.tracks.map(function (e) {
                  return {
                    track_id: e.trackid,
                    status: e.status
                  };
                })
              });
              this.pcid = i.pcid;
              this._transportCreated = !0;
              this._pcReady = this.getReady(i);
              m.log("init subscribe, get transport remote", i);
              _context37.next = 15;
              return this._remoteSdp.setTransportRemoteParameters(i);
            case 15:
              return _context37.abrupt("return", i);
            case 16:
            case "end":
              return _context37.stop();
          }
        }, _callee36, this);
      }));
    }
  }]);
  return Mi;
}(Di);
function Oi(e, t, i) {
  return e.createOffer(i).then(function (e) {
    var i = e.type,
      s = e.sdp;
    return s ? (s = ci(s), "chrome" === P.name && t && (s = function (e, t) {
      var i = h.parse(e);
      t && "chrome" === P.name && (i.media = i.media.map(function (e) {
        if (!e.ssrcGroups || 0 === e.ssrcGroups.length || !e.ssrcs || 0 === e.ssrcs.length) return e;
        var i = e.ssrcGroups.find(function (e) {
          return "FID" === e.semantics;
        });
        if (!i) return e;
        var _i$ssrcs$split$map = i.ssrcs.split(" ").map(function (e) {
            return parseInt(e, 10);
          }),
          _i$ssrcs$split$map2 = _slicedToArray(_i$ssrcs$split$map, 2),
          s = _i$ssrcs$split$map2[0],
          r = _i$ssrcs$split$map2[1];
        var o, n;
        e.ssrcs.forEach(function (e) {
          "cname" === e.attribute && (o = e.value), "msid" === e.attribute && (n = e.value);
        });
        var a = [];
        if (a.push(s), t >= 2) {
          var _t28 = s + 1,
            _i25 = r + 1;
          e.ssrcs.push({
            id: _t28,
            attribute: "cname",
            value: o
          }), e.ssrcs.push({
            id: _t28,
            attribute: "msid",
            value: n
          }), e.ssrcs.push({
            id: _i25,
            attribute: "cname",
            value: o
          }), e.ssrcs.push({
            id: _i25,
            attribute: "msid",
            value: n
          }), e.ssrcGroups.push({
            semantics: "FID",
            ssrcs: "".concat(_t28, " ").concat(_i25)
          }), a.push(_t28);
        }
        if (t >= 3) {
          var _t29 = s + 2,
            _i26 = r + 2;
          e.ssrcs.push({
            id: _t29,
            attribute: "cname",
            value: o
          }), e.ssrcs.push({
            id: _t29,
            attribute: "msid",
            value: n
          }), e.ssrcs.push({
            id: _i26,
            attribute: "cname",
            value: o
          }), e.ssrcs.push({
            id: _i26,
            attribute: "msid",
            value: n
          }), e.ssrcGroups.push({
            semantics: "FID",
            ssrcs: "".concat(_t29, " ").concat(_i26)
          }), a.push(_t29);
        }
        return e.ssrcGroups.push({
          semantics: "SIM",
          ssrcs: a.join(" ")
        }), e;
      }));
      var s = h.write(i).split("\r\n");
      var r = s.findIndex(function (e) {
        return 0 === e.indexOf("a=ssrc-group:FID");
      });
      for (; -1 !== r && 0 === s[r].indexOf("a=ssrc-group:FID");) {
        var _e32 = s[r].split(" ")[2];
        for (var _t30 = r - 1; _t30 >= 0; _t30--) if (s[_t30].indexOf(_e32) > 0) {
          s.splice(_t30 + 1, 0, s[r]), s.splice(r + 1, 1);
          break;
        }
        r++;
      }
      return s.join("\r\n");
    }(s, 3)), {
      type: i,
      sdp: s
    }) : e;
  });
}
function Pi(e, t, i, s) {
  switch (e) {
    case "send":
      return new Ci(t, i, s);
    case "recv":
      return new Mi(t, i, s);
  }
}
var qi;
!function (e) {
  e.SEND_TRACKS = "@transport:send-tracks", e.RESTART_SEND_ICE = "@transport:send-restart-ice", e.REMOVE_TRACKS = "@transport:remove-tracks", e.INIT_RECV = "@transport:init-recv", e.RESTART_RECV_ICE = "@transport:recv-restart-ice", e.ADD_CONUMERS = "@transport:add-consumers", e.REMOVE_CONSUMERS = "@transport:remove-consumers";
}(qi || (qi = {}));
var Li = /*#__PURE__*/function (_Jt5) {
  _inherits(Li, _Jt5);
  _createClass(Li, [{
    key: "publishTracks",
    get: function get() {
      return Array.from(this._publishTracks.values());
    }
  }]);
  function Li(e, t, i, s) {
    var _this45;
    _classCallCheck(this, Li);
    _this45 = _possibleConstructorReturn(this, _getPrototypeOf(Li).call(this)), _this45.sendCommandQueue = new U("SendQueue"), _this45.recvCommandQueue = new U("RecvQueue"), _this45.simulcast = !1, _this45.recvInitCommandQueue = new U("RecvInitQueue"), _this45.sendTrackQueue = [], _this45.consumerQueue = [], _this45._publishTracks = new Map(), _this45.extendedRtpCapabilities = e, _this45.signaling = t, _this45.simulcast = !!s, _this45.coreInstance = i, _this45.sendHandler = Pi("send", e, t, {
      simulcast: _this45.simulcast,
      core: _this45.coreInstance
    }), _this45.recvHandler = Pi("recv", e, t, {
      simulcast: _this45.simulcast,
      core: _this45.coreInstance
    }), _this45.handleSendHandler(), _this45.handleRecvHandler(), _this45.sendCommandQueue.on("exec", _this45.handleSendCommandTask.bind(_assertThisInitialized(_assertThisInitialized(_this45)))), _this45.recvCommandQueue.on("exec", _this45.handleRecvCommandTask.bind(_assertThisInitialized(_assertThisInitialized(_this45)))), _this45.recvInitCommandQueue.on("exec", _this45.handleRecvInitCommandTask.bind(_assertThisInitialized(_assertThisInitialized(_this45)))), _this45.initSubPcPromise = new Promise(function (e) {
      _this45.initSubPcPromiseResolve = e;
    });
    return _this45;
  }
  _createClass(Li, [{
    key: "resolveInitSubPcPromise",
    value: function resolveInitSubPcPromise() {
      this.initSubPcPromiseResolve && (this.initSubPcPromiseResolve(), this.initSubPcPromiseResolve = void 0);
    }
  }, {
    key: "handleSendHandler",
    value: function handleSendHandler() {
      var _this46 = this;
      this.sendHandler.on("@needpubpc", function (e, t, i, s) {
        _this46.safeEmitAsPromise("@needpubpc", e, t).then(i).catch(s);
      }).on("@connectionstatechange", function (e, t) {
        switch (m.log("pubpc connectionstatechange", e), me.addEvent("ICEConnectionState", {
          pc_type: 0,
          state: e,
          id: _this46.sendHandler.pcid,
          protocol: t,
          event_grade: "failed" === e ? Ae.SERVERE : Ae.NORMAL,
          event_category: de.CORE
        }), e) {
          case "remote-disconnected":
          case "closed":
          case "failed":
            _this46.signaling.state === ui.OPEN ? _this46.reconnectProducer() : _this46.sendHandler.close();
            break;
          case "disconnected":
            if (_this46.sendHandler._isRestartingICE || !_this46.sendHandler.pcid) return;
            _this46.signaling.state === ui.OPEN ? _this46.restartSendICE(_this46.sendHandler.pcid) : _this46.signaling.once("@signalingauth", function (e) {
              "disconnected" === _this46.sendHandler.getCurrentIceConnectionState() && (_this46.extendedRtpCapabilities = e.rtpcaps, _this46.restartSendICE(_this46.sendHandler.pcid));
            });
        }
      }).on("@needpubtracks", function (e, t, i, s) {
        var r = e.map(Zt),
          o = Date.now();
        _this46.signaling.request("pub-tracks", {
          tracks: r,
          sdp: t
        }).then(function (t) {
          switch (me.addEvent("PublishTracks", {
            signal_take_time: Date.now() - o,
            result_code: t.code,
            tracks: t.tracks.map(function (t) {
              var i = e.find(function (e) {
                return e.mediaTrack.id === t.localid;
              });
              if (i) return {
                local_id: t.localid,
                track_id: t.trackid,
                source_type: i.sourceType,
                kind: i.info.kind,
                tag: i.info.tag || "",
                muted: !!i.info.muted,
                master: !!i.master,
                kbps: i.info.kbps || -1,
                encode_video_width: 0,
                encode_video_height: 0
              };
            }).filter(function (e) {
              return void 0 !== e;
            })
          }), t.code) {
            case 0:
              break;
            case 10052:
              return s(Ye());
            case 10061:
              return _this46.reconnectProducer(), s(He(10061, t.error));
            default:
              return s(He(t.code, t.error));
          }
          var _iterator26 = _createForOfIteratorHelper(t.tracks),
            _step26;
          try {
            for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
              var _e33 = _step26.value;
              if (!_e33.status) return void s(He(t.code, t.error));
            }
          } catch (err) {
            _iterator26.e(err);
          } finally {
            _iterator26.f();
          }
          i(t);
        }, s);
      }).on("@needunpubtracks", function (e, t, i) {
        me.addEvent("UnPublishTracks", {
          tracks: e.map(function (e) {
            return {
              track_id: e.trackID
            };
          })
        }), _this46.signaling.request("unpub-tracks", {
          tracks: e.map(function (e) {
            return {
              trackid: e.trackID
            };
          })
        }).then(function (e) {
          t(e);
        });
      }).on("@send-qos-message", function (e) {
        _this46.signaling.request("send-qos-message", e);
      });
    }
  }, {
    key: "sendTracks",
    value: function sendTracks(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        return _regeneratorRuntime().wrap(function _callee37$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              return _context38.abrupt("return", 0 === e.length ? Promise.resolve() : this.sendCommandQueue.push(qi.SEND_TRACKS, e));
            case 1:
            case "end":
              return _context38.stop();
          }
        }, _callee37, this);
      }));
    }
  }, {
    key: "removeTracks",
    value: function removeTracks(e) {
      return 0 === e.length ? Promise.resolve() : this.sendCommandQueue.push(qi.REMOVE_TRACKS, e);
    }
  }, {
    key: "restartSendICE",
    value: function restartSendICE(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
        return _regeneratorRuntime().wrap(function _callee38$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              return _context39.abrupt("return", F.supportRestartICE ? this.sendCommandQueue.push(qi.RESTART_SEND_ICE, e) : Promise.resolve(this.reconnectProducer()));
            case 1:
            case "end":
              return _context39.stop();
          }
        }, _callee38, this);
      }));
    }
  }, {
    key: "handleSendCommandTask",
    value: function handleSendCommandTask(e, t) {
      switch (e.method) {
        case qi.SEND_TRACKS:
          return void (t.promise = this._execAddProducerTracks(e.data));
        case qi.REMOVE_TRACKS:
          return void (t.promise = this._execRemoveTracks(e.data));
        case qi.RESTART_SEND_ICE:
          return void (t.promise = this._execRestartSendICE(e.data));
      }
    }
  }, {
    key: "addTrackToPublishTracks",
    value: function addTrackToPublishTracks(e) {
      var _this47 = this;
      var t = e.map(function (e) {
        return new bi(_this47, "send", e);
      });
      var _iterator27 = _createForOfIteratorHelper(t),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var _e34 = _step27.value;
          this._publishTracks.set(_e34.track.mediaTrack.id, _e34);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
      return t;
    }
  }, {
    key: "removeTrackFromPublishTracks",
    value: function removeTrackFromPublishTracks(e) {
      var _iterator28 = _createForOfIteratorHelper(e),
        _step28;
      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var t = _step28.value;
          this._publishTracks.delete(t.mediaTrack.id);
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
    }
  }, {
    key: "_execAddProducerTracks",
    value: function _execAddProducerTracks(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        var t, _iterator29, _step29, _i27, _e35;
        return _regeneratorRuntime().wrap(function _callee39$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              _context40.next = 2;
              return this.sendHandler.addProducerTracks(e.map(function (e) {
                return e.track;
              }));
            case 2:
              t = _context40.sent;
              _iterator29 = _createForOfIteratorHelper(e);
              try {
                for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
                  _i27 = _step29.value;
                  _e35 = tt(t.tracks, "localid", _i27.track.mediaTrack.id);
                  _e35 && (_i27.addTrackId(_e35.trackid), _i27.track.setInfo({
                    versionid: _e35.versionid
                  }), _i27.track.resetStats());
                }
              } catch (err) {
                _iterator29.e(err);
              } finally {
                _iterator29.f();
              }
              return _context40.abrupt("return", (e.map(function (e) {
                return e.connectStatus = E.Connect;
              }), t));
            case 6:
            case "end":
              return _context40.stop();
          }
        }, _callee39, this);
      }));
    }
  }, {
    key: "_execRemoveTracks",
    value: function _execRemoveTracks(e) {
      return this.removeTrackFromPublishTracks(e.map(function (e) {
        return e.track;
      })), e.map(function (e) {
        return e.release();
      }), this.sendHandler.removeProducerTracks(e);
    }
  }, {
    key: "_execRestartSendICE",
    value: function _execRestartSendICE(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        var t;
        return _regeneratorRuntime().wrap(function _callee40$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              this.sendHandler._isRestartingICE = !0;
              _context41.next = 3;
              return this.signaling.request("pubpc-restart", {
                pcid: e
              });
            case 3:
              t = _context41.sent;
              if (!(0 !== t.code)) {
                _context41.next = 6;
                break;
              }
              return _context41.abrupt("return", (this.sendHandler._isRestartingICE = !1, m.debug("restart ice faild", t.code, t.error), void this.reconnectProducer()));
            case 6:
              _context41.prev = 6;
              _context41.next = 9;
              return this.sendHandler.restartICE(t.iceParameters, t.iceCandidates);
            case 9:
              this.sendHandler._isRestartingICE = !1;
              _context41.next = 15;
              break;
            case 12:
              _context41.prev = 12;
              _context41.t0 = _context41["catch"](6);
              m.debug("restart ice faild", t.code, t.error), this.sendHandler._isRestartingICE = !1, this.reconnectProducer();
            case 15:
            case "end":
              return _context41.stop();
          }
        }, _callee40, this, [[6, 12]]);
      }));
    }
  }, {
    key: "reconnectProducer",
    value: function reconnectProducer() {
      this.resetSendCommandQueue(), this.sendHandler.close();
      var e = this.publishTracks;
      this.sendHandler = Pi("send", this.extendedRtpCapabilities, this.signaling, {
        simulcast: this.simulcast,
        core: this.coreInstance
      }), this.handleSendHandler(), e.forEach(function (e) {
        e.connectStatus = E.Connecting;
      }), this.emit("@needrepub", e);
    }
  }, {
    key: "handleRecvHandler",
    value: function handleRecvHandler() {
      var _this48 = this;
      this.recvHandler.on("@needsubpc", function (e, t, i) {
        _this48.safeEmitAsPromise("@needsubpc", e).then(t, i);
      }).on("@connectionstatechange", function (e, t) {
        switch (m.log("sub pc connection state change", e), me.addEvent("ICEConnectionState", {
          pc_type: 1,
          state: e,
          id: _this48.recvHandler.pcid,
          protocol: t,
          event_grade: "failed" === e ? Ae.SERVERE : Ae.NORMAL,
          event_category: de.CORE
        }), e) {
          case "remote-disconnected":
          case "closed":
          case "failed":
            _this48.signaling.state === ui.OPEN ? _this48.resetRecvHandler() : _this48.recvHandler.close();
            break;
          case "disconnected":
            if (_this48.recvHandler._isRestartingICE || !_this48.recvHandler.pcid) return;
            _this48.signaling.state === ui.OPEN ? _this48.restartRecvICE(_this48.recvHandler.pcid) : _this48.signaling.once("@signalingauth", function (e) {
              "disconnected" === _this48.recvHandler.getCurrentIceConnectionState() && (_this48.extendedRtpCapabilities = e.rtpcaps, _this48.restartRecvICE(_this48.recvHandler.pcid));
            });
        }
      });
    }
  }, {
    key: "appendConsumer",
    value: function appendConsumer(e) {
      this.consumerQueue.push(e);
    }
  }, {
    key: "addConsumers",
    value: function addConsumers() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var e;
        return _regeneratorRuntime().wrap(function _callee41$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              e = this.consumerQueue;
              return _context42.abrupt("return", (this.consumerQueue = [], this.recvCommandQueue.push(qi.ADD_CONUMERS, e)));
            case 2:
            case "end":
              return _context42.stop();
          }
        }, _callee41, this);
      }));
    }
  }, {
    key: "initRecvHandler",
    value: function initRecvHandler(e) {
      return this.recvInitCommandQueue.push(qi.INIT_RECV, e);
    }
  }, {
    key: "removeConsumers",
    value: function removeConsumers(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
        return _regeneratorRuntime().wrap(function _callee42$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return this.recvCommandQueue.push(qi.REMOVE_CONSUMERS, e);
            case 2:
            case "end":
              return _context43.stop();
          }
        }, _callee42, this);
      }));
    }
  }, {
    key: "restartRecvICE",
    value: function restartRecvICE(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
        return _regeneratorRuntime().wrap(function _callee43$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              return _context44.abrupt("return", F.supportRestartICE ? this.recvCommandQueue.push(qi.RESTART_RECV_ICE, e) : this.resetRecvHandler());
            case 1:
            case "end":
              return _context44.stop();
          }
        }, _callee43, this);
      }));
    }
  }, {
    key: "_removeConsumers",
    value: function _removeConsumers(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
        return _regeneratorRuntime().wrap(function _callee44$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              _context45.next = 2;
              return this.recvHandler.removeConsumerTracks(e);
            case 2:
            case "end":
              return _context45.stop();
          }
        }, _callee44, this);
      }));
    }
  }, {
    key: "_initRecvHandler",
    value: function _initRecvHandler(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
        return _regeneratorRuntime().wrap(function _callee45$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              if (!this.recvHandler.isPcReady) {
                _context46.next = 6;
                break;
              }
              _context46.next = 3;
              return this.initSubPcPromise;
            case 3:
              _context46.t0 = null;
              _context46.next = 9;
              break;
            case 6:
              _context46.next = 8;
              return this.recvHandler.setupTransport(e);
            case 8:
              _context46.t0 = _context46.sent;
            case 9:
              return _context46.abrupt("return", _context46.t0);
            case 10:
            case "end":
              return _context46.stop();
          }
        }, _callee45, this);
      }));
    }
  }, {
    key: "_addConsumers",
    value: function _addConsumers(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        return _regeneratorRuntime().wrap(function _callee46$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              if (!(0 === e.length)) {
                _context47.next = 2;
                break;
              }
              return _context47.abrupt("return", Promise.resolve([]));
            case 2:
              _context47.next = 4;
              return this.recvHandler.addConsumerTracks(e);
            case 4:
              return _context47.abrupt("return", _context47.sent);
            case 5:
            case "end":
              return _context47.stop();
          }
        }, _callee46, this);
      }));
    }
  }, {
    key: "_execRestartRecvICE",
    value: function _execRestartRecvICE(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
        var t;
        return _regeneratorRuntime().wrap(function _callee47$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              this.recvHandler._isRestartingICE = !0;
              _context48.next = 3;
              return this.signaling.request("subpc-restart", {
                pcid: e
              });
            case 3:
              t = _context48.sent;
              if (!(0 !== t.code)) {
                _context48.next = 6;
                break;
              }
              return _context48.abrupt("return", (this.recvHandler._isRestartingICE = !1, m.debug("restart ice faild", t.code, t.error), void this.resetRecvHandler()));
            case 6:
              _context48.prev = 6;
              _context48.next = 9;
              return this.recvHandler.restartICE(t.iceParameters, t.iceCandidates);
            case 9:
              this.recvHandler._isRestartingICE = !1;
              _context48.next = 15;
              break;
            case 12:
              _context48.prev = 12;
              _context48.t0 = _context48["catch"](6);
              this.recvHandler._isRestartingICE = !1, m.debug("restart ice faild", t.code, t.error), this.resetRecvHandler();
            case 15:
            case "end":
              return _context48.stop();
          }
        }, _callee47, this, [[6, 12]]);
      }));
    }
  }, {
    key: "handleRecvCommandTask",
    value: function handleRecvCommandTask(e, t) {
      switch (e.method) {
        case qi.ADD_CONUMERS:
          return void (t.promise = this._addConsumers(e.data));
        case qi.REMOVE_CONSUMERS:
          return void (t.promise = this._removeConsumers(e.data));
        case qi.RESTART_RECV_ICE:
          return void (t.promise = this._execRestartRecvICE(e.data));
      }
    }
  }, {
    key: "handleRecvInitCommandTask",
    value: function handleRecvInitCommandTask(e, t) {
      e.method !== qi.INIT_RECV || (t.promise = this._initRecvHandler(e.data));
    }
  }, {
    key: "resetSendCommandQueue",
    value: function resetSendCommandQueue() {
      m.log("reset send queue"), this.sendCommandQueue = new U("SendQueue"), this.sendCommandQueue.on("exec", this.handleSendCommandTask.bind(this));
    }
  }, {
    key: "resetRecvCommandQueue",
    value: function resetRecvCommandQueue() {
      m.log("reset recv queue"), this.recvCommandQueue = new U("RecvQueue"), this.recvInitCommandQueue = new U("RecvInitQueue"), this.recvCommandQueue.on("exec", this.handleRecvCommandTask.bind(this)), this.recvInitCommandQueue.on("exec", this.handleRecvInitCommandTask.bind(this));
    }
  }, {
    key: "resetRecvHandler",
    value: function resetRecvHandler() {
      var _this49 = this;
      this.resetRecvCommandQueue(), this.emit("@needresetrecv"), this.recvHandler.close(), this.recvHandler = Pi("recv", this.extendedRtpCapabilities, this.signaling, {
        simulcast: this.simulcast,
        core: this.coreInstance
      }), this.initSubPcPromise = new Promise(function (e) {
        _this49.initSubPcPromiseResolve = e;
      }), this.handleRecvHandler(), this.emit("@needresub");
    }
  }, {
    key: "release",
    value: function release() {
      this.recvHandler.close(), this.sendHandler.close(), this.publishTracks.forEach(function (e) {
        return e.release();
      });
    }
  }]);
  return Li;
}(Jt);
var xi = new Jt();
function Ni(e, t) {
  return new Promise(function (i) {
    var s;
    var r = Date.now(),
      o = new WebSocket(e);
    o.onopen = function () {
      s && clearTimeout(s);
      var t = Date.now() - r;
      i({
        ws: o,
        url: e,
        status: !0,
        reason: "ok",
        connectTime: t
      });
    }, o.onerror = function () {
      s && clearTimeout(s);
      var t = Date.now() - r;
      i({
        ws: o,
        url: e,
        status: !1,
        reason: "onerror",
        connectTime: t
      });
    }, s = setTimeout(function () {
      var t = Date.now() - r;
      i({
        ws: o,
        url: e,
        status: !1,
        reason: "timeout",
        connectTime: t
      }), o.close();
    }, t);
  });
}
var ji;
!function (e) {
  e[e.Idle = 0] = "Idle", e[e.Connecting = 1] = "Connecting", e[e.Connected = 2] = "Connected", e[e.Reconnecting = 3] = "Reconnecting";
}(ji || (ji = {}));
var Fi = {
  transportPolicy: "preferUdp",
  simulcast: !1,
  reconnectTimes: 3,
  requestTimeout: 5e3,
  mcuServerHosts: []
};
var Ui = /*#__PURE__*/function (_t31) {
  _inherits(Ui, _t31);
  _createClass(Ui, [{
    key: "users",
    get: function get() {
      return Array.from(this._users.values());
    }
  }, {
    key: "trackInfoList",
    get: function get() {
      return this._trackInfo.map(zt);
    }
  }, {
    key: "roomState",
    get: function get() {
      return this._roomState;
    },
    set: function set(e) {
      this._roomState !== e && (this._roomState = e, m.debug("roomState change", this._roomState), this.emit("room-state-change", this._roomState), me.addEvent("RoomStateChanged", {
        room_state: e,
        event_grade: this._roomState === ji.Reconnecting ? Ae.SERVERE : Ae.NORMAL,
        event_category: de.CORE
      }));
    }
  }]);
  function Ui(e) {
    var _this50;
    _classCallCheck(this, Ui);
    var t;
    _this50 = _possibleConstructorReturn(this, _getPrototypeOf(Ui).call(this)), t = _assertThisInitialized(_assertThisInitialized(_this50)), _this50.profiles = new Map(), _this50._trackInfo = [], _this50.volumeIndicatorHistory = [], _this50.subscribeTracks = [], _this50._users = new Map(), _this50._roomState = ji.Idle, _this50.mergeJobMerger = {}, _this50.defaultMergeJobTracks = [], _this50.mergeJobTracks = {}, _this50.forwardJobTracks = {}, _this50._mode = ne.RTC, _this50._role = ae.AUDIENCE, _this50._privileges = ["subscribe", "publish"], _this50._publish = function (e, t) {
      return new Promise(function (i, s) {
        return g(_assertThisInitialized(_assertThisInitialized(_this50)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
          var _this51 = this;
          var r, o, n, _t32, _t33, _e36, _t34;
          return _regeneratorRuntime().wrap(function _callee48$(_context49) {
            while (1) switch (_context49.prev = _context49.next) {
              case 0:
                if (!(this.roomState !== ji.Connected)) {
                  _context49.next = 2;
                  break;
                }
                return _context49.abrupt("return", void s(ke("not connected to the room, please run joinRoom first")));
              case 2:
                if (!(0 === e.length && i(), this._mode === ne.LIVE && this._role === ae.AUDIENCE)) {
                  _context49.next = 4;
                  break;
                }
                return _context49.abrupt("return", void s(ke("no permission. Audience in Live mode has no permission to publish.")));
              case 4:
                e.forEach(function (e) {
                  return e.userID = _this51.userID;
                }), e.forEach(function (e) {
                  return e.selfEndedCallback = _this51.unpublish.bind(_this51);
                });
                r = this.connectionTransport, o = this.signaling;
                if (!t) {
                  _context49.next = 11;
                  break;
                }
                _t32 = e.map(function (e) {
                  return e.mediaTrack.id;
                });
                n = r.publishTracks.filter(function (e) {
                  return -1 !== _t32.indexOf(e.track.mediaTrack.id);
                });
                _context49.next = 15;
                break;
              case 11:
                _t33 = r.publishTracks.map(function (e) {
                  return e.track.mediaTrack.id;
                });
                if (!(e.filter(function (e) {
                  return -1 === _t33.indexOf(e.mediaTrack.id);
                }).length !== e.length)) {
                  _context49.next = 14;
                  break;
                }
                return _context49.abrupt("return", void s(ke("there are already published tracks in the provided tracks")));
              case 14:
                n = r.addTrackToPublishTracks(e);
              case 15:
                if (m.debug("start publish", n, t), !t) {
                  _e36 = n.map(function (e) {
                    return e.startConnect();
                  });
                  Promise.all(_e36).then(function () {
                    return i();
                  }).catch(function () {
                    s(Pe());
                  });
                }
                _context49.prev = 16;
                _context49.next = 19;
                return r.sendTracks(n);
              case 19:
                o.sendWsMsg("mute-tracks", {
                  tracks: n.map(function (e) {
                    return {
                      trackid: e.trackID,
                      muted: !!e.track.info.muted
                    };
                  })
                });
                _t34 = tt(this.users, "userID", this.userID);
                _t34 && (_t34.addTracks(n.map(function (e) {
                  return e.track;
                })), _t34.addPublishedTrackInfo(n.map(function (e) {
                  return {
                    trackID: e.trackID,
                    muted: !!e.track.info.muted,
                    kind: e.track.info.kind,
                    tag: e.track.info.tag,
                    userID: _this51.userID,
                    versionid: e.track.info.versionid,
                    profiles: e.track.info.profiles
                  };
                }))), e.forEach(function (e) {
                  e.on("@get-stats", function (t, i, s) {
                    if (!_this51.connectionTransport) return i([]);
                    var r = e.isReplacedByImageTrack ? e.imageStreamTrack.mediaTrack : e.mediaTrack;
                    _this51.connectionTransport.sendHandler.getStats(r, t).then(i, s);
                  });
                }), this.getAllMerger().forEach(function (t) {
                  return t.controller.onAddTracks(e.map(function (e) {
                    return e.info;
                  }));
                });
                _context49.next = 36;
                break;
              case 24:
                _context49.prev = 24;
                _context49.t0 = _context49["catch"](16);
                if (!(_context49.t0 instanceof ge)) {
                  _context49.next = 35;
                  break;
                }
                _context49.t1 = _context49.t0.code;
                _context49.next = _context49.t1 === 10061 ? 30 : _context49.t1 === 30001 ? 30 : _context49.t1 === 10052 ? 31 : 32;
                break;
              case 30:
                return _context49.abrupt("return");
              case 31:
                return _context49.abrupt("return", (m.warning(_context49.t0, "republish"), void setTimeout(function () {
                  return _this51._publish(e, !0);
                }, 1e3)));
              case 32:
                r.removeTrackFromPublishTracks(e), s(_context49.t0);
              case 33:
                _context49.next = 36;
                break;
              case 35:
                m.warning(_context49.t0, "republish"), setTimeout(function () {
                  return _this51._publish(e, !0);
                }, 1e3);
              case 36:
              case "end":
                return _context49.stop();
            }
          }, _callee48, this, [[16, 24]]);
        }));
      });
    }, _this50._subscribe = function (e, s) {
      var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
        o = arguments.length > 3 ? arguments[3] : void 0;
      return new Promise(function (n, a) {
        return g(t, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
          var _this52 = this;
          var t, c, A, d, _e37, _i28, _e39, _e40, _t35, _o6, _u, _e41, _iterator30, _step30, _loop12, _iterator31, _step31, _loop13, _ret, _h, _s17;
          return _regeneratorRuntime().wrap(function _callee50$(_context53) {
            while (1) switch (_context53.prev = _context53.next) {
              case 0:
                if (!(this.roomState !== ji.Connected)) {
                  _context53.next = 2;
                  break;
                }
                return _context53.abrupt("return", void a(ke("can not connected to the room, please joinRoom first")));
              case 2:
                if (!(0 === e.length)) {
                  _context53.next = 4;
                  break;
                }
                return _context53.abrupt("return", void n([]));
              case 4:
                m.debug("subscribe", e, s);
                t = this._trackInfo.filter(function (t) {
                  return e.includes(t.trackid);
                });
                if (!(t.length !== e.length)) {
                  _context53.next = 8;
                  break;
                }
                return _context53.abrupt("return", void a(We(10041, "can not find track in room ".concat(e))));
              case 8:
                A = this.connectionTransport, d = this.signaling;
                if (s) c = this.subscribeTracks.filter(function (t) {
                  return -1 !== e.indexOf(t.trackID);
                });else {
                  _e37 = this.subscribeTracks.map(function (e) {
                    return e.trackID;
                  }), _i28 = t.filter(function (t) {
                    return !_e37.includes(t.trackid);
                  });
                  c = _i28.map(function (e) {
                    return new bi(A, "recv", void 0, e.trackid, e.mid);
                  }), this.subscribeTracks = this.subscribeTracks.concat(c);
                }
                o && Object.entries(o).forEach(function (e) {
                  var _e38 = _slicedToArray(e, 2),
                    t = _e38[0],
                    i = _e38[1];
                  _this52.profiles.set(t, i);
                }), m.log("sub tracks", c, o);
                _context53.prev = 11;
                if (!s) {
                  _e39 = c.map(function (e) {
                    return e.startConnect();
                  });
                  Promise.all(_e39).then(function () {
                    return n(c.map(function (e) {
                      return e.track;
                    }));
                  }).catch(function () {
                    a(Pe());
                  });
                }
                _context53.next = 15;
                return A.initRecvHandler(c.map(function (e) {
                  return e.trackID;
                }));
              case 15:
                _e40 = _context53.sent;
                if (_e40) {
                  _context53.next = 22;
                  break;
                }
                _t35 = Date.now();
                _context53.next = 20;
                return d.request("sub-tracks", {
                  tracks: c.map(function (e) {
                    var t = e.trackID;
                    return _this52.profiles.get(t) ? {
                      trackid: t,
                      profile: _this52.profiles.get(t)
                    } : {
                      trackid: t
                    };
                  })
                });
              case 20:
                _e40 = _context53.sent;
                me.addEvent("SubscribeTracks", {
                  result_code: _e40.code,
                  signal_take_time: Date.now() - _t35,
                  tracks: _e40.tracks.map(function (e) {
                    return {
                      track_id: e.trackid,
                      status: e.status
                    };
                  })
                });
              case 22:
                _context53.t0 = (m.log("get sub res data", _e40), _e40.code);
                _context53.next = _context53.t0 === 0 ? 25 : _context53.t0 === 10052 ? 26 : _context53.t0 === 10062 ? 27 : 28;
                break;
              case 25:
                return _context53.abrupt("break", 29);
              case 26:
                throw Ye();
              case 27:
                throw A.resetRecvHandler(), We(10062, _e40.error);
              case 28:
                throw We(_e40.code, _e40.error);
              case 29:
                _o6 = _e40.tracks.filter(function (e) {
                  return !!e.status;
                }), _u = _e40.tracks.filter(function (e) {
                  return !e.status;
                }).map(function (e) {
                  return e.trackid;
                });
                if (!(_o6.length < _e40.tracks.length && r)) {
                  _context53.next = 32;
                  break;
                }
                throw We(10041, "can not find target track id: ".concat(_u.join(" ")));
              case 32:
                if (_o6 && !r) {
                  m.debug("can not find target track id: ".concat(_u.join(""), ", continue"));
                  _e41 = i(c, function (e) {
                    return -1 !== _u.indexOf(e.trackID);
                  });
                  i(this.subscribeTracks, function (e) {
                    return -1 !== _u.indexOf(e.trackID);
                  }), _e41.map(function (e) {
                    return e.release();
                  });
                }
                _e40.tracks = _o6;
                _iterator30 = _createForOfIteratorHelper(_e40.tracks || []);
                _context53.prev = 35;
                _loop12 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop12() {
                  var i, e, s, r;
                  return _regeneratorRuntime().wrap(function _loop12$(_context50) {
                    while (1) switch (_context50.prev = _context50.next) {
                      case 0:
                        i = _step30.value;
                        e = c.find(function (e) {
                          return e.trackID === i.trackid;
                        }), s = t.find(function (e) {
                          return e.trackid === i.trackid;
                        });
                        if (!(!e || !s)) {
                          _context50.next = 4;
                          break;
                        }
                        return _context50.abrupt("return", 1);
                      case 4:
                        r = i.rtpparams;
                        e.appendConsumner(r, s.kind);
                      case 6:
                      case "end":
                        return _context50.stop();
                    }
                  }, _loop12);
                });
                _iterator30.s();
              case 38:
                if ((_step30 = _iterator30.n()).done) {
                  _context53.next = 44;
                  break;
                }
                return _context53.delegateYield(_loop12(), "t1", 40);
              case 40:
                if (!_context53.t1) {
                  _context53.next = 42;
                  break;
                }
                return _context53.abrupt("continue", 42);
              case 42:
                _context53.next = 38;
                break;
              case 44:
                _context53.next = 49;
                break;
              case 46:
                _context53.prev = 46;
                _context53.t2 = _context53["catch"](35);
                _iterator30.e(_context53.t2);
              case 49:
                _context53.prev = 49;
                _iterator30.f();
                return _context53.finish(49);
              case 52:
                _context53.next = 54;
                return A.addConsumers();
              case 54:
                A.resolveInitSubPcPromise();
                _iterator31 = _createForOfIteratorHelper(c);
                _context53.prev = 56;
                _loop13 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop13() {
                  var e, i, s, r, o, n;
                  return _regeneratorRuntime().wrap(function _loop13$(_context52) {
                    while (1) switch (_context52.prev = _context52.next) {
                      case 0:
                        e = _step31.value;
                        i = e.consumer;
                        if (!(!i || !i.track)) {
                          _context52.next = 4;
                          break;
                        }
                        return _context52.abrupt("return", 0);
                      case 4:
                        s = i.track;
                        r = e.track;
                        o = t.find(function (e) {
                          return e.trackid === i.id;
                        });
                        if (o) {
                          _context52.next = 9;
                          break;
                        }
                        return _context52.abrupt("return", 0);
                      case 9:
                        r ? r.resume(s) : "audio" === s.kind ? (r = new Ri(s, o.playerid, "remote"), r.initAudioManager()) : r = new Wt(s, o.playerid, "remote", o.profiles || []), r.setInfo({
                          trackID: o.trackid,
                          userID: o.playerid,
                          tag: o.tag,
                          kind: o.kind,
                          muted: o.muted,
                          versionid: o.versionid
                        }), r.setMaster(o.master), r.removeAllListeners("@get-stats"), r.removeAllListeners("@ended"), r.on("@get-stats", function (e, t, i) {
                          if (!_this52.connectionTransport) return t([]);
                          _this52.connectionTransport.recvHandler.getStats(r.mediaTrack, e).then(t, i);
                        }), r.once("@ended", function () {
                          return g(_this52, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
                            return _regeneratorRuntime().wrap(function _callee49$(_context51) {
                              while (1) switch (_context51.prev = _context51.next) {
                                case 0:
                                  if (!(r && r.info.trackID)) {
                                    _context51.next = 11;
                                    break;
                                  }
                                  m.warning("remote track ended, try to resubscribe");
                                  _context51.prev = 2;
                                  _context51.next = 5;
                                  return this._unsubscribe([r.info.trackID], !0);
                                case 5:
                                  _context51.next = 9;
                                  break;
                                case 7:
                                  _context51.prev = 7;
                                  _context51.t0 = _context51["catch"](2);
                                case 9:
                                  _context51.next = 11;
                                  return this._subscribe([r.info.trackID], !0);
                                case 11:
                                case "end":
                                  return _context51.stop();
                              }
                            }, _callee49, this, [[2, 7]]);
                          }));
                        }), e.track = r;
                        n = _this52.users.find(function (e) {
                          return e.userID === o.playerid;
                        });
                        n && n.addTracks([r]);
                      case 12:
                      case "end":
                        return _context52.stop();
                    }
                  }, _loop13);
                });
                _iterator31.s();
              case 59:
                if ((_step31 = _iterator31.n()).done) {
                  _context53.next = 66;
                  break;
                }
                return _context53.delegateYield(_loop13(), "t3", 61);
              case 61:
                _ret = _context53.t3;
                if (!(_ret === 0)) {
                  _context53.next = 64;
                  break;
                }
                return _context53.abrupt("continue", 64);
              case 64:
                _context53.next = 59;
                break;
              case 66:
                _context53.next = 71;
                break;
              case 68:
                _context53.prev = 68;
                _context53.t4 = _context53["catch"](56);
                _iterator31.e(_context53.t4);
              case 71:
                _context53.prev = 71;
                _iterator31.f();
                return _context53.finish(71);
              case 74:
                c.forEach(function (e) {
                  return e.connectStatus = E.Connect;
                });
                _h = _e40.tracks.map(function (e) {
                  if (void 0 === e.muted) for (var _t36 = 0; _t36 < _this52._trackInfo.length; _t36++) e.trackid === _this52._trackInfo[_t36].trackid && (e.muted = _this52._trackInfo[_t36].muted);
                  return e;
                });
                this.handleMute({
                  tracks: _h
                });
                _context53.next = 94;
                break;
              case 79:
                _context53.prev = 79;
                _context53.t5 = _context53["catch"](11);
                m.log(_context53.t5);
                _s17 = [];
                c.forEach(function (e) {
                  e.consumer && _s17.push(e.consumer);
                });
                _context53.next = 86;
                return A.removeConsumers(_s17);
              case 86:
                if (_context53.t5 instanceof ge) {
                  _context53.next = 88;
                  break;
                }
                return _context53.abrupt("return", (m.warning(_context53.t5, "resubscribe"), void setTimeout(function () {
                  return _this52._subscribe(e, !0);
                }, 1e3)));
              case 88:
                _context53.t6 = _context53.t5.code;
                _context53.next = _context53.t6 === 10062 ? 91 : _context53.t6 === 30001 ? 91 : _context53.t6 === 10052 ? 92 : 93;
                break;
              case 91:
                return _context53.abrupt("return");
              case 92:
                return _context53.abrupt("return", (m.warning(_context53.t5, "resubscribe"), void setTimeout(function () {
                  return _this52._subscribe(e, !0);
                }, 1e3)));
              case 93:
                i(this.subscribeTracks, function (t) {
                  return -1 !== e.indexOf(t.trackID);
                }), a(_context53.t5);
              case 94:
                n(c.map(function (e) {
                  return e.track;
                }));
              case 95:
              case "end":
                return _context53.stop();
            }
          }, _callee50, this, [[11, 79], [35, 46, 49, 52], [56, 68, 71, 74]]);
        }));
      });
    }, _this50.config = Object.assign(Object.assign({}, Fi), e), m.log("config", _this50.config), m.log("version", D), m.log("browser report", F, P);
    return _this50;
  }
  _createClass(Ui, [{
    key: "_setReconnectTimes",
    value: function _setReconnectTimes(e) {
      this.config.reconnectTimes = e, this.signaling && (this.signaling.reconnectTimes = e);
    }
  }, {
    key: "_getReconnectTimes",
    value: function _getReconnectTimes() {
      return this.config.reconnectTimes || Fi.reconnectTimes;
    }
  }, {
    key: "setRequestTimeout",
    value: function setRequestTimeout(e) {
      this.config.requestTimeout = e, this.signaling && (this.signaling.requestTimeout = e);
    }
  }, {
    key: "_setProfile",
    value: function _setProfile(e, t) {
      if (this.profile = t, this.profiles.set(e, t), !this.subscribeTracks.some(function (t) {
        return t.trackID === e;
      })) return;
      this.signaling.sendWsMsg("set-sub-profile", {
        tracks: [{
          trackid: e,
          profile: this.profile
        }]
      });
    }
  }, {
    key: "getForwardJobTracks",
    value: function getForwardJobTracks() {
      return this.forwardJobTracks;
    }
  }, {
    key: "setClientMode",
    value: function setClientMode(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee51() {
        return _regeneratorRuntime().wrap(function _callee51$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              if (!(this.roomState !== ji.Idle)) {
                _context54.next = 2;
                break;
              }
              throw ke("can not setClientMode, room state is not idle");
            case 2:
              this._mode = e, this._setPrivileges();
            case 3:
            case "end":
              return _context54.stop();
          }
        }, _callee51, this);
      }));
    }
  }, {
    key: "_setPrivileges",
    value: function _setPrivileges() {
      this._mode === ne.RTC || this._mode === ne.LIVE && this._role === ae.BROADCASTER ? this._privileges = ["subscribe", "publish"] : this._privileges = ["subscribe"];
    }
  }, {
    key: "setClientRole",
    value: function setClientRole(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
        var t;
        return _regeneratorRuntime().wrap(function _callee52$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              if (!(this._mode === ne.RTC)) {
                _context55.next = 2;
                break;
              }
              throw ke("client role can only be set in client mode LIVE.");
            case 2:
              if (!(e === ae.AUDIENCE && this.publishedTracks.length > 0 && e === ae.AUDIENCE)) {
                _context55.next = 4;
                break;
              }
              throw ke("cannot change to audience, please unpublish all tracks first.");
            case 4:
              if (!(this._role = e, this._setPrivileges(), this.roomState !== ji.Connected)) {
                _context55.next = 6;
                break;
              }
              return _context55.abrupt("return");
            case 6:
              _context55.next = 8;
              return this.signaling.request("set-privileges", {
                privileges: this._privileges
              });
            case 8:
              t = _context55.sent;
              if (!(me.addEvent("SetClientRole", {
                result_code: t.code,
                user_role: e === ae.BROADCASTER ? 0 : 1,
                audience_latency_level: 0
              }), 0 !== t.code)) {
                _context55.next = 11;
                break;
              }
              throw ze(t.code, t.error);
            case 11:
            case "end":
              return _context55.stop();
          }
        }, _callee52, this);
      }));
    }
  }, {
    key: "joinRoomWithToken",
    value: function joinRoomWithToken(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
        var i, s, r, _s18, _t37, _i29, _r6, _t38;
        return _regeneratorRuntime().wrap(function _callee53$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              i = Date.now();
              s = 0;
              this._mode === ne.LIVE && (s = 1);
              r = this._role === ae.BROADCASTER ? 0 : 1;
              if (!(me.addEvent("JoinRoom", {
                room_token: e,
                user_data: t,
                room_type: s,
                user_role: r,
                audience_latency_level: 0
              }), this.roomState !== ji.Idle)) {
                _context56.next = 6;
                break;
              }
              throw ke("roomState is not idle! Do not repeat join room, please run leaveRoom first");
            case 6:
              this.roomState = ji.Connecting;
              _context56.prev = 7;
              this.roomToken = e, this.userData = t;
              _s18 = et(e);
              if (!(this.userID = _s18.userId, this.roomName = _s18.roomName, this.appId = _s18.appId, me.setUserBase(this.userID, this.roomName, this.appId), m.log("join room, token:", e), m.debug("join room, roomName: ".concat(this.roomName, ", userID: ").concat(this.userID)), !this.roomName.match(/^[a-zA-Z0-9_-]{1,64}$/))) {
                _context56.next = 12;
                break;
              }
              throw this.roomState = ji.Idle, ke("invalid roomname. roomname must match /^[a-zA-Z0-9_-]{1,64}$/");
            case 12:
              if (this.userID.match(/^[a-zA-Z0-9_-]{1,50}$/)) {
                _context56.next = 14;
                break;
              }
              throw this.roomState = ji.Idle, ke("invalid userID. userID must match /^[a-zA-Z0-9_-]{1,50}$/");
            case 14:
              _context56.prev = 14;
              _context56.next = 17;
              return Ai(_s18, e, this.config.requestTimeout);
            case 17:
              _t37 = _context56.sent;
              this.accessToken = _t37.accessToken;
              _i29 = (Date.now() + Math.floor(100 * Math.random())).toString();
              me.setSessionId(_i29), me.setUserBase(this.userID, this.roomName, this.appId);
              _context56.next = 26;
              break;
            case 23:
              _context56.prev = 23;
              _context56.t0 = _context56["catch"](14);
              throw _context56.t0;
            case 26:
              _context56.next = 28;
              return this.joinRoomWithAccess(this.accessToken);
            case 28:
              _r6 = _context56.sent;
              me.addEvent("JoinRoomResult", {
                join_start_time: i,
                join_take_time: Date.now() - i,
                join_result_code: 0,
                join_node_info: this.signaling.url,
                join_error_message: "",
                event_grade: Ae.NORMAL,
                event_category: de.CORE
              });
              _context56.t1 = this._mode === ne.LIVE;
              if (!_context56.t1) {
                _context56.next = 34;
                break;
              }
              _context56.next = 34;
              return this.setClientRole(this._role);
            case 34:
              return _context56.abrupt("return", _r6);
            case 37:
              _context56.prev = 37;
              _context56.t2 = _context56["catch"](7);
              _t38 = _context56.t2;
              throw this.roomState = ji.Idle, m.debug("joinRoomWithToken fail: " + _t38.message), me.addEvent("JoinRoomResult", {
                join_start_time: i,
                join_take_time: Date.now() - i,
                join_result_code: _t38.code ? _t38.code : -1,
                join_node_info: this.signaling ? this.signaling.url : "",
                join_error_message: _t38.message || _t38.error || "",
                event_grade: Ae.SERVERE,
                event_category: de.CORE
              }), _t38;
            case 41:
            case "end":
              return _context56.stop();
          }
        }, _callee53, this, [[7, 37], [14, 23]]);
      }));
    }
  }, {
    key: "joinRoomWithAccess",
    value: function joinRoomWithAccess(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
        var _this53 = this;
        var t, _yield, i, s, _e42, _yield2, _i30, _r7, _o7, _iterator33, _step33, _e43;
        return _regeneratorRuntime().wrap(function _callee55$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              t = $e(e);
              _context58.next = 3;
              return function () {
                return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee54() {
                  var e, _yield$ni, t, i, s, _yield$ni2, r;
                  return _regeneratorRuntime().wrap(function _callee54$(_context57) {
                    while (1) switch (_context57.prev = _context57.next) {
                      case 0:
                        e = qt();
                        _context57.next = 3;
                        return ni(e);
                      case 3:
                        _yield$ni = _context57.sent;
                        t = _yield$ni.isH264;
                        i = _yield$ni.sdp;
                        s = 5;
                      case 7:
                        if (!(!t && s > 0)) {
                          _context57.next = 19;
                          break;
                        }
                        e.close();
                        e = qt();
                        _context57.next = 12;
                        return ni(e);
                      case 12:
                        _yield$ni2 = _context57.sent;
                        t = _yield$ni2.isH264;
                        i = _yield$ni2.sdp;
                        _yield$ni2;
                        s--;
                      case 17:
                        _context57.next = 7;
                        break;
                      case 19:
                        F.needH264FmtpLine && (i += "a=fmtp:107 level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=42e01f".concat("\n")), i = ci(i);
                        r = {
                          capsdp: i,
                          agent: navigator.userAgent
                        };
                        return _context57.abrupt("return", (e.close(), r));
                      case 22:
                      case "end":
                        return _context57.stop();
                    }
                  }, _callee54);
                }));
              }();
            case 3:
              _yield = _context58.sent;
              i = _yield.capsdp;
              if (!(this._roomState === ji.Idle)) {
                _context58.next = 7;
                break;
              }
              throw ke("roomState is idle, maybe because you left the room.");
            case 7:
              s = new mi(e, i, this._getReconnectTimes(), this.config.requestTimeout, this.userData, this._privileges);
              s.on("@error", this.handleDisconnect.bind(this)).on("@ws-state-change", function (e, t) {
                if (t === ui.CONNECTING) _this53.roomState === ji.Connected ? _this53.roomState = ji.Reconnecting : _this53.roomState !== ji.Reconnecting && (_this53.roomState = ji.Connecting);
              }).on("@needupdateaccesstoken", function (e, t) {
                _this53.updateAccessToken().then(e).catch(t);
              }).on("on-player-in", this.handlePlayerIn.bind(this)).on("on-player-out", this.handlePlayerOut.bind(this)).on("on-add-tracks", function (e) {
                _this53.filterSignalTracks(e), _this53.handleAddTracks(e);
              }).on("on-remove-tracks", function (e) {
                _this53.filterSignalTracks(e), _this53.handleRemoveTracks(e);
              }).on("mute-tracks", function (e) {
                _this53.filterSignalTracks(e), _this53.handleMute(e);
              }).on("on-messages", this.handleCustomMessages.bind(this)).on("on-qos-messages", this.handleQosMessages.bind(this)).on("on-pubpc-restart-notify", function (e) {
                var t = _this53.connectionTransport;
                me.addEvent("AbnormalDisconnect", {
                  event_reason: "on-pubpc-restart-notify",
                  event_description: e.error,
                  event_grade: Ae.SERVERE,
                  event_category: de.CORE,
                  event_reason_code: 0,
                  socket_node_info: s.url
                }), t && F.supportRestartICE && t.restartSendICE(e.pcid).catch(m.debug);
              }).on("on-subpc-restart-notify", function (e) {
                var t = _this53.connectionTransport;
                me.addEvent("AbnormalDisconnect", {
                  event_reason: "on-subpc-restart-notify",
                  event_description: e.error,
                  event_grade: Ae.SERVERE,
                  event_category: de.CORE,
                  event_reason_code: 0,
                  socket_node_info: s.url
                }), t && F.supportRestartICE && t.restartRecvICE(e.pcid).catch(m.debug);
              }).on("on-sub-profile-changed", function (e) {
                _this53.emit("on-sub-profile-changed", e);
              }).on("on-job-connected", function (e) {
                _this53.emit("forward-job-connected", {
                  jobId: e.id
                });
              }).on("on-job-disconnected", function (e) {
                _this53.emit("forward-job-disconnected", {
                  jobId: e.id
                });
              }).on("on-merge-job-connected", function (e) {
                _this53.emit("merge-job-connected", {
                  jobId: e.id
                });
              }).on("on-merge-job-disconnected", function (e) {
                _this53.emit("merge-job-disconnected", {
                  jobId: e.id
                });
              }).on("on-command", function (e) {
                _this53.emit("command", {
                  content: e.content,
                  command: e.command
                });
              }).on("on-media-relay-state", function (e) {
                var t = e.roomid.slice(e.roomid.indexOf(":") + 1);
                _this53.emit("media-relay-state-changed", t, e.state);
              }).on("disconnect", this.handleDisconnect.bind(this)).on("on-player-reconnect", this.handleRemoteUserReconnecting.bind(this)).on("on-player-reconnect-in", this.handleRemoteUserReconnected.bind(this)), m.log("init signaling websocket"), this.signaling = s;
              _context58.prev = 9;
              _e42 = t.roomServers && t.roomServers.length > 0 ? t.roomServers.sort(function (e, t) {
                return t.score - e.score;
              }).map(function (e) {
                return e.url;
              }) : [t.signalingurl2];
              _context58.next = 13;
              return function (e, t) {
                var i = [],
                  s = !1;
                return new Promise(function (r, o) {
                  var _iterator32 = _createForOfIteratorHelper(e),
                    _step32;
                  try {
                    for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
                      var n = _step32.value;
                      Ni(n, t).then(function (t) {
                        i.push(t), t.status && (r({
                          ws: t.ws,
                          url: t.url
                        }), s = !0), me.addEvent("WebsocketConnect", {
                          happy_dns_resolve_time: 0,
                          happy_dns_take_effect: !1,
                          socket_node_info: t.url,
                          socket_connect_time: t.connectTime,
                          socket_connect_success: t.status,
                          socket_connect_error_message: t.reason,
                          event_grade: s ? Ae.NORMAL : Ae.SERVERE,
                          event_category: de.CORE,
                          dns_resolve_time: 0,
                          dns_take_effect: !1,
                          dns_resolved_ip: "",
                          socket_connect_reason: "connect"
                        }), i.length !== e.length || s || o(ve("websocket connect failed."));
                      });
                    }
                  } catch (err) {
                    _iterator32.e(err);
                  } finally {
                    _iterator32.f();
                  }
                });
              }(_e42, this.config.requestTimeout);
            case 13:
              _yield2 = _context58.sent;
              _i30 = _yield2.ws;
              _r7 = _yield2.url;
              _context58.next = 18;
              return s.initWs(!0, _i30, _r7);
            case 18:
              _o7 = _context58.sent;
              s.on("@signalingauth", this.handleAuth.bind(this));
              _context58.next = 22;
              return this.handleAuth(_o7);
            case 22:
              _context58.next = 31;
              break;
            case 24:
              _context58.prev = 24;
              _context58.t0 = _context58["catch"](9);
              if (!(this.signaling && (this.signaling.release(), this.signaling = void 0), 10052 === _context58.t0.code)) {
                _context58.next = 30;
                break;
              }
              _context58.next = 29;
              return at(1e3);
            case 29:
              return _context58.abrupt("return", this.joinRoomWithToken(this.roomToken, this.userData));
            case 30:
              throw _context58.t0;
            case 31:
              _iterator33 = _createForOfIteratorHelper(this.users);
              try {
                for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
                  _e43 = _step33.value;
                  _e43.userID !== this.userID && this.emit("user-join", _e43);
                }
              } catch (err) {
                _iterator33.e(err);
              } finally {
                _iterator33.f();
              }
              return _context58.abrupt("return", (this.trackInfoList.length > 0 && this.emit("track-add", this.trackInfoList), this.users));
            case 34:
            case "end":
              return _context58.stop();
          }
        }, _callee55, this, [[9, 24]]);
      }));
    }
  }, {
    key: "_unpublish",
    value: function _unpublish(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
        var t, i, s;
        return _regeneratorRuntime().wrap(function _callee56$(_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context59.next = 2;
                break;
              }
              throw ke("not connected to the room");
            case 2:
              if (!(0 === e.length)) {
                _context59.next = 4;
                break;
              }
              return _context59.abrupt("return");
            case 4:
              m.debug("unpublish", e);
              t = this.connectionTransport, i = t.publishTracks.filter(function (t) {
                return -1 !== e.indexOf(t.trackID);
              });
              if (!(i.length !== e.length)) {
                _context59.next = 8;
                break;
              }
              throw ke("can not find target trackid to unpublish");
            case 8:
              _context59.next = 10;
              return t.removeTracks(i);
            case 10:
              this.getAllMerger().forEach(function (e) {
                return e.controller.onRemoveTracks(i.map(function (e) {
                  return e.track.info;
                }));
              });
              s = tt(this.users, "userID", this.userID);
              s && (s.removeTracksByTrackId(e), s.removePublishedTrackInfo(e)), this.cleanTrackIdsFromMergeJobs(e);
            case 13:
            case "end":
              return _context59.stop();
          }
        }, _callee56, this);
      }));
    }
  }, {
    key: "createMergeJob",
    value: function createMergeJob(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
        var i, s, r;
        return _regeneratorRuntime().wrap(function _callee57$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context60.next = 2;
                break;
              }
              throw ke("can not createMergeJob, room state is not connected");
            case 2:
              i = Object.assign(Object.assign(Object.assign({}, _), t), {
                id: e
              });
              m.debug("send create merge job", i, e);
              s = Date.now();
              _context60.next = 7;
              return this.signaling.request("create-merge-job", i);
            case 7:
              r = _context60.sent;
              if (!(me.addEvent("CreateMergeJob", {
                signal_take_time: Date.now() - s,
                id: e,
                result_code: r.code
              }), 0 !== r.code)) {
                _context60.next = 10;
                break;
              }
              throw Qe(r.code, r.error);
            case 10:
              this.mergeJobTracks[e] ? m.warning("merge job id already exist", e) : this.mergeJobTracks[e] = [];
            case 11:
            case "end":
              return _context60.stop();
          }
        }, _callee57, this);
      }));
    }
  }, {
    key: "createForwardJob",
    value: function createForwardJob(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
        var t, i, s, r, o, n;
        return _regeneratorRuntime().wrap(function _callee58$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context61.next = 2;
                break;
              }
              throw ke("can not createForwardJob, room state is not connected");
            case 2:
              t = !!e.audioTrackId && !e.videoTrackId, i = [e.audioTrackId, e.videoTrackId].filter(Boolean).map(function (e) {
                return {
                  trackid: e
                };
              }), s = {
                id: e.jobId,
                publishUrl: e.publishUrl,
                audioOnly: t,
                tracks: i
              };
              if (!(e && e.userConfigExtraInfo)) {
                _context61.next = 7;
                break;
              }
              if (!(r = e.userConfigExtraInfo, !(new Blob([r]).size <= 1e3))) {
                _context61.next = 6;
                break;
              }
              throw ke("userConfigExtraInfo Up to 1000 Bytes");
            case 6:
              s.seiTemplate = {
                value: e.userConfigExtraInfo
              };
            case 7:
              o = Date.now();
              _context61.next = 10;
              return this.signaling.request("create-forward-job", s);
            case 10:
              n = _context61.sent;
              if (!(me.addEvent("CreateForwardJob", {
                signal_take_time: Date.now() - o,
                id: e.jobId,
                result_code: n.code
              }), 0 !== n.code)) {
                _context61.next = 13;
                break;
              }
              throw Ge(n.code, n.error);
            case 13:
              this.forwardJobTracks[e.jobId] ? m.warning("forward job id already exist", e.jobId) : (this.forwardJobTracks[e.jobId] = [], e.audioTrackId && this.forwardJobTracks[e.jobId].push(e.audioTrackId), e.videoTrackId && this.forwardJobTracks[e.jobId].push(e.videoTrackId));
            case 14:
            case "end":
              return _context61.stop();
          }
        }, _callee58, this);
      }));
    }
  }, {
    key: "stopForwardJob",
    value: function stopForwardJob(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
        return _regeneratorRuntime().wrap(function _callee59$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context62.next = 2;
                break;
              }
              throw ke("can not stopForwardJob, room state is not connected");
            case 2:
              if (!(e && !this.forwardJobTracks[e])) {
                _context62.next = 4;
                break;
              }
              throw ke("no forward job id ".concat(e));
            case 4:
              me.addEvent("StopForwardJob", {
                id: e || ""
              });
              _context62.next = 7;
              return this.signaling.request("stop-forward", {
                id: e,
                delayMillisecond: 0
              });
            case 7:
              delete this.forwardJobTracks[e];
            case 8:
            case "end":
              return _context62.stop();
          }
        }, _callee59, this);
      }));
    }
  }, {
    key: "setDefaultMergeStream",
    value: function setDefaultMergeStream(e, t, i) {
      if (i && !this.mergeJobTracks[i]) throw Me(i);
      this.merger && !i && (this.merger.release(), this.merger = void 0), i && this.mergeJobMerger[i] && (this.mergeJobMerger[i].release(), delete this.mergeJobMerger[i]);
      var s = this.CreateMergerSessionController();
      i ? this.mergeJobMerger[i] = new gi(e, t, s, i) : this.merger = new gi(e, t, s, i);
    }
  }, {
    key: "_stopMerge",
    value: function _stopMerge(e) {
      if (this.roomState !== ji.Connected) throw ke("can not addMergeTracks, room state is not connected");
      if (e && !this.mergeJobTracks[e]) throw Me(e);
      me.addEvent("StopMerge", {
        id: e || ""
      }), this.signaling.sendWsMsg("stop-merge", {
        id: e
      }), e ? (delete this.mergeJobTracks[e], this.mergeJobMerger[e] && (this.mergeJobMerger[e].release(), delete this.mergeJobMerger[e])) : (this.defaultMergeJobTracks = [], this.merger && (this.merger.release(), this.merger = void 0));
    }
  }, {
    key: "_addMergeTracks",
    value: function _addMergeTracks(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee60() {
        var i, s, r;
        return _regeneratorRuntime().wrap(function _callee60$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context63.next = 2;
                break;
              }
              throw ke("can not addMergeTracks, room state is not connected");
            case 2:
              if (!(t && !this.mergeJobTracks[t])) {
                _context63.next = 4;
                break;
              }
              throw Me(t);
            case 4:
              i = e.map(function (e) {
                return {
                  trackid: e.trackID,
                  x: e.x,
                  y: e.y,
                  w: e.w,
                  h: e.h,
                  z: e.z,
                  stretchMode: e.stretchMode
                };
              }), s = {
                id: t,
                add: i
              };
              m.debug("addMergeTracks", s), t ? (this.mergeJobTracks[t] = this.mergeJobTracks[t].concat(e.map(function (e) {
                return e.trackID;
              })), this.mergeJobTracks[t] = u(this.mergeJobTracks[t], function (e) {
                return e;
              })) : (this.defaultMergeJobTracks = this.defaultMergeJobTracks.concat(e.map(function (e) {
                return e.trackID;
              })), this.defaultMergeJobTracks = u(this.defaultMergeJobTracks, function (e) {
                return e;
              }));
              _context63.next = 8;
              return this.signaling.request("update-merge-tracks", s);
            case 8:
              r = _context63.sent;
              if (!(me.addEvent("UpdateMergeTracks", {
                id: t || "",
                add: i.map(function (e) {
                  return {
                    track_id: e.trackid,
                    x: e.x || 0,
                    y: e.y || 0,
                    w: e.w || 0,
                    h: e.h || 0,
                    z: e.z || 0,
                    stretchMode: e.stretchMode || ""
                  };
                }),
                result_code: r.code
              }), 0 !== r.code)) {
                _context63.next = 11;
                break;
              }
              throw ze(r.code, r.error);
            case 11:
            case "end":
              return _context63.stop();
          }
        }, _callee60, this);
      }));
    }
  }, {
    key: "_removeMergeTracks",
    value: function _removeMergeTracks(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee61() {
        var s, r;
        return _regeneratorRuntime().wrap(function _callee61$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context64.next = 2;
                break;
              }
              throw ke("can not addMergeTracks, room state is not connected");
            case 2:
              if (!(t && !this.mergeJobTracks[t])) {
                _context64.next = 4;
                break;
              }
              throw Me(t);
            case 4:
              s = {
                id: t,
                remove: e.map(function (e) {
                  return {
                    trackid: e
                  };
                })
              };
              m.debug("removeMergeTracks", s), i(t ? this.mergeJobTracks[t] : this.defaultMergeJobTracks, function (t) {
                return -1 !== e.indexOf(t);
              });
              _context64.next = 8;
              return this.signaling.request("update-merge-tracks", s);
            case 8:
              r = _context64.sent;
              if (!(me.addEvent("UpdateMergeTracks", {
                id: t || "",
                remove: s.remove.map(function (e) {
                  return {
                    track_id: e.trackid
                  };
                }),
                result_code: r.code
              }), 0 !== r.code)) {
                _context64.next = 11;
                break;
              }
              throw ze(r.code, r.error);
            case 11:
            case "end":
              return _context64.stop();
          }
        }, _callee61, this);
      }));
    }
  }, {
    key: "updateMergeTracks",
    value: function updateMergeTracks(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee62() {
        var i, s;
        return _regeneratorRuntime().wrap(function _callee62$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context65.next = 2;
                break;
              }
              throw ke("can not addMergeTracks, room state is not connected");
            case 2:
              if (!(t && !this.mergeJobTracks[t])) {
                _context65.next = 4;
                break;
              }
              throw Me(t);
            case 4:
              i = e.map(function (e) {
                return {
                  trackid: e.trackID,
                  x: e.x,
                  y: e.y,
                  w: e.w,
                  h: e.h,
                  z: e.z,
                  stretchMode: e.stretchMode
                };
              }), s = {
                id: t,
                all: i,
                mode: 1
              };
              m.debug("updateMergeTracks", s);
              t ? (this.mergeJobTracks[t] = this.mergeJobTracks[t].concat(e.map(function (e) {
                return e.trackID;
              })), this.mergeJobTracks[t] = u(this.mergeJobTracks[t], function (e) {
                return e;
              })) : (this.defaultMergeJobTracks = this.defaultMergeJobTracks.concat(e.map(function (e) {
                return e.trackID;
              })), this.defaultMergeJobTracks = u(this.defaultMergeJobTracks, function (e) {
                return e;
              }));
              me.addEvent("UpdateMergeTracks", {
                id: t || "",
                all: i.map(function (e) {
                  return {
                    track_id: e.trackid,
                    x: e.x || 0,
                    y: e.y || 0,
                    w: e.w || 0,
                    h: e.h || 0,
                    z: e.z || 0,
                    stretchMode: e.stretchMode || ""
                  };
                })
              });
              _context65.next = 10;
              return this.signaling.request("update-merge-tracks", s);
            case 10:
            case "end":
              return _context65.stop();
          }
        }, _callee62, this);
      }));
    }
  }, {
    key: "_unsubscribe",
    value: function _unsubscribe(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee63() {
        var s, r, o;
        return _regeneratorRuntime().wrap(function _callee63$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context66.next = 2;
                break;
              }
              throw ke("no signaling model, please run joinRoomWithToken first");
            case 2:
              s = this.subscribeTracks.filter(function (t) {
                return -1 !== e.indexOf(t.trackID);
              });
              if (!(m.debug("unsubscribe", s), 0 === s.length)) {
                _context66.next = 5;
                break;
              }
              return _context66.abrupt("return");
            case 5:
              r = Date.now();
              _context66.next = 8;
              return this.signaling.request("unsub-tracks", {
                tracks: s.map(function (e) {
                  return {
                    trackid: e.trackID
                  };
                })
              });
            case 8:
              o = _context66.sent;
              me.addEvent("UnSubscribeTracks", {
                tracks: e.map(function (e) {
                  return {
                    track_id: e
                  };
                }),
                result_code: o.code,
                signal_take_time: Date.now() - r
              });
              t || (s.forEach(function (e) {
                return e.release();
              }), i(this.subscribeTracks, function (t) {
                return -1 !== e.indexOf(t.trackID);
              }));
              _context66.next = 13;
              return this.connectionTransport.removeConsumers(s.map(function (e) {
                return e.consumer;
              }));
            case 13:
            case "end":
              return _context66.stop();
          }
        }, _callee63, this);
      }));
    }
  }, {
    key: "_muteTracks",
    value: function _muteTracks(e) {
      if (this.roomState !== ji.Connected) throw ke("no signaling model, please run joinRoomWithToken first");
      var t = this.connectionTransport,
        i = {};
      e.forEach(function (e) {
        i[e.trackID] = e.muted;
      });
      var s = t.publishTracks.filter(function (e) {
        return void 0 !== i[e.trackID];
      });
      s.forEach(function (e) {
        e.setMute(i[e.trackID]);
      }), me.addEvent("MuteTracks", {
        tracks: s.map(function (e) {
          return {
            track_id: e.trackID,
            muted: e.track.info.muted,
            kind: e.track.info.kind
          };
        })
      }), this.signaling.sendWsMsg("mute-tracks", {
        tracks: e.map(function (e) {
          return {
            trackid: e.trackID,
            muted: e.muted
          };
        })
      });
    }
  }, {
    key: "kickoutUser",
    value: function kickoutUser(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee64() {
        return _regeneratorRuntime().wrap(function _callee64$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              m.log("kickoutUser", e);
              _context67.next = 3;
              return this.control("kickplayer", e);
            case 3:
            case "end":
              return _context67.stop();
          }
        }, _callee64, this);
      }));
    }
  }, {
    key: "sendCustomMessage",
    value: function sendCustomMessage(e, t, i) {
      if (this.roomState !== ji.Connected) throw ke("room state is not connected, can not send message");
      var s = i || nt(8),
        r = t && 0 !== t.length ? t : void 0;
      this.signaling.sendWsMsg("send-message", {
        msgid: s,
        target: r,
        type: "normal",
        text: e
      }), m.debug("send custom message", e, r, s);
    }
  }, {
    key: "replaceTrack",
    value: function replaceTrack(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee65() {
        var i;
        return _regeneratorRuntime().wrap(function _callee65$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context68.next = 2;
                break;
              }
              throw ke("no signaling model, please run joinRoomWithToken first");
            case 2:
              m.log("replaceTrack", e, t);
              i = this.connectionTransport.publishTracks.find(function (t) {
                return t.trackID === e;
              });
              if (!(void 0 === i || void 0 === i.track)) {
                _context68.next = 6;
                break;
              }
              throw ke("track not exist: ".concat(e));
            case 6:
              return _context68.abrupt("return", this.connectionTransport.sendHandler.replaceTrack(i, t));
            case 7:
            case "end":
              return _context68.stop();
          }
        }, _callee65, this);
      }));
    }
  }, {
    key: "pushCameraTrackWithImage",
    value: function pushCameraTrackWithImage(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee66() {
        var i;
        return _regeneratorRuntime().wrap(function _callee66$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context69.next = 2;
                break;
              }
              throw ke("no signaling model, please run joinRoomWithToken first");
            case 2:
              m.log("pushCameraTrackWithImage", {
                trackID: e,
                source: t
              });
              i = this.connectionTransport.publishTracks.find(function (t) {
                return t.trackID === e;
              });
              if (!(void 0 === i || void 0 === i.track)) {
                _context69.next = 6;
                break;
              }
              throw ke("track not exist: ".concat(e));
            case 6:
              if (!("video" !== i.track.info.kind)) {
                _context69.next = 8;
                break;
              }
              throw ke("track kind is not video: ".concat(e));
            case 8:
              i.track.imageStreamTrack || (i.track.imageStreamTrack = new ki());
              if (!(void 0 === t && i.track.isReplacedByImageTrack)) {
                _context69.next = 16;
                break;
              }
              _context69.next = 12;
              return this.connectionTransport.sendHandler.replaceProducerTrack(i, "video");
            case 12:
              i.track.isReplacedByImageTrack = !1;
              _context69.t0 = void i.track.switchPlayingTrack();
              _context69.next = 27;
              break;
            case 16:
              if (!(void 0 !== t && i.track && !i.track.isReplacedByImageTrack)) {
                _context69.next = 25;
                break;
              }
              _context69.next = 19;
              return i.track.imageStreamTrack.setSource(t);
            case 19:
              _context69.next = 21;
              return this.connectionTransport.sendHandler.replaceProducerTrack(i, "image");
            case 21:
              i.track.isReplacedByImageTrack = !0;
              _context69.t1 = void i.track.switchPlayingTrack();
              _context69.next = 26;
              break;
            case 25:
              _context69.t1 = void 0;
            case 26:
              _context69.t0 = _context69.t1;
            case 27:
              return _context69.abrupt("return", _context69.t0);
            case 28:
            case "end":
              return _context69.stop();
          }
        }, _callee66, this);
      }));
    }
  }, {
    key: "leaveRoom",
    value: function leaveRoom() {
      var _this54 = this;
      this.roomState !== ji.Idle ? (m.log("leave room"), me.addEvent("LeaveRoom", {
        leave_reason_code: 0
      }), this.signaling && (Object.keys(this.forwardJobTracks).forEach(function (e) {
        return _this54.stopForwardJob(e);
      }), this.signaling.sendDisconnect()), this.releaseRoom()) : m.log("can not leave room, please join room first");
    }
  }, {
    key: "_releasePublishTracks",
    value: function _releasePublishTracks() {}
  }, {
    key: "control",
    value: function control(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee67() {
        var i;
        return _regeneratorRuntime().wrap(function _callee67$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context70.next = 2;
                break;
              }
              throw ke("can not connected to the room, please run joinRoom first");
            case 2:
              _context70.next = 4;
              return this.signaling.request("control", {
                command: e,
                playerid: t
              });
            case 4:
              i = _context70.sent;
              if (!i.error) {
                _context70.next = 7;
                break;
              }
              throw Ke(i.code, i.error);
            case 7:
            case "end":
              return _context70.stop();
          }
        }, _callee67, this);
      }));
    }
  }, {
    key: "handlePlayerOut",
    value: function handlePlayerOut(e) {
      var _this55 = this;
      var t = this._users.get(e.playerid);
      if (t) {
        this._users.delete(e.playerid), i(this._trackInfo, function (t) {
          return t.playerid === e.playerid;
        });
        i(this.subscribeTracks, function (e) {
          return e.track.userID === t.userID;
        }).forEach(function (e) {
          return e.release();
        }), rt(function () {
          m.debug("user-leave", t), _this55.emit("user-leave", t);
        });
      }
    }
  }, {
    key: "handlePlayerIn",
    value: function handlePlayerIn(e) {
      var _this56 = this;
      var t = Xt(e);
      this._users.set(t.userID, t), rt(function () {
        m.debug("user-join", t), _this56.emit("user-join", t);
      });
    }
  }, {
    key: "handleAddTracks",
    value: function handleAddTracks(e) {
      var _this57 = this;
      var t = e.tracks;
      m.log("receive track-add", t, Object.assign({}, this._trackInfo));
      var i = new Set();
      var _iterator34 = _createForOfIteratorHelper(t),
        _step34;
      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var _e44 = _step34.value;
          var _t39 = tt(this.users, "userID", _e44.playerid);
          if (_t39) if (_t39.published && !i.has(_t39.userID) && "stream" === this.sessionMode) {
            var _i32 = _t39.publishedTrackInfo.map(function (e) {
              return Yt(e, !0);
            });
            this.handleRemoveTracks({
              tracks: _i32
            }), _i32.push(_e44), this.handleAddTracks({
              tracks: _i32
            });
          } else this._trackInfo.push(_e44), _t39.addPublishedTrackInfo([zt(_e44)]), i.add(_t39.userID);
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
      if ("stream" === this.sessionMode) {
        var _loop14 = function _loop14() {
          var e = _Array$from[_i31];
          rt(function () {
            m.debug("user-publish", _this57._users.get(e)), _this57.emit("user-publish", _this57._users.get(e));
          });
        };
        for (var _i31 = 0, _Array$from = Array.from(i); _i31 < _Array$from.length; _i31++) {
          _loop14();
        }
      }
      rt(function () {
        m.debug("track-add", t.map(zt)), _this57.emit("track-add", t.map(zt));
      });
    }
  }, {
    key: "handleRemoveTracks",
    value: function handleRemoveTracks(e) {
      var _this58 = this;
      var t = e.tracks;
      m.log("receive track-remove", t, Object.assign({}, this._trackInfo));
      var s = i(this._trackInfo, function (e) {
          return t.map(function (e) {
            return e.trackid;
          }).includes(e.trackid);
        }),
        r = new Set();
      var _iterator35 = _createForOfIteratorHelper(s),
        _step35;
      try {
        var _loop16 = function _loop16() {
          var e = _step35.value;
          var t = _this58._users.get(e.playerid);
          if (!t) return 1; // continue
          t.removePublishedTrackInfo([e.trackid]), t.removeTracksByTrackId([e.trackid]), r.add(t.userID);
          var s = i(_this58.subscribeTracks, function (t) {
            return t.trackID === e.trackid;
          })[0];
          s && s.release();
        };
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          if (_loop16()) continue;
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
      if (this.cleanTrackIdsFromMergeJobs(t.map(function (e) {
        return e.trackid;
      })), "stream" === this.sessionMode) {
        var _loop15 = function _loop15() {
          var e = _Array$from2[_i33];
          var t = _this58._users.get(e);
          if (t.published) {
            var _e45 = t.publishedTrackInfo.map(function (e) {
              return Yt(e, !0);
            });
            _this58.handleRemoveTracks({
              tracks: _e45
            }), _this58.handleAddTracks({
              tracks: _e45
            });
          } else rt(function () {
            m.debug("user-unpublish", t), _this58.emit("user-unpublish", t);
          });
        };
        for (var _i33 = 0, _Array$from2 = Array.from(r); _i33 < _Array$from2.length; _i33++) {
          _loop15();
        }
      }
      rt(function () {
        m.debug("track-remove", s.map(zt)), _this58.emit("track-remove", s.map(zt));
      });
    }
  }, {
    key: "handleMute",
    value: function handleMute(e) {
      var _this59 = this;
      var t = e.tracks;
      var _iterator36 = _createForOfIteratorHelper(t),
        _step36;
      try {
        var _loop17 = function _loop17() {
            var e = _step36.value;
            var t = e.trackid,
              i = e.muted,
              s = tt(_this59._trackInfo, "trackid", t);
            if (!s) return {
              v: void 0
            };
            var r = _this59._users.get(s.playerid);
            if (!r) return {
              v: void 0
            };
            var o = r.publishedTrackInfo.find(function (e) {
              return e.trackID === t;
            });
            o && (o.muted = i);
            var n = r.tracks.find(function (e) {
              return e.info.trackID === t;
            });
            n && (n.info.muted = i, n.setMute(i)), s.muted = i;
            var a = _this59.subscribeTracks.filter(function (e) {
              return e.trackID === t;
            })[0];
            var c;
            a && a.setMute(i);
            for (var _e46 = 0; _e46 < _this59._trackInfo.length; _e46 += 1) _this59._trackInfo[_e46].playerid === s.playerid && _this59._trackInfo[_e46].kind !== s.kind && (c = _this59._trackInfo[_e46]);
            var A = {
              userID: s.playerid,
              muteAudio: !1,
              muteVideo: !1
            };
            "audio" === s.kind ? (A.muteAudio = i, A.muteVideo = !!c && c.muted) : (A.muteVideo = i, A.muteAudio = !!c && c.muted), "stream" === _this59.sessionMode && rt(function () {
              m.log("user-mute", A), _this59.emit("user-mute", A);
            });
          },
          _ret2;
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          _ret2 = _loop17();
          if (_ret2) return _ret2.v;
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
      rt(function () {
        m.log("mute-tracks", t.map(function (e) {
          return {
            trackID: e.trackid,
            muted: e.muted
          };
        })), _this59.emit("mute-tracks", t.map(function (e) {
          return {
            trackID: e.trackid,
            muted: e.muted
          };
        }));
      });
    }
  }, {
    key: "handleCustomMessages",
    value: function handleCustomMessages(e) {
      var t = e.messages;
      this.emit("messages-received", t.map(Kt));
    }
  }, {
    key: "handleQosMessages",
    value: function handleQosMessages(e) {
      var t = e.messages;
      var i = [];
      t.forEach(function (e) {
        try {
          var _t40 = JSON.parse(e.qos);
          _t40.tracks_qos.forEach(function (s) {
            i.push({
              userID: e.playerid,
              networkGrade: _t40.networkGrade,
              kind: s.kind,
              trackID: s.track,
              packetLossRate: s.lostRate,
              rtt: s.rtt
            });
          });
        } catch (e) {
          m.warning("parse SignalingQosMessage error: ", e);
        }
      }), xi.emit("remote-track-stats", i), this.emit("remote-track-stats", i);
    }
  }, {
    key: "handleDisconnect",
    value: function handleDisconnect(e) {
      var _this60 = this;
      if (m.log("handle disconnect", e.code, e), -1 === [0, 10005, 10006].indexOf(e.code) && me.addEvent("AbnormalDisconnect", {
        event_reason: "websocket_error",
        event_description: e.error,
        event_grade: Ae.SERVERE,
        event_category: de.CORE,
        event_reason_code: -1,
        socket_node_info: this.signaling.url
      }), me.addEvent("LeaveRoom", {
        leave_reason_code: e.code
      }), 10052 === e.code && this.roomToken) return this.roomState = ji.Reconnecting, void setTimeout(function () {
        return _this60.signaling.initWs();
      }, 1e3);
      if (10006 === e.code) this.emit("disconnect", {
        code: e.code,
        data: {
          userID: e.kickedid
        }
      });else this.emit("disconnect", {
        code: e.code
      });
      this.releaseRoom();
    }
  }, {
    key: "handleRemoteUserReconnecting",
    value: function handleRemoteUserReconnecting(e) {
      var t = this.users.find(function (t) {
        return t.userID === e.playerid;
      });
      t && (m.debug("remote-user-reconnecting", t), this.emit("remote-user-reconnecting", t));
    }
  }, {
    key: "handleRemoteUserReconnected",
    value: function handleRemoteUserReconnected(e) {
      var t = this.users.find(function (t) {
        return t.userID === e.playerid;
      });
      t && (m.debug("remote-user-reconnected", t), this.emit("remote-user-reconnected", t));
    }
  }, {
    key: "updateAccessToken",
    value: function updateAccessToken() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee68() {
        var e, t, i, s;
        return _regeneratorRuntime().wrap(function _callee68$(_context71) {
          while (1) switch (_context71.prev = _context71.next) {
            case 0:
              e = et(this.roomToken);
              _context71.next = 3;
              return Ai(e, this.roomToken, this.config.requestTimeout);
            case 3:
              t = _context71.sent;
              i = (Date.now() + Math.floor(100 * Math.random())).toString();
              me.setSessionId(i), this.accessToken = t.accessToken;
              s = $e(t.accessToken);
              if (this.signaling) {
                _context71.next = 9;
                break;
              }
              throw ke("room state is idle when updateAccessToken");
            case 9:
              this.signaling.accessToken = this.accessToken, this.signaling.setUrl(s.signalingurl2);
            case 10:
            case "end":
              return _context71.stop();
          }
        }, _callee68, this);
      }));
    }
  }, {
    key: "handleAuth",
    value: function handleAuth(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee69() {
        var _this61 = this;
        var t, i, s, r, _iterator37, _step37, _loop18, _t41, _i34;
        return _regeneratorRuntime().wrap(function _callee69$(_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              if (!(this.filterSignalTracks(e), m.debug("handleAuth", e), e.error)) {
                _context73.next = 4;
                break;
              }
              _context73.next = 3;
              return this.joinRoomWithToken(this.roomToken, this.userData);
            case 3:
              return _context73.abrupt("return", void _context73.sent);
            case 4:
              e.tracks = e.tracks || [], e.tracks = e.tracks.filter(function (e) {
                return e.playerid !== _this61.userID;
              }), e.players = e.players || [];
              t = this.roomState === ji.Reconnecting;
              i = {
                join: [],
                leave: [],
                add: [],
                remove: [],
                mute: []
              };
              s = Array.from(this._users.keys()), r = e.players.map(function (e) {
                return e.playerid;
              });
              if (!(i = function (e, t, i, s, r) {
                var o = {
                    join: [],
                    leave: [],
                    add: [],
                    remove: [],
                    mute: []
                  },
                  n = t.map(function (e) {
                    return e.trackid;
                  }),
                  a = i.map(function (e) {
                    return e.trackid;
                  });
                return n.forEach(function (s, r) {
                  if (t[r].playerid !== e) if (-1 === a.indexOf(s)) o.remove.push(t[r]);else {
                    var _e47 = i.find(function (e) {
                        return e.trackid === s;
                      }),
                      _n4 = t[r];
                    _e47.versionid !== _n4.versionid && (o.remove.push(_n4), o.add.push(_e47));
                  }
                }), a.forEach(function (s, r) {
                  if (i[r].playerid === e) return;
                  var a = n.indexOf(s);
                  -1 === a ? (o.add.push(i[r]), o.mute.push({
                    trackid: s,
                    muted: i[r].muted
                  })) : i[r].muted !== t[a].muted && o.mute.push({
                    trackid: s,
                    muted: i[r].muted
                  });
                }), s.forEach(function (t) {
                  t !== e && -1 === r.indexOf(t) && o.leave.push({
                    playerid: t
                  });
                }), r.forEach(function (t) {
                  t !== e && -1 === s.indexOf(t) && o.join.push({
                    playerid: t
                  });
                }), o;
              }(this.userID, this._trackInfo, e.tracks, s, r), this.roomState = ji.Connected, t)) {
                _context73.next = 12;
                break;
              }
              m.debug("get missing events", i), i.remove.length > 0 && this.handleRemoveTracks({
                tracks: i.remove
              }), i.leave.length > 0 && i.leave.forEach(this.handlePlayerOut.bind(this)), i.join.length > 0 && i.join.forEach(this.handlePlayerIn.bind(this)), i.add.length > 0 && this.handleAddTracks({
                tracks: i.add
              }), i.mute.length > 0 && this.handleMute({
                tracks: i.mute
              });
              _context73.next = 29;
              break;
            case 12:
              this._trackInfo = e.tracks, this._users.clear();
              _iterator37 = _createForOfIteratorHelper(e.players || []);
              _context73.prev = 14;
              _loop18 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop18() {
                var t, e, i;
                return _regeneratorRuntime().wrap(function _loop18$(_context72) {
                  while (1) switch (_context72.prev = _context72.next) {
                    case 0:
                      t = _step37.value;
                      e = Xt(t), i = _this61._trackInfo.filter(function (t) {
                        return t.playerid === e.userID;
                      });
                      e.addPublishedTrackInfo(i.map(zt)), _this61._users.set(e.userID, e);
                    case 3:
                    case "end":
                      return _context72.stop();
                  }
                }, _loop18);
              });
              _iterator37.s();
            case 17:
              if ((_step37 = _iterator37.n()).done) {
                _context73.next = 21;
                break;
              }
              return _context73.delegateYield(_loop18(), "t0", 19);
            case 19:
              _context73.next = 17;
              break;
            case 21:
              _context73.next = 26;
              break;
            case 23:
              _context73.prev = 23;
              _context73.t1 = _context73["catch"](14);
              _iterator37.e(_context73.t1);
            case 26:
              _context73.prev = 26;
              _iterator37.f();
              return _context73.finish(26);
            case 29:
              if (this.connectionTransport) {
                _t41 = this.connectionTransport.publishTracks.filter(function (e) {
                  return e.connectStatus === E.Connecting;
                }), _i34 = this.subscribeTracks.filter(function (e) {
                  return e.connectStatus === E.Connecting;
                });
                this.connectionTransport.extendedRtpCapabilities = e.rtpcaps, (!this.connectionTransport.sendHandler.isPcReady || this.connectionTransport.sendHandler._isRestartingICE || _t41.length > 0) && this.connectionTransport.reconnectProducer(), (!this.connectionTransport.recvHandler.isPcReady || this.connectionTransport.recvHandler._isRestartingICE || _i34.length > 0) && this.connectionTransport.resetRecvHandler();
              } else this.connectionTransport = this.createConnectionTransport(e.rtpcaps);
            case 30:
            case "end":
              return _context73.stop();
          }
        }, _callee69, this, [[14, 23, 26, 29]]);
      }));
    }
  }, {
    key: "createConnectionTransport",
    value: function createConnectionTransport(e) {
      var _this62 = this;
      var t = this.signaling,
        i = new Li(e, t, this, this.config.simulcast);
      return i.on("@needpubpc", function (e, i, s, r) {
        t.request("pubpc", {
          sdp: e,
          tracks: i.map(Zt),
          policy: _this62.config.transportPolicy
        }).then(function (e) {
          switch (e.code) {
            case 0:
              return _this62.emit("refresh-track-info", e.tracks), void s(e);
            case 10052:
              throw Ye();
            default:
              throw ke(e.error);
          }
        }).catch(r);
      }), i.on("@needsubpc", function (e, i, s) {
        t.request("subpc", {
          tracks: e.map(function (e) {
            return _this62.profiles.get(e) ? {
              trackid: e,
              profile: _this62.profiles.get(e)
            } : {
              trackid: e
            };
          }),
          policy: _this62.config.transportPolicy
        }).then(function (e) {
          switch (e.code) {
            case 0:
              return void i(e);
            case 10052:
              throw Ye();
            default:
              throw ke(e.error);
          }
        }).catch(s);
      }).on("@needresub", function () {
        var e = _this62.subscribeTracks.map(function (e) {
          return e.trackID;
        });
        _this62.subscribeTracks.forEach(function (e) {
          return e.connectStatus = E.Connecting;
        }), _this62._subscribe(e, !0);
      }).on("@needrepub", function (e) {
        _this62._publish(e.map(function (e) {
          return e.track;
        }), !0);
      }).on("@needresetrecv", function () {
        _this62.subscribeTracks.filter(function (e) {
          return !!e.track;
        }).forEach(function (e) {
          e.track.removeAllListeners("@ended");
        });
      }), i;
    }
  }, {
    key: "cleanTrackIdsFromMergeJobs",
    value: function cleanTrackIdsFromMergeJobs(e) {
      i(this.defaultMergeJobTracks, function (t) {
        return -1 !== e.indexOf(t);
      });
      for (var _t42 in this.mergeJobTracks) i(_t42, function (t) {
        return -1 !== e.indexOf(t);
      });
    }
  }, {
    key: "CreateMergerSessionController",
    value: function CreateMergerSessionController() {
      var _this63 = this;
      var e = new pi(),
        t = function (_t43) {
          function t(_x) {
            return _t43.apply(this, arguments);
          }
          t.toString = function () {
            return _t43.toString();
          };
          return t;
        }(function (t) {
          e.onAddTracks(t);
        }),
        i = function i(t) {
          e.onRemoveTracks(t);
        };
      return this.on("track-add", t), this.on("track-remove", i), e.getCurrentTracks = function () {
        if (!_this63.connectionTransport) return [];
        var e = _this63._trackInfo.map(zt),
          t = _this63.connectionTransport.publishTracks.map(function (e) {
            return e.track.info;
          });
        return e.concat(t);
      }, e.addMergeTrack = function (e, t) {
        _this63._addMergeTracks(e, t);
      }, e.release = function () {
        _this63.off("track-add", t), _this63.off("track-remove", i);
      }, e;
    }
  }, {
    key: "getAllMerger",
    value: function getAllMerger() {
      var e = [];
      this.merger && e.push(this.merger);
      for (var _t44 in this.mergeJobMerger) e.push(this.mergeJobMerger[_t44]);
      return e;
    }
  }, {
    key: "releaseRoom",
    value: function releaseRoom() {
      this.releaseSession(), this.signaling && (this.signaling.release(), this.signaling = void 0), me.addEvent("UnInit", {
        id: "".concat(this.sessionMode, "_").concat(Date.now())
      }, !0), this.connectionTransport && (this.connectionTransport.release(), this.connectionTransport = void 0), this.getAllMerger().map(function (e) {
        e.release();
      }), this.defaultMergeJobTracks = [], this.mergeJobTracks = {}, this.forwardJobTracks = {}, this.merger = void 0, this.mergeJobMerger = {}, this.roomState = ji.Idle, this._trackInfo = [], this._users.clear(), this.userID = void 0, this.subscribeTracks.forEach(function (e) {
        e.release();
      }), this.subscribeTracks = [], this.profile = void 0, this.profiles.clear(), clearInterval(this.volumeIndicatorTimer), this._mode = ne.RTC, this._role = ae.AUDIENCE, this._privileges = ["subscribe", "publish"];
    }
  }, {
    key: "registerVolumeIndicatorEvent",
    value: function registerVolumeIndicatorEvent() {
      var _this64 = this;
      clearInterval(this.volumeIndicatorTimer), this.volumeIndicatorTimer = setInterval(function () {
        if (!_this64.connectionTransport) return !1;
        var e = [].concat(_toConsumableArray(_this64.subscribedTracks), _toConsumableArray(_this64.publishedTracks)).filter(function (e) {
          return "audio" === e.info.kind && !e.info.muted;
        }).map(function (e) {
          return {
            trackID: e.info.trackID,
            userID: e.userID,
            level: e.getCurrentVolumeLevel() || 0,
            muted: e.info.muted
          };
        });
        if (0 === _this64.volumeIndicatorHistory.length) _this64.volumeIndicatorHistory.push(e.filter(function (e) {
          return e.level >= .1;
        }));else {
          var _t45 = _this64.volumeIndicatorHistory[_this64.volumeIndicatorHistory.length - 1],
            _i35 = {};
          _t45.forEach(function (e) {
            return _i35[e.trackID] = e.level;
          });
          var _s19 = [];
          var _iterator38 = _createForOfIteratorHelper(e),
            _step38;
          try {
            for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
              var _t46 = _step38.value;
              _t46.level >= .1 ? _i35[_t46.trackID] ? _t46.level > _i35[_t46.trackID] ? _s19.push(_t46) : _s19.push(Object.assign(Object.assign({}, _t46), {
                level: _i35[_t46.trackID]
              })) : _s19.push(_t46) : _i35[_t46.trackID] && _s19.push(Object.assign(Object.assign({}, _t46), {
                level: _i35[_t46.trackID]
              }));
            }
          } catch (err) {
            _iterator38.e(err);
          } finally {
            _iterator38.f();
          }
          _this64.volumeIndicatorHistory.push(_s19), 4 === _this64.volumeIndicatorHistory.length && (_this64.emit("volume-indicator", _s19.filter(function (e) {
            return !e.muted;
          }).map(function (e) {
            return {
              trackID: e.trackID,
              userID: e.userID,
              level: e.level
            };
          })), _this64.volumeIndicatorHistory = []);
        }
      }, 500);
    }
  }, {
    key: "startMediaRelay",
    value: function startMediaRelay(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee71() {
        var _this65 = this;
        var _t47, _i36, _s20;
        return _regeneratorRuntime().wrap(function _callee71$(_context75) {
          while (1) switch (_context75.prev = _context75.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context75.next = 2;
                break;
              }
              throw ke("no signaling model, please run joinRoomWithToken first");
            case 2:
              if (!(this._mode === ne.RTC)) {
                _context75.next = 4;
                break;
              }
              throw Re("no permission. only BROADCASTER in LIVE mode has permission to media relay");
            case 4:
              if (!(this._role === ae.AUDIENCE)) {
                _context75.next = 6;
                break;
              }
              throw De("no permission. only BROADCASTER in LIVE mode has permission to media relay");
            case 6:
              _context75.prev = 6;
              _context75.next = 9;
              return Promise.all(e.destRoomInfos.map(function (e) {
                return g(_this65, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee70() {
                  var t, _i37;
                  return _regeneratorRuntime().wrap(function _callee70$(_context74) {
                    while (1) switch (_context74.prev = _context74.next) {
                      case 0:
                        t = et(e.roomToken);
                        _context74.prev = 1;
                        _context74.next = 4;
                        return di(t, e.roomToken, this.config.requestTimeout);
                      case 4:
                        _i37 = _context74.sent;
                        return _context74.abrupt("return", {
                          roomName: e.roomName,
                          playerId: t.userId,
                          token: _i37.relayToken
                        });
                      case 8:
                        _context74.prev = 8;
                        _context74.t0 = _context74["catch"](1);
                        return _context74.abrupt("return", {
                          roomName: "",
                          playerId: "",
                          token: ""
                        });
                      case 11:
                      case "end":
                        return _context74.stop();
                    }
                  }, _callee70, this, [[1, 8]]);
                }));
              }));
            case 9:
              _t47 = _context75.sent.filter(function (e) {
                return e.token;
              });
              _context75.next = 12;
              return this.signaling.request("start-media-relay", {
                destinationInfos: _t47.reduce(function (e, t) {
                  return Object.assign(Object.assign({}, e), _defineProperty({}, t.roomName, Object.assign({}, t)));
                }, {})
              });
            case 12:
              _i36 = _context75.sent;
              if (!(me.addEvent("StartMediaRelay", {
                result_code: _i36.code,
                destination_infos: _t47.map(function (e) {
                  return {
                    room_name: e.roomName,
                    room_token: e.token,
                    uid: e.playerId
                  };
                })
              }), 0 !== _i36.code)) {
                _context75.next = 15;
                break;
              }
              throw ze(_i36.code, _i36.error);
            case 15:
              _s20 = _i36.status;
              return _context75.abrupt("return", Object.keys(_s20).reduce(function (e, t) {
                return Object.assign(Object.assign({}, e), _defineProperty({}, t, _s20[t].state));
              }, {}));
            case 19:
              _context75.prev = 19;
              _context75.t0 = _context75["catch"](6);
              throw _context75.t0 instanceof ge ? _context75.t0 : ke(_context75.t0 instanceof Error ? _context75.t0.message : String(_context75.t0));
            case 22:
            case "end":
              return _context75.stop();
          }
        }, _callee71, this, [[6, 19]]);
      }));
    }
  }, {
    key: "updateMediaRelay",
    value: function updateMediaRelay(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee73() {
        var _this66 = this;
        var _t48, _i38, _s21;
        return _regeneratorRuntime().wrap(function _callee73$(_context77) {
          while (1) switch (_context77.prev = _context77.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context77.next = 2;
                break;
              }
              throw ke("no signaling model, please run joinRoomWithToken first");
            case 2:
              if (!(this._mode === ne.RTC)) {
                _context77.next = 4;
                break;
              }
              throw Re("no permission. only BROADCASTER in LIVE mode has permission to media relay");
            case 4:
              if (!(this._role === ae.AUDIENCE)) {
                _context77.next = 6;
                break;
              }
              throw De("no permission. only BROADCASTER in LIVE mode has permission to media relay");
            case 6:
              _context77.prev = 6;
              _context77.next = 9;
              return Promise.all(e.destRoomInfos.map(function (e) {
                return g(_this66, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee72() {
                  var t, _i39;
                  return _regeneratorRuntime().wrap(function _callee72$(_context76) {
                    while (1) switch (_context76.prev = _context76.next) {
                      case 0:
                        t = et(e.roomToken);
                        _context76.prev = 1;
                        _context76.next = 4;
                        return di(t, e.roomToken, this.config.requestTimeout);
                      case 4:
                        _i39 = _context76.sent;
                        return _context76.abrupt("return", {
                          roomName: e.roomName,
                          playerId: t.userId,
                          token: _i39.relayToken
                        });
                      case 8:
                        _context76.prev = 8;
                        _context76.t0 = _context76["catch"](1);
                        return _context76.abrupt("return", {
                          roomName: "",
                          playerId: "",
                          token: ""
                        });
                      case 11:
                      case "end":
                        return _context76.stop();
                    }
                  }, _callee72, this, [[1, 8]]);
                }));
              }));
            case 9:
              _t48 = _context77.sent.filter(function (e) {
                return e.token;
              });
              _context77.next = 12;
              return this.signaling.request("update-media-relay", {
                destinationInfos: _t48.reduce(function (e, t) {
                  return Object.assign(Object.assign({}, e), _defineProperty({}, t.roomName, Object.assign({}, t)));
                }, {})
              });
            case 12:
              _i38 = _context77.sent;
              if (!(me.addEvent("UpdateMediaRelay", {
                result_code: _i38.code,
                destination_infos: _t48.map(function (e) {
                  return {
                    room_name: e.roomName,
                    room_token: e.token,
                    uid: e.playerId
                  };
                })
              }), 0 !== _i38.code)) {
                _context77.next = 15;
                break;
              }
              throw ze(_i38.code, _i38.error);
            case 15:
              _s21 = _i38.status;
              return _context77.abrupt("return", Object.keys(_s21).reduce(function (e, t) {
                return Object.assign(Object.assign({}, e), _defineProperty({}, t, _s21[t].state));
              }, {}));
            case 19:
              _context77.prev = 19;
              _context77.t0 = _context77["catch"](6);
              throw _context77.t0 instanceof ge ? _context77.t0 : ke(_context77.t0 instanceof Error ? _context77.t0.message : String(_context77.t0));
            case 22:
            case "end":
              return _context77.stop();
          }
        }, _callee73, this, [[6, 19]]);
      }));
    }
  }, {
    key: "stopMediaRelay",
    value: function stopMediaRelay() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee74() {
        var _e48, _t49;
        return _regeneratorRuntime().wrap(function _callee74$(_context78) {
          while (1) switch (_context78.prev = _context78.next) {
            case 0:
              if (!(this.roomState !== ji.Connected)) {
                _context78.next = 2;
                break;
              }
              throw ke("no signaling model, please run joinRoomWithToken first");
            case 2:
              if (!(this._mode === ne.RTC)) {
                _context78.next = 4;
                break;
              }
              throw Re("no permission. only BROADCASTER in LIVE mode has permission to media relay");
            case 4:
              if (!(this._role === ae.AUDIENCE)) {
                _context78.next = 6;
                break;
              }
              throw De("no permission. only BROADCASTER in LIVE mode has permission to media relay");
            case 6:
              _context78.prev = 6;
              _context78.next = 9;
              return this.signaling.request("stop-media-relay", {});
            case 9:
              _e48 = _context78.sent;
              if (!(me.addEvent("StopMediaRelay", {
                result_code: _e48.code
              }), 0 !== _e48.code)) {
                _context78.next = 12;
                break;
              }
              throw ze(_e48.code, _e48.error);
            case 12:
              _t49 = _e48.status;
              return _context78.abrupt("return", Object.keys(_t49).reduce(function (e, i) {
                return Object.assign(Object.assign({}, e), _defineProperty({}, i, _t49[i].state));
              }, {}));
            case 16:
              _context78.prev = 16;
              _context78.t0 = _context78["catch"](6);
              throw _context78.t0 instanceof ge ? _context78.t0 : ke(_context78.t0 instanceof Error ? _context78.t0.message : String(_context78.t0));
            case 19:
            case "end":
              return _context78.stop();
          }
        }, _callee74, this, [[6, 16]]);
      }));
    }
  }, {
    key: "simulcast",
    set: function set(e) {
      this.config.simulcast = e, this.connectionTransport && (this.connectionTransport.simulcast = e, this.connectionTransport.sendHandler._simulcast = e, this.connectionTransport.recvHandler._simulcast = e);
    }
  }, {
    key: "publishedTracks",
    get: function get() {
      return this.connectionTransport ? this.connectionTransport.publishTracks.filter(function (e) {
        return e.connectStatus === E.Connect;
      }).map(function (e) {
        return e.track;
      }) : [];
    }
  }, {
    key: "subscribedTracks",
    get: function get() {
      return this.subscribeTracks.filter(function (e) {
        return e.connectStatus === E.Connect;
      }).map(function (e) {
        return e.track;
      });
    }
  }]);
  return Ui;
}(t);
var Vi = /*#__PURE__*/function (_Ui) {
  _inherits(Vi, _Ui);
  _createClass(Vi, [{
    key: "mergeStreamTracks",
    get: function get() {
      return this.defaultMergeJobTracks;
    }
  }, {
    key: "mergeStreamJobTracks",
    get: function get() {
      return this.mergeJobTracks;
    }
  }]);
  function Vi(e) {
    var _this67;
    _classCallCheck(this, Vi);
    _this67 = _possibleConstructorReturn(this, _getPrototypeOf(Vi).call(this, e)), _this67.isAudioMastered = !1, _this67.isVideoMastered = !1, _this67.sessionMode = "track", me.addEvent("Init", {
      id: "".concat(_this67.sessionMode, "_").concat(Date.now())
    });
    return _this67;
  }
  _createClass(Vi, [{
    key: "join",
    value: function join(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee75() {
        return _regeneratorRuntime().wrap(function _callee75$(_context79) {
          while (1) switch (_context79.prev = _context79.next) {
            case 0:
              _context79.next = 2;
              return this.joinRoomWithToken(e, t);
            case 2:
              return _context79.abrupt("return", _context79.sent);
            case 3:
            case "end":
              return _context79.stop();
          }
        }, _callee75, this);
      }));
    }
  }, {
    key: "leave",
    value: function leave() {
      this.leaveRoom(), this.isAudioMastered = !1, this.isVideoMastered = !1;
    }
  }, {
    key: "publish",
    value: function publish(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee76() {
        var t, i, _iterator39, _step39, _t50;
        return _regeneratorRuntime().wrap(function _callee76$(_context80) {
          while (1) switch (_context80.prev = _context80.next) {
            case 0:
              t = this.isAudioMastered, i = this.isVideoMastered;
              _iterator39 = _createForOfIteratorHelper(e);
              try {
                for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
                  _t50 = _step39.value;
                  "audio" === _t50.info.kind && (this.isAudioMastered ? _t50.setMaster(!1) : (_t50.setMaster(!0), this.isAudioMastered = !0)), "video" === _t50.info.kind && (this.isVideoMastered ? _t50.setMaster(!1) : (_t50.setMaster(!0), this.isVideoMastered = !0));
                }
              } catch (err) {
                _iterator39.e(err);
              } finally {
                _iterator39.f();
              }
              _context80.prev = 3;
              _context80.next = 6;
              return this._publish(e);
            case 6:
              return _context80.abrupt("return", _context80.sent);
            case 9:
              _context80.prev = 9;
              _context80.t0 = _context80["catch"](3);
              throw this.isAudioMastered = t, this.isVideoMastered = i, _context80.t0;
            case 12:
            case "end":
              return _context80.stop();
          }
        }, _callee76, this, [[3, 9]]);
      }));
    }
  }, {
    key: "unpublish",
    value: function unpublish(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee77() {
        var t;
        return _regeneratorRuntime().wrap(function _callee77$(_context81) {
          while (1) switch (_context81.prev = _context81.next) {
            case 0:
              _context81.next = 2;
              return this._unpublish(e);
            case 2:
              t = _context81.sent;
              return _context81.abrupt("return", (this.isAudioMastered = this.publishedTracks.some(function (e) {
                return !("audio" !== e.info.kind || !e.master);
              }), this.isVideoMastered = this.publishedTracks.some(function (e) {
                return !("video" !== e.info.kind || !e.master);
              }), t));
            case 4:
            case "end":
              return _context81.stop();
          }
        }, _callee77, this);
      }));
    }
  }, {
    key: "subscribe",
    value: function subscribe(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
        i = arguments.length > 2 ? arguments[2] : void 0;
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee78() {
        return _regeneratorRuntime().wrap(function _callee78$(_context82) {
          while (1) switch (_context82.prev = _context82.next) {
            case 0:
              _context82.next = 2;
              return this._subscribe(e, !1, t, i);
            case 2:
              return _context82.abrupt("return", _context82.sent);
            case 3:
            case "end":
              return _context82.stop();
          }
        }, _callee78, this);
      }));
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee79() {
        return _regeneratorRuntime().wrap(function _callee79$(_context83) {
          while (1) switch (_context83.prev = _context83.next) {
            case 0:
              _context83.next = 2;
              return this._unsubscribe(e);
            case 2:
              return _context83.abrupt("return", _context83.sent);
            case 3:
            case "end":
              return _context83.stop();
          }
        }, _callee79, this);
      }));
    }
  }, {
    key: "setProfile",
    value: function setProfile(e, t) {
      this._setProfile(e, t);
    }
  }, {
    key: "setReconnectTimes",
    value: function setReconnectTimes(e) {
      this._setReconnectTimes(e);
    }
  }, {
    key: "getReconnectTimes",
    value: function getReconnectTimes() {
      return this._getReconnectTimes();
    }
  }, {
    key: "muteTracks",
    value: function muteTracks(e) {
      this._muteTracks(e);
    }
  }, {
    key: "addMergeStreamTracks",
    value: function addMergeStreamTracks(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee80() {
        return _regeneratorRuntime().wrap(function _callee80$(_context84) {
          while (1) switch (_context84.prev = _context84.next) {
            case 0:
              _context84.next = 2;
              return this._addMergeTracks(e, t);
            case 2:
            case "end":
              return _context84.stop();
          }
        }, _callee80, this);
      }));
    }
  }, {
    key: "removeMergeStreamTracks",
    value: function removeMergeStreamTracks(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee81() {
        return _regeneratorRuntime().wrap(function _callee81$(_context85) {
          while (1) switch (_context85.prev = _context85.next) {
            case 0:
              _context85.next = 2;
              return this._removeMergeTracks(e, t);
            case 2:
            case "end":
              return _context85.stop();
          }
        }, _callee81, this);
      }));
    }
  }, {
    key: "stopMergeStream",
    value: function stopMergeStream(e) {
      this._stopMerge(e);
    }
  }, {
    key: "filterSignalTracks",
    value: function filterSignalTracks() {}
  }, {
    key: "releaseSession",
    value: function releaseSession() {}
  }]);
  return Vi;
}(Ui);
var Bi = "fk6fk2rnb",
  Hi = "https://api-demo.qnsdk.com",
  Qi = "/v1",
  Gi = function Gi(e, t, i) {
    return "/rtc/token/app/".concat(i, "/room/").concat(e, "/user/").concat(t);
  };
function Ji() {
  return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee84() {
    var e, t, i, s, r, o, n, a, c, A, d, u, h, l, _e49, _i40, _p, _f, _k, _v, _b, _T, _y, _E;
    return _regeneratorRuntime().wrap(function _callee84$(_context88) {
      while (1) switch (_context88.prev = _context88.next) {
        case 0:
          m.log("start checkSystemRequirements");
          e = Date.now();
          t = !1, i = "";
          s = new Vi(Fi);
          r = new Vi(Fi);
          _context88.next = 7;
          return function () {
            return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee82() {
              var e;
              return _regeneratorRuntime().wrap(function _callee82$(_context86) {
                while (1) switch (_context86.prev = _context86.next) {
                  case 0:
                    e = "unknow";
                    _context86.prev = 1;
                    _context86.next = 4;
                    return he();
                  case 4:
                    e = _context86.sent;
                    _context86.next = 9;
                    break;
                  case 7:
                    _context86.prev = 7;
                    _context86.t0 = _context86["catch"](1);
                  case 9:
                    return _context86.abrupt("return", e + "_" + nt(8));
                  case 10:
                  case "end":
                    return _context86.stop();
                }
              }, _callee82, null, [[1, 7]]);
            }));
          }();
        case 7:
          o = _context88.sent;
          A = -1, d = -1, u = -1, h = -1, l = -1;
          _context88.prev = 9;
          _context88.next = 12;
          return Xi.getLocalTracks({
            video: {
              enabled: !0
            },
            audio: {
              enabled: !0
            }
          });
        case 12:
          _e49 = _context88.sent;
          if (!(c = _e49.find(function (e) {
            return "video" === e.info.kind;
          }), a = _e49.find(function (e) {
            return "audio" === e.info.kind;
          }), void 0 === c || void 0 === a)) {
            _context88.next = 15;
            break;
          }
          throw ke("getLocalTracks failed.");
        case 15:
          _i40 = function _i40(e, t) {
            return new Promise(function (i, s) {
              (function (e, t) {
                return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee83() {
                  var i, _e50, _t51;
                  return _regeneratorRuntime().wrap(function _callee83$(_context87) {
                    while (1) switch (_context87.prev = _context87.next) {
                      case 0:
                        i = "".concat(Hi).concat(Qi).concat(Gi(e, t, Bi));
                        _context87.prev = 1;
                        if (!("AbortController" in window)) {
                          _context87.next = 10;
                          break;
                        }
                        _t51 = new AbortController();
                        setTimeout(function () {
                          return _t51.abort();
                        }, 5e3);
                        _context87.next = 7;
                        return fetch(i, {
                          signal: _t51.signal,
                          headers: {
                            "Content-Type": "application/json"
                          }
                        });
                      case 7:
                        _e50 = _context87.sent;
                        _context87.next = 13;
                        break;
                      case 10:
                        _context87.next = 12;
                        return fetch(i, {
                          headers: {
                            "Content-Type": "application/json"
                          }
                        });
                      case 12:
                        _e50 = _context87.sent;
                      case 13:
                        if (_e50.ok) {
                          _context87.next = 15;
                          break;
                        }
                        throw new Error(_e50.statusText);
                      case 15:
                        return _context87.abrupt("return", _e50.text());
                      case 18:
                        _context87.prev = 18;
                        _context87.t0 = _context87["catch"](1);
                        throw _context87.t0;
                      case 21:
                      case "end":
                        return _context87.stop();
                    }
                  }, _callee83, null, [[1, 18]]);
                }));
              })(o, e).then(function (e) {
                return t.joinRoomWithToken(e);
              }).then(i).catch(s);
            });
          };
          _context88.next = 18;
          return Promise.all([_i40("userA", s), _i40("userB", r)]);
        case 18:
          _p = function _p(e) {
            return new Promise(function (t, i) {
              e.trackInfoList.length > 0 ? e.subscribe(e.trackInfoList.map(function (e) {
                return e.trackID;
              })).then(t).catch(i) : e.on("track-add", function (s) {
                e.subscribe(s.map(function (e) {
                  return e.trackID;
                })).then(t).catch(i);
              });
            });
          };
          _context88.next = 21;
          return Promise.all([s.publish([c]), r.publish([a]), _p(s), _p(r)]);
        case 21:
          _f = [], _k = [], _v = [], _b = [], _T = [], _y = 30;
          _E = 0;
          _context88.next = 25;
          return new Promise(function (e) {
            n = setInterval(function () {
              var t = s.publishedTracks[0].getStats(),
                i = r.publishedTracks[0].getStats();
              t.length > 0 && i.length > 0 && a && (_f.push(t[0].rtt), _k.push(t[0].packetLossRate), _v.push(i[0].bitrate), _b.push(t[0].bitrate), _T.push(a.getCurrentVolumeLevel())), _f.length > 15 && (clearInterval(n), e()), _E > _y && (m.warning("abnormal track stats: less than 15 valid stats in 30s"), clearInterval(n), e()), _E += 1;
            }, 1e3);
          });
        case 25:
          m.log(JSON.stringify({
            detailTestResult: {
              rtts: _f,
              packetLossRates: _k,
              audioBitrates: _v,
              videoBitrates: _b,
              volumnLevels: _T
            }
          }));
          _f.length > 0 && (A = Math.ceil(_f.reduce(function (e, t) {
            return e + t;
          }, 0) / _f.length), d = _k.reduce(function (e, t) {
            return e + t;
          }, 0) / _k.length, u = _v.reduce(function (e, t) {
            return e + t;
          }, 0) / _v.length, h = _b.reduce(function (e, t) {
            return e + t;
          }, 0) / _b.length, l = _T.reduce(function (e, t) {
            return e + t;
          }, 0) / _T.length);
          t = !0;
          _context88.next = 33;
          break;
        case 30:
          _context88.prev = 30;
          _context88.t0 = _context88["catch"](9);
          t = !1, i = "string" == typeof _context88.t0 ? _context88.t0 : _context88.t0 instanceof ge ? JSON.stringify(_context88.t0) : _context88.t0 instanceof Error ? _context88.t0.message : "";
        case 33:
          _context88.prev = 33;
          _context88.t1 = s.roomState === ji.Connected;
          if (!_context88.t1) {
            _context88.next = 39;
            break;
          }
          _context88.next = 38;
          return s.unpublish(s.publishedTracks.map(function (e) {
            return e.info.trackID;
          }));
        case 38:
          s.leaveRoom();
        case 39:
          _context88.t2 = r.roomState === ji.Connected;
          if (!_context88.t2) {
            _context88.next = 44;
            break;
          }
          _context88.next = 43;
          return r.unpublish(r.publishedTracks.map(function (e) {
            return e.info.trackID;
          }));
        case 43:
          r.leaveRoom();
        case 44:
          c && c.release();
          a && a.release();
          clearTimeout(undefined);
          clearInterval(n);
          me.addEvent("SystemRequirementsTest", {
            room_name: o,
            ok: t,
            reason: i,
            avg_rtt: A,
            avg_packet_loss_rate: d,
            avg_volumn_level: l,
            avg_audio_bitrate: u,
            avg_video_bitrate: h,
            test_take_time: Date.now() - e,
            event_grade: t ? Ae.NORMAL : Ae.SERVERE
          }, !0);
          return _context88.abrupt("return", {
            roomName: o,
            ok: t,
            reason: i,
            avgRTT: A,
            avgPacketLossRate: d,
            avgVolumnLevel: l,
            avgAudioBitrate: u,
            avgVideoBitrate: h
          });
        case 51:
        case "end":
          return _context88.stop();
      }
    }, _callee84, null, [[9, 30, 33, 51]]);
  }));
}
var Wi = /*#__PURE__*/function (_Ri) {
  _inherits(Wi, _Ri);
  function Wi(e, t) {
    var _this68;
    _classCallCheck(this, Wi);
    if (!F.mediaStreamDest) throw be("your browser does not support audio buffer input!");
    var i = new wi();
    i.initAudioContext(), e instanceof AudioBuffer ? (i.setAudioBufferSource(), i.setAudioBuffer(e)) : e instanceof HTMLAudioElement && i.setMediaElementSource(e);
    _this68 = _possibleConstructorReturn(this, _getPrototypeOf(Wi).call(this, i.audioStream.stream.getTracks()[0], t, "local")), _this68.sourceType = S.EXTERNAL, _this68.isLoop = !1, _this68.originSource = e, _this68.audioManager = i, _this68.handleAudioManagerEvents();
    return _this68;
  }
  _createClass(Wi, [{
    key: "setLoop",
    value: function setLoop(e) {
      this.isLoop = e, this.audioManager.setAudioSourceLoop(e);
    }
  }, {
    key: "startAudioSource",
    value: function startAudioSource() {
      this.audioManager.playAudioSource();
    }
  }, {
    key: "pauseAudioSource",
    value: function pauseAudioSource() {
      this.audioManager.pauseAudioSource();
    }
  }, {
    key: "resumeAudioSource",
    value: function resumeAudioSource() {
      this.audioManager.resumeAudioSource();
    }
  }, {
    key: "stopAudioSource",
    value: function stopAudioSource() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      this.audioManager.stopAudioSource(!1, e);
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.audioManager.getAudioSourceCurrentTime() || 0;
    }
  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(e) {
      this.audioManager.setAudioSourceCurrentTime(e);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.audioManager.getAudioSourceDuration() || 0;
    }
  }, {
    key: "handleAudioManagerEvents",
    value: function handleAudioManagerEvents() {
      var _this69 = this;
      this.audioManager.on("@audio-source-state-change", function (e, t) {
        _this69.emit("audio-state-change", e, t);
      });
    }
  }]);
  return Wi;
}(Ri);
var Ki = /*#__PURE__*/function (_t52) {
  _inherits(Ki, _t52);
  _createClass(Ki, [{
    key: "audioSourceIsLoop",
    get: function get() {
      return this._audioTrack instanceof Wi && this._audioTrack.isLoop;
    }
  }]);
  function Ki(e) {
    var _this70;
    _classCallCheck(this, Ki);
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "send",
      s = arguments.length > 2 ? arguments[2] : void 0;
    _this70 = _possibleConstructorReturn(this, _getPrototypeOf(Ki).call(this)), _this70.trackList = [], _this70.isDestroyed = !1, _this70.enableAudio = !0, _this70.enableVideo = !0, _this70.muteAudio = !1, _this70.muteVideo = !1, _this70.onAudioEnded = function (e) {
      _this70.emit("audio-ended", e);
    }, _this70.onVideoEnded = function (e) {
      _this70.emit("video-ended", e);
    }, _this70.onAudioSourceStateChange = function (e, t) {
      _this70.emit("audio-source-state-change", e, t);
    }, _this70.direction = t, _this70.userID = s, e.forEach(function (e) {
      e.setMaster(!0), e.on("mute", function () {
        _this70.updateTrackState();
      }), e.on("release", function () {
        i(_this70.trackList, function (t) {
          return t === e;
        }), _this70.updateTrackState(), 0 === _this70.trackList.length && _this70.release();
      }), _this70.trackList.push(e);
    }), _this70.updateTrackState();
    return _this70;
  }
  _createClass(Ki, [{
    key: "setVolume",
    value: function setVolume(e) {
      this._audioTrack && this._audioTrack.setVolume(e);
    }
  }, {
    key: "play",
    value: function play(e, t) {
      this.trackList.forEach(function (i) {
        return i.play(e, t);
      }), this._audioTrack && (this.audio = this._audioTrack.mediaElement), this._videoTrack && (this.video = this._videoTrack.mediaElement);
    }
  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      return this._audioTrack ? this._audioTrack.getCurrentTimeDomainData() : new Uint8Array(0);
    }
  }, {
    key: "getCurrentFrequencyData",
    value: function getCurrentFrequencyData() {
      return this._audioTrack ? this._audioTrack.getCurrentFrequencyData() : new Uint8Array(0);
    }
  }, {
    key: "getCurrentVolumeLevel",
    value: function getCurrentVolumeLevel() {
      return this._audioTrack ? this._audioTrack.getCurrentVolumeLevel() : 0;
    }
  }, {
    key: "getStats",
    value: function getStats() {
      var e = Tt();
      if (this._audioTrack) {
        var _t53 = this._audioTrack.getStats();
        _t53.length > 0 && (e = _t53[0]);
      }
      var t = Tt();
      if (this._videoTrack) {
        var _e51 = this._videoTrack.getStats();
        _e51.length > 0 && (t = _e51[0]);
      }
      return {
        timestamp: Date.now(),
        videoBitrate: t.bitrate,
        audioBitrate: e.bitrate,
        videoPacketLoss: t.packetLoss,
        audioPacketLoss: e.packetLoss,
        videoPackets: t.packets,
        audioPackets: e.packets,
        videoPacketLossRate: t.packetLossRate,
        audioPacketLossRate: e.packetLossRate,
        videoBytes: t.bytes,
        audioBytes: e.bytes,
        pctype: this.direction
      };
    }
  }, {
    key: "getCurrentFrameDataURL",
    value: function getCurrentFrameDataURL() {
      return this._videoTrack ? this._videoTrack.getCurrentFrameDataURL() : "data:,";
    }
  }, {
    key: "setAudioSourceLoop",
    value: function setAudioSourceLoop(e) {
      this._audioTrack instanceof Wi && this._audioTrack.setLoop(e);
    }
  }, {
    key: "startAudioSource",
    value: function startAudioSource() {
      this._audioTrack instanceof Wi && this._audioTrack.startAudioSource();
    }
  }, {
    key: "pauseAudioSource",
    value: function pauseAudioSource() {
      this._audioTrack instanceof Wi && this._audioTrack.pauseAudioSource();
    }
  }, {
    key: "resumeAudioSource",
    value: function resumeAudioSource() {
      this._audioTrack instanceof Wi && this._audioTrack.resumeAudioSource();
    }
  }, {
    key: "stopAudioSource",
    value: function stopAudioSource() {
      this._audioTrack instanceof Wi && this._audioTrack.stopAudioSource();
    }
  }, {
    key: "getAudioSourceCurrentTime",
    value: function getAudioSourceCurrentTime() {
      return this._audioTrack instanceof Wi ? this._audioTrack.getCurrentTime() : 0;
    }
  }, {
    key: "getAudioSourceDuration",
    value: function getAudioSourceDuration() {
      return this._audioTrack instanceof Wi ? this._audioTrack.getDuration() : 0;
    }
  }, {
    key: "setAudioSourceCurrentTime",
    value: function setAudioSourceCurrentTime(e) {
      if (this._audioTrack instanceof Wi) return this._audioTrack.setCurrentTime(e);
    }
  }, {
    key: "setKbps",
    value: function setKbps(e, t) {
      e && this._videoTrack && this._videoTrack.setKbps(e), t && this._audioTrack && this._audioTrack.setKbps(t);
    }
  }, {
    key: "updateTrackState",
    value: function updateTrackState() {
      var _this71 = this;
      this.trackList.forEach(function (e) {
        "audio" === e.info.kind ? (_this71._audioTrack && (_this71._audioTrack.off("ended", _this71.onAudioEnded), _this71._audioTrack.off("audio-state-change", _this71.onAudioSourceStateChange)), _this71.audioTrack = e.mediaTrack, _this71._audioTrack = e, _this71._audioTrack.on("ended", _this71.onAudioEnded), _this71._audioTrack instanceof Wi && _this71._audioTrack.on("audio-state-change", _this71.onAudioSourceStateChange)) : (_this71._videoTrack && _this71._videoTrack.off("ended", _this71.onVideoEnded), _this71.videoTrack = e.mediaTrack, _this71._videoTrack = e, _this71._videoTrack.on("ended", _this71.onVideoEnded));
      }), this.audioTrack ? (this.enableAudio = !0, this.muteAudio = !this.audioTrack.enabled) : this.enableAudio = !1, this.videoTrack ? (this.enableVideo = !0, this.muteVideo = !this.videoTrack.enabled) : this.enableVideo = !1;
    }
  }, {
    key: "release",
    value: function release() {
      if (!this.isDestroyed) {
        for (var _e52 = 0; _e52 < this.trackList.length; _e52 += 1) {
          var _t54 = this.trackList[_e52];
          _t54.removeAllListeners("release"), _t54.release();
        }
        this.trackList = [], this.isDestroyed = !0, this.emit("release"), this.removeAllListeners();
      }
    }
  }, {
    key: "releaseTrack",
    value: function releaseTrack(e) {
      var _ref = function (e, t, i) {
          var s = [];
          var r = null;
          for (var _o8 = 0; _o8 < e.length; _o8 += 1) e[_o8][t] !== i ? s.push(e[_o8]) : r = e[_o8];
          return {
            removeElement: r,
            newArray: s
          };
        }(this.trackList, "mediaTrack", e.mediaTrack),
        t = _ref.removeElement,
        i = _ref.newArray;
      t && (e.release(), this.trackList = i, 0 === this.trackList.length && (this.isDestroyed = !0));
    }
  }]);
  return Ki;
}(t);
var zi;
!function (e) {
  function t(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "anonymous",
      i = arguments.length > 2 ? arguments[2] : void 0,
      s = arguments.length > 3 ? arguments[3] : void 0;
    return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee85() {
      return _regeneratorRuntime().wrap(function _callee85$(_context89) {
        while (1) switch (_context89.prev = _context89.next) {
          case 0:
            return _context89.abrupt("return", new Promise(function (r, o) {
              var n = document.createElement("audio");
              n.addEventListener("error", function () {
                o(Le());
              });
              var a = function a() {
                n.removeEventListener("canplay", a);
                var e = new Wi(n);
                s && e.setKbps(s), e.setInfo({
                  tag: i
                }), r(e);
              };
              n.addEventListener("canplay", a), n.preload = "auto", n.src = e, n.load(), n.crossOrigin = t;
            }));
          case 1:
          case "end":
            return _context89.stop();
        }
      }, _callee85);
    }));
  }
  function i(e, t, i) {
    return new Promise(function (s, o) {
      var n = new FileReader();
      n.onload = function (e) {
        r(e.target.result).then(function (e) {
          var r = new Wi(e);
          i && r.setKbps(i), r.setInfo({
            tag: t
          }), s(r);
        }).catch(function () {
          o(Le());
        });
      }, n.readAsArrayBuffer(e);
    });
  }
  function s(e, t, i) {
    var s = new Wi(e);
    return i && s.setKbps(i), s.setInfo({
      tag: t
    }), s;
  }
  function r(e) {
    return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee86() {
      return _regeneratorRuntime().wrap(function _callee86$(_context90) {
        while (1) switch (_context90.prev = _context90.next) {
          case 0:
            _context90.t0 = "suspended" === Ei.state;
            if (!_context90.t0) {
              _context90.next = 4;
              break;
            }
            _context90.next = 4;
            return Ei.resume();
          case 4:
            _context90.next = 6;
            return new Promise(function (t, i) {
              Ei.decodeAudioData(e, function (e) {
                t(e);
              }, function (e) {
                i(Se(e));
              });
            });
          case 6:
            return _context90.abrupt("return", _context90.sent);
          case 7:
          case "end":
            return _context90.stop();
        }
      }, _callee86);
    }));
  }
  e.createAudioTrackFromURL = t, e.createAudioTrackFromFile = i, e.createAudioTrackFromBuffer = s, e.createAudioTrackFromSource = function (e, r, o) {
    return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee87() {
      return _regeneratorRuntime().wrap(function _callee87$(_context91) {
        while (1) switch (_context91.prev = _context91.next) {
          case 0:
            if (!(e instanceof File)) {
              _context91.next = 6;
              break;
            }
            _context91.next = 3;
            return i(e, r, o);
          case 3:
            _context91.t0 = _context91.sent;
            _context91.next = 19;
            break;
          case 6:
            if (!(e instanceof AudioBuffer)) {
              _context91.next = 10;
              break;
            }
            _context91.t1 = s(e, r, o);
            _context91.next = 18;
            break;
          case 10:
            if (!("string" == typeof e)) {
              _context91.next = 16;
              break;
            }
            _context91.next = 13;
            return t(e, "anonymous", r, o);
          case 13:
            _context91.t2 = _context91.sent;
            _context91.next = 17;
            break;
          case 16:
            _context91.t2 = Promise.reject(Le());
          case 17:
            _context91.t1 = _context91.t2;
          case 18:
            _context91.t0 = _context91.t1;
          case 19:
            return _context91.abrupt("return", _context91.t0);
          case 20:
          case "end":
            return _context91.stop();
        }
      }, _callee87);
    }));
  }, e.decodeAudioData = r;
}(zi || (zi = {}));
var Yi = {
  audio: {
    enabled: !0
  },
  video: {
    enabled: !0,
    bitrate: 600
  }
};
function Zi(e, t) {
  "video" === e.kind && ("contentHint" in e ? (e.contentHint = t, e.contentHint !== t && m.warning("invalid optimizationMode ", t)) : m.warning("optimizationMode not support in this browser"));
}
var Xi = new ( /*#__PURE__*/function (_t55) {
  _inherits(_class3, _t55);
  function _class3() {
    var _this72;
    _classCallCheck(this, _class3);
    _this72 = _possibleConstructorReturn(this, _getPrototypeOf(_class3).call(this)), _this72.deviceMap = {}, F.support && (_this72.updateDeivceInfo(), F.ondevicechange ? navigator.mediaDevices.addEventListener("devicechange", function () {
      _this72.updateDeivceInfo();
    }) : window.setInterval(_this72.updateDeivceInfo.bind(_assertThisInitialized(_assertThisInitialized(_this72))), 1e3));
    return _this72;
  }
  _createClass(_class3, [{
    key: "getDeviceInfo",
    value: function getDeviceInfo(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee88() {
        var _e53, _t56, _i41, _e54;
        return _regeneratorRuntime().wrap(function _callee88$(_context92) {
          while (1) switch (_context92.prev = _context92.next) {
            case 0:
              if (e) {
                _context92.next = 22;
                break;
              }
              _e53 = {
                audio: !1,
                video: !1
              };
              _context92.t0 = t;
              _context92.next = _context92.t0 === "all" ? 5 : _context92.t0 === "cameras" ? 7 : _context92.t0 === "microphones" ? 9 : _context92.t0 === "playback" ? 9 : 10;
              break;
            case 5:
              _e53.audio = !0, _e53.video = !0;
              return _context92.abrupt("break", 10);
            case 7:
              _e53.video = !0;
              return _context92.abrupt("break", 10);
            case 9:
              _e53.audio = !0;
            case 10:
              _context92.prev = 10;
              _context92.next = 13;
              return navigator.mediaDevices.getUserMedia(_e53);
            case 13:
              _t56 = _context92.sent;
              this.updateDeivceInfo();
              _i41 = _t56.getTracks();
              for (_e54 = 0; _e54 < _i41.length; _e54++) _i41[_e54].stop();
              _context92.next = 22;
              break;
            case 19:
              _context92.prev = 19;
              _context92.t1 = _context92["catch"](10);
              throw "NotAllowedError" === _context92.t1.name ? Ee("") : _context92.t1;
            case 22:
              if (this.deviceInfo) {
                _context92.next = 24;
                break;
              }
              return _context92.abrupt("return", []);
            case 24:
              _context92.t2 = t;
              _context92.next = _context92.t2 === "all" ? 27 : _context92.t2 === "cameras" ? 28 : _context92.t2 === "microphones" ? 29 : _context92.t2 === "playback" ? 30 : 31;
              break;
            case 27:
              return _context92.abrupt("return", this.deviceInfo);
            case 28:
              return _context92.abrupt("return", this.deviceInfo.filter(function (e) {
                return "videoinput" === e.kind;
              }));
            case 29:
              return _context92.abrupt("return", this.deviceInfo.filter(function (e) {
                return "audioinput" === e.kind;
              }));
            case 30:
              return _context92.abrupt("return", this.deviceInfo.filter(function (e) {
                return "audiooutput" === e.kind;
              }));
            case 31:
            case "end":
              return _context92.stop();
          }
        }, _callee88, this, [[10, 19]]);
      }));
    }
  }, {
    key: "getElectronScreenSources",
    value: function getElectronScreenSources(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee89() {
        var t, _window$require, _e55, i;
        return _regeneratorRuntime().wrap(function _callee89$(_context93) {
          while (1) switch (_context93.prev = _context93.next) {
            case 0:
              _context93.prev = 0;
              _window$require = window.require("electron"), _e55 = _window$require.ipcRenderer;
              t = {
                getSources: function getSources(t) {
                  return _e55.invoke("QNRTC_DESKTOP_CAPTURER_GET_SOURCES", t);
                }
              };
              _context93.next = 8;
              break;
            case 5:
              _context93.prev = 5;
              _context93.t0 = _context93["catch"](0);
              throw m.warning(_context93.t0), _e(_context93.t0 instanceof Error ? _context93.t0.message : String(_context93.t0));
            case 8:
              i = {
                types: [],
                thumbnailSize: {
                  width: 150,
                  height: 150
                }
              };
              _context93.t1 = e;
              _context93.next = _context93.t1 === void 0 ? 12 : _context93.t1 === oe.ALL ? 12 : _context93.t1 === oe.SCREEN ? 14 : _context93.t1 === oe.WINDOW ? 16 : 17;
              break;
            case 12:
              i.types.push("window", "screen");
              return _context93.abrupt("break", 17);
            case 14:
              i.types.push("screen");
              return _context93.abrupt("break", 17);
            case 16:
              i.types.push("window");
            case 17:
              _context93.prev = 17;
              _context93.next = 20;
              return t.getSources(i);
            case 20:
              return _context93.abrupt("return", _context93.sent.map(function (e) {
                return {
                  ID: e.id,
                  name: e.name,
                  url: e.thumbnail.toDataURL()
                };
              }));
            case 23:
              _context93.prev = 23;
              _context93.t2 = _context93["catch"](17);
              throw m.warning(_context93.t2), ke("Electron getSources error, ".concat(_context93.t2 instanceof Error ? _context93.t2.message : String(_context93.t2)));
            case 26:
            case "end":
              return _context93.stop();
          }
        }, _callee89, null, [[0, 5], [17, 23]]);
      }));
    }
  }, {
    key: "createElectronScreenTrack",
    value: function createElectronScreenTrack() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee91() {
        var t, i, _e56, _i42, s, _iterator41, _step41, _t57;
        return _regeneratorRuntime().wrap(function _callee91$(_context95) {
          while (1) switch (_context95.prev = _context95.next) {
            case 0:
              if (!(!0 === e.audio && (t = {
                audio: {
                  mandatory: {
                    chromeMediaSource: "desktop"
                  }
                },
                video: {
                  mandatory: {
                    chromeMediaSource: "desktop"
                  }
                }
              }), e.sourceID)) {
                _context95.next = 4;
                break;
              }
              t = {
                video: {
                  mandatory: {
                    chromeMediaSourceId: e.sourceID,
                    chromeMediaSource: "desktop"
                  }
                }
              };
              _context95.next = 13;
              break;
            case 4:
              _context95.next = 6;
              return this.getElectronScreenSources();
            case 6:
              _e56 = _context95.sent;
              if (!(0 === _e56.length)) {
                _context95.next = 9;
                break;
              }
              return _context95.abrupt("return", []);
            case 9:
              _context95.next = 11;
              return function (e) {
                return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee90() {
                  return _regeneratorRuntime().wrap(function _callee90$(_context94) {
                    while (1) switch (_context94.prev = _context94.next) {
                      case 0:
                        return _context94.abrupt("return", new Promise(function (t, i) {
                          var s = document.createElement("div");
                          s.setAttribute("style", "position: fixed; z-index: 99999999; top: 50%; left: 50%; width: 620px; height: 525px; background: #ECECEC; border-radius: 4px; -webkit-transform: translate(-50%,-50%); transform: translate(-50%,-50%);");
                          var r = document.createElement("div");
                          r.setAttribute("style", "text-align: center; height: 25px; line-height: 25px; border-radius: 4px 4px 0 0; background: #D4D2D4; border-bottom:  solid 1px #B9B8B9;"), r.innerText = "share screen";
                          var o = document.createElement("div");
                          o.setAttribute("style", "width: 100%; height: 500px; padding: 15px 25px ; box-sizing: border-box;"), s.appendChild(r), s.appendChild(o);
                          var n = document.createElement("div");
                          n.setAttribute("style", "height: 12%;"), n.innerText = "QiNiu Web Screensharing wants to share the contents. Choose what you'd like to share.";
                          var a = document.createElement("div");
                          a.setAttribute("style", "width: 100%; height: 80%; background: #FFF; border:  solid 1px #CBCBCB; display: flex; flex-wrap: wrap; justify-content: space-around; overflow-y: scroll; padding: 0 15px; box-sizing: border-box;");
                          var c = document.createElement("button");
                          c.setAttribute("style", "width: 85px;"), c.innerText = "cancel", c.onclick = function () {
                            document.body.removeChild(s), i(Ee("user cancel selection"));
                          };
                          var A = document.createElement("div");
                          A.setAttribute("style", "text-align: right; padding: 16px 0;"), A.appendChild(c), o.appendChild(n), o.appendChild(a), o.appendChild(A);
                          var _iterator40 = _createForOfIteratorHelper(e),
                            _step40;
                          try {
                            var _loop19 = function _loop19() {
                              var i = _step40.value;
                              var e = document.createElement("div");
                              e.setAttribute("style", "width: 30%; height: 160px; padding: 20px 0; text-align: center;box-sizing: content-box;"), e.onclick = function () {
                                document.body.removeChild(s), t(i.ID);
                              };
                              var r = document.createElement("div");
                              r.setAttribute("style", "height: 120px; display: table-cell; vertical-align: middle;");
                              var o = document.createElement("img");
                              o.setAttribute("style", "width: 100%; background: #333333; box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);"), o.src = i.url, r.appendChild(o);
                              var n = document.createElement("div");
                              n.setAttribute("style", "height: 40px; line-height: 40px; display: inline-block; width: 70%; word-break: keep-all; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"), n.innerText = i.name, e.appendChild(r), e.appendChild(n), a.appendChild(e);
                            };
                            for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
                              _loop19();
                            }
                          } catch (err) {
                            _iterator40.e(err);
                          } finally {
                            _iterator40.f();
                          }
                          document.body.appendChild(s);
                        }));
                      case 1:
                      case "end":
                        return _context94.stop();
                    }
                  }, _callee90);
                }));
              }(_e56);
            case 11:
              _i42 = _context95.sent;
              t = {
                video: {
                  mandatory: {
                    chromeMediaSourceId: _i42,
                    chromeMediaSource: "desktop"
                  }
                }
              };
            case 13:
              e.width && (t.video.maxWidth = e.width, t.video.minWidth = e.width), e.height && (t.video.maxHeight = e.height, t.video.minHeight = e.height);
              _context95.prev = 14;
              m.log("electron getUserMedia constraints: ", t);
              _context95.next = 18;
              return navigator.mediaDevices.getUserMedia(t);
            case 18:
              i = _context95.sent;
              _context95.next = 24;
              break;
            case 21:
              _context95.prev = 21;
              _context95.t0 = _context95["catch"](14);
              throw ke("Electron getUserMedia error, ".concat(_context95.t0 instanceof Error ? _context95.t0.message : "", ", config: ").concat(JSON.stringify(t)));
            case 24:
              s = [];
              _iterator41 = _createForOfIteratorHelper(i.getTracks());
              try {
                for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
                  _t57 = _step41.value;
                  "audio" === _t57.kind ? s.push($t(_t57, e.audioTag, e.bitrate)) : (e.optimizationMode && Zi(_t57, e.optimizationMode), s.push($t(_t57, e.tag, e.bitrate)));
                }
              } catch (err) {
                _iterator41.e(err);
              } finally {
                _iterator41.f();
              }
              return _context95.abrupt("return", s);
            case 28:
            case "end":
              return _context95.stop();
          }
        }, _callee91, this, [[14, 21]]);
      }));
    }
  }, {
    key: "getLocalTracks",
    value: function getLocalTracks() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Yi;
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee93() {
        var _t58, _i43, _s22, t, i, s, r, o, n, a, c, _iterator42, _step42, _t61, _i45, _iterator43, _step43, _e57, _t62, _t60;
        return _regeneratorRuntime().wrap(function _callee93$(_context97) {
          while (1) switch (_context97.prev = _context97.next) {
            case 0:
              if (!(m.debug("get local tracks", e), v(e) && k(e))) {
                _context97.next = 7;
                break;
              }
              _t58 = {
                screen: e.screen
              };
              _i43 = {
                video: e.video,
                audio: e.audio
              };
              _context97.next = 5;
              return Promise.all([this.getLocalTracks(_t58), this.getLocalTracks(_i43)]);
            case 5:
              _s22 = _context97.sent;
              return _context97.abrupt("return", _s22[0].concat(_s22[1]));
            case 7:
              _context97.next = 9;
              return function (e) {
                return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee92() {
                  var _t59, t, i, _i44;
                  return _regeneratorRuntime().wrap(function _callee92$(_context96) {
                    while (1) switch (_context96.prev = _context96.next) {
                      case 0:
                        if (e) {
                          _context96.next = 2;
                          break;
                        }
                        return _context96.abrupt("return", {
                          audio: !0,
                          video: !0
                        });
                      case 2:
                        if (!v(e)) {
                          _context96.next = 15;
                          break;
                        }
                        if (!k(e)) {
                          _context96.next = 5;
                          break;
                        }
                        throw ke("can not get mediaStream with video and screen are all enabled");
                      case 5:
                        if (F.screenSharing) {
                          _context96.next = 7;
                          break;
                        }
                        throw be("your browser can not share screen");
                      case 7:
                        _t59 = e.screen;
                        _context96.t0 = M && (_t59.forceChromePlugin || !F.getDisplayMedia);
                        if (!_context96.t0) {
                          _context96.next = 13;
                          break;
                        }
                        _context96.next = 12;
                        return Vt();
                      case 12:
                        _context96.t0 = !_context96.sent;
                      case 13:
                        if (!_context96.t0) {
                          _context96.next = 15;
                          break;
                        }
                        throw ye("");
                      case 15:
                        t = !(!e.audio || !e.audio.enabled || e.audio.source) && {
                          deviceId: e.audio.deviceId,
                          sampleRate: e.audio.sampleRate,
                          sampleSize: e.audio.sampleSize,
                          channelCount: e.audio.channelCount,
                          autoGainControl: e.audio.autoGainControl,
                          echoCancellation: e.audio.echoCancellation,
                          noiseSuppression: e.audio.noiseSuppression
                        }, i = !(!e.video || !e.video.enabled) && {
                          frameRate: e.video.frameRate,
                          height: e.video.height,
                          width: e.video.width,
                          deviceId: e.video.deviceId,
                          facingMode: e.video.facingMode
                        };
                        if (!(v(e) && e.screen)) {
                          _context96.next = 23;
                          break;
                        }
                        if (!(F.getDisplayMedia && !e.screen.forceChromePlugin)) {
                          _context96.next = 19;
                          break;
                        }
                        return _context96.abrupt("return", ti({
                          audio: t,
                          video: {
                            displaySurface: ei(e.screen.source),
                            width: e.screen.width,
                            height: e.screen.height,
                            frameRate: e.screen.frameRate
                          }
                        }));
                      case 19:
                        _context96.next = 21;
                        return Bt(!1, e.screen);
                      case 21:
                        _i44 = _context96.sent;
                        return _context96.abrupt("return", ti({
                          audio: t,
                          video: _i44
                        }));
                      case 23:
                        return _context96.abrupt("return", ti({
                          audio: t,
                          video: i
                        }));
                      case 24:
                      case "end":
                        return _context96.stop();
                    }
                  }, _callee92);
                }));
              }(e);
            case 9:
              t = _context97.sent;
              t.video && "object" == typeof t.video && t.video.deviceId && me.addEvent("DeviceChanged", {
                type: 0,
                desc: t.video.deviceId,
                event_grade: Ae.GENERAL,
                event_category: de.VIDEO
              }), t.audio && "object" == typeof t.audio && t.audio.deviceId && me.addEvent("DeviceChanged", {
                type: 1,
                desc: t.audio.deviceId,
                event_grade: Ae.GENERAL,
                event_category: de.AUDIO
              });
              _context97.prev = 11;
              _context97.next = 14;
              return this.getUserMedia(e, t, !0);
            case 14:
              i = _context97.sent;
              _context97.next = 20;
              break;
            case 17:
              _context97.prev = 17;
              _context97.t0 = _context97["catch"](11);
              throw "NotAllowedError" === _context97.t0.name ? Ee("") : _context97.t0;
            case 20:
              f(e) && (r = e.audio.bitrate, n = e.audio.tag), v(e) && (s = e.screen.bitrate, o = e.screen.tag, n = e.screen.audioTag), k(e) && (s = e.video.bitrate, o = e.video.tag);
              a = i ? i.getTracks() : [], c = [];
              _iterator42 = _createForOfIteratorHelper(a);
              try {
                for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
                  _t61 = _step42.value;
                  _i45 = void 0;
                  e.video && e.video.optimizationMode && (_i45 = e.video.optimizationMode), e.screen && e.screen.optimizationMode && (_i45 = e.screen.optimizationMode), _i45 && Zi(_t61, _i45);
                }
              } catch (err) {
                _iterator42.e(err);
              } finally {
                _iterator42.f();
              }
              _iterator43 = _createForOfIteratorHelper(a);
              try {
                for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
                  _e57 = _step43.value;
                  _t62 = void 0;
                  _t62 = "audio" === _e57.kind ? $t(_e57, n, r) : $t(_e57, o, s), c.push(_t62);
                }
              } catch (err) {
                _iterator43.e(err);
              } finally {
                _iterator43.f();
              }
              if (!(e.audio && e.audio.source)) {
                _context97.next = 31;
                break;
              }
              _context97.next = 29;
              return zi.createAudioTrackFromSource(e.audio.source, n, r);
            case 29:
              _t60 = _context97.sent;
              c.push(_t60);
            case 31:
              return _context97.abrupt("return", (this.updateDeivceInfo(), c));
            case 32:
            case "end":
              return _context97.stop();
          }
        }, _callee93, this, [[11, 17]]);
      }));
    }
  }, {
    key: "getLocalStream",
    value: function getLocalStream(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee94() {
        var t;
        return _regeneratorRuntime().wrap(function _callee94$(_context98) {
          while (1) switch (_context98.prev = _context98.next) {
            case 0:
              if (!(e && v(e) && k(e))) {
                _context98.next = 2;
                break;
              }
              throw ke("can not get local stream with video and screen");
            case 2:
              _context98.next = 4;
              return this.getLocalTracks(e);
            case 4:
              t = _context98.sent;
              return _context98.abrupt("return", new Ki(t, "send"));
            case 6:
            case "end":
              return _context98.stop();
          }
        }, _callee94, this);
      }));
    }
  }, {
    key: "getUserMedia",
    value: function getUserMedia(e, t) {
      var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee95() {
        var s, _i46, r, o, n, _a2, _a$getSettings, _a$getSettings$height, c, _a$getSettings$width, _A2, _n5, _n6;
        return _regeneratorRuntime().wrap(function _callee95$(_context99) {
          while (1) switch (_context99.prev = _context99.next) {
            case 0:
              if (!(m.debug("request to get user media, config", e), m.debug("request to get user media, constraints", t), !t.audio && !t.video)) {
                _context99.next = 2;
                break;
              }
              return _context99.abrupt("return", null);
            case 2:
              if (!v(e)) {
                _context99.next = 8;
                break;
              }
              _context99.next = 5;
              return this.getDisplayMedia(t, e);
            case 5:
              s = _context99.sent;
              _context99.next = 22;
              break;
            case 8:
              _context99.next = 10;
              return navigator.mediaDevices.getUserMedia(t);
            case 10:
              s = _context99.sent;
              if (!(!q && "getSettings" in MediaStreamTrack.prototype && i)) {
                _context99.next = 22;
                break;
              }
              _i46 = t.video;
              if (!(_i46 && "boolean" != typeof _i46)) {
                _context99.next = 22;
                break;
              }
              r = _i46.width, o = _i46.height;
              if (!("number" == typeof r && "number" == typeof o)) {
                _context99.next = 22;
                break;
              }
              n = s.getVideoTracks(), _a2 = n && n[0], _a$getSettings = _a2.getSettings(), _a$getSettings$height = _a$getSettings.height, c = _a$getSettings$height === void 0 ? o : _a$getSettings$height, _a$getSettings$width = _a$getSettings.width, _A2 = _a$getSettings$width === void 0 ? r : _a$getSettings$width;
              if (!(_A2 && c)) {
                _context99.next = 22;
                break;
              }
              _n5 = (o - c) * (r - _A2);
              if (!(_n5 * _n5 > 10)) {
                _context99.next = 22;
                break;
              }
              _n6 = o / r;
              return _context99.abrupt("return", (c / _A2 < _n6 ? (_i46.height = c, _i46.width = c / _n6) : (_i46.width = _A2, _i46.height = _A2 * _n6), m.debug("justified constraint constraintHeight, contraintWidth, constraintRatio, screenHeight, screenWidth:", o, r, _n6, c, _A2, _i46), s.getTracks().forEach(function (e) {
                return e.stop();
              }), this.getUserMedia(e, Object.assign(Object.assign({}, t), {
                video: _i46
              }), !1)));
            case 22:
              return _context99.abrupt("return", s);
            case 23:
            case "end":
              return _context99.stop();
          }
        }, _callee95, this);
      }));
    }
  }, {
    key: "getDisplayMedia",
    value: function getDisplayMedia(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee96() {
        var i, s, r;
        return _regeneratorRuntime().wrap(function _callee96$(_context100) {
          while (1) switch (_context100.prev = _context100.next) {
            case 0:
              _context100.t0 = e.audio;
              if (!_context100.t0) {
                _context100.next = 5;
                break;
              }
              _context100.next = 4;
              return navigator.mediaDevices.getUserMedia({
                audio: e.audio
              });
            case 4:
              i = _context100.sent;
            case 5:
              r = t.screen && t.screen.audio && !e.audio ? {
                video: e.video,
                audio: t.screen.audio
              } : {
                video: e.video
              };
              if (!(F.getDisplayMedia && t.screen && !t.screen.forceChromePlugin)) {
                _context100.next = 12;
                break;
              }
              _context100.next = 9;
              return navigator.mediaDevices.getDisplayMedia(r);
            case 9:
              _context100.t1 = _context100.sent;
              _context100.next = 15;
              break;
            case 12:
              _context100.next = 14;
              return navigator.mediaDevices.getUserMedia(r);
            case 14:
              _context100.t1 = _context100.sent;
            case 15:
              s = _context100.t1;
              i && s.addTrack(i.getAudioTracks()[0]);
              return _context100.abrupt("return", s);
            case 18:
            case "end":
              return _context100.stop();
          }
        }, _callee96);
      }));
    }
  }, {
    key: "updateDeivceInfo",
    value: function updateDeivceInfo() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee97() {
        var _this73 = this;
        var e, t, i;
        return _regeneratorRuntime().wrap(function _callee97$(_context101) {
          while (1) switch (_context101.prev = _context101.next) {
            case 0:
              _context101.next = 2;
              return navigator.mediaDevices.enumerateDevices();
            case 2:
              this.deviceInfo = _context101.sent;
              e = this.deviceInfo.map(function (e) {
                return e.deviceId;
              }), t = Object.keys(this.deviceMap);
              i = !1;
              t.forEach(function (t) {
                if (-1 === e.indexOf(t) && "@default" !== t) {
                  _this73.emit("device-remove", _this73.deviceMap[t].device);
                  var _e58 = _this73.deviceMap[t].device;
                  _this73.emit("device-changed", {
                    device: _e58,
                    state: B.INACTIVE
                  });
                  var s = "audioinput" === _e58.kind || "audiooutput" === _e58.kind ? "AudioDeviceInOut" : "VideoDeviceInOut",
                    r = "AudioDeviceInOut" === s ? de.AUDIO : de.VIDEO;
                  me.addEvent(s, {
                    device_type: "audiooutput" === _e58.kind ? 1 : 0,
                    device_state: 0,
                    device_label: _e58.label,
                    device_id: _e58.deviceId,
                    device_info: _e58.label,
                    event_grade: Ae.GENERAL,
                    event_category: r
                  }), delete _this73.deviceMap[t], i = !0;
                } else _this73.deviceMap[t].tick += 1;
              }), e.forEach(function (e, s) {
                if (-1 === t.indexOf(e) && "@default" !== e) {
                  _this73.deviceMap[e] = {
                    device: _this73.deviceInfo[s],
                    tick: 0
                  };
                  var _t63 = _this73.deviceMap[e].device;
                  _this73.emit("device-changed", {
                    device: _t63,
                    state: B.ACTIVE
                  }), _this73.emit("device-add", _t63);
                  var r = "audioinput" === _t63.kind || "audiooutput" === _t63.kind ? "AudioDeviceInOut" : "VideoDeviceInOut",
                    o = "AudioDeviceInOut" === r ? de.AUDIO : de.VIDEO;
                  me.addEvent(r, {
                    device_type: "audiooutput" === _t63.kind ? 1 : 0,
                    device_state: 1,
                    device_label: _t63.label,
                    device_id: _t63.deviceId,
                    event_grade: Ae.GENERAL,
                    event_category: o
                  }), i = !0;
                }
              }), i && this.emit("device-update", this.deviceInfo);
            case 6:
            case "end":
              return _context101.stop();
          }
        }, _callee97, this);
      }));
    }
  }]);
  return _class3;
}(t))();
var $i = /*#__PURE__*/function () {
  function $i(e, t) {
    _classCallCheck(this, $i);
    this.networkQuality = $.UNKNOWN, this._client = e, this._user = t, this.userID = t.userID, this.userData = t.userData;
  }
  _createClass($i, [{
    key: "getVideoTracks",
    value: function getVideoTracks() {
      var e = [];
      var _iterator44 = _createForOfIteratorHelper(this._client._remoteTracks),
        _step44;
      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var _t64 = _step44.value;
          _t64.isVideo() && _t64.userID === this.userID && e.push(_t64);
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
      return e;
    }
  }, {
    key: "getAudioTracks",
    value: function getAudioTracks() {
      var e = [];
      var _iterator45 = _createForOfIteratorHelper(this._client._remoteTracks),
        _step45;
      try {
        for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
          var _t65 = _step45.value;
          _t65.isAudio() && _t65.userID === this.userID && e.push(_t65);
        }
      } catch (err) {
        _iterator45.e(err);
      } finally {
        _iterator45.f();
      }
      return e;
    }
  }]);
  return $i;
}();
var es = /*#__PURE__*/function (_t66) {
  _inherits(es, _t66);
  function es() {
    var _this74;
    _classCallCheck(this, es);
    _this74 = _possibleConstructorReturn(this, _getPrototypeOf(es).apply(this, arguments)), _this74._isMuted = !1;
    return _this74;
  }
  _createClass(es, [{
    key: "eventNames",
    value: function eventNames() {
      return _get(_getPrototypeOf(es.prototype), "eventNames", this).call(this);
    }
  }, {
    key: "play",
    value: function play(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return this._track ? "boolean" == typeof t ? this._track.play(e, t, {}) : this._track.play(e, void 0, t) : Promise.reject();
    }
  }, {
    key: "isAudio",
    value: function isAudio() {
      return "audio" === this._kind;
    }
  }, {
    key: "isVideo",
    value: function isVideo() {
      return "video" === this._kind;
    }
  }, {
    key: "isMuted",
    value: function isMuted() {
      return this._isMuted;
    }
  }, {
    key: "getMediaStreamTrack",
    value: function getMediaStreamTrack() {
      return this.track ? this.track.mediaTrack : void 0;
    }
  }, {
    key: "mediaElement",
    get: function get() {
      return this._track && this._track.mediaElement;
    }
  }, {
    key: "track",
    get: function get() {
      return this._track;
    },
    set: function set(e) {
      e && (this._track = e, this._track.on("ended", function () {
        xi.emit("trackEnded", e.mediaTrack.id);
      }), this._track.on("audioBuffer", function (t) {
        xi.emit("audioBuffer", t, e.mediaTrack.id);
      }), this.trackID = this._track.info.trackID, this.userID = this._track.info.userID, this.tag = this._track.info.tag, this._kind = this._track.info.kind, this._isMuted = !!this._track.info.muted);
    }
  }]);
  return es;
}(t);
var ts = /*#__PURE__*/function (_es) {
  _inherits(ts, _es);
  function ts(e) {
    var _this75;
    _classCallCheck(this, ts);
    _this75 = _possibleConstructorReturn(this, _getPrototypeOf(ts).call(this)), _this75._isSubScribed = !1, _this75.uplinkStats = {
      uplinkRTT: 0,
      uplinkLostRate: 0
    }, _this75._kind = e.kind, _this75.trackID = e.trackID, _this75.userID = e.userID, _this75.tag = e.tag, xi.on("remote-track-stats", function (e) {
      var _iterator46 = _createForOfIteratorHelper(e),
        _step46;
      try {
        for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
          var _t67 = _step46.value;
          _t67.trackID === _this75.trackID && (_this75.uplinkStats.uplinkLostRate = _t67.packetLossRate, _this75.uplinkStats.uplinkRTT = _t67.rtt);
        }
      } catch (err) {
        _iterator46.e(err);
      } finally {
        _iterator46.f();
      }
    }), xi.on("mute-tracks", function (e) {
      var _iterator47 = _createForOfIteratorHelper(e),
        _step47;
      try {
        for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
          var _t68 = _step47.value;
          _t68.trackID === _this75.trackID && (_this75._isMuted = _t68.muted, _this75.emit("mute-state-changed", _t68.muted));
        }
      } catch (err) {
        _iterator47.e(err);
      } finally {
        _iterator47.f();
      }
    });
    return _this75;
  }
  _createClass(ts, [{
    key: "isSubscribed",
    value: function isSubscribed() {
      return this._isSubScribed;
    }
  }]);
  return ts;
}(es);
var is = /*#__PURE__*/function (_ts) {
  _inherits(is, _ts);
  function is(e) {
    var _this76;
    _classCallCheck(this, is);
    _this76 = _possibleConstructorReturn(this, _getPrototypeOf(is).call(this, e)), _this76.isMultiProfileEnabled = !1, _this76.isLowStreamEnabled = !1, _this76.profile = ee.HIGH, e.profiles.length > 0 && (_this76.isMultiProfileEnabled = !0, _this76.isLowStreamEnabled = !0), xi.on("sub-profile-changed", function (e, t) {
      if (e === _this76.trackID) switch (t) {
        case "high":
          _this76.profile = ee.HIGH, _this76.emit("profile-changed", ee.HIGH), _this76.emit("low-stream-state-changed", !1);
          break;
        case "medium":
          _this76.profile = ee.MEDIUM, _this76.emit("profile-changed", ee.MEDIUM);
          break;
        case "low":
          _this76.profile = ee.LOW, _this76.emit("profile-changed", ee.LOW), _this76.emit("low-stream-state-changed", !0);
      }
    });
    return _this76;
  }
  _createClass(is, [{
    key: "setProfile",
    value: function setProfile(e) {
      xi.emit("set-profile", this.trackID, e);
    }
  }, {
    key: "setLowStream",
    value: function setLowStream(e) {
      if (!this.isLowStreamEnabled) throw ke("isLowStreamEnabled is false, do not setLowStream on normal track");
      var t = e ? ee.LOW : ee.HIGH;
      xi.emit("set-profile", this.trackID, t);
    }
  }, {
    key: "getCurrentFrameData",
    value: function getCurrentFrameData() {
      return this._track ? this._track.getCurrentFrameDataURL() : "data:,";
    }
  }, {
    key: "getStats",
    value: function getStats() {
      var e = {
        downlinkFrameRate: 0,
        downlinkBitrate: 0,
        downlinkLostRate: 0,
        uplinkRTT: 0,
        uplinkLostRate: 0
      };
      if (!this._track) return e;
      var t = this._track.getStats();
      return 0 === t.length || (e.downlinkBitrate = t[0].bitrate, e.downlinkFrameRate = t[0].frameRate, e.downlinkLostRate = t[0].packetLossRate, e.uplinkLostRate = this.uplinkStats.uplinkLostRate, e.uplinkRTT = this.uplinkStats.uplinkRTT, this.isMultiProfileEnabled && (e.profile = this.profile)), e;
    }
  }]);
  return is;
}(ts);
var ss = /*#__PURE__*/function (_ts2) {
  _inherits(ss, _ts2);
  function ss(e) {
    var _this77;
    _classCallCheck(this, ss);
    _this77 = _possibleConstructorReturn(this, _getPrototypeOf(ss).call(this, e)), xi.on("audioBuffer", function (e, t) {
      _this77._track && t === _this77._track.mediaTrack.id && _this77.emit("audioFrame", e);
    });
    return _this77;
  }
  _createClass(ss, [{
    key: "setVolume",
    value: function setVolume(e) {
      this.track && this.track.setVolume(e);
    }
  }, {
    key: "getVolumeLevel",
    value: function getVolumeLevel() {
      if (this.track) return this.track.getCurrentVolumeLevel();
    }
  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      if (this.track) return this.track.getCurrentTimeDomainData();
    }
  }, {
    key: "getCurrentFrequencyDomainData",
    value: function getCurrentFrequencyDomainData() {
      if (this.track) return this.track.getCurrentFrequencyData();
    }
  }, {
    key: "setPlaybackDevice",
    value: function setPlaybackDevice(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee98() {
        return _regeneratorRuntime().wrap(function _callee98$(_context102) {
          while (1) switch (_context102.prev = _context102.next) {
            case 0:
              if (!this.track) {
                _context102.next = 2;
                break;
              }
              return _context102.abrupt("return", this.track.setPlaybackDevice(e));
            case 2:
            case "end":
              return _context102.stop();
          }
        }, _callee98, this);
      }));
    }
  }, {
    key: "getStats",
    value: function getStats() {
      var e = {
        downlinkBitrate: 0,
        downlinkLostRate: 0,
        uplinkRTT: 0,
        uplinkLostRate: 0
      };
      if (!this._track) return e;
      var t = this._track.getStats();
      return 0 === t.length || (e.downlinkBitrate = t[0].bitrate, e.downlinkLostRate = t[0].packetLossRate, e.uplinkLostRate = this.uplinkStats.uplinkLostRate, e.uplinkRTT = this.uplinkStats.uplinkRTT), e;
    }
  }]);
  return ss;
}(ts);
var rs = /*#__PURE__*/function () {
  function rs(e, t) {
    _classCallCheck(this, rs);
    this.dbName = e, this.storeConfigs = t, this.db = void 0;
  }
  _createClass(rs, [{
    key: "getDB",
    value: function getDB() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee99() {
        var _this78 = this;
        return _regeneratorRuntime().wrap(function _callee99$(_context103) {
          while (1) switch (_context103.prev = _context103.next) {
            case 0:
              return _context103.abrupt("return", null != this.db ? this.db : new Promise(function (e) {
                var t = indexedDB.open(_this78.dbName);
                t.addEventListener("upgradeneeded", function () {
                  var _iterator48 = _createForOfIteratorHelper(_this78.storeConfigs),
                    _step48;
                  try {
                    for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
                      var _e59 = _step48.value;
                      var _i47 = t.result.createObjectStore(_e59.name);
                      var _iterator49 = _createForOfIteratorHelper(_e59.indexes),
                        _step49;
                      try {
                        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
                          var _t69 = _step49.value;
                          _i47.createIndex(_t69.name, _t69.keyPath);
                        }
                      } catch (err) {
                        _iterator49.e(err);
                      } finally {
                        _iterator49.f();
                      }
                    }
                  } catch (err) {
                    _iterator48.e(err);
                  } finally {
                    _iterator48.f();
                  }
                }), e(ns(t));
              }));
            case 1:
            case "end":
              return _context103.stop();
          }
        }, _callee99, this);
      }));
    }
  }, {
    key: "get",
    value: function get(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee100() {
        return _regeneratorRuntime().wrap(function _callee100$(_context104) {
          while (1) switch (_context104.prev = _context104.next) {
            case 0:
              _context104.t0 = ns;
              _context104.next = 3;
              return this.getDB();
            case 3:
              _context104.t1 = _context104.sent.transaction(e, "readonly").objectStore(e).get(t);
              return _context104.abrupt("return", (0, _context104.t0)(_context104.t1));
            case 5:
            case "end":
              return _context104.stop();
          }
        }, _callee100, this);
      }));
    }
  }, {
    key: "getAll",
    value: function getAll(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee101() {
        return _regeneratorRuntime().wrap(function _callee101$(_context105) {
          while (1) switch (_context105.prev = _context105.next) {
            case 0:
              _context105.t0 = ns;
              _context105.next = 3;
              return this.getDB();
            case 3:
              _context105.t1 = _context105.sent.transaction(e, "readonly").objectStore(e).getAll();
              return _context105.abrupt("return", (0, _context105.t0)(_context105.t1));
            case 5:
            case "end":
              return _context105.stop();
          }
        }, _callee101, this);
      }));
    }
  }, {
    key: "count",
    value: function count(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee102() {
        return _regeneratorRuntime().wrap(function _callee102$(_context106) {
          while (1) switch (_context106.prev = _context106.next) {
            case 0:
              _context106.t0 = ns;
              _context106.next = 3;
              return this.getDB();
            case 3:
              _context106.t1 = _context106.sent.transaction(e, "readonly").objectStore(e).count();
              return _context106.abrupt("return", (0, _context106.t0)(_context106.t1));
            case 5:
            case "end":
              return _context106.stop();
          }
        }, _callee102, this);
      }));
    }
  }, {
    key: "set",
    value: function set(e, t, i) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee103() {
        var s;
        return _regeneratorRuntime().wrap(function _callee103$(_context107) {
          while (1) switch (_context107.prev = _context107.next) {
            case 0:
              _context107.next = 2;
              return this.getDB();
            case 2:
              s = _context107.sent.transaction(e, "readwrite");
              return _context107.abrupt("return", (s.objectStore(e).put(i, t), as(s)));
            case 4:
            case "end":
              return _context107.stop();
          }
        }, _callee103, this);
      }));
    }
  }, {
    key: "remove",
    value: function remove(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee104() {
        var i;
        return _regeneratorRuntime().wrap(function _callee104$(_context108) {
          while (1) switch (_context108.prev = _context108.next) {
            case 0:
              _context108.next = 2;
              return this.getDB();
            case 2:
              i = _context108.sent.transaction(e, "readwrite");
              return _context108.abrupt("return", (i.objectStore(e).delete(t), as(i)));
            case 4:
            case "end":
              return _context108.stop();
          }
        }, _callee104, this);
      }));
    }
  }, {
    key: "removeRange",
    value: function removeRange(e, t, i) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee106() {
        var _this79 = this;
        var s, r;
        return _regeneratorRuntime().wrap(function _callee106$(_context110) {
          while (1) switch (_context110.prev = _context110.next) {
            case 0:
              s = 0;
              _context110.next = 3;
              return this.getDB();
            case 3:
              r = _context110.sent.transaction(e, "readwrite").objectStore(e).openCursor(void 0, "next");
              return _context110.abrupt("return", new Promise(function (e, o) {
                r.addEventListener("error", function () {
                  return o(new os(r.error));
                }), r.addEventListener("success", function () {
                  return g(_this79, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee105() {
                    var o;
                    return _regeneratorRuntime().wrap(function _callee105$(_context109) {
                      while (1) switch (_context109.prev = _context109.next) {
                        case 0:
                          o = r.result;
                          if (!(null == o || s >= i)) {
                            _context109.next = 5;
                            break;
                          }
                          e();
                          _context109.next = 11;
                          break;
                        case 5:
                          _context109.t0 = s >= t && s < i;
                          if (!_context109.t0) {
                            _context109.next = 9;
                            break;
                          }
                          _context109.next = 9;
                          return ns(o.delete());
                        case 9:
                          ++s;
                          o.continue();
                        case 11:
                        case "end":
                          return _context109.stop();
                      }
                    }, _callee105);
                  }));
                });
              }));
            case 5:
            case "end":
              return _context110.stop();
          }
        }, _callee106, this);
      }));
    }
  }, {
    key: "clear",
    value: function clear() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee107() {
        var e;
        return _regeneratorRuntime().wrap(function _callee107$(_context111) {
          while (1) switch (_context111.prev = _context111.next) {
            case 0:
              _context111.next = 2;
              return this.getDB();
            case 2:
              e = _context111.sent;
              _context111.next = 5;
              return Promise.all(this.storeConfigs.map(function (t) {
                var i = t.name;
                var s = e.transaction(i, "readwrite");
                return s.objectStore(i).clear(), as(s);
              }));
            case 5:
            case "end":
              return _context111.stop();
          }
        }, _callee107, this);
      }));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.db && this.db.close();
    }
  }]);
  return rs;
}();
var os = /*#__PURE__*/function (_Error3) {
  _inherits(os, _Error3);
  function os(e) {
    var _this80;
    _classCallCheck(this, os);
    _this80 = _possibleConstructorReturn(this, _getPrototypeOf(os).call(this, e + "")), _this80.cause = e, _this80.name = "IndexedDBError";
    return _this80;
  }
  return os;
}(_wrapNativeSuper(Error));
function ns(e) {
  return new Promise(function (t, i) {
    e.addEventListener("success", function () {
      return t(e.result);
    }), e.addEventListener("error", function () {
      return i(new os(e.error));
    });
  });
}
function as(e) {
  return new Promise(function (t, i) {
    e.addEventListener("complete", function () {
      return t();
    }), e.addEventListener("error", function () {
      return i(new os(e.error));
    }), e.addEventListener("abort", function () {
      return i(new os(e.error));
    });
  });
}
var cs = "log",
  As = "https://upload.qiniup.com";
var ds;
!function (e) {
  e[e.Err_Fetch_Token = 25001] = "Err_Fetch_Token", e[e.Err_Read_File = 25002] = "Err_Read_File";
}(ds || (ds = {}));
var us = {
  name: cs,
  indexes: []
};
var hs = new ( /*#__PURE__*/function () {
  function _class4() {
    _classCallCheck(this, _class4);
    this.taskq = new U("log", !1), this.useLog = !1, this.db = new rs("qnwebrtc/dc/v1", [us]), this.initLogQueue();
  }
  _createClass(_class4, [{
    key: "setLogConfig",
    value: function setLogConfig(e) {
      this.useLog = !0, this.config = Object.assign(Object.assign({}, e), {
        maxCount: e.maxCount > 3e3 ? 3e3 : e.maxCount
      });
    }
  }, {
    key: "uploadLog",
    value: function uploadLog(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee108() {
        var _this81 = this;
        return _regeneratorRuntime().wrap(function _callee108$(_context112) {
          while (1) switch (_context112.prev = _context112.next) {
            case 0:
              if (!this.useLog) {
                _context112.next = 2;
                break;
              }
              return _context112.abrupt("return", new Promise(function (t) {
                _this81.taskq.push("uploadLog", {
                  token: e,
                  resolve: t
                });
              }));
            case 2:
            case "end":
              return _context112.stop();
          }
        }, _callee108, this);
      }));
    }
  }, {
    key: "_uploadLog",
    value: function _uploadLog(e) {
      var t = e.token,
        i = e.resolve;
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee109() {
        var e, s, r, o, _e60, n, a, c, A, d, u, _e61;
        return _regeneratorRuntime().wrap(function _callee109$(_context113) {
          while (1) switch (_context113.prev = _context113.next) {
            case 0:
              _context113.prev = 0;
              _context113.next = 3;
              return this.db.getAll(cs);
            case 3:
              e = _context113.sent;
              _context113.next = 9;
              break;
            case 6:
              _context113.prev = 6;
              _context113.t0 = _context113["catch"](0);
              return _context113.abrupt("return", {
                code: ds.Err_Read_File
              });
            case 9:
              s = e.map(function (e) {
                return e.map(function (e) {
                  return JSON.stringify(e);
                }).join(" ") + "\n";
              }), r = [];
              o = 0;
              for (_e60 = s.length - 1; _e60 >= 0 && o + s[_e60].length <= 10485760; _e60--) o += s[_e60].length, r.unshift(s[_e60]);
              n = new Blob(r, {
                type: "text/plain;charset=utf-8"
              }), a = new File([n], "log.text", {
                type: "text/plain"
              });
              if (!(void 0 === t)) {
                _context113.next = 25;
                break;
              }
              _context113.prev = 14;
              _context113.next = 17;
              return lt("/v4/sdk/log/upload/token");
            case 17:
              c = _context113.sent.uploadToken;
              _context113.next = 23;
              break;
            case 20:
              _context113.prev = 20;
              _context113.t1 = _context113["catch"](14);
              return _context113.abrupt("return", {
                code: ds.Err_Fetch_Token
              });
            case 23:
              _context113.next = 26;
              break;
            case 25:
              c = t;
            case 26:
              A = qs._clients.map(function (e) {
                return e.userID;
              }).join("_");
              _context113.next = 29;
              return he();
            case 29:
              d = _context113.sent;
              u = new FormData();
              u.append("action", As), u.append("key", "QNLog_".concat(Date.now(), "_").concat(this.config.tag, "_").concat(d, "_").concat(A)), u.append("token", c), u.append("file", a);
              _context113.prev = 32;
              _context113.next = 35;
              return fetch(As, {
                method: "POST",
                body: u
              });
            case 35:
              _e61 = _context113.sent;
              _context113.t2 = 200 === _e61.status;
              if (!_context113.t2) {
                _context113.next = 40;
                break;
              }
              _context113.next = 40;
              return this.db.clear();
            case 40:
              i({
                code: _e61.status
              });
              _context113.next = 46;
              break;
            case 43:
              _context113.prev = 43;
              _context113.t3 = _context113["catch"](32);
              i({
                code: -1
              });
            case 46:
            case "end":
              return _context113.stop();
          }
        }, _callee109, this, [[0, 6], [14, 20], [32, 43]]);
      }));
    }
  }, {
    key: "addLog",
    value: function addLog(e, t) {
      var _this82 = this;
      if (!this.useLog) return;
      var i = [e].concat(_toConsumableArray(t)).map(function (e) {
        return _this82.pretty(e, 2);
      });
      this.taskq.push("add", i);
    }
  }, {
    key: "_addLog",
    value: function _addLog(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee110() {
        var t;
        return _regeneratorRuntime().wrap(function _callee110$(_context114) {
          while (1) switch (_context114.prev = _context114.next) {
            case 0:
              _context114.next = 2;
              return this.db.count(cs);
            case 2:
              _context114.t0 = _context114.sent;
              _context114.t1 = this.config.maxCount;
              _context114.t2 = _context114.t0 >= _context114.t1;
              if (!_context114.t2) {
                _context114.next = 8;
                break;
              }
              _context114.next = 8;
              return this.db.removeRange(cs, 0, 1);
            case 8:
              t = e;
              _context114.next = 11;
              return this.db.set(cs, Date.now().toString(), t);
            case 11:
            case "end":
              return _context114.stop();
          }
        }, _callee110, this);
      }));
    }
  }, {
    key: "initLogQueue",
    value: function initLogQueue() {
      var _this83 = this;
      this.taskq.on("exec", function (e, t) {
        switch (e.method) {
          case "add":
            return void (t.promise = _this83._addLog(e.data));
          case "uploadLog":
            return void (t.promise = _this83._uploadLog(e.data));
        }
      });
    }
  }, {
    key: "pretty",
    value: function pretty(e, t) {
      var i = function i(e) {
        return e ? "function" == typeof e || "object" == typeof e ? "[native code]" : e.toString() : "";
      };
      if ("object" == typeof e) {
        var s = {};
        for (var r in e) 0 === t ? s[r] = i(e[r]) : "object" == typeof e[r] ? s[r] = this.pretty(e[r], t - 1) : s[r] = i(e[r]);
        return s;
      }
      return e;
    }
  }]);
  return _class4;
}())();
var ls = /*#__PURE__*/function (_t70) {
  _inherits(ls, _t70);
  function ls(e) {
    var _this84;
    _classCallCheck(this, ls);
    _this84 = _possibleConstructorReturn(this, _getPrototypeOf(ls).call(this)), _this84.readyUploadLog = !1, _this84.connectionState = V.DISCONNECTED, _this84._localTracks = [], _this84._remoteTracks = [], _this84._disconnectedInfo = {
      code: 0
    }, _this84.remoteUsers = [], _this84.session = new Vi(e), _this84.session.on("refresh-track-info", function (e) {
      var _iterator50 = _createForOfIteratorHelper(e),
        _step50;
      try {
        var _loop20 = function _loop20() {
          var t = _step50.value;
          _this84._localTracks.forEach(function (e) {
            e._track && e._track.mediaTrack.id === t.localid && (e.trackID = t.trackid);
          });
        };
        for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
          _loop20();
        }
      } catch (err) {
        _iterator50.e(err);
      } finally {
        _iterator50.f();
      }
    }), _this84.session.on("user-join", function (e) {
      var t = new $i(_assertThisInitialized(_assertThisInitialized(_this84)), e);
      _this84.remoteUsers.push(t), _this84.emit("user-joined", e.userID, e.userData);
    }), _this84.session.on("user-leave", function (e) {
      _this84.remoteUsers = _this84.remoteUsers.filter(function (t) {
        return t.userID !== e.userID;
      }), _this84.emit("user-left", e.userID);
    }), _this84.session.on("track-add", function (e) {
      var _this84$_remoteTracks;
      if (0 === e.length) return;
      var t = e.map(function (e) {
        return "audio" === e.kind ? new ss(e) : new is(e);
      });
      (_this84$_remoteTracks = _this84._remoteTracks).push.apply(_this84$_remoteTracks, _toConsumableArray(t));
      var i = a(t, function (e) {
        return e.userID;
      });
      Object.entries(i).forEach(function (e) {
        var _e62 = _slicedToArray(e, 2),
          t = _e62[0],
          i = _e62[1];
        _this84.emit("user-published", t, i);
      });
    }), _this84.session.on("track-remove", function (e) {
      if (0 === e.length) return;
      var t = e[0].userID,
        i = new Set();
      var _iterator51 = _createForOfIteratorHelper(e),
        _step51;
      try {
        for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
          var _t71 = _step51.value;
          i.add(_t71.trackID);
        }
      } catch (err) {
        _iterator51.e(err);
      } finally {
        _iterator51.f();
      }
      var s = [],
        r = [];
      var _iterator52 = _createForOfIteratorHelper(_this84._remoteTracks),
        _step52;
      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var _e63 = _step52.value;
          i.has(_e63.trackID) ? s.push(_e63) : r.push(_e63);
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }
      _this84._remoteTracks = r, _this84.emit("user-unpublished", t, s);
    }), _this84.session.on("mute-tracks", function (e) {
      0 !== e.length && xi.emit("mute-tracks", e);
    }), xi.on("set-mute-tracks", function (e, t, i) {
      if (i === _this84.getClientKey()) _this84.session.muteTracks([{
        trackID: e,
        muted: t
      }]);else if ("" === i) throw ke("can not setMuted，please publish track first");
    }), _this84.session.on("room-state-change", function (e) {
      switch (e) {
        case ji.Idle:
          _this84.connectionState = V.DISCONNECTED;
          break;
        case ji.Connecting:
          _this84.connectionState = V.CONNECTING;
          break;
        case ji.Reconnecting:
          _this84.connectionState = V.RECONNECTING;
          break;
        case ji.Connected:
          _this84.connectionState = _this84.connectionState === V.CONNECTING ? V.CONNECTED : V.RECONNECTED;
          break;
        default:
          m.warning("Invalid roomState: ", e);
      }
      if (_this84.connectionState === V.DISCONNECTED) {
        var _e64;
        switch (_this84._disconnectedInfo.code) {
          case 0:
            _e64 = te.LEAVE;
            break;
          case 10006:
            _e64 = te.KICKED_OUT;
            break;
          default:
            _e64 = te.ERROR;
        }
        var _t72 = {
          reason: _e64
        };
        if (_e64 === te.ERROR) switch (_t72.errorCode = _this84._disconnectedInfo.code, _t72.errorCode) {
          case 10001:
            _t72.errorMessage = "token 错误";
            break;
          case 10002:
            _t72.errorMessage = "token 过期";
            break;
          case 10004:
            _t72.errorMessage = "reconnect token 过期";
            break;
          case 10007:
            _t72.errorMessage = "断线重连失败";
            break;
          case 10022:
            _t72.errorMessage = "该用户在其他页面或终端登录";
            break;
          case 10011:
            _t72.errorMessage = "房间人数已满";
            break;
          case 10012:
            _t72.errorMessage = "房间已关闭";
            break;
          default:
            _t72.errorMessage = "unexpected error";
        }
        _this84.release(), _this84.emit("connection-state-changed", _this84.connectionState, _t72);
      } else _this84.emit("connection-state-changed", _this84.connectionState);
    }), _this84.session.on("messages-received", function (e) {
      var _iterator53 = _createForOfIteratorHelper(e),
        _step53;
      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var _t73 = _step53.value;
          var _e65 = {
            ID: _t73.msgid,
            userID: _t73.userID,
            content: _t73.data,
            timestamp: _t73.timestamp
          };
          _this84.emit("message-received", _e65);
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
    }), _this84.session.on("media-relay-state-changed", function (e, t) {
      _this84.emit("media-relay-state-changed", e, t);
    }), _this84.session.on("remote-user-reconnecting", function (e) {
      _this84.emit("user-reconnecting", e.userID);
    }), _this84.session.on("remote-user-reconnected", function (e) {
      _this84.emit("user-reconnected", e.userID);
    }), _this84.session.on("forward-job-connected", function (e) {
      _this84.emit("direct-livestreaming-state-changed", e.jobId, X.STARTED);
    }), _this84.session.on("forward-job-disconnected", function (e) {
      _this84.emit("direct-livestreaming-state-changed", e.jobId, X.STOPPED);
    }), _this84.session.on("merge-job-connected", function (e) {
      _this84.emit("transcoding-livestreaming-state-changed", e.jobId, X.STARTED);
    }), _this84.session.on("merge-job-disconnected", function (e) {
      _this84.emit("transcoding-livestreaming-state-changed", e.jobId, X.STOPPED);
    }), _this84.session.on("command", function (e) {
      if ("upload-log" === e.command) try {
        var _t74 = JSON.parse(e.content);
        _t74.auto_upload_log && 1 === _t74.auto_upload_log && (_this84.readyUploadLog = !0);
      } catch (e) {}
    }), _this84.session.on("disconnect", function (e) {
      _this84._disconnectedInfo = e;
    }), _this84.session.on("on-sub-profile-changed", function (e) {
      xi.emit("sub-profile-changed", e.trackid, e.profile);
    }), _this84.session.on("volume-indicator", function (e) {
      _this84.emit("volume-indicator", e);
    }), xi.on("remote-track-stats", function (e) {
      var _iterator54 = _createForOfIteratorHelper(e),
        _step54;
      try {
        var _loop21 = function _loop21() {
            var t = _step54.value;
            var e = _this84.remoteUsers.filter(function (e) {
              return e.userID === t.userID;
            })[0];
            if (!e) return {
              v: void 0
            };
            switch (t.networkGrade) {
              case y.INVALID:
                e.networkQuality = $.UNKNOWN;
                break;
              case y.POOR:
                e.networkQuality = $.POOR;
                break;
              case y.FAIR:
                e.networkQuality = $.FAIR;
                break;
              case y.GOOD:
                e.networkQuality = $.GOOD;
                break;
              case y.EXCELLENT:
                e.networkQuality = $.EXCELLENT;
                break;
              default:
                m.warning("unkonw network grade: ", t.networkGrade);
            }
          },
          _ret3;
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          _ret3 = _loop21();
          if (_ret3) return _ret3.v;
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }
    }), xi.on("set-profile", function (e, t) {
      switch (t) {
        case ee.HIGH:
          _this84.session.setProfile(e, "high");
          break;
        case ee.MEDIUM:
          _this84.session.setProfile(e, "medium");
          break;
        case ee.LOW:
          _this84.session.setProfile(e, "low");
      }
    }), xi.on("setMediaStreamTrack", function (e, t, i, s, r) {
      if (i === _this84.getClientKey()) _this84.session.replaceTrack(e, t).then(s).catch(r);else if ("" === i) throw ke("can not setMediaStreamTrack，please publish track first");
    });
    return _this84;
  }
  _createClass(ls, [{
    key: "setTransportPolicy",
    value: function setTransportPolicy(e) {
      this.session.config.transportPolicy = e;
    }
  }, {
    key: "getRemoteUser",
    value: function getRemoteUser(e) {
      return this.remoteUsers.find(function (t) {
        return t.userID === e;
      });
    }
  }, {
    key: "setClientMode",
    value: function setClientMode(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee111() {
        return _regeneratorRuntime().wrap(function _callee111$(_context115) {
          while (1) switch (_context115.prev = _context115.next) {
            case 0:
              this.session.setClientMode(e);
            case 1:
            case "end":
              return _context115.stop();
          }
        }, _callee111, this);
      }));
    }
  }, {
    key: "setClientRole",
    value: function setClientRole(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee112() {
        return _regeneratorRuntime().wrap(function _callee112$(_context116) {
          while (1) switch (_context116.prev = _context116.next) {
            case 0:
              _context116.next = 2;
              return this.session.setClientRole(e);
            case 2:
            case "end":
              return _context116.stop();
          }
        }, _callee112, this);
      }));
    }
  }, {
    key: "join",
    value: function join(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee113() {
        var _this85 = this;
        var i, _e66, s, r, o, n, a, _e67, _t75, _e68, _s23;
        return _regeneratorRuntime().wrap(function _callee113$(_context117) {
          while (1) switch (_context117.prev = _context117.next) {
            case 0:
              _context117.next = 2;
              return this.session.joinRoomWithToken(e, t);
            case 2:
              i = localStorage.getItem("QNConfig");
              if (i) try {
                _e66 = JSON.parse(i).find(function (e) {
                  return e.appid === _this85.session.appId && e.userid === _this85.session.userID;
                });
                _e66 && "1" === _e66.auto_upload_log && (this.readyUploadLog = !0);
              } catch (e) {}
              s = "".concat(P.name, " ").concat(P.version);
              _context117.next = 7;
              return he();
            case 7:
              r = _context117.sent;
              o = P.os;
              n = this.session.appId;
              a = this.session.userID;
              _context117.prev = 11;
              _context117.next = 14;
              return lt("/v4/sdk/config?platform=Web&appid=".concat(n, "&osversion=").concat(o, "&device_model=").concat(s, "&device_name=").concat(r, "&user_id=").concat(a));
            case 14:
              _e67 = _context117.sent;
              _t75 = {};
              if (_e67.content.split(";").filter(function (e) {
                return e;
              }).forEach(function (e) {
                var i = e.split(":");
                _t75[i[0]] = i[1];
              }), n && (_t75.appid = n), a && (_t75.userid = a), i) {
                _e68 = JSON.parse(i), _s23 = _e68.findIndex(function (e) {
                  return e.appid === _t75.appid && e.userid === _t75.userid;
                });
                _s23 > -1 ? _e68[_s23] = _t75 : _e68.push(_t75), localStorage.setItem("QNConfig", JSON.stringify(_e68));
              } else localStorage.setItem("QNConfig", JSON.stringify([_t75]));
              _context117.next = 22;
              break;
            case 19:
              _context117.prev = 19;
              _context117.t0 = _context117["catch"](11);
              m.warning(_context117.t0);
            case 22:
            case "end":
              return _context117.stop();
          }
        }, _callee113, this, [[11, 19]]);
      }));
    }
  }, {
    key: "leave",
    value: function leave() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee115() {
        var _this86 = this;
        return _regeneratorRuntime().wrap(function _callee115$(_context119) {
          while (1) switch (_context119.prev = _context119.next) {
            case 0:
              _context119.next = 2;
              return Promise.resolve().then(function () {
                return _this86.session.leave();
              });
            case 2:
              this.release();
              this.readyUploadLog && setTimeout(function () {
                return g(_this86, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee114() {
                  return _regeneratorRuntime().wrap(function _callee114$(_context118) {
                    while (1) switch (_context118.prev = _context118.next) {
                      case 0:
                        _context118.next = 2;
                        return hs.uploadLog();
                      case 2:
                        this.readyUploadLog = !1;
                      case 3:
                      case "end":
                        return _context118.stop();
                    }
                  }, _callee114, this);
                }));
              }, 0);
            case 4:
            case "end":
              return _context119.stop();
          }
        }, _callee115, this);
      }));
    }
  }, {
    key: "release",
    value: function release() {
      this._localTracks = [], this._remoteTracks = [], this._disconnectedInfo = {
        code: 0
      }, this.remoteUsers = [];
    }
  }, {
    key: "publish",
    value: function publish(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee116() {
        var _this$_localTracks, _iterator55, _step55, _t76;
        return _regeneratorRuntime().wrap(function _callee116$(_context120) {
          while (1) switch (_context120.prev = _context120.next) {
            case 0:
              if (!Array.isArray(e)) {
                _context120.next = 9;
                break;
              }
              e.find(function (e) {
                return e.isVideo();
              }) && (this.session.simulcast = !!e.filter(function (e) {
                return e.isVideo();
              }).find(function (e) {
                return e.isMultiProfileEnabled;
              }));
              _context120.next = 4;
              return this.session.publish(e.map(function (e) {
                return e.track;
              }));
            case 4:
              _iterator55 = _createForOfIteratorHelper(e);
              try {
                for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
                  _t76 = _step55.value;
                  _t76.trackID = _t76.track.info.trackID, _t76.userID = this.session.userID, _t76.client = this.getClientKey();
                }
              } catch (err) {
                _iterator55.e(err);
              } finally {
                _iterator55.f();
              }
              (_this$_localTracks = this._localTracks).push.apply(_this$_localTracks, _toConsumableArray(e));
              _context120.next = 16;
              break;
            case 9:
              e.isVideo() && e.isMultiProfileEnabled && (this.session.config.simulcast = !0);
              _context120.next = 12;
              return this.session.publish([e.track]);
            case 12:
              e.trackID = e.track.info.trackID;
              e.userID = this.session.userID;
              e.client = this.getClientKey();
              this._localTracks.push(e);
            case 16:
            case "end":
              return _context120.stop();
          }
        }, _callee116, this);
      }));
    }
  }, {
    key: "getClientKey",
    value: function getClientKey() {
      return n("".concat(this.roomName ? this.roomName : "").concat(this.userID ? this.userID : "").concat(this.session.appId ? this.session.appId : ""));
    }
  }, {
    key: "unpublish",
    value: function unpublish(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee117() {
        return _regeneratorRuntime().wrap(function _callee117$(_context121) {
          while (1) switch (_context121.prev = _context121.next) {
            case 0:
              if (!Array.isArray(e)) {
                _context121.next = 8;
                break;
              }
              if (!(this._localTracks.filter(function (t) {
                return e.includes(t);
              }).length !== e.length)) {
                _context121.next = 3;
                break;
              }
              throw ke("target tracks has not published");
            case 3:
              _context121.next = 5;
              return this.session.unpublish(e.map(function (e) {
                return e.trackID;
              }));
            case 5:
              this._localTracks = this._localTracks.filter(function (t) {
                return !e.includes(t);
              });
              _context121.next = 13;
              break;
            case 8:
              if (this._localTracks.includes(e)) {
                _context121.next = 10;
                break;
              }
              throw ke("target tracks has not published");
            case 10:
              _context121.next = 12;
              return this.session.unpublish([e.trackID]);
            case 12:
              this._localTracks = this._localTracks.filter(function (t) {
                return t !== e;
              });
            case 13:
            case "end":
              return _context121.stop();
          }
        }, _callee117, this);
      }));
    }
  }, {
    key: "subscribe",
    value: function subscribe(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee118() {
        var t, _i48, s, _iterator56, _step56, _loop22, _i49;
        return _regeneratorRuntime().wrap(function _callee118$(_context123) {
          while (1) switch (_context123.prev = _context123.next) {
            case 0:
              if (!Array.isArray(e)) {
                _context123.next = 24;
                break;
              }
              _context123.next = 3;
              return this.session.subscribe(e.map(function (e) {
                return e.trackID;
              }));
            case 3:
              t = _context123.sent;
              _i48 = [], s = [];
              _iterator56 = _createForOfIteratorHelper(t);
              _context123.prev = 6;
              _loop22 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop22() {
                var r, t, o;
                return _regeneratorRuntime().wrap(function _loop22$(_context122) {
                  while (1) switch (_context122.prev = _context122.next) {
                    case 0:
                      r = _step56.value;
                      t = e.filter(function (e) {
                        return e.trackID === r.info.trackID;
                      });
                      if (!(0 === t.length)) {
                        _context122.next = 4;
                        break;
                      }
                      return _context122.abrupt("return", 1);
                    case 4:
                      o = t[0];
                      o.track = r, o._isSubScribed = !0, "audio" === r.info.kind ? s.push(o) : _i48.push(o);
                    case 6:
                    case "end":
                      return _context122.stop();
                  }
                }, _loop22);
              });
              _iterator56.s();
            case 9:
              if ((_step56 = _iterator56.n()).done) {
                _context123.next = 15;
                break;
              }
              return _context123.delegateYield(_loop22(), "t0", 11);
            case 11:
              if (!_context123.t0) {
                _context123.next = 13;
                break;
              }
              return _context123.abrupt("continue", 13);
            case 13:
              _context123.next = 9;
              break;
            case 15:
              _context123.next = 20;
              break;
            case 17:
              _context123.prev = 17;
              _context123.t1 = _context123["catch"](6);
              _iterator56.e(_context123.t1);
            case 20:
              _context123.prev = 20;
              _iterator56.f();
              return _context123.finish(20);
            case 23:
              return _context123.abrupt("return", {
                audioTracks: s,
                videoTracks: _i48
              });
            case 24:
              _context123.next = 26;
              return this.session.subscribe([e.trackID]);
            case 26:
              t = _context123.sent;
              if (!(t.length > 0)) {
                _context123.next = 30;
                break;
              }
              _i49 = t[0];
              return _context123.abrupt("return", (e.track = _i49, e._isSubScribed = !0, "audio" === _i49.info.kind ? {
                videoTracks: [],
                audioTracks: [e]
              } : {
                audioTracks: [],
                videoTracks: [e]
              }));
            case 30:
              return _context123.abrupt("return", {
                audioTracks: [],
                videoTracks: []
              });
            case 31:
            case "end":
              return _context123.stop();
          }
        }, _callee118, this, [[6, 17, 20, 23]]);
      }));
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee119() {
        return _regeneratorRuntime().wrap(function _callee119$(_context124) {
          while (1) switch (_context124.prev = _context124.next) {
            case 0:
              if (!Array.isArray(e)) {
                _context124.next = 6;
                break;
              }
              _context124.next = 3;
              return this.session.unsubscribe(e.map(function (e) {
                return e.trackID;
              }));
            case 3:
              e.forEach(function (e) {
                e._isSubScribed = !1;
              });
              _context124.next = 9;
              break;
            case 6:
              _context124.next = 8;
              return this.session.unsubscribe([e.trackID]);
            case 8:
              e._isSubScribed = !1;
            case 9:
            case "end":
              return _context124.stop();
          }
        }, _callee119, this);
      }));
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(e, t, i) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee120() {
        var _this87 = this;
        return _regeneratorRuntime().wrap(function _callee120$(_context125) {
          while (1) switch (_context125.prev = _context125.next) {
            case 0:
              if (!("string" != typeof e)) {
                _context125.next = 2;
                break;
              }
              throw ke("messageID should be type of string, receive type ".concat(typeof e));
            case 2:
              if (!("string" != typeof t)) {
                _context125.next = 4;
                break;
              }
              throw ke("message should be type of string, receive type ".concat(typeof t));
            case 4:
              if (!Array.isArray(i)) {
                _context125.next = 9;
                break;
              }
              _context125.next = 7;
              return Promise.resolve().then(function () {
                return _this87.session.sendCustomMessage(t, i.map(function (e) {
                  return e.userID;
                }), e);
              });
            case 7:
              _context125.next = 11;
              break;
            case 9:
              _context125.next = 11;
              return Promise.resolve().then(function () {
                return _this87.session.sendCustomMessage(t, [], e);
              });
            case 11:
            case "end":
              return _context125.stop();
          }
        }, _callee120);
      }));
    }
  }, {
    key: "startDirectLiveStreaming",
    value: function startDirectLiveStreaming(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee121() {
        return _regeneratorRuntime().wrap(function _callee121$(_context126) {
          while (1) switch (_context126.prev = _context126.next) {
            case 0:
              if (!(null == e.audioTrack && null == e.videoTrack)) {
                _context126.next = 2;
                break;
              }
              throw fe("No track provided. Please check the parameter.");
            case 2:
              _context126.next = 4;
              return this.session.createForwardJob(st({
                userConfigExtraInfo: e.userConfigExtraInfo,
                jobId: e.streamID,
                publishUrl: e.url,
                audioTrackId: e.audioTrack && e.audioTrack.trackID,
                videoTrackId: e.videoTrack && e.videoTrack.trackID
              }));
            case 4:
            case "end":
              return _context126.stop();
          }
        }, _callee121, this);
      }));
    }
  }, {
    key: "stopDirectLiveStreaming",
    value: function stopDirectLiveStreaming(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee122() {
        return _regeneratorRuntime().wrap(function _callee122$(_context127) {
          while (1) switch (_context127.prev = _context127.next) {
            case 0:
              _context127.next = 2;
              return this.session.stopForwardJob(e);
            case 2:
            case "end":
              return _context127.stop();
          }
        }, _callee122, this);
      }));
    }
  }, {
    key: "startTranscodingLiveStreaming",
    value: function startTranscodingLiveStreaming(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee123() {
        return _regeneratorRuntime().wrap(function _callee123$(_context128) {
          while (1) switch (_context128.prev = _context128.next) {
            case 0:
              _context128.next = 2;
              return this.session.createMergeJob(e.streamID, st({
                publishUrl: e.url,
                height: e.height,
                width: e.width,
                fps: e.videoFrameRate,
                kbps: e.bitrate,
                stretchMode: e.renderMode,
                watermarks: e.watermarks && e.watermarks.map(function (e) {
                  return {
                    x: e.x,
                    y: e.y,
                    w: e.width,
                    h: e.height,
                    url: e.url
                  };
                }),
                background: e.background && {
                  x: e.background.x,
                  y: e.background.y,
                  w: e.background.width,
                  h: e.background.height,
                  url: e.background.url
                },
                maxRate: e.maxBitrate,
                minRate: e.minBitrate,
                holdLastFrame: e.holdLastFrame
              }));
            case 2:
              _context128.t0 = e.transcodingTracks;
              if (!_context128.t0) {
                _context128.next = 6;
                break;
              }
              _context128.next = 6;
              return this.setTranscodingLiveStreamingTracks(e.streamID, e.transcodingTracks);
            case 6:
            case "end":
              return _context128.stop();
          }
        }, _callee123, this);
      }));
    }
  }, {
    key: "stopTranscodingLiveStreaming",
    value: function stopTranscodingLiveStreaming(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee124() {
        return _regeneratorRuntime().wrap(function _callee124$(_context129) {
          while (1) switch (_context129.prev = _context129.next) {
            case 0:
              _context129.next = 2;
              return this.session.stopMergeStream(e);
            case 2:
            case "end":
              return _context129.stop();
          }
        }, _callee124, this);
      }));
    }
  }, {
    key: "setTranscodingLiveStreamingTracks",
    value: function setTranscodingLiveStreamingTracks(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee125() {
        var i;
        return _regeneratorRuntime().wrap(function _callee125$(_context130) {
          while (1) switch (_context130.prev = _context130.next) {
            case 0:
              i = t.map(function (e) {
                return st({
                  trackID: e.trackID,
                  x: e.x,
                  y: e.y,
                  w: e.width,
                  h: e.height,
                  z: e.zOrder,
                  stretchMode: e.renderMode
                });
              });
              if (!e) {
                _context130.next = 6;
                break;
              }
              _context130.next = 4;
              return this.session.addMergeStreamTracks(i, e);
            case 4:
              _context130.next = 8;
              break;
            case 6:
              _context130.next = 8;
              return this.session.addMergeStreamTracks(i);
            case 8:
            case "end":
              return _context130.stop();
          }
        }, _callee125, this);
      }));
    }
  }, {
    key: "removeTranscodingLiveStreamingTracks",
    value: function removeTranscodingLiveStreamingTracks(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee126() {
        return _regeneratorRuntime().wrap(function _callee126$(_context131) {
          while (1) switch (_context131.prev = _context131.next) {
            case 0:
              if (!e) {
                _context131.next = 5;
                break;
              }
              _context131.next = 3;
              return this.session.removeMergeStreamTracks(t.map(function (e) {
                return e.trackID;
              }), e);
            case 3:
              _context131.next = 7;
              break;
            case 5:
              _context131.next = 7;
              return this.session.removeMergeStreamTracks(t.map(function (e) {
                return e.trackID;
              }));
            case 7:
            case "end":
              return _context131.stop();
          }
        }, _callee126, this);
      }));
    }
  }, {
    key: "getNetworkQuality",
    value: function getNetworkQuality() {
      var e = $.UNKNOWN;
      var t = this._localTracks.reduce(function (e, t) {
        return t.track ? [].concat(_toConsumableArray(e), _toConsumableArray(t.track.getStats().map(function (e) {
          return e.networkGrade;
        }))) : _toConsumableArray(e);
      }, []);
      return t.includes(y.POOR) ? (e = $.POOR, e) : t.includes(y.FAIR) ? (e = $.FAIR, e) : t.includes(y.GOOD) ? (e = $.GOOD, e) : t.includes(y.EXCELLENT) ? (e = $.EXCELLENT, e) : e;
    }
  }, {
    key: "getUserNetworkQuality",
    value: function getUserNetworkQuality(e) {
      var t = $.UNKNOWN;
      if (this._remoteTracks.find(function (t) {
        return t.userID === e && t.isSubscribed();
      })) {
        var _i50 = this.remoteUsers.filter(function (t) {
          return t.userID === e;
        })[0];
        if (!_i50) return m.warning("cannot find userID: ", e), t;
        t = _i50.networkQuality;
      }
      return t;
    }
  }, {
    key: "enableAudioVolumeIndicator",
    value: function enableAudioVolumeIndicator() {
      this.session.registerVolumeIndicatorEvent();
    }
  }, {
    key: "kickOutUser",
    value: function kickOutUser(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee127() {
        return _regeneratorRuntime().wrap(function _callee127$(_context132) {
          while (1) switch (_context132.prev = _context132.next) {
            case 0:
              if (!this.remoteUsers.find(function (t) {
                return t.userID === e;
              })) {
                _context132.next = 5;
                break;
              }
              _context132.next = 3;
              return this.session.kickoutUser(e);
            case 3:
              _context132.next = 6;
              break;
            case 5:
              m.warning("cannot find userID: ", e);
            case 6:
            case "end":
              return _context132.stop();
          }
        }, _callee127, this);
      }));
    }
  }, {
    key: "startMediaRelay",
    value: function startMediaRelay(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee128() {
        return _regeneratorRuntime().wrap(function _callee128$(_context133) {
          while (1) switch (_context133.prev = _context133.next) {
            case 0:
              return _context133.abrupt("return", this.session.startMediaRelay(e));
            case 1:
            case "end":
              return _context133.stop();
          }
        }, _callee128, this);
      }));
    }
  }, {
    key: "updateMediaRelay",
    value: function updateMediaRelay(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee129() {
        return _regeneratorRuntime().wrap(function _callee129$(_context134) {
          while (1) switch (_context134.prev = _context134.next) {
            case 0:
              return _context134.abrupt("return", this.session.updateMediaRelay(e));
            case 1:
            case "end":
              return _context134.stop();
          }
        }, _callee129, this);
      }));
    }
  }, {
    key: "stopMediaRelay",
    value: function stopMediaRelay() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee130() {
        return _regeneratorRuntime().wrap(function _callee130$(_context135) {
          while (1) switch (_context135.prev = _context135.next) {
            case 0:
              return _context135.abrupt("return", this.session.stopMediaRelay());
            case 1:
            case "end":
              return _context135.stop();
          }
        }, _callee130, this);
      }));
    }
  }, {
    key: "config",
    set: function set(e) {
      this.session.config = e, this.setTransportPolicy(e.transportPolicy), e.simulcast && (this.session.simulcast = e.simulcast), e.reconnectTimes && this.session.setReconnectTimes(e.reconnectTimes), e.requestTimeout && this.session.setRequestTimeout(e.requestTimeout);
    }
  }, {
    key: "userID",
    get: function get() {
      return this.session.userID;
    }
  }, {
    key: "userData",
    get: function get() {
      return this.session.userData;
    }
  }, {
    key: "roomName",
    get: function get() {
      return this.session.roomName;
    }
  }]);
  return ls;
}(t);
var ms = /*#__PURE__*/function (_es2) {
  _inherits(ms, _es2);
  function ms(e) {
    var _this88;
    _classCallCheck(this, ms);
    _this88 = _possibleConstructorReturn(this, _getPrototypeOf(ms).call(this)), _this88.track = e, _this88.client = "", xi.on("trackEnded", function (e) {
      _this88._track && e === _this88._track.mediaTrack.id && _this88.emit("ended");
    });
    return _this88;
  }
  _createClass(ms, [{
    key: "setMuted",
    value: function setMuted(e) {
      this._isMuted = e, xi.emit("set-mute-tracks", this.trackID, e, this.client);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.track && this.track.release();
    }
  }]);
  return ms;
}(es);
var ps = /*#__PURE__*/function (_ms) {
  _inherits(ps, _ms);
  function ps(e) {
    var _this89;
    _classCallCheck(this, ps);
    _this89 = _possibleConstructorReturn(this, _getPrototypeOf(ps).call(this, e)), _this89.isMultiProfileEnabled = !1;
    return _this89;
  }
  _createClass(ps, [{
    key: "getLowStreamConfig",
    value: function getLowStreamConfig() {
      if (this._track) return this._track.lowStreamConfig;
    }
  }, {
    key: "getCurrentFrameData",
    value: function getCurrentFrameData() {
      return this._track ? this._track.getCurrentFrameDataURL() : "data:,";
    }
  }, {
    key: "getStats",
    value: function getStats() {
      if (!this._track) return [];
      var e = this._track.getStats();
      if (0 === e.length) return [];
      if (1 === e.length) {
        return e.map(function (e) {
          return {
            uplinkBitrate: e.bitrate,
            uplinkFrameRate: e.frameRate,
            uplinkLostRate: e.packetLossRate,
            uplinkRTT: e.rtt
          };
        });
      }
      {
        e = e.filter(function (e) {
          return 0 !== e.bitrate;
        }).sort(function (e, t) {
          return e.bitrate - t.bitrate;
        });
        var _t77 = e.map(function (e) {
          return {
            uplinkBitrate: e.bitrate,
            uplinkFrameRate: e.frameRate,
            uplinkLostRate: e.packetLossRate,
            uplinkRTT: e.rtt
          };
        });
        return _t77[0] && (_t77[0].profile = ee.LOW), _t77[1] && (_t77[1].profile = ee.MEDIUM), _t77[2] && (_t77[2].profile = ee.HIGH), 2 == _t77.length && _t77[1].profile === ee.MEDIUM && (_t77[1].profile = ee.HIGH), _t77;
      }
    }
  }, {
    key: "setOptimizationMode",
    value: function setOptimizationMode(e) {
      if (!this._track) return !1;
      var t = this._track.mediaTrack;
      return "contentHint" in t && (t.contentHint = e, t.contentHint === e);
    }
  }]);
  return ps;
}(ms);
var gs = /*#__PURE__*/function (_ps) {
  _inherits(gs, _ps);
  _createClass(gs, [{
    key: "facingMode",
    get: function get() {
      var e;
      return null === (e = this._track) || void 0 === e ? void 0 : e.mediaTrack.getSettings().facingMode;
    }
  }]);
  function gs(e) {
    _classCallCheck(this, gs);
    return _possibleConstructorReturn(this, _getPrototypeOf(gs).call(this, e));
  }
  _createClass(gs, [{
    key: "setMuted",
    value: function setMuted(e) {
      if (Os) throw ke("iOS 15.1 mute interface causes Safari crash, please upgrade to iOS 15.2+");
      _get(_getPrototypeOf(gs.prototype), "setMuted", this).call(this, e);
    }
  }, {
    key: "play",
    value: function play(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      var i;
      return "object" == typeof t && void 0 === t.mirror && (t.mirror = !0), m.debug("cam play:", t, null === (i = this.track) || void 0 === i ? void 0 : i.mediaTrack.getSettings()), _get(_getPrototypeOf(gs.prototype), "play", this).call(this, e, t);
    }
  }, {
    key: "switchCamera",
    value: function switchCamera(e) {
      var t;
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee131() {
        var _i51, s, _t78, r, o, _n7, _a3, _e69, _t79;
        return _regeneratorRuntime().wrap(function _callee131$(_context136) {
          while (1) switch (_context136.prev = _context136.next) {
            case 0:
              if (!this.track) {
                _context136.next = 43;
                break;
              }
              _i51 = {
                settings: this.track.mediaTrack.getSettings(),
                constraints: this.track.mediaTrack.getConstraints()
              };
              s = this.track.mediaTrack.getConstraints();
              if (!("string" == typeof e)) {
                _context136.next = 8;
                break;
              }
              _t78 = e;
              delete s.facingMode, s.deviceId = {
                exact: _t78
              };
              _context136.next = 15;
              break;
            case 8:
              if (!("object" == typeof e)) {
                _context136.next = 12;
                break;
              }
              s = Object.assign(Object.assign({}, s), e);
              _context136.next = 15;
              break;
            case 12:
              if (!(void 0 !== e)) {
                _context136.next = 14;
                break;
              }
              return _context136.abrupt("return", void m.error(this, "invalid argument calling `switchCamera` with arg: ", e));
            case 14:
              delete s.deviceId, s.facingMode = "user" === this.facingMode ? "environment" : "user";
            case 15:
              r = null === (t = this.track.mediaElement) || void 0 === t ? void 0 : t.srcObject;
              r instanceof MediaStream && (this.track.mediaElement.style.display = "none", r.getTracks().forEach(function (e) {
                e.stop(), r.removeTrack(e);
              }));
              o = Object.assign({}, s);
              m.debug("switching camera with new constraints", o);
              _n7 = 3;
              _a3 = 0;
            case 21:
              _context136.prev = 21;
              _context136.next = 24;
              return navigator.mediaDevices.getUserMedia({
                video: o
              });
            case 24:
              _e69 = _context136.sent.getVideoTracks()[0];
              _t79 = {
                settings: _e69.getSettings(),
                constraints: _e69.getConstraints()
              };
              m.debug("switchCamera", {
                before: _i51,
                after: _t79
              });
              _context136.next = 29;
              return xi.safeEmitAsPromise("setMediaStreamTrack", this.trackID, _e69, this.client);
            case 29:
              return _context136.abrupt("break", 43);
            case 32:
              _context136.prev = 32;
              _context136.t0 = _context136["catch"](21);
              if (!(_a3 < _n7 && _context136.t0 instanceof DOMException && "NotFoundError" == _context136.t0.name)) {
                _context136.next = 40;
                break;
              }
              _a3++;
              m.debug("retrying switching camera (".concat(_a3, "/").concat(_n7, ")"));
              _context136.next = 39;
              return at(300);
            case 39:
              return _context136.abrupt("continue", 41);
            case 40:
              throw _context136.t0;
            case 41:
              _context136.next = 21;
              break;
            case 43:
            case "end":
              return _context136.stop();
          }
        }, _callee131, this, [[21, 32]]);
      }));
    }
  }]);
  return gs;
}(ps);
var fs = /*#__PURE__*/function (_Ri2) {
  _inherits(fs, _Ri2);
  function fs(e) {
    var _this90;
    _classCallCheck(this, fs);
    var t = Ei.createMediaStreamDestination();
    _this90 = _possibleConstructorReturn(this, _getPrototypeOf(fs).call(this, t.stream.getAudioTracks()[0], e, "local")), _this90.sourceType = S.MIXING, _this90.initAudioManager(!0), _this90.destination = t, _this90.inputList = [];
    return _this90;
  }
  _createClass(fs, [{
    key: "appendAudioSource",
    value: function appendAudioSource(e) {
      var _this91 = this;
      this.inputList.find(function (t) {
        return t.track === e;
      }) ? m.warning("track is already in the track list") : (this.inputList.push({
        track: e
      }), e.on("ended", function () {
        _this91.emit("ended");
      }), e.audioManager.gainNode.connect(this.destination));
    }
  }, {
    key: "removeAudioSource",
    value: function removeAudioSource(e) {
      var t = this.inputList.find(function (t) {
        return t.track === e;
      });
      if (t) {
        try {
          t.track.audioManager.gainNode.disconnect(this.destination);
        } catch (e) {}
        i(this.inputList, function (e) {
          return e === t;
        });
      }
    }
  }, {
    key: "release",
    value: function release() {
      var _iterator57 = _createForOfIteratorHelper(this.inputList),
        _step57;
      try {
        for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
          var _e70 = _step57.value;
          this.removeAudioSource(_e70.track);
        }
      } catch (err) {
        _iterator57.e(err);
      } finally {
        _iterator57.f();
      }
      _get(_getPrototypeOf(fs.prototype), "release", this).call(this);
    }
  }]);
  return fs;
}(Ri);
var ks = /*#__PURE__*/function (_ms2) {
  _inherits(ks, _ms2);
  function ks(e) {
    var _this92;
    _classCallCheck(this, ks);
    var t = new fs();
    t.info = e.info, t.appendAudioSource(e), _this92 = _possibleConstructorReturn(this, _getPrototypeOf(ks).call(this, t)), _this92.filterList = [], _this92.sourceTrack = e, _this92.outputTrack = t, xi.on("audioBuffer", function (t, i) {
      i === e.mediaTrack.id && _this92.emit("audioFrame", t);
    });
    return _this92;
  }
  _createClass(ks, [{
    key: "addAudioFilter",
    value: function addAudioFilter(e) {
      this.filterList.push(e), e.add(this.outputTrack);
    }
  }, {
    key: "removeAudioFilter",
    value: function removeAudioFilter(e) {
      e.remove(this.outputTrack);
      var t = this.filterList.findIndex(function (t) {
        return t === e;
      });
      t >= 0 && this.filterList.splice(t, 1);
    }
  }, {
    key: "setVolume",
    value: function setVolume(e) {
      this.sourceTrack && this.sourceTrack.setVolume(e);
    }
  }, {
    key: "getVolumeLevel",
    value: function getVolumeLevel() {
      if (this.track) return this.track.getCurrentVolumeLevel();
    }
  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      if (this.track) return this.track.getCurrentTimeDomainData();
    }
  }, {
    key: "getCurrentFrequencyDomainData",
    value: function getCurrentFrequencyDomainData() {
      if (this.track) return this.track.getCurrentFrequencyData();
    }
  }, {
    key: "setPlaybackDevice",
    value: function setPlaybackDevice(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee132() {
        return _regeneratorRuntime().wrap(function _callee132$(_context137) {
          while (1) switch (_context137.prev = _context137.next) {
            case 0:
              if (!this.track) {
                _context137.next = 2;
                break;
              }
              return _context137.abrupt("return", this.track.setPlaybackDevice(e));
            case 2:
            case "end":
              return _context137.stop();
          }
        }, _callee132, this);
      }));
    }
  }, {
    key: "getStats",
    value: function getStats() {
      var e = {
        uplinkBitrate: 0,
        uplinkRTT: 0,
        uplinkLostRate: 0
      };
      if (!this._track) return e;
      var t = this._track.getStats();
      return 0 === t.length || (e.uplinkBitrate = t[0].bitrate, e.uplinkRTT = t[0].rtt, e.uplinkLostRate = t[0].packetLossRate), e;
    }
  }, {
    key: "setEarMonitorEnabled",
    value: function setEarMonitorEnabled(e) {
      throw new Error("setEarMonitorEnabled not supported.");
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this93 = this;
      this.outputTrack.removeAudioSource(this.sourceTrack), this.outputTrack.release(), this.filterList.forEach(function (e) {
        e.remove(_this93.outputTrack);
      }), this.sourceTrack.release();
    }
  }]);
  return ks;
}(ms);
var vs = /*#__PURE__*/function () {
  function vs() {
    _classCallCheck(this, vs);
    this.gainNode = Ei.createGain(), this.gainNode.connect(Ei.destination);
  }
  _createClass(vs, [{
    key: "setPlayingVolume",
    value: function setPlayingVolume(e) {
      this.gainNode.gain.setValueAtTime(e, Ei.currentTime);
    }
  }, {
    key: "addAudioNode",
    value: function addAudioNode(e) {
      e.connect(this.gainNode);
    }
  }, {
    key: "removeAudioNode",
    value: function removeAudioNode(e) {
      e.disconnect(this.gainNode);
    }
  }, {
    key: "release",
    value: function release() {
      this.gainNode.disconnect();
    }
  }]);
  return vs;
}();
var bs = /*#__PURE__*/function (_ks) {
  _inherits(bs, _ks);
  function bs(e) {
    var _this94;
    _classCallCheck(this, bs);
    _this94 = _possibleConstructorReturn(this, _getPrototypeOf(bs).call(this, e)), _this94.playbackEngine = new vs(), _this94.earMonitorEnable = !1;
    return _this94;
  }
  _createClass(bs, [{
    key: "isEarMonitorEnabled",
    value: function isEarMonitorEnabled() {
      return this.earMonitorEnable;
    }
  }, {
    key: "setEarMonitorEnabled",
    value: function setEarMonitorEnabled(e) {
      this.earMonitorEnable = e, this.earMonitorEnable ? this.playbackEngine.addAudioNode(this.sourceTrack.audioManager.gainNode) : this.playbackEngine.removeAudioNode(this.sourceTrack.audioManager.gainNode);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(bs.prototype), "destroy", this).call(this), this.playbackEngine.release();
    }
  }]);
  return bs;
}(ks);
var Ts = /*#__PURE__*/function (_ps2) {
  _inherits(Ts, _ps2);
  function Ts(e) {
    _classCallCheck(this, Ts);
    return _possibleConstructorReturn(this, _getPrototypeOf(Ts).call(this, e));
  }
  return Ts;
}(ps);
var ys = /*#__PURE__*/function (_ks2) {
  _inherits(ys, _ks2);
  function ys(e, t) {
    var _this95;
    _classCallCheck(this, ys);
    _this95 = _possibleConstructorReturn(this, _getPrototypeOf(ys).call(this, e)), _this95.rawTrack = e, _this95.source = t, e.on("audio-state-change", function (e) {
      switch (e) {
        case w.IDLE:
        case w.LOADING:
          return;
        case w.PLAY:
          return void _this95.emit("state-changed", Y.PlAYING);
        case w.PAUSE:
          return void _this95.emit("state-changed", Y.PAUSED);
        case w.END:
          return void _this95.emit("state-changed", Y.STOPPED);
      }
    });
    return _this95;
  }
  _createClass(ys, [{
    key: "start",
    value: function start(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee133() {
        return _regeneratorRuntime().wrap(function _callee133$(_context138) {
          while (1) switch (_context138.prev = _context138.next) {
            case 0:
              e && this.rawTrack.setLoop(e), this.rawTrack.startAudioSource();
            case 1:
            case "end":
              return _context138.stop();
          }
        }, _callee133, this);
      }));
    }
  }, {
    key: "stop",
    value: function stop() {
      this.rawTrack.stopAudioSource();
    }
  }, {
    key: "resume",
    value: function resume() {
      this.rawTrack.resumeAudioSource();
    }
  }, {
    key: "pause",
    value: function pause() {
      this.rawTrack.pauseAudioSource();
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.rawTrack.getDuration();
    }
  }, {
    key: "getCurrentPosition",
    value: function getCurrentPosition() {
      return this.rawTrack.getCurrentTime();
    }
  }, {
    key: "seekTo",
    value: function seekTo(e) {
      this.rawTrack.setCurrentTime(e);
    }
  }]);
  return ys;
}(ks);
var Es = /*#__PURE__*/function (_ks3) {
  _inherits(Es, _ks3);
  function Es(e) {
    _classCallCheck(this, Es);
    return _possibleConstructorReturn(this, _getPrototypeOf(Es).call(this, e));
  }
  _createClass(Es, [{
    key: "setMediaStreamTrack",
    value: function setMediaStreamTrack(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee134() {
        return _regeneratorRuntime().wrap(function _callee134$(_context139) {
          while (1) switch (_context139.prev = _context139.next) {
            case 0:
              return _context139.abrupt("return", xi.safeEmitAsPromise("setMediaStreamTrack", this.trackID, e, this.client));
            case 1:
            case "end":
              return _context139.stop();
          }
        }, _callee134, this);
      }));
    }
  }]);
  return Es;
}(ks);
var Ss = /*#__PURE__*/function (_ps3) {
  _inherits(Ss, _ps3);
  function Ss(e) {
    _classCallCheck(this, Ss);
    return _possibleConstructorReturn(this, _getPrototypeOf(Ss).call(this, e));
  }
  _createClass(Ss, [{
    key: "setMediaStreamTrack",
    value: function setMediaStreamTrack(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee135() {
        return _regeneratorRuntime().wrap(function _callee135$(_context140) {
          while (1) switch (_context140.prev = _context140.next) {
            case 0:
              return _context140.abrupt("return", xi.safeEmitAsPromise("setMediaStreamTrack", this.trackID, e, this.client));
            case 1:
            case "end":
              return _context140.stop();
          }
        }, _callee135, this);
      }));
    }
  }]);
  return Ss;
}(ps);
var Is = /*#__PURE__*/function (_ps4) {
  _inherits(Is, _ps4);
  function Is(e, t, i, s) {
    var _this96;
    _classCallCheck(this, Is);
    _this96 = _possibleConstructorReturn(this, _getPrototypeOf(Is).call(this, e)), _this96.drawImage = function () {
      _this96.drawImageOnce(), requestAnimationFrame(_this96.drawImage);
    }, _this96.drawImageOnce = function () {
      if (_this96.ctx) {
        var _iterator58 = _createForOfIteratorHelper(_this96.canvasSources),
          _step58;
        try {
          for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
            var _e71 = _step58.value;
            _this96.ctx.drawImage(_e71.source, _e71.x, _e71.y, _e71.width, _e71.heigth);
          }
        } catch (err) {
          _iterator58.e(err);
        } finally {
          _iterator58.f();
        }
      }
    }, _this96.canvas = t, _this96.ctx = i, _this96.updateSources(s).then(_this96.drawImage).catch(function (e) {
      m.warning(e);
    });
    var r = new Audio();
    r.src = "data:audio/mpeg;base64,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", r.autoplay = !0, r.loop = !0, r.muted = !0, r.ontimeupdate = function () {
      _this96.drawImageOnce();
    }, _this96.audioElement = r;
    return _this96;
  }
  _createClass(Is, [{
    key: "updateSources",
    value: function updateSources(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee136() {
        var t, _i52;
        return _regeneratorRuntime().wrap(function _callee136$(_context141) {
          while (1) switch (_context141.prev = _context141.next) {
            case 0:
              this.sources = e, this.canvasSources = [];
              _context141.next = 3;
              return Promise.all(e.map(function (e) {
                return fi.loadImage(e.source);
              }));
            case 3:
              t = _context141.sent;
              this.ctx && this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
              for (_i52 = 0; _i52 < e.length; _i52++) this.canvasSources.push({
                source: t[_i52],
                x: e[_i52].x,
                y: e[_i52].y,
                width: e[_i52].width || t[_i52].width,
                heigth: e[_i52].height || t[_i52].height
              });
            case 6:
            case "end":
              return _context141.stop();
          }
        }, _callee136, this);
      }));
    }
  }, {
    key: "play",
    value: function play(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return void 0 === t.mirror && (t.mirror = !1), _get(_getPrototypeOf(Is.prototype), "play", this).call(this, e, t);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.ctx = null, this.canvas.remove(), this.sources = [], this.canvasSources = [], this.audioElement.ontimeupdate = null, this.audioElement.src = "", this.audioElement.remove(), _get(_getPrototypeOf(Is.prototype), "destroy", this).call(this);
    }
  }]);
  return Is;
}(ps);
var _s;
!function (e) {
  e.IDLE = "IDLE", e.RECORDING = "RECORDING", e.STOPPED = "STOPPED";
}(_s || (_s = {}));
var ws = /*#__PURE__*/function (_t80) {
  _inherits(ws, _t80);
  function ws(e, t) {
    var _this97;
    _classCallCheck(this, ws);
    var i, s;
    _this97 = _possibleConstructorReturn(this, _getPrototypeOf(ws).call(this)), _this97.source = e, _this97.config = t, _this97.maxDurationMs = null !== (i = t.maxDurationMs) && void 0 !== i ? i : 12e4, _this97.recorderInfoUpdateInterval = null !== (s = t.recorderInfoUpdateInterval) && void 0 !== s ? s : 1e3;
    return _this97;
  }
  _createClass(ws, [{
    key: "startRecording",
    value: function startRecording() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee138() {
        var _this98 = this;
        var _e72, e, t, i, s, _e73, r, o, _t81, n;
        return _regeneratorRuntime().wrap(function _callee138$(_context143) {
          while (1) switch (_context143.prev = _context143.next) {
            case 0:
              if (!(this.state === _s.RECORDING)) {
                _context143.next = 3;
                break;
              }
              _e72 = Be();
              throw this.emit(ws.ERROR, Be()), _e72;
            case 3:
              e = this.config.storagePath, t = [], i = [];
              this.source.forEach(function (e) {
                return "video" === e.track.kind ? t.push(e) : i.push(e);
              });
              s = [];
              if (!(i.length && s.push(this.processAudioTracks(i)), t.length && s.push(this.processVideoTracks(t)), 0 === s.length)) {
                _context143.next = 9;
                break;
              }
              _e73 = Ue();
              throw this.emit(ws.ERROR, _e73), _e73;
            case 9:
              r = new MediaStream(s);
              this.mediaRecorder = new MediaRecorder(r);
              _context143.prev = 11;
              _context143.next = 14;
              return window.showSaveFilePicker({
                excludeAcceptAllOption: !0,
                suggestedName: e,
                types: [{
                  description: "qnweb-rtc-record",
                  accept: {
                    "video/webm": [".webm"],
                    "audio/webm": [".weba"]
                  }
                }]
              });
            case 14:
              o = _context143.sent;
              _context143.next = 21;
              break;
            case 17:
              _context143.prev = 17;
              _context143.t0 = _context143["catch"](11);
              _t81 = Fe();
              throw this.emit(ws.ERROR, _t81), _t81;
            case 21:
              _context143.next = 23;
              return o.getFile();
            case 23:
              n = _context143.sent;
              _context143.next = 26;
              return o.createWritable();
            case 26:
              this.writer = _context143.sent;
              this.mediaRecorder.onstart = function (e) {
                var t = e.timeStamp;
                var i = 0,
                  s = performance.now();
                _this98.mediaRecorder.ondataavailable = function (e) {
                  return g(_this98, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee137() {
                    var _e74, r, _e75;
                    return _regeneratorRuntime().wrap(function _callee137$(_context142) {
                      while (1) switch (_context142.prev = _context142.next) {
                        case 0:
                          if (!(e.data.size >= 1e3)) {
                            _context142.next = 4;
                            break;
                          }
                          s = performance.now();
                          _context142.next = 7;
                          break;
                        case 4:
                          if (!(performance.now() - s >= 5e3)) {
                            _context142.next = 7;
                            break;
                          }
                          _e74 = Ue();
                          throw this.emit(ws.ERROR, _e74), this.releaseRecoreding(), _e74;
                        case 7:
                          r = e.timeStamp - t;
                          if (!(r > this.maxDurationMs)) {
                            _context142.next = 11;
                            break;
                          }
                          _e75 = Ve();
                          throw this.emit(ws.ERROR, _e75), this.releaseRecoreding(), _e75;
                        case 11:
                          i += e.data.size, this.emit(ws.INFO_UPDATED, {
                            durationMs: r,
                            fileSize: i,
                            fileName: n.name
                          }), this.writer.write(e.data);
                        case 12:
                        case "end":
                          return _context142.stop();
                      }
                    }, _callee137, this);
                  }));
                };
              };
              this.mediaRecorder.start(this.recorderInfoUpdateInterval);
              this.state = _s.RECORDING;
            case 30:
            case "end":
              return _context143.stop();
          }
        }, _callee138, this, [[11, 17]]);
      }));
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee139() {
        var _this99 = this;
        var _e76;
        return _regeneratorRuntime().wrap(function _callee139$(_context144) {
          while (1) switch (_context144.prev = _context144.next) {
            case 0:
              if (!(this.state === _s.IDLE || this.state === _s.STOPPED)) {
                _context144.next = 3;
                break;
              }
              _e76 = Be();
              throw this.emit(ws.ERROR, _e76), _e76;
            case 3:
              return _context144.abrupt("return", new Promise(function (e) {
                _this99.mediaRecorder.stop(), setTimeout(function () {
                  _this99.writer.close(), _this99.state = _s.STOPPED, e();
                }, 1e3);
              }));
            case 4:
            case "end":
              return _context144.stop();
          }
        }, _callee139, this);
      }));
    }
  }, {
    key: "releaseRecoreding",
    value: function releaseRecoreding() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee140() {
        var _this100 = this;
        var _e77;
        return _regeneratorRuntime().wrap(function _callee140$(_context145) {
          while (1) switch (_context145.prev = _context145.next) {
            case 0:
              if (!(this.state === _s.IDLE)) {
                _context145.next = 3;
                break;
              }
              _e77 = Be();
              throw this.emit(ws.ERROR, _e77), _e77;
            case 3:
              return _context145.abrupt("return", new Promise(function (e) {
                _this100.mediaRecorder.stop(), setTimeout(function () {
                  _this100.writer.close(), _this100.state = _s.IDLE, _this100.removeAllListeners(), e();
                }, 1e3);
              }));
            case 4:
            case "end":
              return _context145.stop();
          }
        }, _callee140, this);
      }));
    }
  }, {
    key: "processVideoTracks",
    value: function processVideoTracks(e) {
      var _this$config = this.config,
        t = _this$config.width,
        i = _this$config.height,
        s = _this$config.frameRate,
        r = _this$config.storagePath,
        o = document.createElement("canvas"),
        n = o.getContext("2d"),
        a = window.devicePixelRatio || 1;
      o.width = t * a, o.height = i * a, o.style.width = "".concat(t, "px"), o.style.height = "".concat(i, "px"), n.scale(a, a);
      var c = e.sort(function (e, t) {
          return (e.zOrder || 0) - (t.zOrder || 0);
        }),
        A = [];
      var _iterator59 = _createForOfIteratorHelper(c),
        _step59;
      try {
        for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
          var _e79 = _step59.value;
          var _t82 = document.createElement("video");
          _t82.srcObject = new MediaStream([_e79.track]), A.push(Object.assign({
            elt: _t82
          }, _e79)), _t82.play();
        }
      } catch (err) {
        _iterator59.e(err);
      } finally {
        _iterator59.f();
      }
      this.renderVideoCanvas(n, A);
      var d = o.captureStream(s).getVideoTracks().pop();
      if (void 0 === d) {
        var _e78 = Ue();
        throw this.emit(ws.ERROR, _e78), this.releaseRecoreding(), _e78;
      }
      return d;
    }
  }, {
    key: "processAudioTracks",
    value: function processAudioTracks(e) {
      var t = new AudioContext(),
        i = t.createMediaStreamDestination();
      var _iterator60 = _createForOfIteratorHelper(e),
        _step60;
      try {
        for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
          var _s24 = _step60.value;
          t.createMediaStreamSource(new MediaStream([_s24.track])).connect(i);
        }
      } catch (err) {
        _iterator60.e(err);
      } finally {
        _iterator60.f();
      }
      var s = i.stream.getAudioTracks().pop();
      if (void 0 === s) {
        var _e80 = Ue();
        throw this.emit(ws.ERROR, _e80), this.releaseRecoreding(), _e80;
      }
      return s;
    }
  }, {
    key: "renderVideoCanvas",
    value: function renderVideoCanvas(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee141() {
        var _iterator61, _step61, _i53;
        return _regeneratorRuntime().wrap(function _callee141$(_context146) {
          while (1) switch (_context146.prev = _context146.next) {
            case 0:
              _iterator61 = _createForOfIteratorHelper(t);
              try {
                for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
                  _i53 = _step61.value;
                  e.drawImage(_i53.elt, _i53.x, _i53.y, _i53.width, _i53.height);
                }
              } catch (err) {
                _iterator61.e(err);
              } finally {
                _iterator61.f();
              }
              requestAnimationFrame(this.renderVideoCanvas.bind(this, e, t));
            case 3:
            case "end":
              return _context146.stop();
          }
        }, _callee141, this);
      }));
    }
  }, {
    key: "state",
    set: function set(e) {
      this._state = e, this.emit(ws.STATE_CHANGED, e);
    },
    get: function get() {
      return this._state;
    }
  }]);
  return ws;
}(t);
ws.STATE_CHANGED = "state-changed", ws.INFO_UPDATED = "info-updated", ws.ERROR = "error";
var Rs = /*#__PURE__*/function (_t83) {
  _inherits(Rs, _t83);
  function Rs() {
    var _this101;
    _classCallCheck(this, Rs);
    _this101 = _possibleConstructorReturn(this, _getPrototypeOf(Rs).call(this)), _this101.handleDeviceManager();
    return _this101;
  }
  _createClass(Rs, [{
    key: "setRecordingDevice",
    value: function setRecordingDevice(e) {
      this.currentRecordingDeviceID = e;
    }
  }, {
    key: "setPlaybackDevice",
    value: function setPlaybackDevice(e) {
      this.currentPlaybackDeviceID = e;
    }
  }, {
    key: "setCameraDevice",
    value: function setCameraDevice(e) {
      this.currentCameraDeviceID = e;
    }
  }, {
    key: "startRecordingDeviceTest",
    value: function startRecordingDeviceTest(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee142() {
        var _this102 = this;
        var i;
        return _regeneratorRuntime().wrap(function _callee142$(_context147) {
          while (1) switch (_context147.prev = _context147.next) {
            case 0:
              if (!(this.recordingDeviceTrack instanceof bs)) {
                _context147.next = 2;
                break;
              }
              return _context147.abrupt("return");
            case 2:
              if (!this.currentRecordingDeviceID) {
                _context147.next = 8;
                break;
              }
              _context147.next = 5;
              return qs.createMicrophoneAudioTrack({
                microphoneId: this.currentRecordingDeviceID
              });
            case 5:
              this.recordingDeviceTrack = _context147.sent;
              _context147.next = 11;
              break;
            case 8:
              _context147.next = 10;
              return qs.createMicrophoneAudioTrack();
            case 10:
              this.recordingDeviceTrack = _context147.sent;
            case 11:
              t && this.recordingDeviceTrack.setEarMonitorEnabled(!0);
              i = function i() {
                var e = _this102.recordingDeviceTrack ? _this102.recordingDeviceTrack.getVolumeLevel() : 0;
                _this102.emit("test-recording-device-volume", e);
              };
              this.recordingDeviceTimer = setInterval(function () {
                i();
              }, e), i();
            case 14:
            case "end":
              return _context147.stop();
          }
        }, _callee142, this);
      }));
    }
  }, {
    key: "stopRecordingDeviceTest",
    value: function stopRecordingDeviceTest() {
      clearInterval(this.recordingDeviceTimer), this.recordingDeviceTrack && this.recordingDeviceTrack.destroy(), this.recordingDeviceTrack = null;
    }
  }, {
    key: "startPlaybackDeviceTest",
    value: function startPlaybackDeviceTest(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee143() {
        var t;
        return _regeneratorRuntime().wrap(function _callee143$(_context148) {
          while (1) switch (_context148.prev = _context148.next) {
            case 0:
              if (!(this.playbackDeviceTrack instanceof ys)) {
                _context148.next = 2;
                break;
              }
              return _context148.abrupt("return");
            case 2:
              t = e instanceof Blob ? URL.createObjectURL(e) : e;
              _context148.next = 5;
              return qs.createBufferSourceAudioTrack({
                source: t
              });
            case 5:
              this.playbackDeviceTrack = _context148.sent;
              this.playbackDeviceEl = document.createElement("div");
              document.body.append(this.playbackDeviceEl);
              this.playbackDeviceTrack.start();
              this.playbackDeviceTrack.play(this.playbackDeviceEl);
              this.currentPlaybackDeviceID && this.playbackDeviceTrack.mediaElement.setSinkId(this.currentPlaybackDeviceID);
            case 11:
            case "end":
              return _context148.stop();
          }
        }, _callee143, this);
      }));
    }
  }, {
    key: "stopPlaybackDeviceTest",
    value: function stopPlaybackDeviceTest() {
      this.playbackDeviceTrack && this.playbackDeviceTrack.destroy(), this.playbackDeviceTrack = null, this.playbackDeviceEl.remove();
    }
  }, {
    key: "getCameraDevices",
    value: function getCameraDevices() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee144() {
        return _regeneratorRuntime().wrap(function _callee144$(_context149) {
          while (1) switch (_context149.prev = _context149.next) {
            case 0:
              return _context149.abrupt("return", Xi.getDeviceInfo(e, "cameras"));
            case 1:
            case "end":
              return _context149.stop();
          }
        }, _callee144);
      }));
    }
  }, {
    key: "getRecordingDevices",
    value: function getRecordingDevices() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee145() {
        return _regeneratorRuntime().wrap(function _callee145$(_context150) {
          while (1) switch (_context150.prev = _context150.next) {
            case 0:
              return _context150.abrupt("return", Xi.getDeviceInfo(e, "microphones"));
            case 1:
            case "end":
              return _context150.stop();
          }
        }, _callee145);
      }));
    }
  }, {
    key: "getPlaybackDevices",
    value: function getPlaybackDevices() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee146() {
        return _regeneratorRuntime().wrap(function _callee146$(_context151) {
          while (1) switch (_context151.prev = _context151.next) {
            case 0:
              return _context151.abrupt("return", Xi.getDeviceInfo(e, "playback"));
            case 1:
            case "end":
              return _context151.stop();
          }
        }, _callee146);
      }));
    }
  }, {
    key: "getDevices",
    value: function getDevices() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee147() {
        return _regeneratorRuntime().wrap(function _callee147$(_context152) {
          while (1) switch (_context152.prev = _context152.next) {
            case 0:
              return _context152.abrupt("return", Xi.getDeviceInfo(e, "all"));
            case 1:
            case "end":
              return _context152.stop();
          }
        }, _callee147);
      }));
    }
  }, {
    key: "handleDeviceManager",
    value: function handleDeviceManager() {
      var _this103 = this;
      Xi.on("device-changed", function (e) {
        switch (e.device.kind) {
          case "audioinput":
            _this103.emit("recording-device-changed", e.device, e.state);
            break;
          case "audiooutput":
            _this103.emit("playback-device-changed", e.device, e.state);
            break;
          case "videoinput":
            _this103.emit("camera-device-changed", e.device, e.state);
        }
      });
    }
  }]);
  return Rs;
}(t);
var Ds = /*#__PURE__*/function (_t84) {
  _inherits(Ds, _t84);
  function Ds(e) {
    var _this104;
    _classCallCheck(this, Ds);
    _this104 = _possibleConstructorReturn(this, _getPrototypeOf(Ds).call(this)), _this104.source = e, _this104.outTrackList = [], _this104.musicOption = {
      loop: !1,
      volume: 1
    }, _this104.musicVolume = 1, _this104.playbackEngine = new vs(), _this104.playback = !0;
    return _this104;
  }
  _createClass(Ds, [{
    key: "add",
    value: function add(e) {
      this.outTrackList.find(function (t) {
        return t === e;
      }) || (this.outTrackList.push(e), this.musicTrack && e.appendAudioSource(this.musicTrack));
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = this.outTrackList.findIndex(function (t) {
        return t === e;
      });
      t >= 0 && this.outTrackList.splice(t, 1), this.musicTrack && e.removeAudioSource(this.musicTrack);
    }
  }, {
    key: "start",
    value: function start() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee148() {
        return _regeneratorRuntime().wrap(function _callee148$(_context153) {
          while (1) switch (_context153.prev = _context153.next) {
            case 0:
              this._start(e);
            case 1:
            case "end":
              return _context153.stop();
          }
        }, _callee148, this);
      }));
    }
  }, {
    key: "stop",
    value: function stop() {
      this.loopCount = 1, this.stopMusicMixing();
    }
  }, {
    key: "resume",
    value: function resume() {
      this.musicTrack ? this.musicTrack.resumeAudioSource() : m.warning("can not find target music, please run startAudioMixing");
    }
  }, {
    key: "pause",
    value: function pause() {
      this.musicTrack ? this.musicTrack.pauseAudioSource() : m.warning("can not find target music, please run startAudioMixing");
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.musicTrack ? this.musicTrack.getDuration() : 0;
    }
  }, {
    key: "getCurrentPosition",
    value: function getCurrentPosition() {
      return this.musicTrack ? this.musicTrack.getCurrentTime() : 0;
    }
  }, {
    key: "seekTo",
    value: function seekTo(e) {
      if (this.musicTrack && this.musicTrack.setCurrentTime(e), this.musicTrack && !this.musicTrack.audioManager.audioSource) throw ke("can not find audio source");
    }
  }, {
    key: "getMixingVolume",
    value: function getMixingVolume() {
      return this.musicVolume;
    }
  }, {
    key: "setMixingVolume",
    value: function setMixingVolume(e) {
      var t = Number(e);
      t = isNaN(t) ? 0 : t, this.musicVolume = t, this.setMusicOption({
        volume: this.musicVolume
      });
    }
  }, {
    key: "release",
    value: function release() {
      this.loopCount = 1, this.stopMusicMixing();
    }
  }, {
    key: "_start",
    value: function _start() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
        t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee149() {
        return _regeneratorRuntime().wrap(function _callee149$(_context154) {
          while (1) switch (_context154.prev = _context154.next) {
            case 0:
              this.loopCount = Math.max(-1, Number(e));
              this.setMusicOption({
                loop: -1 === this.loopCount,
                volume: this.musicVolume
              });
              _context154.t0 = 0 !== this.loopCount;
              if (!_context154.t0) {
                _context154.next = 6;
                break;
              }
              _context154.next = 6;
              return this.startMusicMixing(this.source, t);
            case 6:
            case "end":
              return _context154.stop();
          }
        }, _callee149, this);
      }));
    }
  }, {
    key: "startMusicMixing",
    value: function startMusicMixing(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee150() {
        var _this105 = this;
        return _regeneratorRuntime().wrap(function _callee150$(_context155) {
          while (1) switch (_context155.prev = _context155.next) {
            case 0:
              if (!this.musicTrack) {
                _context155.next = 5;
                break;
              }
              this.stopMusicMixing(t);
              _context155.next = 4;
              return this.startMusicMixing(e);
            case 4:
              return _context155.abrupt("return", _context155.sent);
            case 5:
              _context155.prev = 5;
              _context155.next = 8;
              return zi.createAudioTrackFromSource(e);
            case 8:
              this.musicTrack = _context155.sent;
              this.outTrackList.forEach(function (e) {
                return e.appendAudioSource(_this105.musicTrack);
              });
              this.setMusicOption({});
              if (this.musicTrack.audioManager.audioSource) {
                _context155.next = 13;
                break;
              }
              throw ke("can not find audio source");
            case 13:
              this.playback && this.audioNode && this.playbackEngine.addAudioNode(this.audioNode), this.musicTrack.on("audio-state-change", function (e) {
                switch (e) {
                  case w.IDLE:
                    _this105.emit(Ds.STATE_CHANGED, Y.IDLE);
                    break;
                  case w.LOADING:
                    break;
                  case w.PLAY:
                    _this105.emit(Ds.STATE_CHANGED, Y.MIXING);
                    break;
                  case w.PAUSE:
                    _this105.emit(Ds.STATE_CHANGED, Y.PAUSED);
                    break;
                  case w.END:
                    _this105.loopCount > 1 ? (--_this105.loopCount, _this105._start(_this105.loopCount, !0)) : _this105.emit(Ds.STATE_CHANGED, Y.COMPLETED);
                    break;
                  case w.STOP:
                    _this105.emit(Ds.STATE_CHANGED, Y.STOPPED);
                }
              }), this.musicTrack.startAudioSource();
              _context155.next = 20;
              break;
            case 16:
              _context155.prev = 16;
              _context155.t0 = _context155["catch"](5);
              if (!(_context155.t0 instanceof ge)) {
                _context155.next = 20;
                break;
              }
              throw this.emit(Ds.ERROR, _context155.t0), _context155.t0;
            case 20:
            case "end":
              return _context155.stop();
          }
        }, _callee150, this, [[5, 16]]);
      }));
    }
  }, {
    key: "stopMusicMixing",
    value: function stopMusicMixing() {
      var _this106 = this;
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      this.musicTrack && (this.musicTrack.stopAudioSource(e), this.outTrackList.forEach(function (e) {
        return e.removeAudioSource(_this106.musicTrack);
      }), this.musicTrack.release(), this.musicTrack = void 0);
    }
  }, {
    key: "setMusicOption",
    value: function setMusicOption(e) {
      this.musicOption = Object.assign(this.musicOption, e), this.musicTrack && (this.musicTrack.setVolume(this.musicOption.volume), this.musicTrack.setLoop(this.musicOption.loop));
    }
  }, {
    key: "audioNode",
    get: function get() {
      return this.musicTrack ? this.musicTrack.audioManager.gainNode : null;
    }
  }]);
  return Ds;
}(t);
Ds.STATE_CHANGED = "state-changed", Ds.ERROR = "error";
var Cs = /*#__PURE__*/function (_t85) {
  _inherits(Cs, _t85);
  function Cs(e, t) {
    var _this107;
    _classCallCheck(this, Cs);
    _this107 = _possibleConstructorReturn(this, _getPrototypeOf(Cs).call(this)), _this107.playbackEngine = e, _this107.effectID = t, _this107.playback = !0, _this107.loopCount = 1;
    return _this107;
  }
  _createClass(Cs, [{
    key: "getDuration",
    value: function getDuration() {
      return this.getValidateAudioTrack().getDuration();
    }
  }, {
    key: "getID",
    value: function getID() {
      return this.effectID;
    }
  }, {
    key: "getFilePath",
    value: function getFilePath() {
      return this._filePath;
    }
  }, {
    key: "setLoopCount",
    value: function setLoopCount(e) {
      this.loopCount = -1 === e ? Number.MAX_SAFE_INTEGER : Math.max(0, Number(e)), 0 === this.loopCount && this.stopEffect();
    }
  }, {
    key: "getLoopCount",
    value: function getLoopCount() {
      return this.loopCount === Number.MAX_SAFE_INTEGER ? -1 : this.loopCount;
    }
  }, {
    key: "playEffect",
    value: function playEffect(e) {
      if (this.loopCount > 0) {
        var _t86 = this.getValidateAudioTrack();
        e && _t86.setVolume(e), this.playback && _t86.audioManager.audioSource && this.playbackEngine.addAudioNode(_t86.audioManager.gainNode), _t86.startAudioSource();
      }
    }
  }, {
    key: "stopEffect",
    value: function stopEffect() {
      var e = this.getValidateAudioTrack();
      this.loopCount = 1, e.stopAudioSource();
    }
  }, {
    key: "resumeEffect",
    value: function resumeEffect() {
      this.getValidateAudioTrack().resumeAudioSource();
    }
  }, {
    key: "pauseEffect",
    value: function pauseEffect() {
      this.getValidateAudioTrack().pauseAudioSource();
    }
  }, {
    key: "getCurrentPosition",
    value: function getCurrentPosition() {
      return this.getValidateAudioTrack().getCurrentTime();
    }
  }, {
    key: "addEffectSource",
    value: function addEffectSource(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee151() {
        return _regeneratorRuntime().wrap(function _callee151$(_context156) {
          while (1) switch (_context156.prev = _context156.next) {
            case 0:
              _context156.prev = 0;
              _context156.next = 3;
              return zi.createAudioTrackFromSource(e);
            case 3:
              this.audioTrack = _context156.sent;
              this._filePath = "string" == typeof e ? e : URL.createObjectURL(e);
              this.handleAudioTrack();
              _context156.next = 11;
              break;
            case 8:
              _context156.prev = 8;
              _context156.t0 = _context156["catch"](0);
              _context156.t0 instanceof ge && this.emit(Cs.ERROR, _context156.t0);
            case 11:
            case "end":
              return _context156.stop();
          }
        }, _callee151, this, [[0, 8]]);
      }));
    }
  }, {
    key: "appendAudioSource",
    value: function appendAudioSource(e) {
      this.audioTrack && e.appendAudioSource(this.audioTrack);
    }
  }, {
    key: "removeAudioSource",
    value: function removeAudioSource(e) {
      this.audioTrack && e.removeAudioSource(this.audioTrack);
    }
  }, {
    key: "release",
    value: function release() {
      void 0 !== this.audioTrack && (this.audioTrack.release(), this.audioTrack = void 0);
    }
  }, {
    key: "getValidateAudioTrack",
    value: function getValidateAudioTrack() {
      if (void 0 === this.audioTrack) {
        var _e81 = xe();
        throw this.emit(Cs.ERROR, _e81), _e81;
      }
      return this.audioTrack;
    }
  }, {
    key: "handleAudioTrack",
    value: function handleAudioTrack() {
      var _this108 = this;
      this.audioTrack && this.audioTrack.on("audio-state-change", function (e) {
        if (e === w.END) _this108.loopCount > 1 ? (_this108.loopCount = _this108.loopCount === Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : _this108.loopCount - 1, _this108.playEffect(_this108.loopCount)) : _this108.emit(Cs.FINISHED);
      });
    }
  }]);
  return Cs;
}(t);
Cs.FINISHED = "finished", Cs.ERROR = "error";
var Ms = /*#__PURE__*/function (_t87) {
  _inherits(Ms, _t87);
  function Ms() {
    var _this109;
    _classCallCheck(this, Ms);
    _this109 = _possibleConstructorReturn(this, _getPrototypeOf(Ms).apply(this, arguments)), _this109.outTrackList = [], _this109.audioEffectMap = new Map(), _this109.startedList = new Map(), _this109.playbackEngine = new vs();
    return _this109;
  }
  _createClass(Ms, [{
    key: "add",
    value: function add(e) {
      this.outTrackList.find(function (t) {
        return t === e;
      }) || (this.outTrackList.push(e), this.audioEffectMap.forEach(function (t) {
        t.appendAudioSource(e);
      }));
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = this.outTrackList.findIndex(function (t) {
        return t === e;
      });
      t >= 0 && this.outTrackList.splice(t, 1), this.audioEffectMap.forEach(function (t) {
        t.removeAudioSource(e);
      });
    }
  }, {
    key: "createAudioEffect",
    value: function createAudioEffect(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee152() {
        var _e82, _i54;
        return _regeneratorRuntime().wrap(function _callee152$(_context157) {
          while (1) switch (_context157.prev = _context157.next) {
            case 0:
              if (!this.audioEffectMap.has(e)) {
                _context157.next = 3;
                break;
              }
              _e82 = Ne();
              throw this.emit(Ms.ERROR, _e82), _e82;
            case 3:
              _i54 = new Cs(this.playbackEngine, e);
              this.handleAudioEffect(e, _i54);
              _context157.next = 7;
              return _i54.addEffectSource(t);
            case 7:
              this.outTrackList.forEach(function (e) {
                return _i54.appendAudioSource(e);
              });
              this.audioEffectMap.set(e, _i54);
              return _context157.abrupt("return", _i54);
            case 10:
            case "end":
              return _context157.stop();
          }
        }, _callee152, this);
      }));
    }
  }, {
    key: "start",
    value: function start(e) {
      this.getValidateAudioEffect(e).playEffect(1), this.startedList.set(e, !0);
    }
  }, {
    key: "stop",
    value: function stop(e) {
      this.getValidateAudioEffect(e).stopEffect();
    }
  }, {
    key: "pause",
    value: function pause(e) {
      this.getValidateAudioEffect(e).pauseEffect();
    }
  }, {
    key: "resume",
    value: function resume(e) {
      this.getValidateAudioEffect(e).resumeEffect();
    }
  }, {
    key: "stopAll",
    value: function stopAll() {
      this.audioEffectMap.forEach(function (e) {
        e.stopEffect();
      });
    }
  }, {
    key: "pauseAll",
    value: function pauseAll() {
      this.audioEffectMap.forEach(function (e) {
        e.pauseEffect();
      });
    }
  }, {
    key: "resumeAll",
    value: function resumeAll() {
      this.audioEffectMap.forEach(function (e) {
        e.resumeEffect();
      });
    }
  }, {
    key: "getCurrentPosition",
    value: function getCurrentPosition(e) {
      var t = this.getValidateAudioEffect(e);
      return this.startedList.get(e) ? Math.floor(1e3 * t.getCurrentPosition()) : 0;
    }
  }, {
    key: "setVolume",
    value: function setVolume(e, t) {
      this.getValidateAudioEffect(e).getValidateAudioTrack().setVolume(t);
    }
  }, {
    key: "getVolume",
    value: function getVolume(e) {
      return this.getValidateAudioEffect(e).getValidateAudioTrack().getVolume();
    }
  }, {
    key: "setAllEffectsVolume",
    value: function setAllEffectsVolume(e) {
      this.audioEffectMap.forEach(function (t) {
        t.getValidateAudioTrack().setVolume(e);
      });
    }
  }, {
    key: "release",
    value: function release() {
      var _this110 = this;
      this.audioEffectMap.forEach(function (e) {
        e.release(), _this110.outTrackList.forEach(function (t) {
          return e.removeAudioSource(t);
        });
      }), this.audioEffectMap.clear();
    }
  }, {
    key: "getValidateAudioEffect",
    value: function getValidateAudioEffect(e) {
      var t = this.audioEffectMap.get(e);
      if (void 0 === t) {
        var _e83 = je();
        throw this.emit(Ms.ERROR, _e83), _e83;
      }
      return t;
    }
  }, {
    key: "handleAudioEffect",
    value: function handleAudioEffect(e, t) {
      var _this111 = this;
      t.on(Cs.FINISHED, function () {
        _this111.emit(Ms.FINISHED, e);
      }), t.on(Cs.ERROR, function (e) {
        throw _this111.emit(Ms.ERROR, e), e;
      });
    }
  }]);
  return Ms;
}(t);
Ms.FINISHED = "finished", Ms.ERROR = "error";
var Os = ("safari" === P.name || "ios" === P.name) && navigator.userAgent.includes("15_1");
Os && m.warning("QNRTC: iOS 15.1 has a bug causing the SDK to crash. Please upgrade to iOS 15.2 or later.", P);
var Ps = /*#__PURE__*/function () {
  function Ps() {
    _classCallCheck(this, Ps);
  }
  _createClass(Ps, null, [{
    key: "isBrowserSupported",
    value: function isBrowserSupported() {
      return F.support;
    }
  }, {
    key: "checkSystemRequirements",
    value: function checkSystemRequirements() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee153() {
        return _regeneratorRuntime().wrap(function _callee153$(_context158) {
          while (1) switch (_context158.prev = _context158.next) {
            case 0:
              _context158.next = 2;
              return Ji();
            case 2:
              return _context158.abrupt("return", _context158.sent);
            case 3:
            case "end":
              return _context158.stop();
          }
        }, _callee153);
      }));
    }
  }, {
    key: "setLogLevel",
    value: function setLogLevel(e) {
      switch (e) {
        case ie.VERBOSE:
          m.setLevel("log");
          break;
        case ie.INFO:
          m.setLevel("debug");
          break;
        case ie.WARNING:
        case ie.ERROR:
          m.setLevel("warning");
          break;
        case ie.NONE:
          m.setLevel("disable");
      }
    }
  }, {
    key: "isChromeExtensionAvailable",
    value: function isChromeExtensionAvailable() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee154() {
        return _regeneratorRuntime().wrap(function _callee154$(_context159) {
          while (1) switch (_context159.prev = _context159.next) {
            case 0:
              _context159.next = 2;
              return Vt();
            case 2:
              return _context159.abrupt("return", _context159.sent);
            case 3:
            case "end":
              return _context159.stop();
          }
        }, _callee154);
      }));
    }
  }, {
    key: "createClient",
    value: function createClient() {
      var e = new ls(this._config);
      return Ps._clients.push(e), e;
    }
  }, {
    key: "getCameras",
    value: function getCameras() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee155() {
        return _regeneratorRuntime().wrap(function _callee155$(_context160) {
          while (1) switch (_context160.prev = _context160.next) {
            case 0:
              return _context160.abrupt("return", Xi.getDeviceInfo(e, "cameras"));
            case 1:
            case "end":
              return _context160.stop();
          }
        }, _callee155);
      }));
    }
  }, {
    key: "getMicrophones",
    value: function getMicrophones() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee156() {
        return _regeneratorRuntime().wrap(function _callee156$(_context161) {
          while (1) switch (_context161.prev = _context161.next) {
            case 0:
              return _context161.abrupt("return", Xi.getDeviceInfo(e, "microphones"));
            case 1:
            case "end":
              return _context161.stop();
          }
        }, _callee156);
      }));
    }
  }, {
    key: "getPlaybackDevices",
    value: function getPlaybackDevices() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee157() {
        return _regeneratorRuntime().wrap(function _callee157$(_context162) {
          while (1) switch (_context162.prev = _context162.next) {
            case 0:
              return _context162.abrupt("return", Xi.getDeviceInfo(e, "playback"));
            case 1:
            case "end":
              return _context162.stop();
          }
        }, _callee157);
      }));
    }
  }, {
    key: "getDevices",
    value: function getDevices() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee158() {
        return _regeneratorRuntime().wrap(function _callee158$(_context163) {
          while (1) switch (_context163.prev = _context163.next) {
            case 0:
              return _context163.abrupt("return", Xi.getDeviceInfo(e, "all"));
            case 1:
            case "end":
              return _context163.stop();
          }
        }, _callee158);
      }));
    }
  }, {
    key: "createAudioMusicMixer",
    value: function createAudioMusicMixer(e) {
      return this.audioMusicMixer || (this.audioMusicMixer = new Ds(e)), this.audioMusicMixer;
    }
  }, {
    key: "destroyAudioMusicMixer",
    value: function destroyAudioMusicMixer() {
      this.audioMusicMixer && this.audioMusicMixer.release();
    }
  }, {
    key: "createAudioEffectMixer",
    value: function createAudioEffectMixer() {
      return this.audioEffectMixer || (this.audioEffectMixer = new Ms()), this.audioEffectMixer;
    }
  }, {
    key: "destroyAudioEffectMixer",
    value: function destroyAudioEffectMixer() {
      this.audioEffectMixer && this.audioEffectMixer.release();
    }
  }, {
    key: "createCameraVideoTrack",
    value: function createCameraVideoTrack(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee159() {
        var t, i, s, r;
        return _regeneratorRuntime().wrap(function _callee159$(_context164) {
          while (1) switch (_context164.prev = _context164.next) {
            case 0:
              if (!(m.log("createCameraVideoTrack start", e), e && e.encoderConfig)) {
                _context164.next = 9;
                break;
              }
              if (!("string" == typeof e.encoderConfig)) {
                _context164.next = 6;
                break;
              }
              if (!(t = H[e.encoderConfig], !t)) {
                _context164.next = 4;
                break;
              }
              throw qe();
            case 4:
              _context164.next = 7;
              break;
            case 6:
              t = Object.assign(Object.assign({}, Q), e.encoderConfig);
            case 7:
              _context164.next = 10;
              break;
            case 9:
              t = Q;
            case 10:
              i = st({
                enabled: !0,
                width: t.width,
                height: t.height,
                frameRate: t.frameRate,
                bitrate: t.bitrate,
                tag: e && e.tag,
                facingMode: e && e.facingMode,
                optimizationMode: e && e.optimizationMode,
                deviceId: e && e.cameraId && {
                  exact: e.cameraId
                }
              });
              !i.deviceId && Ps.deviceManager && Ps.deviceManager.currentCameraDeviceID && (i.deviceId = {
                exact: Ps.deviceManager.currentCameraDeviceID
              });
              _context164.next = 14;
              return Xi.getLocalTracks({
                video: i
              });
            case 14:
              s = _context164.sent[0];
              e && e.encoderConfig && "string" != typeof e.encoderConfig && e.encoderConfig.lowStreamConfig && (s.lowStreamConfig = e.encoderConfig.lowStreamConfig);
              r = new gs(s);
              return _context164.abrupt("return", (void 0 !== t.isMultiProfileEnabled && (r.isMultiProfileEnabled = t.isMultiProfileEnabled), m.log("createCameraVideoTrack end", r), r));
            case 18:
            case "end":
              return _context164.stop();
          }
        }, _callee159);
      }));
    }
  }, {
    key: "createMicrophoneAudioTrack",
    value: function createMicrophoneAudioTrack(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee160() {
        var t, i, s, r;
        return _regeneratorRuntime().wrap(function _callee160$(_context165) {
          while (1) switch (_context165.prev = _context165.next) {
            case 0:
              if (!(m.log("createMicrophoneAudioTrack start", e), e && e.encoderConfig)) {
                _context165.next = 9;
                break;
              }
              if (!("string" == typeof e.encoderConfig)) {
                _context165.next = 6;
                break;
              }
              if (!(t = G[e.encoderConfig], !t)) {
                _context165.next = 4;
                break;
              }
              throw qe();
            case 4:
              _context165.next = 7;
              break;
            case 6:
              t = Object.assign(Object.assign({}, J), e.encoderConfig);
            case 7:
              _context165.next = 10;
              break;
            case 9:
              t = J;
            case 10:
              i = st({
                enabled: !0,
                bitrate: t.bitrate,
                sampleRate: t.sampleRate,
                sampleSize: t.sampleSize,
                channelCount: t.stereo ? 2 : 1,
                autoGainControl: !e || void 0 === e.AGC || e.AGC,
                noiseSuppression: !e || void 0 === e.ANS || e.ANS,
                echoCancellation: !e || void 0 === e.AEC || e.AEC,
                deviceId: e && e.microphoneId && {
                  exact: e.microphoneId
                },
                tag: e && e.tag
              });
              !i.deviceId && Ps.deviceManager && Ps.deviceManager.currentRecordingDeviceID && (i.deviceId = Ps.deviceManager.currentRecordingDeviceID);
              _context165.next = 14;
              return Xi.getLocalTracks({
                audio: i
              });
            case 14:
              s = _context165.sent;
              r = new bs(s[0]);
              return _context165.abrupt("return", (m.log("createMicrophoneAudioTrack end", r), r));
            case 17:
            case "end":
              return _context165.stop();
          }
        }, _callee160);
      }));
    }
  }, {
    key: "createScreenVideoTrack",
    value: function createScreenVideoTrack(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee161() {
        var i, s, r, _t88, _r8, _t89, _r9, o, _n8;
        return _regeneratorRuntime().wrap(function _callee161$(_context166) {
          while (1) switch (_context166.prev = _context166.next) {
            case 0:
              if (!(m.log("createScreenVideoTrack start", e, t), e && e.encoderConfig)) {
                _context166.next = 9;
                break;
              }
              if (!("string" == typeof e.encoderConfig)) {
                _context166.next = 6;
                break;
              }
              if (!(i = W[e.encoderConfig], !i)) {
                _context166.next = 4;
                break;
              }
              throw qe();
            case 4:
              _context166.next = 7;
              break;
            case 6:
              i = Object.assign(Object.assign({}, K), e.encoderConfig);
            case 7:
              _context166.next = 10;
              break;
            case 9:
              i = K;
            case 10:
              s = [];
              if (!L) {
                _context166.next = 17;
                break;
              }
              _context166.next = 14;
              return Xi.createElectronScreenTrack(st({
                sourceID: e && e.electronScreenSourceID,
                screenBitrate: i.bitrate,
                width: i.width,
                height: i.height,
                optimizationMode: e && e.optimizationMode,
                tag: e && e.screenVideoTag,
                audio: !(!t || !["enable", "auto"].includes(t)) || void 0,
                audioTag: e && e.screenAudioTag
              }));
            case 14:
              s = _context166.sent;
              _context166.next = 28;
              break;
            case 17:
              r = st({
                enabled: !0,
                width: i.width,
                height: i.height,
                frameRate: i.frameRate,
                bitrate: i.bitrate,
                optimizationMode: e && e.optimizationMode,
                tag: e && e.screenVideoTag,
                audio: !(!t || !["enable", "auto"].includes(t)) || void 0,
                audioTag: e && e.screenAudioTag
              });
              if (!(e && e.chromeExtensionSourceType)) {
                _context166.next = 25;
                break;
              }
              _context166.t0 = e.chromeExtensionSourceType;
              _context166.next = _context166.t0 === z.ALL ? 22 : _context166.t0 === z.SCREEN ? 24 : _context166.t0 === z.WINDOW ? 24 : 25;
              break;
            case 22:
              r = Object.assign(Object.assign({}, r), {
                forceChromePlugin: !0
              });
              return _context166.abrupt("break", 25);
            case 24:
              r = Object.assign(Object.assign({}, r), {
                forceChromePlugin: !0,
                source: e.chromeExtensionSourceType
              });
            case 25:
              _context166.next = 27;
              return Xi.getLocalTracks({
                screen: r
              });
            case 27:
              s = _context166.sent;
            case 28:
              if (!(1 === s.length && "video" === s[0].info.kind && "enable" === t)) {
                _context166.next = 30;
                break;
              }
              throw s[0].release(), Ie();
            case 30:
              if (!(1 === s.length && "video" === s[0].info.kind)) {
                _context166.next = 35;
                break;
              }
              _t88 = s[0];
              e && e.encoderConfig && "string" != typeof e.encoderConfig && e.encoderConfig.lowStreamConfig && (_t88.lowStreamConfig = e.encoderConfig.lowStreamConfig);
              _r8 = new Ts(_t88);
              return _context166.abrupt("return", (void 0 !== i.isMultiProfileEnabled && (_r8.isMultiProfileEnabled = i.isMultiProfileEnabled), m.log("createScreenVideoTrack end", _r8), _r8));
            case 35:
              _t89 = s.filter(function (e) {
                return "audio" === e.info.kind;
              })[0], _r9 = s.filter(function (e) {
                return "video" === e.info.kind;
              })[0];
              if (!(!_t89 || !_r9)) {
                _context166.next = 38;
                break;
              }
              throw ke("createScreenVideoTrack error, audioTrack: ".concat(_t89, ", videoTrack: ").concat(_r9));
            case 38:
              e && e.encoderConfig && "string" != typeof e.encoderConfig && e.encoderConfig.lowStreamConfig && (_r9.lowStreamConfig = e.encoderConfig.lowStreamConfig);
              o = new ks(_t89), _n8 = new Ts(_r9);
              return _context166.abrupt("return", (void 0 !== i.isMultiProfileEnabled && (_n8.isMultiProfileEnabled = i.isMultiProfileEnabled), m.log("createScreenVideoTrack end", [_n8, o]), [_n8, o]));
            case 41:
            case "end":
              return _context166.stop();
          }
        }, _callee161);
      }));
    }
  }, {
    key: "createMicrophoneAndCameraTracks",
    value: function createMicrophoneAndCameraTracks(e, t) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee162() {
        var i, s, r, o, n, a, c, A, d;
        return _regeneratorRuntime().wrap(function _callee162$(_context167) {
          while (1) switch (_context167.prev = _context167.next) {
            case 0:
              if (!(m.log("createMicrophoneAndCameraTracks start", e, t), e && e.encoderConfig)) {
                _context167.next = 9;
                break;
              }
              if (!("string" == typeof e.encoderConfig)) {
                _context167.next = 6;
                break;
              }
              if (!(i = G[e.encoderConfig], !i)) {
                _context167.next = 4;
                break;
              }
              throw qe();
            case 4:
              _context167.next = 7;
              break;
            case 6:
              i = Object.assign(Object.assign({}, J), e.encoderConfig);
            case 7:
              _context167.next = 10;
              break;
            case 9:
              i = J;
            case 10:
              if (!(t && t.encoderConfig)) {
                _context167.next = 19;
                break;
              }
              if (!("string" == typeof t.encoderConfig)) {
                _context167.next = 16;
                break;
              }
              if (!(s = H[t.encoderConfig], !s)) {
                _context167.next = 14;
                break;
              }
              throw qe();
            case 14:
              _context167.next = 17;
              break;
            case 16:
              s = Object.assign(Object.assign({}, Q), t.encoderConfig);
            case 17:
              _context167.next = 20;
              break;
            case 19:
              s = Q;
            case 20:
              r = st({
                enabled: !0,
                bitrate: i.bitrate,
                sampleRate: i.sampleRate,
                sampleSize: i.sampleSize,
                channelCount: i.stereo ? 2 : 1,
                autoGainControl: !e || void 0 === e.AGC || e.AGC,
                noiseSuppression: !e || void 0 === e.ANS || e.ANS,
                echoCancellation: !e || void 0 === e.AEC || e.AEC,
                deviceId: e && e.microphoneId && {
                  exact: e.microphoneId
                },
                tag: e && e.tag
              });
              !r.deviceId && Ps.deviceManager && Ps.deviceManager.currentRecordingDeviceID && (r.deviceId = Ps.deviceManager.currentRecordingDeviceID);
              o = st({
                enabled: !0,
                width: s.width,
                height: s.height,
                frameRate: s.frameRate,
                bitrate: s.bitrate,
                tag: t && t.tag,
                facingMode: t && t.facingMode,
                deviceId: t && t.cameraId && {
                  exact: t.cameraId
                }
              });
              !o.deviceId && Ps.deviceManager && Ps.deviceManager.currentCameraDeviceID && (o.deviceId = {
                exact: Ps.deviceManager.currentCameraDeviceID
              });
              _context167.next = 26;
              return Xi.getLocalTracks({
                audio: r,
                video: o
              });
            case 26:
              n = _context167.sent;
              a = n.filter(function (e) {
                return "audio" === e.info.kind;
              })[0];
              c = n.filter(function (e) {
                return "video" === e.info.kind;
              })[0];
              if (!(!a || !c)) {
                _context167.next = 31;
                break;
              }
              throw ke("createMicrophoneAndCameraTracks error, audioTrack: ".concat(a, ", videoTrack: ").concat(c));
            case 31:
              t && t.encoderConfig && "string" != typeof t.encoderConfig && t.encoderConfig.lowStreamConfig && (c.lowStreamConfig = t.encoderConfig.lowStreamConfig);
              A = new bs(a), d = new gs(c);
              return _context167.abrupt("return", (void 0 !== s.isMultiProfileEnabled && (d.isMultiProfileEnabled = s.isMultiProfileEnabled), m.log("createMicrophoneAndCameraTracks end", [A, d]), [A, d]));
            case 34:
            case "end":
              return _context167.stop();
          }
        }, _callee162);
      }));
    }
  }, {
    key: "createBufferSourceAudioTrack",
    value: function createBufferSourceAudioTrack(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee163() {
        var t, i, s;
        return _regeneratorRuntime().wrap(function _callee163$(_context168) {
          while (1) switch (_context168.prev = _context168.next) {
            case 0:
              if (!(m.log("createBufferSourceAudioTrack start", e), e && e.encoderConfig)) {
                _context168.next = 9;
                break;
              }
              if (!("string" == typeof e.encoderConfig)) {
                _context168.next = 6;
                break;
              }
              if (!(t = G[e.encoderConfig], !t)) {
                _context168.next = 4;
                break;
              }
              throw qe();
            case 4:
              _context168.next = 7;
              break;
            case 6:
              t = Object.assign(Object.assign({}, J), e.encoderConfig);
            case 7:
              _context168.next = 10;
              break;
            case 9:
              t = J;
            case 10:
              _context168.next = 12;
              return Xi.getLocalTracks({
                audio: st({
                  enabled: !0,
                  source: e.source,
                  bitrate: t.bitrate,
                  sampleRate: t.sampleRate,
                  sampleSize: t.sampleSize,
                  channelCount: t.stereo ? 2 : 1,
                  tag: e && e.tag
                })
              });
            case 12:
              i = _context168.sent;
              s = new ys(i[0], e.source);
              return _context168.abrupt("return", (m.log("createBufferSourceAudioTrack end", s), s));
            case 15:
            case "end":
              return _context168.stop();
          }
        }, _callee163);
      }));
    }
  }, {
    key: "createCanvasVideoTrack",
    value: function createCanvasVideoTrack(e) {
      var t = document.createElement("canvas");
      t.width = e.width, t.height = e.height;
      var i = t.getContext("2d");
      if (null === i) throw be("get context error, canvas track not supported");
      var s;
      if (t.captureStream) s = t.captureStream(15);else {
        if (!t.mozCaptureStream) throw be("capture stream error, canvas track not supported");
        s = t.mozCaptureStream(15);
      }
      var r = s.getTracks()[0];
      e.optimizationMode && "contentHint" in r && (r.contentHint = e.optimizationMode);
      var o = $t(r, e.tag);
      return new Is(o, t, i, e.sources);
    }
  }, {
    key: "createCustomAudioTrack",
    value: function createCustomAudioTrack(e) {
      var t = $t(e.mediaStreamTrack, e.tag, e.bitrate);
      return new Es(t);
    }
  }, {
    key: "createCustomVideoTrack",
    value: function createCustomVideoTrack(e) {
      e.optimizationMode && "contentHint" in e.mediaStreamTrack && (e.mediaStreamTrack.contentHint = e.optimizationMode);
      var t = $t(e.mediaStreamTrack, e.tag, e.bitrate);
      return new Ss(t);
    }
  }, {
    key: "setTransportPolicy",
    value: function setTransportPolicy(e) {
      var _this112 = this;
      e === se.FORCE_TCP && (this._config.transportPolicy = "forceTcp"), e === se.FORCE_UDP && (this._config.transportPolicy = "forceUdp"), this._clients.forEach(function (e) {
        return e.setTransportPolicy(_this112._config.transportPolicy);
      });
    }
  }, {
    key: "setConfig",
    value: function setConfig(e) {
      this._config = Object.assign(Object.assign({}, this._config), e), e.mcuServerHosts && ut.splice.apply(ut, [0, ut.length].concat(_toConsumableArray(e.mcuServerHosts))), this._clients.forEach(function (t) {
        t.config = Object.assign(Object.assign({}, t.config), e);
      }), m.debug("setConfig", e);
    }
  }, {
    key: "checkAudioTrackIsActive",
    value: function checkAudioTrackIsActive(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5e3;
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee164() {
        var i;
        return _regeneratorRuntime().wrap(function _callee164$(_context169) {
          while (1) switch (_context169.prev = _context169.next) {
            case 0:
              i = Math.min(200, t);
              return _context169.abrupt("return", new Promise(function (t, s) {
                if (e.isAudio()) {
                  var _s25 = .01,
                    r = 200;
                  var o = e.getVolumeLevel() || 0,
                    _n9 = e.getVolumeLevel() || 0,
                    _a4 = _n9 <= _s25,
                    c = !0;
                  if (e.isMuted()) t(!1);else {
                    var _A3 = setInterval(function () {
                      e.isMuted() ? (t(!1), clearInterval(_A3)) : (o = _n9, _n9 = e.getVolumeLevel() || 0, _n9 > _s25 && (_a4 = !1), _n9 !== o && (c = !1));
                    }, r);
                    setTimeout(function () {
                      return setTimeout(function () {
                        _A3 && (clearInterval(_A3), t(!_a4 && !c));
                      }, 0);
                    }, i);
                  }
                } else s(ke("only support audio track"));
              }));
            case 2:
            case "end":
              return _context169.stop();
          }
        }, _callee164);
      }));
    }
  }, {
    key: "checkVideoTrackIsActive",
    value: function checkVideoTrackIsActive(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5e3;
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee165() {
        return _regeneratorRuntime().wrap(function _callee165$(_context170) {
          while (1) switch (_context170.prev = _context170.next) {
            case 0:
              return _context170.abrupt("return", new Promise(function (i, s) {
                if (e.isVideo()) {
                  var r = e.getMediaStreamTrack();
                  if (e.isMuted() && i(!1), void 0 === r) s(ke("cannot find mediaStreamTrack"));else {
                    var o = document.createElement("video");
                    o.style.width = "1px", o.style.height = "1px", o.setAttribute("muted", ""), o.muted = !0, o.setAttribute("playsinline", ""), o.controls = !1, o.style.opacity = "0.01", o.style.position = "fixed", o.style.left = "0", o.style.top = "0", document.body.appendChild(o), o.srcObject = new MediaStream([r]), o.play();
                    var _n10 = document.createElement("canvas");
                    _n10.width = 160, _n10.height = 120;
                    var _a5 = _n10.getContext("2d");
                    if (_a5) {
                      var _s26 = !1,
                        _r10 = null;
                      var c = setInterval(function () {
                        e.isMuted() && (c && (clearInterval(c), i(!1)), o && o.remove()), _a5.drawImage(o, 0, 0, 160, 120);
                        var t = _a5.getImageData(0, 0, _n10.width, _n10.height);
                        var A = Math.floor(t.data.length / 3);
                        if (_r10) {
                          for (var _e84 = 0; _e84 < A; _e84 += 3) if (t.data[_e84] !== _r10[_e84]) {
                            _s26 = !0;
                            break;
                          }
                        } else _r10 = t.data;
                      }, 30);
                      setTimeout(function () {
                        setTimeout(function () {
                          c && (clearInterval(c), i(_s26)), o && o.remove();
                        }, 0);
                      }, t);
                    } else s(ke("can not get canvas 2d context"));
                  }
                } else s(ke("only support video track"));
              }));
            case 1:
            case "end":
              return _context170.stop();
          }
        }, _callee165);
      }));
    }
  }, {
    key: "getElectronScreenSources",
    value: function getElectronScreenSources(e) {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee166() {
        return _regeneratorRuntime().wrap(function _callee166$(_context171) {
          while (1) switch (_context171.prev = _context171.next) {
            case 0:
              return _context171.abrupt("return", Xi.getElectronScreenSources(e));
            case 1:
            case "end":
              return _context171.stop();
          }
        }, _callee166);
      }));
    }
  }, {
    key: "createMediaRecorder",
    value: function createMediaRecorder(e, t) {
      return new ws(e, t);
    }
  }, {
    key: "setLogConfig",
    value: function setLogConfig(e) {
      switch (hs.setLogConfig(e), e.level) {
        case ie.VERBOSE:
          m.setSavedLevel("log");
          break;
        case ie.INFO:
          m.setSavedLevel("debug");
          break;
        case ie.WARNING:
        case ie.ERROR:
          m.setSavedLevel("warning");
          break;
        case ie.NONE:
          m.setSavedLevel("disable");
          break;
        default:
          m.setSavedLevel("log");
      }
      m.removeAllListeners(), m.addListener("log", function (e, t) {
        hs.addLog(e, t);
      });
    }
  }, {
    key: "uploadLog",
    value: function uploadLog() {
      return g(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee167() {
        return _regeneratorRuntime().wrap(function _callee167$(_context172) {
          while (1) switch (_context172.prev = _context172.next) {
            case 0:
              return _context172.abrupt("return", hs.uploadLog());
            case 1:
            case "end":
              return _context172.stop();
          }
        }, _callee167);
      }));
    }
  }, {
    key: "createDeviceManger",
    value: function createDeviceManger() {
      return Ps.deviceManager || (Ps.deviceManager = new Rs()), Ps.deviceManager;
    }
  }, {
    key: "VERSION",
    get: function get() {
      return D;
    }
  }]);
  return Ps;
}();
Ps.audioMusicMixer = null, Ps.audioEffectMixer = null, Ps._clients = [], Ps._config = Object.assign({}, Fi), Xi.on("device-changed", function (e) {
  switch (e.device.kind) {
    case "audioinput":
      Ps.onMicrophoneChanged && Ps.onMicrophoneChanged(e);
      break;
    case "audiooutput":
      Ps.onPlaybackDeviceChanged && Ps.onPlaybackDeviceChanged(e);
      break;
    case "videoinput":
      Ps.onCameraChanged && Ps.onCameraChanged(e);
  }
});
var qs = Ps;
var Ls = function Ls() {
  _classCallCheck(this, Ls);
};
m.debug("SDK VERSION", qs.VERSION), m.debug("BROWSER VERSION", e.browserDetails);
export { G as AUDIO_ENCODER_CONFIG_SETTINGS, w as AudioSourceState, y as NetworkGrade, b as PermissionNameCode, T as PermissionStateCode, Cs as QNAudioEffect, Ms as QNAudioEffectMixer, Ls as QNAudioFilter, fs as QNAudioMixingTrack, Ds as QNAudioMusicMixer, Y as QNAudioSourceState, ys as QNBufferSourceAudioTrack, gs as QNCameraVideoTrack, Is as QNCanvasVideoTrack, z as QNChromeExtensionSourceType, ne as QNClientMode, ae as QNClientRole, te as QNConnectionDisconnectedReason, V as QNConnectionState, Es as QNCustomAudioTrack, Ss as QNCustomVideoTrack, B as QNDeviceState, oe as QNElectronScreenSourceType, de as QNEventCategory, Ae as QNEventGrade, X as QNLiveStreamingState, ks as QNLocalAudioTrack, ms as QNLocalTrack, ps as QNLocalVideoTrack, ie as QNLogLevel, ws as QNMediaRecorder, ce as QNMediaRelayState, bs as QNMicrophoneAudioTrack, $ as QNNetworkQuality, ls as QNRTCClient, _s as QNRecorderState, ss as QNRemoteAudioTrack, ts as QNRemoteTrack, $i as QNRemoteUser, is as QNRemoteVideoTrack, Z as QNRenderMode, Ts as QNScreenVideoTrack, es as QNTrack, ee as QNTrackProfile, se as QNTransportPolicy, re as QNVideoOptimizationMode, R as QosEventType, f as REC_AUDIO_ENABLE, v as REC_SCREEN_ENABLE, k as REC_VIDEO_ENABLE, W as SUPPORT_SCREEN_ENCODER_CONFIG_LIST, H as SUPPORT_VIDEO_ENCODER_CONFIG_LIST, E as TrackConnectStatus, S as TrackSourceType, qs as default, J as defaultAudioEncoderConfiguration, _ as defaultMergeJob, K as defaultScreenEncoderConfiguration, Q as defaultVideoEncoderConfiguration, I as isDefined };